/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AliveClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Alive/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getAuth(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Alive/GetAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AppointmentScheduleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getPage(keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, totalRow?: number | undefined, sortDirection?: number | undefined, sortItem?: number | undefined): Observable<AppointmentSchedulePageModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetPage?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (totalRow === null)
            throw new Error("The parameter 'totalRow' cannot be null.");
        else if (totalRow !== undefined)
            url_ += "TotalRow=" + encodeURIComponent("" + totalRow) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortItem === null)
            throw new Error("The parameter 'sortItem' cannot be null.");
        else if (sortItem !== undefined)
            url_ += "SortItem=" + encodeURIComponent("" + sortItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPage(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentSchedulePageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentSchedulePageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPage(response: HttpResponseBase): Observable<AppointmentSchedulePageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentSchedulePageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentSchedulePageModel>(<any>null);
    }

    getAppointmentSchedules(filterModel: GetAppointmentSchedulesFilterModel): Observable<AppointmentScheduleEntryModel[]> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetAppointmentSchedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentSchedules(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentScheduleEntryModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentScheduleEntryModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointmentSchedules(response: HttpResponseBase): Observable<AppointmentScheduleEntryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentScheduleEntryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentScheduleEntryModel[]>(<any>null);
    }

    create(model: AppointmentScheduleCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    createMultipleSchedules(model: AppointmentScheduleUpdateModel[], batchId?: string | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/CreateMultipleSchedules?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleSchedules(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMultipleSchedules(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    update(model: AppointmentScheduleUpdateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    delete(schedulesToDelete: number[]): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedulesToDelete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getById(id?: number | undefined): Observable<AppointmentScheduleUpdateModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentScheduleUpdateModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentScheduleUpdateModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AppointmentScheduleUpdateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentScheduleUpdateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentScheduleUpdateModel>(<any>null);
    }

    cancel(appointmentScheduleId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/Cancel?";
        if (appointmentScheduleId === null)
            throw new Error("The parameter 'appointmentScheduleId' cannot be null.");
        else if (appointmentScheduleId !== undefined)
            url_ += "appointmentScheduleId=" + encodeURIComponent("" + appointmentScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    checkAppointmentScheduleCancelStatus(appointmentScheduleId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/CheckAppointmentScheduleCancelStatus?";
        if (appointmentScheduleId === null)
            throw new Error("The parameter 'appointmentScheduleId' cannot be null.");
        else if (appointmentScheduleId !== undefined)
            url_ += "appointmentScheduleId=" + encodeURIComponent("" + appointmentScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAppointmentScheduleCancelStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAppointmentScheduleCancelStatus(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAppointmentScheduleCancelStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    checkAppointmentScheduleUpdateStatus(model: AppointmentScheduleUpdateModel): Observable<number> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/CheckAppointmentScheduleUpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAppointmentScheduleUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAppointmentScheduleUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAppointmentScheduleUpdateStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    enableFlexibleSchedule(treatmentProviderId?: number | undefined, flexibleScheduleEnabled?: boolean | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/Enable?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (flexibleScheduleEnabled === null)
            throw new Error("The parameter 'flexibleScheduleEnabled' cannot be null.");
        else if (flexibleScheduleEnabled !== undefined)
            url_ += "flexibleScheduleEnabled=" + encodeURIComponent("" + flexibleScheduleEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableFlexibleSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableFlexibleSchedule(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEnableFlexibleSchedule(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getAvailableDates(getSlotsModel: GetSlotsModel): Observable<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetAvailableDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSlotsModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableDates(<any>response_);
                } catch (e) {
                    return <Observable<moment.Moment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<moment.Moment[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableDates(response: HttpResponseBase): Observable<moment.Moment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(moment(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment[]>(<any>null);
    }

    getAppointmentScheduleAvailability(getSlotsModel: GetSlotsModel): Observable<SlotModel[]> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetAppointmentScheduleAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSlotsModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentScheduleAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentScheduleAvailability(<any>response_);
                } catch (e) {
                    return <Observable<SlotModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SlotModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointmentScheduleAvailability(response: HttpResponseBase): Observable<SlotModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlotModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SlotModel[]>(<any>null);
    }

    getSlotsForCalendar(getSlotsModel: GetSlotsModel): Observable<SlotModel[]> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetSlotsForCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSlotsModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlotsForCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlotsForCalendar(<any>response_);
                } catch (e) {
                    return <Observable<SlotModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SlotModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlotsForCalendar(response: HttpResponseBase): Observable<SlotModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlotModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SlotModel[]>(<any>null);
    }

    generateSlotsForRepeatBookings(model: SlotModel, occurances?: number | undefined): Observable<SlotModel[]> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GenerateSlotsForRepeatBookings?";
        if (occurances === null)
            throw new Error("The parameter 'occurances' cannot be null.");
        else if (occurances !== undefined)
            url_ += "occurances=" + encodeURIComponent("" + occurances) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSlotsForRepeatBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSlotsForRepeatBookings(<any>response_);
                } catch (e) {
                    return <Observable<SlotModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SlotModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateSlotsForRepeatBookings(response: HttpResponseBase): Observable<SlotModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlotModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SlotModel[]>(<any>null);
    }

    createBatch(): Observable<AppointmentScheduleBatchDTO> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/CreateBatch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatch(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentScheduleBatchDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentScheduleBatchDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBatch(response: HttpResponseBase): Observable<AppointmentScheduleBatchDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentScheduleBatchDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentScheduleBatchDTO>(<any>null);
    }

    discardBatch(batchId?: string | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/DiscardBatch?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscardBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardBatch(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDiscardBatch(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getBatchAppointmentSchedules(batchId?: string | undefined): Observable<AppointmentScheduleUpdateDTO[]> {
        let url_ = this.baseUrl + "/api/v2/AppointmentSchedule/GetBatchAppointmentSchedules?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchAppointmentSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchAppointmentSchedules(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentScheduleUpdateDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentScheduleUpdateDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBatchAppointmentSchedules(response: HttpResponseBase): Observable<AppointmentScheduleUpdateDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentScheduleUpdateDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentScheduleUpdateDTO[]>(<any>null);
    }
}

@Injectable()
export class AssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    createAssignment(model: AssignmentCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssignment(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAssignment(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getAssignmentForTreatmentProviderEmployee(treatmentProviderEmployeeId: number, date?: moment.Moment | null | undefined): Observable<AssignmentBookingModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/TreatmentProviderEmployee/{treatmentProviderEmployeeId}?";
        if (treatmentProviderEmployeeId === undefined || treatmentProviderEmployeeId === null)
            throw new Error("The parameter 'treatmentProviderEmployeeId' must be defined.");
        url_ = url_.replace("{treatmentProviderEmployeeId}", encodeURIComponent("" + treatmentProviderEmployeeId));
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentForTreatmentProviderEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentForTreatmentProviderEmployee(<any>response_);
                } catch (e) {
                    return <Observable<AssignmentBookingModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssignmentBookingModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignmentForTreatmentProviderEmployee(response: HttpResponseBase): Observable<AssignmentBookingModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentBookingModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignmentBookingModel>(<any>null);
    }

    getScheduleTypes(): Observable<ScheduleTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/Assignment/ScheduleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleTypes(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduleTypes(response: HttpResponseBase): Observable<ScheduleTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleTypeModel[]>(<any>null);
    }

    getScheduleRepetitionPatternTypes(): Observable<ScheduleRepetitionPatternTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/Assignment/GetScheduleRepetitionPatternTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleRepetitionPatternTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleRepetitionPatternTypes(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleRepetitionPatternTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleRepetitionPatternTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduleRepetitionPatternTypes(response: HttpResponseBase): Observable<ScheduleRepetitionPatternTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleRepetitionPatternTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleRepetitionPatternTypeModel[]>(<any>null);
    }

    getAll(keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortItem?: number | undefined, sortDirection?: number | undefined): Observable<AssignmentPageModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortItem === null)
            throw new Error("The parameter 'sortItem' cannot be null.");
        else if (sortItem !== undefined)
            url_ += "sortItem=" + encodeURIComponent("" + sortItem) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AssignmentPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssignmentPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssignmentPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignmentPageModel>(<any>null);
    }

    getAssignment(id?: number | undefined): Observable<AssignmentDetailsPageEntryModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignment(<any>response_);
                } catch (e) {
                    return <Observable<AssignmentDetailsPageEntryModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssignmentDetailsPageEntryModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignment(response: HttpResponseBase): Observable<AssignmentDetailsPageEntryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentDetailsPageEntryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignmentDetailsPageEntryModel>(<any>null);
    }

    editAssignment(editAssignmentModel: EditAssignmentModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editAssignmentModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditAssignment(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditAssignment(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    checkIfAssignmentCanEdit(editAssignmentModel: EditAssignmentModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/CheckIfAssignmentCanEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editAssignmentModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfAssignmentCanEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfAssignmentCanEdit(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfAssignmentCanEdit(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editBasicInfoAssignment(assignmentId?: number | undefined, numberOfParticipants?: number | undefined, isVideoCallAvailable?: boolean | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/EditBasicInfo?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (numberOfParticipants === null)
            throw new Error("The parameter 'numberOfParticipants' cannot be null.");
        else if (numberOfParticipants !== undefined)
            url_ += "numberOfParticipants=" + encodeURIComponent("" + numberOfParticipants) + "&";
        if (isVideoCallAvailable === null)
            throw new Error("The parameter 'isVideoCallAvailable' cannot be null.");
        else if (isVideoCallAvailable !== undefined)
            url_ += "isVideoCallAvailable=" + encodeURIComponent("" + isVideoCallAvailable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBasicInfoAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBasicInfoAssignment(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditBasicInfoAssignment(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    createException(exception: ScheduleExceptionCreateModel, assignmentId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/CreateException?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exception);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateException(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateException(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    checkScheduleExceptionCreateStatus(exception: ScheduleExceptionCreateModel, assignmentId?: number | undefined): Observable<ScheduleExceptionCreateStatusModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/CheckScheduleExceptionCreateStatus?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exception);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckScheduleExceptionCreateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckScheduleExceptionCreateStatus(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleExceptionCreateStatusModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleExceptionCreateStatusModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckScheduleExceptionCreateStatus(response: HttpResponseBase): Observable<ScheduleExceptionCreateStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleExceptionCreateStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleExceptionCreateStatusModel>(<any>null);
    }

    checkAssignmentCancelStatus(assignmentId?: number | undefined): Observable<AssignmentCancelStatusModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/CheckCancelStatus?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAssignmentCancelStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAssignmentCancelStatus(<any>response_);
                } catch (e) {
                    return <Observable<AssignmentCancelStatusModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssignmentCancelStatusModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAssignmentCancelStatus(response: HttpResponseBase): Observable<AssignmentCancelStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentCancelStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignmentCancelStatusModel>(<any>null);
    }

    cancelAssignment(assignmentId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/CheckAssignmentCancelStatus?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAssignment(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCancelAssignment(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updateRepetitionPattern(model: UpdateRepetitionPatternModel, assignmentId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/UpdateRepetitionPattern?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRepetitionPattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRepetitionPattern(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRepetitionPattern(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    stopRepetitionPattern(assignmentId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/StopRepetitionPattern?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopRepetitionPattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopRepetitionPattern(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processStopRepetitionPattern(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    undoException(scheduleId?: number | undefined, assignmentId?: number | undefined, deleteRepeatingDates?: boolean | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/UndoException?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (deleteRepeatingDates === null)
            throw new Error("The parameter 'deleteRepeatingDates' cannot be null.");
        else if (deleteRepeatingDates !== undefined)
            url_ += "deleteRepeatingDates=" + encodeURIComponent("" + deleteRepeatingDates) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoException(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUndoException(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editSchedules(model: EditSchedulesModel, assignmentId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Assignment/EditSchedules?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditSchedules(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditSchedules(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class AvailabilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getSchedulesForTreatmentProviderEmployee(date?: moment.Moment | undefined, treatmentProviderEmployeeIds?: number[] | null | undefined, patientId?: number | undefined, treatmentTypeId?: number | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | null | undefined): Observable<ScheduleSlotDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetSchedulesForTreatmentProviderEmployee?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (treatmentProviderEmployeeIds !== undefined && treatmentProviderEmployeeIds !== null)
            treatmentProviderEmployeeIds && treatmentProviderEmployeeIds.forEach(item => { url_ += "treatmentProviderEmployeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall !== undefined && isVideoCall !== null)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulesForTreatmentProviderEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulesForTreatmentProviderEmployee(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleSlotDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleSlotDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSchedulesForTreatmentProviderEmployee(response: HttpResponseBase): Observable<ScheduleSlotDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleSlotDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleSlotDTO[]>(<any>null);
    }

    getDatesForTreatmentProviderEmployees(patientId?: number | undefined, treatmentTypeId?: number | undefined, treatmentProviderEmployeeIds?: number[] | null | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | null | undefined): Observable<ScheduleDateDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetDatesForTreatmentProviderEmployees?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (treatmentProviderEmployeeIds !== undefined && treatmentProviderEmployeeIds !== null)
            treatmentProviderEmployeeIds && treatmentProviderEmployeeIds.forEach(item => { url_ += "treatmentProviderEmployeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall !== undefined && isVideoCall !== null)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatesForTreatmentProviderEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatesForTreatmentProviderEmployees(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleDateDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleDateDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDatesForTreatmentProviderEmployees(response: HttpResponseBase): Observable<ScheduleDateDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleDateDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleDateDTO[]>(<any>null);
    }

    getSchedulesForTreatmentProvider(patientId?: number | undefined, treatmentProviderId?: number | undefined, treatmentTypeId?: number | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | null | undefined): Observable<ScheduleSlotDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetSchedulesForTreatmentProvider?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall !== undefined && isVideoCall !== null)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulesForTreatmentProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulesForTreatmentProvider(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleSlotDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleSlotDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSchedulesForTreatmentProvider(response: HttpResponseBase): Observable<ScheduleSlotDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleSlotDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleSlotDTO[]>(<any>null);
    }

    getSchedulesForTreatmentProviderBookingWidget(date?: moment.Moment | undefined, patientId?: number | undefined, treatmentProviderId?: number | undefined, treatmentTypeId?: number | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | null | undefined): Observable<ScheduleSlotDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetSchedulesForTreatmentProviderBookingWidget?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall !== undefined && isVideoCall !== null)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulesForTreatmentProviderBookingWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulesForTreatmentProviderBookingWidget(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleSlotDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleSlotDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSchedulesForTreatmentProviderBookingWidget(response: HttpResponseBase): Observable<ScheduleSlotDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleSlotDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleSlotDTO[]>(<any>null);
    }

    getEmployeesForTreatmentProvider(patientId?: number | undefined, treatmentProviderId?: number | undefined, treatmentTypeId?: number | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | null | undefined): Observable<TreatmentProviderEmployeeShortDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetEmployeesForTreatmentProvider?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall !== undefined && isVideoCall !== null)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForTreatmentProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForTreatmentProvider(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderEmployeeShortDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderEmployeeShortDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeesForTreatmentProvider(response: HttpResponseBase): Observable<TreatmentProviderEmployeeShortDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderEmployeeShortDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderEmployeeShortDTO[]>(<any>null);
    }

    getTPESForTreatmentProviderWithAppointmentSchedules(patientId?: number | undefined, treatmentProviderId?: number | undefined, treatmentTypeId?: number | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | null | undefined): Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetTPESForTreatmentProviderWithAppointmentSchedules?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall !== undefined && isVideoCall !== null)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTPESForTreatmentProviderWithAppointmentSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTPESForTreatmentProviderWithAppointmentSchedules(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTPESForTreatmentProviderWithAppointmentSchedules(response: HttpResponseBase): Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderEmployeesSchedulePartnersDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderEmployeesSchedulePartnersDTO[]>(<any>null);
    }

    getEmployeesForGroupTreatment(treatmentProviderId?: number | undefined, treatmentTypeId?: number | undefined, locationId?: number | null | undefined, isVideoCall?: boolean | undefined): Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]> {
        let url_ = this.baseUrl + "/api/v2/Availability/GetEmployeesForGroupTreatment?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isVideoCall === null)
            throw new Error("The parameter 'isVideoCall' cannot be null.");
        else if (isVideoCall !== undefined)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForGroupTreatment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForGroupTreatment(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeesForGroupTreatment(response: HttpResponseBase): Observable<TreatmentProviderEmployeesSchedulePartnersDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderEmployeesSchedulePartnersDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderEmployeesSchedulePartnersDTO[]>(<any>null);
    }
}

@Injectable()
export class BackgroundWorkerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    receiveSNS(): Observable<void> {
        let url_ = this.baseUrl + "/api/BackgroundWorker";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceiveSNS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveSNS(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReceiveSNS(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BookingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAllBookings(patient?: string | null | undefined, treatmentProviderEmployee?: string | null | undefined, clinic?: string | null | undefined, statuses?: number[] | null | undefined, treatmentTypes?: number[] | null | undefined, dateFrom?: moment.Moment | null | undefined, dateTo?: moment.Moment | null | undefined, recent?: boolean | undefined, upcoming?: boolean | undefined, perPage?: number | undefined, page?: number | undefined): Observable<BookingPageModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/GetAllBookings?";
        if (patient !== undefined && patient !== null)
            url_ += "patient=" + encodeURIComponent("" + patient) + "&";
        if (treatmentProviderEmployee !== undefined && treatmentProviderEmployee !== null)
            url_ += "treatmentProviderEmployee=" + encodeURIComponent("" + treatmentProviderEmployee) + "&";
        if (clinic !== undefined && clinic !== null)
            url_ += "clinic=" + encodeURIComponent("" + clinic) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentTypes !== undefined && treatmentTypes !== null)
            treatmentTypes && treatmentTypes.forEach(item => { url_ += "treatmentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (recent === null)
            throw new Error("The parameter 'recent' cannot be null.");
        else if (recent !== undefined)
            url_ += "recent=" + encodeURIComponent("" + recent) + "&";
        if (upcoming === null)
            throw new Error("The parameter 'upcoming' cannot be null.");
        else if (upcoming !== undefined)
            url_ += "upcoming=" + encodeURIComponent("" + upcoming) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBookings(<any>response_);
                } catch (e) {
                    return <Observable<BookingPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookingPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBookings(response: HttpResponseBase): Observable<BookingPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingPageModel>(<any>null);
    }

    getBooking(id: number): Observable<BookingPageDetailsModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/GetBooking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBooking(<any>response_);
                } catch (e) {
                    return <Observable<BookingPageDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookingPageDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetBooking(response: HttpResponseBase): Observable<BookingPageDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingPageDetailsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingPageDetailsModel>(<any>null);
    }

    createBooking(model: BookingCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/CreateBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBooking(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBooking(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    rescheduleBooking(model: BookingCreateModel, existingBookingId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/RescheduleBooking?";
        if (existingBookingId === null)
            throw new Error("The parameter 'existingBookingId' cannot be null.");
        else if (existingBookingId !== undefined)
            url_ += "existingBookingId=" + encodeURIComponent("" + existingBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleBooking(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRescheduleBooking(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getAllBookingsPerCase(caseId?: number | undefined, perPage?: number | undefined, page?: number | undefined): Observable<BookingPageModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/GetAllBookingsPerCase?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBookingsPerCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBookingsPerCase(<any>response_);
                } catch (e) {
                    return <Observable<BookingPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookingPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBookingsPerCase(response: HttpResponseBase): Observable<BookingPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingPageModel>(<any>null);
    }

    updateNoShowBooking(bookingId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/UpdateNoShowBooking?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNoShowBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNoShowBooking(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNoShowBooking(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    cancelBooking(bookingId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/CancelBooking?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelBooking(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCancelBooking(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    checkIfBookingCanBeCanceled(bookingId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/CheckCancelBooking?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfBookingCanBeCanceled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfBookingCanBeCanceled(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfBookingCanBeCanceled(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    checkIfBookingCanBeRescheduled(bookingId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/CheckRescheduleBooking?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfBookingCanBeRescheduled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfBookingCanBeRescheduled(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfBookingCanBeRescheduled(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    createPastBookings(model: PastBookingsCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/CreatePastBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePastBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePastBookings(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePastBookings(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    createMultipleBookings(createMultipleBookingModels: MultipleBookingCreateModel[]): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/CreateMultipleBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createMultipleBookingModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleBookings(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMultipleBookings(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    rescheduleAppointmentScheduleBooking(model: MultipleBookingCreateModel, existingBookingId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Bookings/RescheduleAppointmentScheduleBooking?";
        if (existingBookingId === null)
            throw new Error("The parameter 'existingBookingId' cannot be null.");
        else if (existingBookingId !== undefined)
            url_ += "existingBookingId=" + encodeURIComponent("" + existingBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleAppointmentScheduleBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleAppointmentScheduleBooking(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRescheduleAppointmentScheduleBooking(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class BookingStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(): Observable<BookingStatusModel[]> {
        let url_ = this.baseUrl + "/api/v2/BookingStatus/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<BookingStatusModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookingStatusModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BookingStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingStatusModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingStatusModel[]>(<any>null);
    }

    getBookingStatusesForBookingsPage(): Observable<BookingStatusModel[]> {
        let url_ = this.baseUrl + "/api/v2/BookingStatus/GetBookingStatusesForBookingsPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingStatusesForBookingsPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingStatusesForBookingsPage(<any>response_);
                } catch (e) {
                    return <Observable<BookingStatusModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookingStatusModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBookingStatusesForBookingsPage(response: HttpResponseBase): Observable<BookingStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingStatusModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingStatusModel[]>(<any>null);
    }
}

@Injectable()
export class CalendarClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getCalendarItems(dateFrom?: moment.Moment | undefined, dateTo?: moment.Moment | undefined, patientIds?: number[] | null | undefined, treatmentProviderEmployeeIds?: number[] | null | undefined, treatmentProviderIds?: number[] | null | undefined, companyIds?: number[] | null | undefined, bookingStatusIds?: number[] | null | undefined, treatmentTypeIds?: number[] | null | undefined, timeFrom?: string | null | undefined, timeTo?: string | null | undefined): Observable<CalendarScheduleModel[]> {
        let url_ = this.baseUrl + "/api/v2/Calendar/GetCalendarItems?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (patientIds !== undefined && patientIds !== null)
            patientIds && patientIds.forEach(item => { url_ += "patientIds=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentProviderEmployeeIds !== undefined && treatmentProviderEmployeeIds !== null)
            treatmentProviderEmployeeIds && treatmentProviderEmployeeIds.forEach(item => { url_ += "treatmentProviderEmployeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentProviderIds !== undefined && treatmentProviderIds !== null)
            treatmentProviderIds && treatmentProviderIds.forEach(item => { url_ += "treatmentProviderIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "companyIds=" + encodeURIComponent("" + item) + "&"; });
        if (bookingStatusIds !== undefined && bookingStatusIds !== null)
            bookingStatusIds && bookingStatusIds.forEach(item => { url_ += "bookingStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentTypeIds !== undefined && treatmentTypeIds !== null)
            treatmentTypeIds && treatmentTypeIds.forEach(item => { url_ += "treatmentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (timeFrom !== undefined && timeFrom !== null)
            url_ += "timeFrom=" + encodeURIComponent("" + timeFrom) + "&";
        if (timeTo !== undefined && timeTo !== null)
            url_ += "timeTo=" + encodeURIComponent("" + timeTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarItems(<any>response_);
                } catch (e) {
                    return <Observable<CalendarScheduleModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarScheduleModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarItems(response: HttpResponseBase): Observable<CalendarScheduleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarScheduleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarScheduleModel[]>(<any>null);
    }

    getCalendarItemsForAssignment(assignmentId?: number | undefined, dateFrom?: moment.Moment | undefined, dateTo?: moment.Moment | undefined): Observable<CalendarScheduleModel[]> {
        let url_ = this.baseUrl + "/api/v2/Calendar/GetCalendarItemsForAssignment?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarItemsForAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarItemsForAssignment(<any>response_);
                } catch (e) {
                    return <Observable<CalendarScheduleModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarScheduleModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarItemsForAssignment(response: HttpResponseBase): Observable<CalendarScheduleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarScheduleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarScheduleModel[]>(<any>null);
    }

    getExceptionTimeRangeForSelectedDate(assignmentId?: number | undefined, dateFrom?: moment.Moment | undefined, dateTo?: moment.Moment | undefined): Observable<ExceptionTimeRange> {
        let url_ = this.baseUrl + "/api/v2/Calendar/GetExceptionTimeRangeForSelectedDate?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptionTimeRangeForSelectedDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptionTimeRangeForSelectedDate(<any>response_);
                } catch (e) {
                    return <Observable<ExceptionTimeRange>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExceptionTimeRange>><any>_observableThrow(response_);
        }));
    }

    protected processGetExceptionTimeRangeForSelectedDate(response: HttpResponseBase): Observable<ExceptionTimeRange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExceptionTimeRange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExceptionTimeRange>(<any>null);
    }
}

@Injectable()
export class CaseConsentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    requestConsent(createConsent: CaseConsentCreateModel, culture?: string | null | undefined, urlPattern?: string | null | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/CaseConsent/RequestConsent?";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        if (urlPattern !== undefined && urlPattern !== null)
            url_ += "urlPattern=" + encodeURIComponent("" + urlPattern) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createConsent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestConsent(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRequestConsent(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getUnansweredConsents(caseId?: number | undefined): Observable<CaseConsentShortModel> {
        let url_ = this.baseUrl + "/api/v2/CaseConsent/GetUnansweredConsents?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnansweredConsents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnansweredConsents(<any>response_);
                } catch (e) {
                    return <Observable<CaseConsentShortModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CaseConsentShortModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnansweredConsents(response: HttpResponseBase): Observable<CaseConsentShortModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseConsentShortModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CaseConsentShortModel>(<any>null);
    }

    updateCaseConsent(caseConsent: CaseConsentShortModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/CaseConsent/UpdateCaseConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(caseConsent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseConsent(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCaseConsent(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getConsentHistory(caseId?: number | undefined): Observable<ConsentListModel> {
        let url_ = this.baseUrl + "/api/v2/CaseConsent/GetConsentHistory?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsentHistory(<any>response_);
                } catch (e) {
                    return <Observable<ConsentListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsentListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsentHistory(response: HttpResponseBase): Observable<ConsentListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsentListModel>(<any>null);
    }

    revoke(consent: CaseConsentShortModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/CaseConsent/Revoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevoke(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRevoke(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class CaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, statuses?: number[] | null | undefined, companies?: number[] | null | undefined, sortItem?: number | undefined, sortDirection?: number | undefined): Observable<CasePageModel> {
        let url_ = this.baseUrl + "/api/v2/Case/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (companies !== undefined && companies !== null)
            companies && companies.forEach(item => { url_ += "companies=" + encodeURIComponent("" + item) + "&"; });
        if (sortItem === null)
            throw new Error("The parameter 'sortItem' cannot be null.");
        else if (sortItem !== undefined)
            url_ += "sortItem=" + encodeURIComponent("" + sortItem) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CasePageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CasePageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CasePageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CasePageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CasePageModel>(<any>null);
    }

    post(model: CaseCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Case/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    get(caseId?: number | undefined): Observable<CaseDetailsModel> {
        let url_ = this.baseUrl + "/api/v2/Case/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CaseDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CaseDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CaseDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseDetailsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CaseDetailsModel>(<any>null);
    }

    put(model: CaseEditModel, id?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Case/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editStatus(caseId?: number | undefined, statusCode?: string | null | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Case/EditStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (statusCode !== undefined && statusCode !== null)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditStatus(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditStatus(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    exportCaseDetails(caseId?: number | undefined, injuryDateLabel?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/Case/ExportCaseDetails?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (injuryDateLabel !== undefined && injuryDateLabel !== null)
            url_ += "injuryDateLabel=" + encodeURIComponent("" + injuryDateLabel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCaseDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCaseDetails(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportCaseDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = HttpResponseException.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

@Injectable()
export class CaseStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(): Observable<CaseStatusShortDetailsModel[]> {
        let url_ = this.baseUrl + "/api/v2/CaseStatus/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CaseStatusShortDetailsModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CaseStatusShortDetailsModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CaseStatusShortDetailsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseStatusShortDetailsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CaseStatusShortDetailsModel[]>(<any>null);
    }
}

@Injectable()
export class ClinicProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    hasClinicProfileEnabled(treatmentProviderId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/HasClinicProfileEnabled?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasClinicProfileEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasClinicProfileEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasClinicProfileEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getTreatments(treatmentProviderId?: number | undefined, treatmentType?: string | null | undefined): Observable<TreatmentProviderTreatmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/GetTreatments?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentType !== undefined && treatmentType !== null)
            url_ += "treatmentType=" + encodeURIComponent("" + treatmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatments(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderTreatmentTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderTreatmentTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatments(response: HttpResponseBase): Observable<TreatmentProviderTreatmentTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderTreatmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderTreatmentTypeModel[]>(<any>null);
    }

    getEmployees(treatmentProviderId?: number | undefined, treatmentType?: string | null | undefined): Observable<TreatmentProviderTreatmentSpecialistModel[]> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/GetEmployees?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentType !== undefined && treatmentType !== null)
            url_ += "treatmentType=" + encodeURIComponent("" + treatmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployees(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderTreatmentSpecialistModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderTreatmentSpecialistModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployees(response: HttpResponseBase): Observable<TreatmentProviderTreatmentSpecialistModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderTreatmentSpecialistModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderTreatmentSpecialistModel[]>(<any>null);
    }

    getEmployeeById(treatmentProviderId?: number | undefined, treatmentProviderEmployeeId?: number | undefined): Observable<TreatmentProviderEmployeeClinicProfileModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/GetEmployeeById?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentProviderEmployeeId === null)
            throw new Error("The parameter 'treatmentProviderEmployeeId' cannot be null.");
        else if (treatmentProviderEmployeeId !== undefined)
            url_ += "treatmentProviderEmployeeId=" + encodeURIComponent("" + treatmentProviderEmployeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeById(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderEmployeeClinicProfileModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderEmployeeClinicProfileModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeById(response: HttpResponseBase): Observable<TreatmentProviderEmployeeClinicProfileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentProviderEmployeeClinicProfileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderEmployeeClinicProfileModel>(<any>null);
    }

    get(treatmentProviderId?: number | undefined): Observable<ClinicProfileModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/Get?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ClinicProfileModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicProfileModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClinicProfileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicProfileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicProfileModel>(<any>null);
    }

    editProfile(model: ClinicProfileModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/EditProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditProfile(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditProfile(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    postLocation(locationModel: LocationModel, treatmentProviderId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/PostLocation?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLocation(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostLocation(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    postContact(contactModel: ContactShortModel, treatmentProviderId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/PostContact?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contactModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostContact(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostContact(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updateDescription(clinicDescriptionUpdateModel: ClinicDescriptionUpdateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/UpdateDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicDescriptionUpdateModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDescription(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDescription(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editGeneralInfo(model: TreatmentProviderClinicProfileModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/EditGeneralInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditGeneralInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditGeneralInfo(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditGeneralInfo(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editWorkingTime(model: WorkingTimeModel[]): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/EditWorkingTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditWorkingTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditWorkingTime(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditWorkingTime(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    clinicProfileUploadFile(treatmentProviderId?: number | undefined, file?: FileParameter | null | undefined): Observable<FileModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/ClinicProfileUploadFile?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicProfileUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicProfileUploadFile(<any>response_);
                } catch (e) {
                    return <Observable<FileModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileModel>><any>_observableThrow(response_);
        }));
    }

    protected processClinicProfileUploadFile(response: HttpResponseBase): Observable<FileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 415) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result415: any = null;
            let resultData415 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result415 = HttpResponseException.fromJS(resultData415);
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = HttpResponseException.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileModel>(<any>null);
    }

    orderTreatmentTypes(treatmentProviderTreatmentTypeUpdate: TreatmentProviderTreatmentTypeUpdateModel): Observable<TreatmentProviderTreatmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/OrderTreatmentTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentProviderTreatmentTypeUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderTreatmentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderTreatmentTypes(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderTreatmentTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderTreatmentTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processOrderTreatmentTypes(response: HttpResponseBase): Observable<TreatmentProviderTreatmentTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderTreatmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderTreatmentTypeModel[]>(<any>null);
    }

    orderClinicGallery(treatmentProviderGalleryUpdate: TreatmentProviderGalleryUpdateModel): Observable<ClinicGalleryImageModel[]> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/OrderClinicGallery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentProviderGalleryUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderClinicGallery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderClinicGallery(<any>response_);
                } catch (e) {
                    return <Observable<ClinicGalleryImageModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicGalleryImageModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processOrderClinicGallery(response: HttpResponseBase): Observable<ClinicGalleryImageModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicGalleryImageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicGalleryImageModel[]>(<any>null);
    }

    orderSpecialists(treatmentProviderEmployeePriorityUpdate: TreatmentProviderEmployeePriorityUpdateModel): Observable<TreatmentProviderTreatmentSpecialistModel[]> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/OrderSpecialists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentProviderEmployeePriorityUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderSpecialists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderSpecialists(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderTreatmentSpecialistModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderTreatmentSpecialistModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processOrderSpecialists(response: HttpResponseBase): Observable<TreatmentProviderTreatmentSpecialistModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderTreatmentSpecialistModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderTreatmentSpecialistModel[]>(<any>null);
    }

    createSpecialist(model: CreateTPEClinicProfileModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/CreateSpecialist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSpecialist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSpecialist(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSpecialist(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editSpecialist(model: UpdateTreatmentProviderEmployeeClinicProfileModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/EditSpecialist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditSpecialist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditSpecialist(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditSpecialist(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    editClinicTreatmentType(treatmentTypeModel: TreatmentProviderTreatmentTypeModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/EditClinicTreatmentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentTypeModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditClinicTreatmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditClinicTreatmentType(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditClinicTreatmentType(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updateTreatmentTypes(treatmentTypeModel: UpdateTreatmentProviderTreatmentTypesModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/UpdateTreatmentTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentTypeModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTreatmentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTreatmentTypes(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTreatmentTypes(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    setClinicProfileEnable(treatmentProviderId?: number | undefined, clinicProfileEnable?: boolean | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/SetClinicProfile?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (clinicProfileEnable === null)
            throw new Error("The parameter 'clinicProfileEnable' cannot be null.");
        else if (clinicProfileEnable !== undefined)
            url_ += "clinicProfileEnable=" + encodeURIComponent("" + clinicProfileEnable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetClinicProfileEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetClinicProfileEnable(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetClinicProfileEnable(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    addGalleryPhoto(model: ClinicGalleryImageModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/AddGalleryPhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddGalleryPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddGalleryPhoto(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddGalleryPhoto(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    setEmployeeProfilePicture(model: UserProfilePictureModel, treatmentProviderId?: number | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/SetEmployeeProfilePicture?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEmployeeProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEmployeeProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSetEmployeeProfilePicture(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    getClinicIdFromProfileUrl(profileUrl?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/v2/ClinicProfile/GetClinicIdFromProfileUrl?";
        if (profileUrl !== undefined && profileUrl !== null)
            url_ += "profileUrl=" + encodeURIComponent("" + profileUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClinicIdFromProfileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClinicIdFromProfileUrl(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetClinicIdFromProfileUrl(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

@Injectable()
export class CompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAllCompaniesPage(keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<CompanyPageModel> {
        let url_ = this.baseUrl + "/api/v2/Company/GetCompaniesPage?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesPage(<any>response_);
                } catch (e) {
                    return <Observable<CompanyPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCompaniesPage(response: HttpResponseBase): Observable<CompanyPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyPageModel>(<any>null);
    }

    getCompaniesByUser(): Observable<CompanyShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/Company/GetCompaniesByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompaniesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompaniesByUser(<any>response_);
                } catch (e) {
                    return <Observable<CompanyShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompaniesByUser(response: HttpResponseBase): Observable<CompanyShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyShortModel[]>(<any>null);
    }

    getAllCompanies(): Observable<ShortCompanyDetailsModel[]> {
        let url_ = this.baseUrl + "/api/v2/Company/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(<any>response_);
                } catch (e) {
                    return <Observable<ShortCompanyDetailsModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShortCompanyDetailsModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<ShortCompanyDetailsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShortCompanyDetailsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShortCompanyDetailsModel[]>(<any>null);
    }

    createCompany(model: CompanyCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/CreateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompany(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCompany(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getCompanyById(companyId?: number | undefined): Observable<CompanyEditDetailsModel> {
        let url_ = this.baseUrl + "/api/v2/Company/GetCompanyById?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyById(<any>response_);
                } catch (e) {
                    return <Observable<CompanyEditDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyEditDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyById(response: HttpResponseBase): Observable<CompanyEditDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyEditDetailsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyEditDetailsModel>(<any>null);
    }

    updateCompany(model: CompanyEditDetailsModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/UpdateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompany(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCompany(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    canEmployeeGroupBeDeleted(employeeGroupId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/CanEmployeeGroupBeDeleted?";
        if (employeeGroupId === null)
            throw new Error("The parameter 'employeeGroupId' cannot be null.");
        else if (employeeGroupId !== undefined)
            url_ += "employeeGroupId=" + encodeURIComponent("" + employeeGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanEmployeeGroupBeDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanEmployeeGroupBeDeleted(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCanEmployeeGroupBeDeleted(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    deleteCompany(companyId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/DeleteCompany?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getCompanyRooms(companiesIds: number[]): Observable<RoomSelectModel[]> {
        let url_ = this.baseUrl + "/api/v2/Company/GetCompanyRooms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(companiesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyRooms(<any>response_);
                } catch (e) {
                    return <Observable<RoomSelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoomSelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyRooms(response: HttpResponseBase): Observable<RoomSelectModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomSelectModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomSelectModel[]>(<any>null);
    }

    getAllDataOwners(): Observable<DataOwnerModel[]> {
        let url_ = this.baseUrl + "/api/v2/Company/GetDataOwners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDataOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDataOwners(<any>response_);
                } catch (e) {
                    return <Observable<DataOwnerModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DataOwnerModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDataOwners(response: HttpResponseBase): Observable<DataOwnerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataOwnerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataOwnerModel[]>(<any>null);
    }

    getCompanyEmployeeGroups(companyId?: number | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<EmployeeGroupPageModel> {
        let url_ = this.baseUrl + "/api/v2/Company/GetCompanyEmployeeGroups?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyEmployeeGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyEmployeeGroups(<any>response_);
                } catch (e) {
                    return <Observable<EmployeeGroupPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmployeeGroupPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyEmployeeGroups(response: HttpResponseBase): Observable<EmployeeGroupPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeGroupPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeGroupPageModel>(<any>null);
    }

    updateEmployeeGroup(employeeGroup: EmployeeGroupShortModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/UpdateEmployeeGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeGroup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployeeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployeeGroup(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEmployeeGroup(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    deleteEmployeeGroup(employeeGroupId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/DeleteEmployeeGroup?";
        if (employeeGroupId === null)
            throw new Error("The parameter 'employeeGroupId' cannot be null.");
        else if (employeeGroupId !== undefined)
            url_ += "employeeGroupId=" + encodeURIComponent("" + employeeGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmployeeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmployeeGroup(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEmployeeGroup(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    addEmployeeGroup(employeeGroupName?: string | null | undefined, companyId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Company/AddEmployeeGroup?";
        if (employeeGroupName !== undefined && employeeGroupName !== null)
            url_ += "employeeGroupName=" + encodeURIComponent("" + employeeGroupName) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEmployeeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEmployeeGroup(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddEmployeeGroup(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getNetworkDefaultCompany(networkId?: number | undefined): Observable<CompanySelectDTO> {
        let url_ = this.baseUrl + "/api/v2/Company/GetNetworkDefaultCompany?";
        if (networkId === null)
            throw new Error("The parameter 'networkId' cannot be null.");
        else if (networkId !== undefined)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetworkDefaultCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetworkDefaultCompany(<any>response_);
                } catch (e) {
                    return <Observable<CompanySelectDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanySelectDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetNetworkDefaultCompany(response: HttpResponseBase): Observable<CompanySelectDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanySelectDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanySelectDTO>(<any>null);
    }
}

@Injectable()
export class CompleteRegistrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(id: number, token: string | null): Observable<ResultDTO> {
        let url_ = this.baseUrl + "/api/v2/CompleteRegistration/{id}/{token}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ResultDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDTO>(<any>null);
    }

    post(modelBody: CreateUserRepresentativeModel, modelPath: CreateUserRepresentativeModel | null): Observable<ResultDTO> {
        let url_ = this.baseUrl + "/api/v2/CompleteRegistration/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<ResultDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDTO>(<any>null);
    }
}

@Injectable()
export class CompleteSignUpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(id: number, token: string | null): Observable<ResultDTO> {
        let url_ = this.baseUrl + "/api/v2/CompleteSignUp/{Id}/{Token}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{Token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ResultDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDTO>(<any>null);
    }
}

@Injectable()
export class ForgotPasswordClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    changePassword(model: ChangePasswordModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ForgotPassword/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    post(model: ForgotPasswordModel): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    patch(model: ResetPasswordModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatch(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPatch(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class HomeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getActiveCases(): Observable<HomePageCaseModel[]> {
        let url_ = this.baseUrl + "/api/v2/Home/GetActiveCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveCases(<any>response_);
                } catch (e) {
                    return <Observable<HomePageCaseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomePageCaseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveCases(response: HttpResponseBase): Observable<HomePageCaseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HomePageCaseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomePageCaseModel[]>(<any>null);
    }
}

@Injectable()
export class ImportUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    addUsers(filePath?: string | null | undefined): Observable<IdentityResultModel> {
        let url_ = this.baseUrl + "/api/v2/ImportUsers/AddUsers?";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsers(<any>response_);
                } catch (e) {
                    return <Observable<IdentityResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddUsers(response: HttpResponseBase): Observable<IdentityResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityResultModel>(<any>null);
    }

    importUsersFile(file?: FileParameter | null | undefined): Observable<FileModel> {
        let url_ = this.baseUrl + "/api/v2/ImportUsers/ImportUsersFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportUsersFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportUsersFile(<any>response_);
                } catch (e) {
                    return <Observable<FileModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileModel>><any>_observableThrow(response_);
        }));
    }

    protected processImportUsersFile(response: HttpResponseBase): Observable<FileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 415) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result415: any = null;
            let resultData415 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result415 = HttpResponseException.fromJS(resultData415);
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = HttpResponseException.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileModel>(<any>null);
    }
}

@Injectable()
export class InternalCommentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(caseId?: number | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<InternalCommentPageModel> {
        let url_ = this.baseUrl + "/api/v2/InternalComment/GetAll?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<InternalCommentPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<InternalCommentPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InternalCommentPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalCommentPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InternalCommentPageModel>(<any>null);
    }

    post(internalComment: InternalCommentCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/InternalComment/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(internalComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    delete(internalCommentId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/InternalComment/Delete?";
        if (internalCommentId === null)
            throw new Error("The parameter 'internalCommentId' cannot be null.");
        else if (internalCommentId !== undefined)
            url_ += "internalCommentId=" + encodeURIComponent("" + internalCommentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class JournalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(caseId?: number | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<MedicalJournalPageModel> {
        let url_ = this.baseUrl + "/api/v2/Journal/GetAll?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalJournalPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalJournalPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalJournalPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalJournalPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalJournalPageModel>(<any>null);
    }

    post(model: MedicalJournalCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Journal/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    uploadJournalFile(caseId?: number | undefined, file?: FileParameter | null | undefined): Observable<FileModel> {
        let url_ = this.baseUrl + "/api/v2/Journal/UploadJournalFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadJournalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadJournalFile(<any>response_);
                } catch (e) {
                    return <Observable<FileModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileModel>><any>_observableThrow(response_);
        }));
    }

    protected processUploadJournalFile(response: HttpResponseBase): Observable<FileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 415) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result415: any = null;
            let resultData415 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result415 = HttpResponseException.fromJS(resultData415);
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = HttpResponseException.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileModel>(<any>null);
    }

    downloadFile(fileId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/Journal/DownloadFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getAllowedFileExtensions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v2/Journal/GetAllowedFileExtensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedFileExtensions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedFileExtensions(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllowedFileExtensions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    exportJournal(journalId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/Journal/ExportJournal?";
        if (journalId === null)
            throw new Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportJournal(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportJournal(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = HttpResponseException.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

@Injectable()
export class MitIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    openMitId(): Observable<any> {
        let url_ = this.baseUrl + "/api/v2/MitId/OpenMitId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenMitId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenMitId(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processOpenMitId(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

@Injectable()
export class NotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAllTemplates(showEmailTemplates?: boolean | undefined, showTextMessageTemplates?: boolean | undefined, language?: string | null | undefined, treatmentProviderNetworkId?: number | null | undefined, keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<NotificationTemplatesPageModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/GetAllTemplates?";
        if (showEmailTemplates === null)
            throw new Error("The parameter 'showEmailTemplates' cannot be null.");
        else if (showEmailTemplates !== undefined)
            url_ += "showEmailTemplates=" + encodeURIComponent("" + showEmailTemplates) + "&";
        if (showTextMessageTemplates === null)
            throw new Error("The parameter 'showTextMessageTemplates' cannot be null.");
        else if (showTextMessageTemplates !== undefined)
            url_ += "showTextMessageTemplates=" + encodeURIComponent("" + showTextMessageTemplates) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (treatmentProviderNetworkId !== undefined && treatmentProviderNetworkId !== null)
            url_ += "treatmentProviderNetworkId=" + encodeURIComponent("" + treatmentProviderNetworkId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTemplates(<any>response_);
                } catch (e) {
                    return <Observable<NotificationTemplatesPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationTemplatesPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTemplates(response: HttpResponseBase): Observable<NotificationTemplatesPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationTemplatesPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationTemplatesPageModel>(<any>null);
    }

    editEmailTemplate(model: EmailTemplateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/EditEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditEmailTemplate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditEmailTemplate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getEmailTemplate(templateId?: number | undefined): Observable<EmailTemplateModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/GetEmailTemplate?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplate(<any>response_);
                } catch (e) {
                    return <Observable<EmailTemplateModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailTemplateModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplate(response: HttpResponseBase): Observable<EmailTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailTemplateModel>(<any>null);
    }

    getTextMessageTemplate(templateId?: number | undefined): Observable<TextMessageTemplateModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/GetTextMessageTemplate?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTextMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTextMessageTemplate(<any>response_);
                } catch (e) {
                    return <Observable<TextMessageTemplateModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TextMessageTemplateModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetTextMessageTemplate(response: HttpResponseBase): Observable<TextMessageTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TextMessageTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TextMessageTemplateModel>(<any>null);
    }

    editTextMessageTemplate(model: TextMessageTemplateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/EditTextMessageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTextMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTextMessageTemplate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditTextMessageTemplate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getEnabledNotificationsForUser(userId?: number | undefined): Observable<UserNotificationModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/GetEnabledNotificationsForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledNotificationsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledNotificationsForUser(<any>response_);
                } catch (e) {
                    return <Observable<UserNotificationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotificationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnabledNotificationsForUser(response: HttpResponseBase): Observable<UserNotificationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationModel>(<any>null);
    }

    createEmailTemplate(emailTemplateModel: EmailTemplateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/CreateEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailTemplateModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmailTemplate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateEmailTemplate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    createTextMessageTemplate(textMessageTemplateModel: TextMessageTemplate): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Notification/CreateTextMessageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(textMessageTemplateModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTextMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTextMessageTemplate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTextMessageTemplate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getAllNotifications(networkId?: number | null | undefined): Observable<NotificationModel[]> {
        let url_ = this.baseUrl + "/api/v2/Notification/GetAllNotifications?";
        if (networkId !== undefined && networkId !== null)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotifications(<any>response_);
                } catch (e) {
                    return <Observable<NotificationModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNotifications(response: HttpResponseBase): Observable<NotificationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationModel[]>(<any>null);
    }
}

@Injectable()
export class PortalNotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getUserPortalNotifications(): Observable<PortalNotificationModel[]> {
        let url_ = this.baseUrl + "/api/v2/PortalNotifications/GetAllForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPortalNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPortalNotifications(<any>response_);
                } catch (e) {
                    return <Observable<PortalNotificationModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PortalNotificationModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPortalNotifications(response: HttpResponseBase): Observable<PortalNotificationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalNotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PortalNotificationModel[]>(<any>null);
    }

    getAllActiveNotifications(): Observable<PortalNotificationModel[]> {
        let url_ = this.baseUrl + "/api/v2/PortalNotifications/GetAllForAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveNotifications(<any>response_);
                } catch (e) {
                    return <Observable<PortalNotificationModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PortalNotificationModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllActiveNotifications(response: HttpResponseBase): Observable<PortalNotificationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalNotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PortalNotificationModel[]>(<any>null);
    }

    createPortalNotification(model: PortalNotificationModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/PortalNotifications/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePortalNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePortalNotification(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePortalNotification(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updatePortalNotification(model: PortalNotificationModel): Observable<IdentityResultModel> {
        let url_ = this.baseUrl + "/api/v2/PortalNotifications/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePortalNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePortalNotification(<any>response_);
                } catch (e) {
                    return <Observable<IdentityResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePortalNotification(response: HttpResponseBase): Observable<IdentityResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityResultModel>(<any>null);
    }

    markAsRead(model: PortalNotificationModel): Observable<IdentityResultModel> {
        let url_ = this.baseUrl + "/api/v2/PortalNotifications/MarkAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(<any>response_);
                } catch (e) {
                    return <Observable<IdentityResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<IdentityResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityResultModel>(<any>null);
    }

    deletePortalNotification(portalNotificationId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/PortalNotifications/Delete?";
        if (portalNotificationId === null)
            throw new Error("The parameter 'portalNotificationId' cannot be null.");
        else if (portalNotificationId !== undefined)
            url_ += "portalNotificationId=" + encodeURIComponent("" + portalNotificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePortalNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePortalNotification(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePortalNotification(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class RegionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getRegions(): Observable<RegionModel[]> {
        let url_ = this.baseUrl + "/api/v2/Regions/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(<any>response_);
                } catch (e) {
                    return <Observable<RegionModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegions(response: HttpResponseBase): Observable<RegionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionModel[]>(<any>null);
    }
}

@Injectable()
export class ReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    authorize(reportId?: string | null | undefined): Observable<PowerBiTokenModel> {
        let url_ = this.baseUrl + "/api/v2/Reports/Authorize?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize(<any>response_);
                } catch (e) {
                    return <Observable<PowerBiTokenModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PowerBiTokenModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthorize(response: HttpResponseBase): Observable<PowerBiTokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerBiTokenModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PowerBiTokenModel>(<any>null);
    }

    getAll(): Observable<ReportModel[]> {
        let url_ = this.baseUrl + "/api/v2/Reports/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ReportModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportModel[]>(<any>null);
    }
}

@Injectable()
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(): Observable<RoleModel[]> {
        let url_ = this.baseUrl + "/api/v2/Roles/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel[]>(<any>null);
    }
}

@Injectable()
export class ScheduleExceptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    createAppointmentScheduleException(model: AppointmentScheduleExceptionCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ScheduleException/CreateException";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentScheduleException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentScheduleException(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAppointmentScheduleException(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updateAppointmentScheduleException(model: AppointmentScheduleExceptionUpdateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ScheduleException/UpdateException";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAppointmentScheduleException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAppointmentScheduleException(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAppointmentScheduleException(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    deleteAppointmentScheduleException(exceptionsToDelete: number[]): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/ScheduleException/DeleteException";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exceptionsToDelete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAppointmentScheduleException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAppointmentScheduleException(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAppointmentScheduleException(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class SchedulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAllSchedules(dateFrom?: moment.Moment | null | undefined, dateTo?: moment.Moment | null | undefined, patientIds?: number[] | null | undefined, treatmentProviderIds?: number[] | null | undefined, treatmentTypeIds?: number[] | null | undefined, scheduleTypeIds?: number[] | null | undefined, treatmentProviderEmployeeId?: number | undefined, doNotFetchUnassigned?: boolean | undefined): Observable<ScheduleItemGroupModel[]> {
        let url_ = this.baseUrl + "/api/v2/Schedules/GetAllSchedules?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (patientIds !== undefined && patientIds !== null)
            patientIds && patientIds.forEach(item => { url_ += "patientIds=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentProviderIds !== undefined && treatmentProviderIds !== null)
            treatmentProviderIds && treatmentProviderIds.forEach(item => { url_ += "treatmentProviderIds=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentTypeIds !== undefined && treatmentTypeIds !== null)
            treatmentTypeIds && treatmentTypeIds.forEach(item => { url_ += "treatmentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (scheduleTypeIds !== undefined && scheduleTypeIds !== null)
            scheduleTypeIds && scheduleTypeIds.forEach(item => { url_ += "scheduleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (treatmentProviderEmployeeId === null)
            throw new Error("The parameter 'treatmentProviderEmployeeId' cannot be null.");
        else if (treatmentProviderEmployeeId !== undefined)
            url_ += "treatmentProviderEmployeeId=" + encodeURIComponent("" + treatmentProviderEmployeeId) + "&";
        if (doNotFetchUnassigned === null)
            throw new Error("The parameter 'doNotFetchUnassigned' cannot be null.");
        else if (doNotFetchUnassigned !== undefined)
            url_ += "doNotFetchUnassigned=" + encodeURIComponent("" + doNotFetchUnassigned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSchedules(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleItemGroupModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleItemGroupModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSchedules(response: HttpResponseBase): Observable<ScheduleItemGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleItemGroupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleItemGroupModel[]>(<any>null);
    }
}

@Injectable()
export class CompanySelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(keyword?: string | null | undefined): Observable<CompanySelectDTO[]> {
        let url_ = this.baseUrl + "/api/v2/select/companies?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CompanySelectDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanySelectDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanySelectDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanySelectDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanySelectDTO[]>(<any>null);
    }
}

@Injectable()
export class SelfRegistrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    sendSelfRegistrationEmail(requestModel: SelfRegistrationRequestModel): Observable<SelfRegistrationRequestModel> {
        let url_ = this.baseUrl + "/api/v2/SelfRegistration/SendSelfRegistrationEmailAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSelfRegistrationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSelfRegistrationEmail(<any>response_);
                } catch (e) {
                    return <Observable<SelfRegistrationRequestModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelfRegistrationRequestModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendSelfRegistrationEmail(response: HttpResponseBase): Observable<SelfRegistrationRequestModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfRegistrationRequestModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelfRegistrationRequestModel>(<any>null);
    }

    resendSelfRegistrationEmail(requestModel: SelfRegistrationRequestModel): Observable<SelfRegistrationRequestModel> {
        let url_ = this.baseUrl + "/api/v2/SelfRegistration/ResendSelfRegistrationEmailAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendSelfRegistrationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendSelfRegistrationEmail(<any>response_);
                } catch (e) {
                    return <Observable<SelfRegistrationRequestModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelfRegistrationRequestModel>><any>_observableThrow(response_);
        }));
    }

    protected processResendSelfRegistrationEmail(response: HttpResponseBase): Observable<SelfRegistrationRequestModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfRegistrationRequestModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelfRegistrationRequestModel>(<any>null);
    }

    selfRegistrationCreateTreatmentProvider(model: SelfRegisterTreatmentProviderCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/SelfRegistration/CreateTreatmentProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelfRegistrationCreateTreatmentProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfRegistrationCreateTreatmentProvider(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processSelfRegistrationCreateTreatmentProvider(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    selfRegistrationCreateTreatmentProviderAndFetchUserInfo(model: SelfRegisterTreatmentProviderCreateModel): Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/v2/SelfRegistration/CreateTreatmentProviderAndFetchUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelfRegistrationCreateTreatmentProviderAndFetchUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfRegistrationCreateTreatmentProviderAndFetchUserInfo(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processSelfRegistrationCreateTreatmentProviderAndFetchUserInfo(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    updateUser(model: UpdateUserModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/SelfRegistration/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class SexesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<SexModel[]> {
        let url_ = this.baseUrl + "/api/v2/Sexes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SexModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SexModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SexModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SexModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SexModel[]>(<any>null);
    }
}

@Injectable()
export class TenantConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getNetwork(requestModel: TreatmentProviderNetworkRequestModel): Observable<TreatmentProviderNetworkShortModel> {
        let url_ = this.baseUrl + "/api/v2/TenantConfiguration/GetNetwork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetwork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetwork(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderNetworkShortModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderNetworkShortModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetNetwork(response: HttpResponseBase): Observable<TreatmentProviderNetworkShortModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentProviderNetworkShortModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderNetworkShortModel>(<any>null);
    }
}

@Injectable()
export class TermsAndConditionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(urlPattern?: string | null | undefined, codeType?: string | null | undefined, codeEntity?: string | null | undefined): Observable<TermsAndConditionsModel> {
        let url_ = this.baseUrl + "/api/v2/TermsAndConditions/Get?";
        if (urlPattern !== undefined && urlPattern !== null)
            url_ += "urlPattern=" + encodeURIComponent("" + urlPattern) + "&";
        if (codeType !== undefined && codeType !== null)
            url_ += "codeType=" + encodeURIComponent("" + codeType) + "&";
        if (codeEntity !== undefined && codeEntity !== null)
            url_ += "codeEntity=" + encodeURIComponent("" + codeEntity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TermsAndConditionsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TermsAndConditionsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TermsAndConditionsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermsAndConditionsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TermsAndConditionsModel>(<any>null);
    }

    update(termsAndConditionsUpdateModel: TermsAndConditionsUpdateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TermsAndConditions/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(termsAndConditionsUpdateModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class TokenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    login(): Observable<void> {
        let url_ = this.baseUrl + "/api/Token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/Token/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TreatmentAreaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(): Observable<TreatmentAreaModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmenArea/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentAreaModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentAreaModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TreatmentAreaModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentAreaModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentAreaModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderNetworkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAllNetworks(): Observable<TreatmentProviderNetworkShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderNetworks/GetAllNetworks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNetworks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNetworks(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderNetworkShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderNetworkShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNetworks(response: HttpResponseBase): Observable<TreatmentProviderNetworkShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderNetworkShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderNetworkShortModel[]>(<any>null);
    }

    getNetworkPhoneNumber(): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderNetworks/GetNetworkPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetworkPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetworkPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetNetworkPhoneNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    setDefaultClinicProfile(networkCode?: string | null | undefined, defaultClinicProfile?: boolean | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderNetworks/SetDefaultClinicProfile?";
        if (networkCode !== undefined && networkCode !== null)
            url_ += "networkCode=" + encodeURIComponent("" + networkCode) + "&";
        if (defaultClinicProfile === null)
            throw new Error("The parameter 'defaultClinicProfile' cannot be null.");
        else if (defaultClinicProfile !== undefined)
            url_ += "defaultClinicProfile=" + encodeURIComponent("" + defaultClinicProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultClinicProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultClinicProfile(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultClinicProfile(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderPhotosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    post(modelBody: TreatmentProviderPhotoModel, modelPath: TreatmentProviderPhotoModel | null): Observable<PhotoPostResponseModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderPhotos/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<PhotoPostResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PhotoPostResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<PhotoPostResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoPostResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 405) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result405: any = null;
            let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result405 = resultData405 !== undefined ? resultData405 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhotoPostResponseModel>(<any>null);
    }

    delete(id: number): Observable<PhotoDeleteResponseModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderPhotos/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<PhotoDeleteResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PhotoDeleteResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<PhotoDeleteResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoDeleteResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 405) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result405: any = null;
            let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result405 = resultData405 !== undefined ? resultData405 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhotoDeleteResponseModel>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderRegisterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    post(modelBody: TreatmentProviderRegisterModel, modelPath: TreatmentProviderRegisterModel | null): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderRegister/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TreatmentProvidersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    createTreatmentProvider(model: TreatmentProviderCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/CreateTreatmentProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTreatmentProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTreatmentProvider(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTreatmentProvider(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getTreatmentProvidersByNetworkId(networkId?: number | undefined): Observable<TreatmentProviderShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/GetTreatmentProvidersByNetworkId?";
        if (networkId === null)
            throw new Error("The parameter 'networkId' cannot be null.");
        else if (networkId !== undefined)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProvidersByNetworkId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProvidersByNetworkId(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentProvidersByNetworkId(response: HttpResponseBase): Observable<TreatmentProviderShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderShortModel[]>(<any>null);
    }

    getTreatmentProvidersForPastBookingsByNetworkId(networkId?: number | undefined): Observable<TreatmentProviderShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/GetTreatmentProvidersForPastBookingsByNetworkId?";
        if (networkId === null)
            throw new Error("The parameter 'networkId' cannot be null.");
        else if (networkId !== undefined)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProvidersForPastBookingsByNetworkId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProvidersForPastBookingsByNetworkId(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentProvidersForPastBookingsByNetworkId(response: HttpResponseBase): Observable<TreatmentProviderShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderShortModel[]>(<any>null);
    }

    getAllTreatmentProvidersPage(keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<TreatmentProviderPageModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/GetAllTreatmentProvidersPage?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentProvidersPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentProvidersPage(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTreatmentProvidersPage(response: HttpResponseBase): Observable<TreatmentProviderPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentProviderPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderPageModel>(<any>null);
    }

    getEdit(treatmentProviderId?: number | undefined): Observable<TreatmentProviderEditModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/GetEdit?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdit(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderEditModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderEditModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEdit(response: HttpResponseBase): Observable<TreatmentProviderEditModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentProviderEditModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderEditModel>(<any>null);
    }

    editTreatmentProvider(treatmentProvider: TreatmentProviderEditModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/EditTreatmentProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentProvider);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTreatmentProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTreatmentProvider(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processEditTreatmentProvider(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    delete(treatmentProviderId?: number | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/Delete?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getTreatmentProviderLocations(treatmentProviderId?: number | undefined): Observable<LocationModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/GetTreatmentProviderLocations?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProviderLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProviderLocations(<any>response_);
                } catch (e) {
                    return <Observable<LocationModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentProviderLocations(response: HttpResponseBase): Observable<LocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationModel[]>(<any>null);
    }

    getDistanceFromPatientToTreater(userLatitude?: number | undefined, userLongitude?: number | undefined, clinicsLatitude?: number | undefined, clinicsLongitude?: number | undefined): Observable<GoogleDistanceResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviders/DistanceFromPatientToTreater?";
        if (userLatitude === null)
            throw new Error("The parameter 'userLatitude' cannot be null.");
        else if (userLatitude !== undefined)
            url_ += "userLatitude=" + encodeURIComponent("" + userLatitude) + "&";
        if (userLongitude === null)
            throw new Error("The parameter 'userLongitude' cannot be null.");
        else if (userLongitude !== undefined)
            url_ += "userLongitude=" + encodeURIComponent("" + userLongitude) + "&";
        if (clinicsLatitude === null)
            throw new Error("The parameter 'clinicsLatitude' cannot be null.");
        else if (clinicsLatitude !== undefined)
            url_ += "clinicsLatitude=" + encodeURIComponent("" + clinicsLatitude) + "&";
        if (clinicsLongitude === null)
            throw new Error("The parameter 'clinicsLongitude' cannot be null.");
        else if (clinicsLongitude !== undefined)
            url_ += "clinicsLongitude=" + encodeURIComponent("" + clinicsLongitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistanceFromPatientToTreater(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistanceFromPatientToTreater(<any>response_);
                } catch (e) {
                    return <Observable<GoogleDistanceResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoogleDistanceResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetDistanceFromPatientToTreater(response: HttpResponseBase): Observable<GoogleDistanceResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoogleDistanceResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoogleDistanceResultModel>(<any>null);
    }
}

@Injectable()
export class TreatmentProvidersFilterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(patientId?: number | undefined, page?: number | undefined, treatmentTypeId?: number | null | undefined, keyword?: string | null | undefined, isVideoCall?: boolean | undefined): Observable<TreatmentProviderMapLocationDTO[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProvidersFilter/Get?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (treatmentTypeId !== undefined && treatmentTypeId !== null)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isVideoCall === null)
            throw new Error("The parameter 'isVideoCall' cannot be null.");
        else if (isVideoCall !== undefined)
            url_ += "isVideoCall=" + encodeURIComponent("" + isVideoCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderMapLocationDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderMapLocationDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentProviderMapLocationDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderMapLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderMapLocationDTO[]>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<TreatmentProviderStatusModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderStatus/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderStatusModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderStatusModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentProviderStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderStatusModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderStatusModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderTreatmentSpecialtiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderTreatmentSpecialties/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    post(modelBody: TreatmentProviderTreatmentSpecialtyUpdateDTO, modelPath: TreatmentProviderTreatmentSpecialtyUpdateDTO | null): Observable<TreatmentSpecialtyModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderTreatmentSpecialties/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentSpecialtyModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentSpecialtyModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<TreatmentSpecialtyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentSpecialtyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentSpecialtyModel>(<any>null);
    }

    delete(modelBody: TreatmentProviderTreatmentSpecialtyUpdateDTO, modelPath: TreatmentProviderTreatmentSpecialtyUpdateDTO | null): Observable<TreatmentProviderTreatmentSpecialtyUpdateDTO> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderTreatmentSpecialties/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderTreatmentSpecialtyUpdateDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderTreatmentSpecialtyUpdateDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<TreatmentProviderTreatmentSpecialtyUpdateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentProviderTreatmentSpecialtyUpdateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderTreatmentSpecialtyUpdateDTO>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getTreatmentProviderTypes(): Observable<TreatmentProviderTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentProviderTypes/GetTreatmentProviderTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProviderTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProviderTypes(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentProviderTypes(response: HttpResponseBase): Observable<TreatmentProviderTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderTypeModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<TreatmentModel[]> {
        let url_ = this.baseUrl + "/api/v2/Treatments/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentSpecialistsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(treatmentProviderId: number): Observable<TreatmentSpecialistModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentSpecialists/{treatmentProviderId}";
        if (treatmentProviderId === undefined || treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' must be defined.");
        url_ = url_.replace("{treatmentProviderId}", encodeURIComponent("" + treatmentProviderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentSpecialistModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentSpecialistModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentSpecialistModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentSpecialistModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentSpecialistModel[]>(<any>null);
    }

    post(modelBody: TreatmentSpecialistCreateModel, modelPath: TreatmentSpecialistCreateModel | null): Observable<TreatmentSpecialistModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentSpecialists/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentSpecialistModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentSpecialistModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<TreatmentSpecialistModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentSpecialistModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentSpecialistModel>(<any>null);
    }

    put(id: number, modelBody: TreatmentSpecialistEditModel, modelPath: TreatmentSpecialistEditModel | null): Observable<TreatmentSpecialistModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentSpecialists/{id}/{model}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentSpecialistModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentSpecialistModel>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<TreatmentSpecialistModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentSpecialistModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentSpecialistModel>(<any>null);
    }

    delete(id: number, modelBody: TreatmentSpecialistDeleteModel, modelPath: TreatmentSpecialistDeleteModel | null): Observable<TreatmentSpecialistDeleteResponse> {
        let url_ = this.baseUrl + "/api/v2/TreatmentSpecialists/{id}/{model}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentSpecialistDeleteResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentSpecialistDeleteResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<TreatmentSpecialistDeleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentSpecialistDeleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentSpecialistDeleteResponse>(<any>null);
    }
}

@Injectable()
export class TreatmentSpecialtiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<TreatmentSpecialtyModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentSpecialties/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentSpecialtyModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentSpecialtyModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentSpecialtyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentSpecialtyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentSpecialtyModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentSpecialtyTreatmentTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(id: number): Observable<TreatmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentSpecialtyTreatmentTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentTypeModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getTreatmentTypes(patientId?: number | null | undefined): Observable<CompanyTreatmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/GetTreatmentTypes?";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentTypes(<any>response_);
                } catch (e) {
                    return <Observable<CompanyTreatmentTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyTreatmentTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentTypes(response: HttpResponseBase): Observable<CompanyTreatmentTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyTreatmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyTreatmentTypeModel[]>(<any>null);
    }

    getAllTreatmentTypes(keyword?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<TreatmentTypePageModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/GetAllTreatmentTypes?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentTypes(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentTypePageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentTypePageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTreatmentTypes(response: HttpResponseBase): Observable<TreatmentTypePageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentTypePageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentTypePageModel>(<any>null);
    }

    getTreatmentType(id: number): Observable<TreatmentTypeUpdateModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/GetTreatmentType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentType(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentTypeUpdateModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentTypeUpdateModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentType(response: HttpResponseBase): Observable<TreatmentTypeUpdateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentTypeUpdateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentTypeUpdateModel>(<any>null);
    }

    post(treatmentType: TreatmentTypeModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getTreatmentTypesForTreatmentProviders(treatmentProviderIds?: number[] | null | undefined): Observable<TreatmentTypeShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/GetTreatmentTypesForTreatmentProviders?";
        if (treatmentProviderIds !== undefined && treatmentProviderIds !== null)
            treatmentProviderIds && treatmentProviderIds.forEach(item => { url_ += "treatmentProviderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentTypesForTreatmentProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentTypesForTreatmentProviders(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentTypeShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentTypeShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentTypesForTreatmentProviders(response: HttpResponseBase): Observable<TreatmentTypeShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentTypeShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentTypeShortModel[]>(<any>null);
    }

    create(name?: string | null | undefined): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/Create?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    createTreatmentType(model: TreatmentTypeCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/CreateTreatmentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTreatmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTreatmentType(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTreatmentType(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updateTreatmentType(model: TreatmentTypeUpdateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/UpdateTreatmentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTreatmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTreatmentType(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTreatmentType(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    deleteTreatmentType(id: number): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/DeleteTreatmentType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTreatmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTreatmentType(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTreatmentType(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    getTreatmentTypesForSearch(caseRequired?: boolean | undefined, patientId?: number | undefined): Observable<CompanyTreatmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypes/GetTreatmentTypesForSearch?";
        if (caseRequired === null)
            throw new Error("The parameter 'caseRequired' cannot be null.");
        else if (caseRequired !== undefined)
            url_ += "caseRequired=" + encodeURIComponent("" + caseRequired) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentTypesForSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentTypesForSearch(<any>response_);
                } catch (e) {
                    return <Observable<CompanyTreatmentTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyTreatmentTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreatmentTypesForSearch(response: HttpResponseBase): Observable<CompanyTreatmentTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyTreatmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyTreatmentTypeModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentTypesFilterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(keyword: string | null): Observable<TreatmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/v2/TreatmentTypesFilter/{keyword}";
        if (keyword === undefined || keyword === null)
            throw new Error("The parameter 'keyword' must be defined.");
        url_ = url_.replace("{keyword}", encodeURIComponent("" + keyword));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentTypeModel[]>(<any>null);
    }
}

@Injectable()
export class UserConsentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/UserConsent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    accept(patientId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/UserConsent/Accept?";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    decline(model: UserConsentDeclineModel): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/UserConsent/Decline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecline(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDecline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/v2/UserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    patch(model: UpdateUserInfoModel): Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/v2/UserInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatch(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processPatch(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    updateUserLanguage(language?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/UserInfo/UpdateUserLanguage?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getUserInfoByUsername(username?: string | null | undefined): Observable<ConfirmationUserInfoModel> {
        let url_ = this.baseUrl + "/api/v2/UserInfo/GetByEmail?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfoByUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfoByUsername(<any>response_);
                } catch (e) {
                    return <Observable<ConfirmationUserInfoModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfirmationUserInfoModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserInfoByUsername(response: HttpResponseBase): Observable<ConfirmationUserInfoModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmationUserInfoModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmationUserInfoModel>(<any>null);
    }
}

@Injectable()
export class UserProfilePictureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    post(modelBody: UserProfilePictureModel, modelPath: UserProfilePictureModel | null): Observable<any> {
        let url_ = this.baseUrl + "/api/v2/UserProfilePicture/{model}";
        if (modelPath === undefined || modelPath === null)
            throw new Error("The parameter 'modelPath' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + modelPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    delete(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/UserProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(keyword?: string | null | undefined, companyIds?: number[] | null | undefined, roleCode?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<UserPageModel> {
        let url_ = this.baseUrl + "/api/v2/Users/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "companyIds=" + encodeURIComponent("" + item) + "&"; });
        if (roleCode !== undefined && roleCode !== null)
            url_ += "roleCode=" + encodeURIComponent("" + roleCode) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserPageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserPageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPageModel>(<any>null);
    }

    getUser(patientId?: number | undefined, treatmentTypeId?: number | undefined): Observable<UserShortModel> {
        let url_ = this.baseUrl + "/api/v2/Users/GetUser?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (treatmentTypeId === null)
            throw new Error("The parameter 'treatmentTypeId' cannot be null.");
        else if (treatmentTypeId !== undefined)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(<any>response_);
                } catch (e) {
                    return <Observable<UserShortModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserShortModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserShortModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserShortModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserShortModel>(<any>null);
    }

    getAll2(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v2/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll2(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll2(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    get(id: number): Observable<UserShortModel> {
        let url_ = this.baseUrl + "/api/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserShortModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserShortModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserShortModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserShortModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserShortModel>(<any>null);
    }

    put(id: number, value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    createUser(model: UserCreateModel): Observable<ResultModel> {
        let url_ = this.baseUrl + "/api/v2/Users/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(<any>response_);
                } catch (e) {
                    return <Observable<ResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<ResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultModel>(<any>null);
    }

    updateUser(model: UserEditModel): Observable<IdentityResultModel> {
        let url_ = this.baseUrl + "/api/v2/Users/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<IdentityResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<IdentityResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityResultModel>(<any>null);
    }

    confirmUser(model: ConfirmationUserInfoModel): Observable<IdentityResultModel> {
        let url_ = this.baseUrl + "/api/v2/Users/ConfirmUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmUser(<any>response_);
                } catch (e) {
                    return <Observable<IdentityResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmUser(response: HttpResponseBase): Observable<IdentityResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityResultModel>(<any>null);
    }

    checkIfEmailExists(email?: string | null | undefined): Observable<IdentityResultModel> {
        let url_ = this.baseUrl + "/api/v2/Users/CheckIfEmailExists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfEmailExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfEmailExists(<any>response_);
                } catch (e) {
                    return <Observable<IdentityResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentityResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfEmailExists(response: HttpResponseBase): Observable<IdentityResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentityResultModel>(<any>null);
    }
}

@Injectable()
export class UserTreatmentProvidersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    get(): Observable<TreatmentProviderModel[]> {
        let url_ = this.baseUrl + "/api/v2/UserTreatmentProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentProviderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderModel[]>(<any>null);
    }

    autocompleteUsers(keyword?: string | null | undefined): Observable<UserAutoCompleteModel[]> {
        let url_ = this.baseUrl + "/api/v2/UserTreatmentProviders/AutocompleteUsers?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutocompleteUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutocompleteUsers(<any>response_);
                } catch (e) {
                    return <Observable<UserAutoCompleteModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAutoCompleteModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processAutocompleteUsers(response: HttpResponseBase): Observable<UserAutoCompleteModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAutoCompleteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAutoCompleteModel[]>(<any>null);
    }

    lastBookedUsers(): Observable<UserAutoCompleteModel[]> {
        let url_ = this.baseUrl + "/api/v2/UserTreatmentProviders/LastBookedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLastBookedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLastBookedUsers(<any>response_);
                } catch (e) {
                    return <Observable<UserAutoCompleteModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAutoCompleteModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processLastBookedUsers(response: HttpResponseBase): Observable<UserAutoCompleteModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAutoCompleteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAutoCompleteModel[]>(<any>null);
    }

    autocompleteUsersForTP(treatmentProviderId?: number | undefined, keyword?: string | null | undefined): Observable<UserShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/UserTreatmentProviders/AutocompleteUsersForTP?";
        if (treatmentProviderId === null)
            throw new Error("The parameter 'treatmentProviderId' cannot be null.");
        else if (treatmentProviderId !== undefined)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutocompleteUsersForTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutocompleteUsersForTP(<any>response_);
                } catch (e) {
                    return <Observable<UserShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processAutocompleteUsersForTP(response: HttpResponseBase): Observable<UserShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserShortModel[]>(<any>null);
    }

    getUserAutoComplete(id?: number | undefined): Observable<UserAutoCompleteModel> {
        let url_ = this.baseUrl + "/api/v2/UserTreatmentProviders/GetUserAutoComplete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAutoComplete(<any>response_);
                } catch (e) {
                    return <Observable<UserAutoCompleteModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAutoCompleteModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAutoComplete(response: HttpResponseBase): Observable<UserAutoCompleteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAutoCompleteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAutoCompleteModel>(<any>null);
    }

    getSpecialAccessTreatmentProvidersByPatient(patientId?: number | undefined): Observable<TreatmentProviderSelectModel[]> {
        let url_ = this.baseUrl + "/api/v2/UserTreatmentProviders/GetSpecialAccessTreatmentProvidersByPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialAccessTreatmentProvidersByPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialAccessTreatmentProvidersByPatient(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderSelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderSelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialAccessTreatmentProvidersByPatient(response: HttpResponseBase): Observable<TreatmentProviderSelectModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderSelectModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderSelectModel[]>(<any>null);
    }
}

@Injectable()
export class ValuesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v2/Values";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    post(value: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/Values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    get(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/Values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    put(id: number, value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class VideoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getToken(bookingId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/Video/GetToken?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    kickParticipant(roomSid?: string | null | undefined, participantSid?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Video/GetToken?";
        if (roomSid !== undefined && roomSid !== null)
            url_ += "roomSid=" + encodeURIComponent("" + roomSid) + "&";
        if (participantSid !== undefined && participantSid !== null)
            url_ += "participantSid=" + encodeURIComponent("" + participantSid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKickParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKickParticipant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processKickParticipant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getParticipantsInfo(bookingId?: number | undefined): Observable<VideoParticipantModel[]> {
        let url_ = this.baseUrl + "/api/v2/Video/GetParticipantsInfo?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsInfo(<any>response_);
                } catch (e) {
                    return <Observable<VideoParticipantModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VideoParticipantModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetParticipantsInfo(response: HttpResponseBase): Observable<VideoParticipantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoParticipantModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VideoParticipantModel[]>(<any>null);
    }

    getParticipantInfo(bookingId?: number | undefined, participantId?: number | undefined): Observable<VideoParticipantModel> {
        let url_ = this.baseUrl + "/api/v2/Video/GetParticipantInfo?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantInfo(<any>response_);
                } catch (e) {
                    return <Observable<VideoParticipantModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<VideoParticipantModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetParticipantInfo(response: HttpResponseBase): Observable<VideoParticipantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoParticipantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VideoParticipantModel>(<any>null);
    }

    updateParticipantInfo(model: PersonalInfoEditModel): Observable<ParticipantResultModel> {
        let url_ = this.baseUrl + "/api/v2/Video/UpdateParticipantInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParticipantInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParticipantInfo(<any>response_);
                } catch (e) {
                    return <Observable<ParticipantResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ParticipantResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateParticipantInfo(response: HttpResponseBase): Observable<ParticipantResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParticipantResultModel>(<any>null);
    }
}

@Injectable()
export class EmployeeGroupSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(companyId?: number | undefined, keyword?: string | null | undefined): Observable<EmployeeGroupShortDTO[]> {
        let url_ = this.baseUrl + "/api/v2/select/employeeGroups?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<EmployeeGroupShortDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmployeeGroupShortDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmployeeGroupShortDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeGroupShortDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeGroupShortDTO[]>(<any>null);
    }
}

@Injectable()
export class PatientSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(keyword?: string | null | undefined): Observable<UserRefModel[]> {
        let url_ = this.baseUrl + "/api/v2/select/patient?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserRefModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRefModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserRefModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRefModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRefModel[]>(<any>null);
    }
}

@Injectable()
export class ScheduleTypeSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(searchKeyword?: string | null | undefined): Observable<ScheduleTypeDTO[]> {
        let url_ = this.baseUrl + "/api/v2/select/scheduleTypes?";
        if (searchKeyword !== undefined && searchKeyword !== null)
            url_ += "searchKeyword=" + encodeURIComponent("" + searchKeyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleTypeDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleTypeDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ScheduleTypeDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleTypeDTO[]>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderEmployeeSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(keyword?: string | null | undefined, treatmentProviderId?: number | null | undefined, treatmentTypeId?: number | null | undefined, currentAssignmentTPEId?: number | null | undefined): Observable<TreatmentProviderEmployeeShortModel[]> {
        let url_ = this.baseUrl + "/api/v2/select/treatmentProviderEmployees?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (treatmentProviderId !== undefined && treatmentProviderId !== null)
            url_ += "treatmentProviderId=" + encodeURIComponent("" + treatmentProviderId) + "&";
        if (treatmentTypeId !== undefined && treatmentTypeId !== null)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (currentAssignmentTPEId !== undefined && currentAssignmentTPEId !== null)
            url_ += "currentAssignmentTPEId=" + encodeURIComponent("" + currentAssignmentTPEId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderEmployeeShortModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderEmployeeShortModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TreatmentProviderEmployeeShortModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderEmployeeShortModel[]>(<any>null);
    }
}

@Injectable()
export class TreatmentProviderSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(model: TreatmentProviderAssignmentsSelectModel): Observable<TreatmentProviderSelectDTO[]> {
        let url_ = this.baseUrl + "/api/v2/select/treatmentProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderSelectDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderSelectDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TreatmentProviderSelectDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderSelectDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderSelectDTO[]>(<any>null);
    }

    getAllAvailableForPastBooking(searchKeyword?: string | null | undefined, companyId?: number | null | undefined, treatmentTypeId?: number | null | undefined, mustHaveEmployees?: boolean | undefined, withLocation?: boolean | undefined, networkId?: number | null | undefined): Observable<TreatmentProviderAvailableForPastBookingsDTO[]> {
        let url_ = this.baseUrl + "/api/v2/select/treatmentProvidersAvailableForPastBooking?";
        if (searchKeyword !== undefined && searchKeyword !== null)
            url_ += "searchKeyword=" + encodeURIComponent("" + searchKeyword) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (treatmentTypeId !== undefined && treatmentTypeId !== null)
            url_ += "treatmentTypeId=" + encodeURIComponent("" + treatmentTypeId) + "&";
        if (mustHaveEmployees === null)
            throw new Error("The parameter 'mustHaveEmployees' cannot be null.");
        else if (mustHaveEmployees !== undefined)
            url_ += "mustHaveEmployees=" + encodeURIComponent("" + mustHaveEmployees) + "&";
        if (withLocation === null)
            throw new Error("The parameter 'withLocation' cannot be null.");
        else if (withLocation !== undefined)
            url_ += "withLocation=" + encodeURIComponent("" + withLocation) + "&";
        if (networkId !== undefined && networkId !== null)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForPastBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForPastBooking(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentProviderAvailableForPastBookingsDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentProviderAvailableForPastBookingsDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAvailableForPastBooking(response: HttpResponseBase): Observable<TreatmentProviderAvailableForPastBookingsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentProviderAvailableForPastBookingsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentProviderAvailableForPastBookingsDTO[]>(<any>null);
    }
}

@Injectable()
export class TreatmentTypeSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
    }

    getAll(model: TreatmentTypeSelectModel): Observable<TreatmentTypeShortDTO[]> {
        let url_ = this.baseUrl + "/api/v2/select/treatmentTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TreatmentTypeShortDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreatmentTypeShortDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TreatmentTypeShortDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentTypeShortDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreatmentTypeShortDTO[]>(<any>null);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data; 
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class PageModel implements IPageModel {
    keyword?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    sortDirection?: number;
    sortItem?: number;

    constructor(data?: IPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["Keyword"];
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRow = _data["TotalRow"];
            this.sortDirection = _data["SortDirection"];
            this.sortItem = _data["SortItem"];
        }
    }

    static fromJS(data: any): PageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Keyword"] = this.keyword;
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRow"] = this.totalRow;
        data["SortDirection"] = this.sortDirection;
        data["SortItem"] = this.sortItem;
        return data; 
    }

    clone(): PageModel {
        const json = this.toJSON();
        let result = new PageModel();
        result.init(json);
        return result;
    }
}

export interface IPageModel {
    keyword?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    sortDirection?: number;
    sortItem?: number;
}

export class AppointmentSchedulePageModel extends PageModel implements IAppointmentSchedulePageModel {
    appointmentSchedules?: AppointmentScheduleEntryModel[] | undefined;

    constructor(data?: IAppointmentSchedulePageModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["AppointmentSchedules"])) {
                this.appointmentSchedules = [] as any;
                for (let item of _data["AppointmentSchedules"])
                    this.appointmentSchedules!.push(AppointmentScheduleEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppointmentSchedulePageModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSchedulePageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appointmentSchedules)) {
            data["AppointmentSchedules"] = [];
            for (let item of this.appointmentSchedules)
                data["AppointmentSchedules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AppointmentSchedulePageModel {
        const json = this.toJSON();
        let result = new AppointmentSchedulePageModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentSchedulePageModel extends IPageModel {
    appointmentSchedules?: AppointmentScheduleEntryModel[] | undefined;
}

export class AppointmentScheduleEntryModel implements IAppointmentScheduleEntryModel {
    id?: number;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    duration?: number;
    companiesNames?: string[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    treatmentTypeName?: string | undefined;
    scheduleRepetitionPatternEndDate?: moment.Moment | undefined;
    status?: AssignmentStatusModel | undefined;

    constructor(data?: IAppointmentScheduleEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.duration = _data["Duration"];
            if (Array.isArray(_data["CompaniesNames"])) {
                this.companiesNames = [] as any;
                for (let item of _data["CompaniesNames"])
                    this.companiesNames!.push(item);
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.treatmentTypeName = _data["TreatmentTypeName"];
            this.scheduleRepetitionPatternEndDate = _data["ScheduleRepetitionPatternEndDate"] ? moment(_data["ScheduleRepetitionPatternEndDate"].toString()) : <any>undefined;
            this.status = _data["Status"] ? AssignmentStatusModel.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["Duration"] = this.duration;
        if (Array.isArray(this.companiesNames)) {
            data["CompaniesNames"] = [];
            for (let item of this.companiesNames)
                data["CompaniesNames"].push(item);
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["TreatmentTypeName"] = this.treatmentTypeName;
        data["ScheduleRepetitionPatternEndDate"] = this.scheduleRepetitionPatternEndDate ? this.scheduleRepetitionPatternEndDate.toISOString() : <any>undefined;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AppointmentScheduleEntryModel {
        const json = this.toJSON();
        let result = new AppointmentScheduleEntryModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleEntryModel {
    id?: number;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    duration?: number;
    companiesNames?: string[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    treatmentTypeName?: string | undefined;
    scheduleRepetitionPatternEndDate?: moment.Moment | undefined;
    status?: AssignmentStatusModel | undefined;
}

export class TreatmentProviderEmployeeShortModel implements ITreatmentProviderEmployeeShortModel {
    id?: number;
    userId?: number;
    user?: UserRefModel | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    appointmentScheduleEnabled?: boolean;
    currentAssignmentTPEId?: number | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    priority?: number;

    constructor(data?: ITreatmentProviderEmployeeShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserRefModel.fromJS(_data["User"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProviderName = _data["TreatmentProviderName"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
            this.currentAssignmentTPEId = _data["CurrentAssignmentTPEId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
            this.priority = _data["Priority"];
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeeShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeeShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        data["CurrentAssignmentTPEId"] = this.currentAssignmentTPEId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["Priority"] = this.priority;
        return data; 
    }

    clone(): TreatmentProviderEmployeeShortModel {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeeShortModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeeShortModel {
    id?: number;
    userId?: number;
    user?: UserRefModel | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    appointmentScheduleEnabled?: boolean;
    currentAssignmentTPEId?: number | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    priority?: number;
}

export class UserRefModel implements IUserRefModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    profilePicture?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserRefModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.profilePicture = _data["ProfilePicture"];
            this.phoneNumber = _data["PhoneNumber"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): UserRefModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRefModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["ProfilePicture"] = this.profilePicture;
        data["PhoneNumber"] = this.phoneNumber;
        data["Email"] = this.email;
        return data; 
    }

    clone(): UserRefModel {
        const json = this.toJSON();
        let result = new UserRefModel();
        result.init(json);
        return result;
    }
}

export interface IUserRefModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    profilePicture?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export class TreatmentTypeShortModel implements ITreatmentTypeShortModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    icon?: string | undefined;
    defaultPhoto?: string | undefined;
    isVideoCall?: boolean;

    constructor(data?: ITreatmentTypeShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.icon = _data["Icon"];
            this.defaultPhoto = _data["DefaultPhoto"];
            this.isVideoCall = _data["IsVideoCall"];
        }
    }

    static fromJS(data: any): TreatmentTypeShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["Icon"] = this.icon;
        data["DefaultPhoto"] = this.defaultPhoto;
        data["IsVideoCall"] = this.isVideoCall;
        return data; 
    }

    clone(): TreatmentTypeShortModel {
        const json = this.toJSON();
        let result = new TreatmentTypeShortModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeShortModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    icon?: string | undefined;
    defaultPhoto?: string | undefined;
    isVideoCall?: boolean;
}

export class AssignmentStatusModel implements IAssignmentStatusModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;

    constructor(data?: IAssignmentStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.colorCode = _data["ColorCode"];
        }
    }

    static fromJS(data: any): AssignmentStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["ColorCode"] = this.colorCode;
        return data; 
    }

    clone(): AssignmentStatusModel {
        const json = this.toJSON();
        let result = new AssignmentStatusModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentStatusModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
}

export class GetAppointmentSchedulesFilterModel implements IGetAppointmentSchedulesFilterModel {
    appointmentScheduleId?: number | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    companyId?: number | undefined;
    treatmentProviderEmployeeId?: number | undefined;
    treatmentTypeId?: number | undefined;
    treatmentProviderId?: number | undefined;
    locationId?: number | undefined;
    statusId?: number | undefined;

    constructor(data?: IGetAppointmentSchedulesFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.companyId = _data["CompanyId"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.locationId = _data["LocationId"];
            this.statusId = _data["StatusId"];
        }
    }

    static fromJS(data: any): GetAppointmentSchedulesFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentSchedulesFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["CompanyId"] = this.companyId;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["LocationId"] = this.locationId;
        data["StatusId"] = this.statusId;
        return data; 
    }

    clone(): GetAppointmentSchedulesFilterModel {
        const json = this.toJSON();
        let result = new GetAppointmentSchedulesFilterModel();
        result.init(json);
        return result;
    }
}

export interface IGetAppointmentSchedulesFilterModel {
    appointmentScheduleId?: number | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    companyId?: number | undefined;
    treatmentProviderEmployeeId?: number | undefined;
    treatmentTypeId?: number | undefined;
    treatmentProviderId?: number | undefined;
    locationId?: number | undefined;
    statusId?: number | undefined;
}

export class ResultModel implements IResultModel {
    entityResults?: EntityResultModel[] | undefined;
    succeeded?: boolean;
    status?: string | undefined;
    statusCode?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["EntityResults"])) {
                this.entityResults = [] as any;
                for (let item of _data["EntityResults"])
                    this.entityResults!.push(EntityResultModel.fromJS(item));
            }
            this.succeeded = _data["Succeeded"];
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.errorMessage = _data["ErrorMessage"];
            this.errorCode = _data["ErrorCode"];
        }
    }

    static fromJS(data: any): ResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entityResults)) {
            data["EntityResults"] = [];
            for (let item of this.entityResults)
                data["EntityResults"].push(item.toJSON());
        }
        data["Succeeded"] = this.succeeded;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ErrorMessage"] = this.errorMessage;
        data["ErrorCode"] = this.errorCode;
        return data; 
    }

    clone(): ResultModel {
        const json = this.toJSON();
        let result = new ResultModel();
        result.init(json);
        return result;
    }
}

export interface IResultModel {
    entityResults?: EntityResultModel[] | undefined;
    succeeded?: boolean;
    status?: string | undefined;
    statusCode?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export class EntityResultModel implements IEntityResultModel {
    id?: string | undefined;
    externalReferenceId?: string | undefined;
    entityType?: string | undefined;
    operation?: string | undefined;

    constructor(data?: IEntityResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.entityType = _data["EntityType"];
            this.operation = _data["Operation"];
        }
    }

    static fromJS(data: any): EntityResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntityResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["EntityType"] = this.entityType;
        data["Operation"] = this.operation;
        return data; 
    }

    clone(): EntityResultModel {
        const json = this.toJSON();
        let result = new EntityResultModel();
        result.init(json);
        return result;
    }
}

export interface IEntityResultModel {
    id?: string | undefined;
    externalReferenceId?: string | undefined;
    entityType?: string | undefined;
    operation?: string | undefined;
}

export class AppointmentScheduleCreateModel implements IAppointmentScheduleCreateModel {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    scheduleExceptions?: AppointmentScheduleExceptionUpdateModel[] | undefined;
    locationId?: number | undefined;
    companies?: CompanySelectDTO[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    roomId?: number | undefined;
    treatmentProviderId?: number;
    treatmentTypeId?: number;
    groupTreatment?: boolean;
    inhouse?: boolean;
    isVideoCallAvailable?: boolean;
    userId?: number;
    appointmentScheduleBatchId?: string | undefined;

    constructor(data?: IAppointmentScheduleCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleModel.fromJS(item));
            }
            this.duration = _data["Duration"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.maxDaysInAdvanceCanBeBooked = _data["MaxDaysInAdvanceCanBeBooked"];
            this.minHoursBeforeScheduleStartCanBeBooked = _data["MinHoursBeforeScheduleStartCanBeBooked"];
            this.bufferTimeBetweenSlotsInMinutes = _data["BufferTimeBetweenSlotsInMinutes"];
            this.bookableEveryInMinutes = _data["BookableEveryInMinutes"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(AppointmentScheduleExceptionUpdateModel.fromJS(item));
            }
            this.locationId = _data["LocationId"];
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanySelectDTO.fromJS(item));
            }
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternModel.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            this.roomId = _data["RoomId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.groupTreatment = _data["GroupTreatment"];
            this.inhouse = _data["Inhouse"];
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
            this.userId = _data["UserId"];
            this.appointmentScheduleBatchId = _data["AppointmentScheduleBatchId"];
        }
    }

    static fromJS(data: any): AppointmentScheduleCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["Duration"] = this.duration;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["MaxDaysInAdvanceCanBeBooked"] = this.maxDaysInAdvanceCanBeBooked;
        data["MinHoursBeforeScheduleStartCanBeBooked"] = this.minHoursBeforeScheduleStartCanBeBooked;
        data["BufferTimeBetweenSlotsInMinutes"] = this.bufferTimeBetweenSlotsInMinutes;
        data["BookableEveryInMinutes"] = this.bookableEveryInMinutes;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["LocationId"] = this.locationId;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        data["RoomId"] = this.roomId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["GroupTreatment"] = this.groupTreatment;
        data["Inhouse"] = this.inhouse;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        data["UserId"] = this.userId;
        data["AppointmentScheduleBatchId"] = this.appointmentScheduleBatchId;
        return data; 
    }

    clone(): AppointmentScheduleCreateModel {
        const json = this.toJSON();
        let result = new AppointmentScheduleCreateModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleCreateModel {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    scheduleExceptions?: AppointmentScheduleExceptionUpdateModel[] | undefined;
    locationId?: number | undefined;
    companies?: CompanySelectDTO[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    roomId?: number | undefined;
    treatmentProviderId?: number;
    treatmentTypeId?: number;
    groupTreatment?: boolean;
    inhouse?: boolean;
    isVideoCallAvailable?: boolean;
    userId?: number;
    appointmentScheduleBatchId?: string | undefined;
}

export class DailyScheduleModel implements IDailyScheduleModel {
    id?: number;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    active?: boolean;
    appointmentScheduleId?: number | undefined;
    scheduleExceptionId?: number | undefined;

    constructor(data?: IDailyScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.dayOfWeek = _data["DayOfWeek"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.active = _data["Active"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.scheduleExceptionId = _data["ScheduleExceptionId"];
        }
    }

    static fromJS(data: any): DailyScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DayOfWeek"] = this.dayOfWeek;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["Active"] = this.active;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["ScheduleExceptionId"] = this.scheduleExceptionId;
        return data; 
    }

    clone(): DailyScheduleModel {
        const json = this.toJSON();
        let result = new DailyScheduleModel();
        result.init(json);
        return result;
    }
}

export interface IDailyScheduleModel {
    id?: number;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    active?: boolean;
    appointmentScheduleId?: number | undefined;
    scheduleExceptionId?: number | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class AppointmentScheduleExceptionCreateModel implements IAppointmentScheduleExceptionCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    scheduleType?: ScheduleTypeModel | undefined;
    scheduleTypeId?: number;
    appointmentScheduleId?: number;
    fullDay?: boolean;
    isRepeating?: boolean;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;

    constructor(data?: IAppointmentScheduleExceptionCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleModel.fromJS(item));
            }
            this.scheduleType = _data["ScheduleType"] ? ScheduleTypeModel.fromJS(_data["ScheduleType"]) : <any>undefined;
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.fullDay = _data["FullDay"];
            this.isRepeating = _data["IsRepeating"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternModel.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleExceptionCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleExceptionCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["FullDay"] = this.fullDay;
        data["IsRepeating"] = this.isRepeating;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AppointmentScheduleExceptionCreateModel {
        const json = this.toJSON();
        let result = new AppointmentScheduleExceptionCreateModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleExceptionCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    scheduleType?: ScheduleTypeModel | undefined;
    scheduleTypeId?: number;
    appointmentScheduleId?: number;
    fullDay?: boolean;
    isRepeating?: boolean;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
}

export class AppointmentScheduleExceptionUpdateModel extends AppointmentScheduleExceptionCreateModel implements IAppointmentScheduleExceptionUpdateModel {
    id?: number;

    constructor(data?: IAppointmentScheduleExceptionUpdateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): AppointmentScheduleExceptionUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleExceptionUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data; 
    }

    clone(): AppointmentScheduleExceptionUpdateModel {
        const json = this.toJSON();
        let result = new AppointmentScheduleExceptionUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleExceptionUpdateModel extends IAppointmentScheduleExceptionCreateModel {
    id?: number;
}

export class ScheduleTypeModel implements IScheduleTypeModel {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;

    constructor(data?: IScheduleTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.color = _data["Color"];
        }
    }

    static fromJS(data: any): ScheduleTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Color"] = this.color;
        return data; 
    }

    clone(): ScheduleTypeModel {
        const json = this.toJSON();
        let result = new ScheduleTypeModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleTypeModel {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
}

export class ScheduleRepetitionPatternModel implements IScheduleRepetitionPatternModel {
    id?: number;
    maximumOccurances?: number | undefined;
    separationCount?: number;
    dayOfWeek?: number | undefined;
    weekOfMonth?: number | undefined;
    dayOfMonth?: number | undefined;
    monthOfYear?: number | undefined;
    endDate?: moment.Moment | undefined;
    scheduleRepetitionPatternTypeId?: number;
    scheduleRepetitionPatternType?: ScheduleRepetitionPatternTypeModel | undefined;

    constructor(data?: IScheduleRepetitionPatternModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.maximumOccurances = _data["MaximumOccurances"];
            this.separationCount = _data["SeparationCount"];
            this.dayOfWeek = _data["DayOfWeek"];
            this.weekOfMonth = _data["WeekOfMonth"];
            this.dayOfMonth = _data["DayOfMonth"];
            this.monthOfYear = _data["MonthOfYear"];
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.scheduleRepetitionPatternTypeId = _data["ScheduleRepetitionPatternTypeId"];
            this.scheduleRepetitionPatternType = _data["ScheduleRepetitionPatternType"] ? ScheduleRepetitionPatternTypeModel.fromJS(_data["ScheduleRepetitionPatternType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleRepetitionPatternModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleRepetitionPatternModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MaximumOccurances"] = this.maximumOccurances;
        data["SeparationCount"] = this.separationCount;
        data["DayOfWeek"] = this.dayOfWeek;
        data["WeekOfMonth"] = this.weekOfMonth;
        data["DayOfMonth"] = this.dayOfMonth;
        data["MonthOfYear"] = this.monthOfYear;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ScheduleRepetitionPatternTypeId"] = this.scheduleRepetitionPatternTypeId;
        data["ScheduleRepetitionPatternType"] = this.scheduleRepetitionPatternType ? this.scheduleRepetitionPatternType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ScheduleRepetitionPatternModel {
        const json = this.toJSON();
        let result = new ScheduleRepetitionPatternModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleRepetitionPatternModel {
    id?: number;
    maximumOccurances?: number | undefined;
    separationCount?: number;
    dayOfWeek?: number | undefined;
    weekOfMonth?: number | undefined;
    dayOfMonth?: number | undefined;
    monthOfYear?: number | undefined;
    endDate?: moment.Moment | undefined;
    scheduleRepetitionPatternTypeId?: number;
    scheduleRepetitionPatternType?: ScheduleRepetitionPatternTypeModel | undefined;
}

export class ScheduleRepetitionPatternTypeModel implements IScheduleRepetitionPatternTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;

    constructor(data?: IScheduleRepetitionPatternTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
        }
    }

    static fromJS(data: any): ScheduleRepetitionPatternTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleRepetitionPatternTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        return data; 
    }

    clone(): ScheduleRepetitionPatternTypeModel {
        const json = this.toJSON();
        let result = new ScheduleRepetitionPatternTypeModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleRepetitionPatternTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
}

export class CompanySelectDTO implements ICompanySelectDTO {
    id?: number;
    name?: string | undefined;
    cVR?: string | undefined;

    constructor(data?: ICompanySelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.cVR = _data["CVR"];
        }
    }

    static fromJS(data: any): CompanySelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CVR"] = this.cVR;
        return data; 
    }

    clone(): CompanySelectDTO {
        const json = this.toJSON();
        let result = new CompanySelectDTO();
        result.init(json);
        return result;
    }
}

export interface ICompanySelectDTO {
    id?: number;
    name?: string | undefined;
    cVR?: string | undefined;
}

export class AppointmentScheduleUpdateModel extends AppointmentScheduleCreateModel implements IAppointmentScheduleUpdateModel {
    id?: number;
    treatmentProvider?: TreatmentProviderSelectDTO | undefined;
    treatmentType?: TreatmentTypeShortModel | undefined;

    constructor(data?: IAppointmentScheduleUpdateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProviderSelectDTO.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppointmentScheduleUpdateModel {
        const json = this.toJSON();
        let result = new AppointmentScheduleUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleUpdateModel extends IAppointmentScheduleCreateModel {
    id?: number;
    treatmentProvider?: TreatmentProviderSelectDTO | undefined;
    treatmentType?: TreatmentTypeShortModel | undefined;
}

export class TreatmentProviderSelectDTO implements ITreatmentProviderSelectDTO {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    onlyInhouse?: boolean;
    clinicProfileEnabled?: boolean;
    appointmentScheduleEnabled?: boolean;
    clinicProfileUrl?: string | undefined;

    constructor(data?: ITreatmentProviderSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.onlyInhouse = _data["OnlyInhouse"];
            this.clinicProfileEnabled = _data["ClinicProfileEnabled"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
            this.clinicProfileUrl = _data["ClinicProfileUrl"];
        }
    }

    static fromJS(data: any): TreatmentProviderSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["OnlyInhouse"] = this.onlyInhouse;
        data["ClinicProfileEnabled"] = this.clinicProfileEnabled;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        data["ClinicProfileUrl"] = this.clinicProfileUrl;
        return data; 
    }

    clone(): TreatmentProviderSelectDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderSelectDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderSelectDTO {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    onlyInhouse?: boolean;
    clinicProfileEnabled?: boolean;
    appointmentScheduleEnabled?: boolean;
    clinicProfileUrl?: string | undefined;
}

export class GetSlotsModel implements IGetSlotsModel {
    queryStart?: moment.Moment | undefined;
    queryEnd?: moment.Moment | undefined;
    treatmentProviderEmployeeIds?: number[] | undefined;
    treatmentProviderIds?: number[] | undefined;
    companyIds?: number[] | undefined;
    treatmentTypeIds?: number[] | undefined;
    bookingStatusIds?: number[] | undefined;
    patientIds?: number[] | undefined;
    locationId?: number | undefined;
    appointmentScheduleIds?: number[] | undefined;
    durations?: number[] | undefined;
    includeBookings?: boolean;

    constructor(data?: IGetSlotsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queryStart = _data["QueryStart"] ? moment(_data["QueryStart"].toString()) : <any>undefined;
            this.queryEnd = _data["QueryEnd"] ? moment(_data["QueryEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["TreatmentProviderEmployeeIds"])) {
                this.treatmentProviderEmployeeIds = [] as any;
                for (let item of _data["TreatmentProviderEmployeeIds"])
                    this.treatmentProviderEmployeeIds!.push(item);
            }
            if (Array.isArray(_data["TreatmentProviderIds"])) {
                this.treatmentProviderIds = [] as any;
                for (let item of _data["TreatmentProviderIds"])
                    this.treatmentProviderIds!.push(item);
            }
            if (Array.isArray(_data["CompanyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["CompanyIds"])
                    this.companyIds!.push(item);
            }
            if (Array.isArray(_data["TreatmentTypeIds"])) {
                this.treatmentTypeIds = [] as any;
                for (let item of _data["TreatmentTypeIds"])
                    this.treatmentTypeIds!.push(item);
            }
            if (Array.isArray(_data["BookingStatusIds"])) {
                this.bookingStatusIds = [] as any;
                for (let item of _data["BookingStatusIds"])
                    this.bookingStatusIds!.push(item);
            }
            if (Array.isArray(_data["PatientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["PatientIds"])
                    this.patientIds!.push(item);
            }
            this.locationId = _data["LocationId"];
            if (Array.isArray(_data["AppointmentScheduleIds"])) {
                this.appointmentScheduleIds = [] as any;
                for (let item of _data["AppointmentScheduleIds"])
                    this.appointmentScheduleIds!.push(item);
            }
            if (Array.isArray(_data["Durations"])) {
                this.durations = [] as any;
                for (let item of _data["Durations"])
                    this.durations!.push(item);
            }
            this.includeBookings = _data["IncludeBookings"];
        }
    }

    static fromJS(data: any): GetSlotsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlotsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QueryStart"] = this.queryStart ? this.queryStart.toISOString() : <any>undefined;
        data["QueryEnd"] = this.queryEnd ? this.queryEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.treatmentProviderEmployeeIds)) {
            data["TreatmentProviderEmployeeIds"] = [];
            for (let item of this.treatmentProviderEmployeeIds)
                data["TreatmentProviderEmployeeIds"].push(item);
        }
        if (Array.isArray(this.treatmentProviderIds)) {
            data["TreatmentProviderIds"] = [];
            for (let item of this.treatmentProviderIds)
                data["TreatmentProviderIds"].push(item);
        }
        if (Array.isArray(this.companyIds)) {
            data["CompanyIds"] = [];
            for (let item of this.companyIds)
                data["CompanyIds"].push(item);
        }
        if (Array.isArray(this.treatmentTypeIds)) {
            data["TreatmentTypeIds"] = [];
            for (let item of this.treatmentTypeIds)
                data["TreatmentTypeIds"].push(item);
        }
        if (Array.isArray(this.bookingStatusIds)) {
            data["BookingStatusIds"] = [];
            for (let item of this.bookingStatusIds)
                data["BookingStatusIds"].push(item);
        }
        if (Array.isArray(this.patientIds)) {
            data["PatientIds"] = [];
            for (let item of this.patientIds)
                data["PatientIds"].push(item);
        }
        data["LocationId"] = this.locationId;
        if (Array.isArray(this.appointmentScheduleIds)) {
            data["AppointmentScheduleIds"] = [];
            for (let item of this.appointmentScheduleIds)
                data["AppointmentScheduleIds"].push(item);
        }
        if (Array.isArray(this.durations)) {
            data["Durations"] = [];
            for (let item of this.durations)
                data["Durations"].push(item);
        }
        data["IncludeBookings"] = this.includeBookings;
        return data; 
    }

    clone(): GetSlotsModel {
        const json = this.toJSON();
        let result = new GetSlotsModel();
        result.init(json);
        return result;
    }
}

export interface IGetSlotsModel {
    queryStart?: moment.Moment | undefined;
    queryEnd?: moment.Moment | undefined;
    treatmentProviderEmployeeIds?: number[] | undefined;
    treatmentProviderIds?: number[] | undefined;
    companyIds?: number[] | undefined;
    treatmentTypeIds?: number[] | undefined;
    bookingStatusIds?: number[] | undefined;
    patientIds?: number[] | undefined;
    locationId?: number | undefined;
    appointmentScheduleIds?: number[] | undefined;
    durations?: number[] | undefined;
    includeBookings?: boolean;
}

export class SlotModel implements ISlotModel {
    date?: moment.Moment;
    startTime?: string;
    endTime?: string;
    appointmentScheduleId?: number;
    isVideoCallAvailable?: boolean;
    groupTreatment?: boolean;
    numberOfBookings?: number;
    numberOfParticipants?: number;
    treatmentType?: string | undefined;
    tPEFullName?: string | undefined;
    treatmentProviderName?: string | undefined;
    canRepeat?: boolean;
    isAvailable?: boolean;
    bookings?: CalendarItemBookingModel[] | undefined;

    constructor(data?: ISlotModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
            this.groupTreatment = _data["GroupTreatment"];
            this.numberOfBookings = _data["NumberOfBookings"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.treatmentType = _data["TreatmentType"];
            this.tPEFullName = _data["TPEFullName"];
            this.treatmentProviderName = _data["TreatmentProviderName"];
            this.canRepeat = _data["CanRepeat"];
            this.isAvailable = _data["IsAvailable"];
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(CalendarItemBookingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlotModel {
        data = typeof data === 'object' ? data : {};
        let result = new SlotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        data["GroupTreatment"] = this.groupTreatment;
        data["NumberOfBookings"] = this.numberOfBookings;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["TreatmentType"] = this.treatmentType;
        data["TPEFullName"] = this.tPEFullName;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        data["CanRepeat"] = this.canRepeat;
        data["IsAvailable"] = this.isAvailable;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SlotModel {
        const json = this.toJSON();
        let result = new SlotModel();
        result.init(json);
        return result;
    }
}

export interface ISlotModel {
    date?: moment.Moment;
    startTime?: string;
    endTime?: string;
    appointmentScheduleId?: number;
    isVideoCallAvailable?: boolean;
    groupTreatment?: boolean;
    numberOfBookings?: number;
    numberOfParticipants?: number;
    treatmentType?: string | undefined;
    tPEFullName?: string | undefined;
    treatmentProviderName?: string | undefined;
    canRepeat?: boolean;
    isAvailable?: boolean;
    bookings?: CalendarItemBookingModel[] | undefined;
}

export class CalendarItemBookingModel implements ICalendarItemBookingModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    patientName?: string | undefined;
    patientId?: number;
    bookingStatusId?: number;
    bookingStatus?: BookingStatusModel | undefined;
    groupTreatment?: boolean;

    constructor(data?: ICalendarItemBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.patientName = _data["PatientName"];
            this.patientId = _data["PatientId"];
            this.bookingStatusId = _data["BookingStatusId"];
            this.bookingStatus = _data["BookingStatus"] ? BookingStatusModel.fromJS(_data["BookingStatus"]) : <any>undefined;
            this.groupTreatment = _data["GroupTreatment"];
        }
    }

    static fromJS(data: any): CalendarItemBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarItemBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["PatientName"] = this.patientName;
        data["PatientId"] = this.patientId;
        data["BookingStatusId"] = this.bookingStatusId;
        data["BookingStatus"] = this.bookingStatus ? this.bookingStatus.toJSON() : <any>undefined;
        data["GroupTreatment"] = this.groupTreatment;
        return data; 
    }

    clone(): CalendarItemBookingModel {
        const json = this.toJSON();
        let result = new CalendarItemBookingModel();
        result.init(json);
        return result;
    }
}

export interface ICalendarItemBookingModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    patientName?: string | undefined;
    patientId?: number;
    bookingStatusId?: number;
    bookingStatus?: BookingStatusModel | undefined;
    groupTreatment?: boolean;
}

export class BaseEntityModel implements IBaseEntityModel {
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;

    constructor(data?: IBaseEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): BaseEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): BaseEntityModel {
        const json = this.toJSON();
        let result = new BaseEntityModel();
        result.init(json);
        return result;
    }
}

export interface IBaseEntityModel {
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
}

export class BookingStatusModel extends BaseEntityModel implements IBookingStatusModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;

    constructor(data?: IBookingStatusModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.colorCode = _data["ColorCode"];
        }
    }

    static fromJS(data: any): BookingStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["ColorCode"] = this.colorCode;
        super.toJSON(data);
        return data; 
    }

    clone(): BookingStatusModel {
        const json = this.toJSON();
        let result = new BookingStatusModel();
        result.init(json);
        return result;
    }
}

export interface IBookingStatusModel extends IBaseEntityModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
}

export class AppointmentScheduleBatchDTO implements IAppointmentScheduleBatchDTO {
    id?: string;
    userId?: number;
    isFinalized?: boolean;
    createdAt?: moment.Moment;

    constructor(data?: IAppointmentScheduleBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.isFinalized = _data["IsFinalized"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["IsFinalized"] = this.isFinalized;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }

    clone(): AppointmentScheduleBatchDTO {
        const json = this.toJSON();
        let result = new AppointmentScheduleBatchDTO();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleBatchDTO {
    id?: string;
    userId?: number;
    isFinalized?: boolean;
    createdAt?: moment.Moment;
}

export class AppointmentScheduleCreateDTO implements IAppointmentScheduleCreateDTO {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailyScheduleDTO[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortDTO[] | undefined;
    scheduleExceptions?: AppointmentScheduleExceptionUpdateDTO[] | undefined;
    locationId?: number | undefined;
    companies?: CompanySelectDTO[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternDTO | undefined;
    roomId?: number | undefined;
    treatmentProviderId?: number;
    treatmentTypeId?: number;
    groupTreatment?: boolean;
    inhouse?: boolean;
    isVideoCallAvailable?: boolean;
    userId?: number;
    appointmentScheduleBatchId?: string | undefined;

    constructor(data?: IAppointmentScheduleCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleDTO.fromJS(item));
            }
            this.duration = _data["Duration"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.maxDaysInAdvanceCanBeBooked = _data["MaxDaysInAdvanceCanBeBooked"];
            this.minHoursBeforeScheduleStartCanBeBooked = _data["MinHoursBeforeScheduleStartCanBeBooked"];
            this.bufferTimeBetweenSlotsInMinutes = _data["BufferTimeBetweenSlotsInMinutes"];
            this.bookableEveryInMinutes = _data["BookableEveryInMinutes"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortDTO.fromJS(item));
            }
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(AppointmentScheduleExceptionUpdateDTO.fromJS(item));
            }
            this.locationId = _data["LocationId"];
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanySelectDTO.fromJS(item));
            }
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternDTO.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            this.roomId = _data["RoomId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.groupTreatment = _data["GroupTreatment"];
            this.inhouse = _data["Inhouse"];
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
            this.userId = _data["UserId"];
            this.appointmentScheduleBatchId = _data["AppointmentScheduleBatchId"];
        }
    }

    static fromJS(data: any): AppointmentScheduleCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["Duration"] = this.duration;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["MaxDaysInAdvanceCanBeBooked"] = this.maxDaysInAdvanceCanBeBooked;
        data["MinHoursBeforeScheduleStartCanBeBooked"] = this.minHoursBeforeScheduleStartCanBeBooked;
        data["BufferTimeBetweenSlotsInMinutes"] = this.bufferTimeBetweenSlotsInMinutes;
        data["BookableEveryInMinutes"] = this.bookableEveryInMinutes;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["LocationId"] = this.locationId;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        data["RoomId"] = this.roomId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["GroupTreatment"] = this.groupTreatment;
        data["Inhouse"] = this.inhouse;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        data["UserId"] = this.userId;
        data["AppointmentScheduleBatchId"] = this.appointmentScheduleBatchId;
        return data; 
    }

    clone(): AppointmentScheduleCreateDTO {
        const json = this.toJSON();
        let result = new AppointmentScheduleCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleCreateDTO {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailyScheduleDTO[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortDTO[] | undefined;
    scheduleExceptions?: AppointmentScheduleExceptionUpdateDTO[] | undefined;
    locationId?: number | undefined;
    companies?: CompanySelectDTO[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternDTO | undefined;
    roomId?: number | undefined;
    treatmentProviderId?: number;
    treatmentTypeId?: number;
    groupTreatment?: boolean;
    inhouse?: boolean;
    isVideoCallAvailable?: boolean;
    userId?: number;
    appointmentScheduleBatchId?: string | undefined;
}

export class AppointmentScheduleUpdateDTO extends AppointmentScheduleCreateDTO implements IAppointmentScheduleUpdateDTO {
    id?: number;
    treatmentProvider?: TreatmentProviderSelectDTO | undefined;
    treatmentType?: TreatmentTypeShortDTO | undefined;

    constructor(data?: IAppointmentScheduleUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProviderSelectDTO.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortDTO.fromJS(_data["TreatmentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppointmentScheduleUpdateDTO {
        const json = this.toJSON();
        let result = new AppointmentScheduleUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleUpdateDTO extends IAppointmentScheduleCreateDTO {
    id?: number;
    treatmentProvider?: TreatmentProviderSelectDTO | undefined;
    treatmentType?: TreatmentTypeShortDTO | undefined;
}

export class TreatmentTypeShortDTO implements ITreatmentTypeShortDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    icon?: string | undefined;
    defaultPhoto?: string | undefined;
    isVideoCall?: boolean;

    constructor(data?: ITreatmentTypeShortDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.icon = _data["Icon"];
            this.defaultPhoto = _data["DefaultPhoto"];
            this.isVideoCall = _data["IsVideoCall"];
        }
    }

    static fromJS(data: any): TreatmentTypeShortDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeShortDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["Icon"] = this.icon;
        data["DefaultPhoto"] = this.defaultPhoto;
        data["IsVideoCall"] = this.isVideoCall;
        return data; 
    }

    clone(): TreatmentTypeShortDTO {
        const json = this.toJSON();
        let result = new TreatmentTypeShortDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeShortDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    icon?: string | undefined;
    defaultPhoto?: string | undefined;
    isVideoCall?: boolean;
}

export class DailyScheduleDTO implements IDailyScheduleDTO {
    id?: number;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    appointmentScheduleId?: number | undefined;
    scheduleExceptionId?: number | undefined;

    constructor(data?: IDailyScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.dayOfWeek = _data["DayOfWeek"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.scheduleExceptionId = _data["ScheduleExceptionId"];
        }
    }

    static fromJS(data: any): DailyScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DayOfWeek"] = this.dayOfWeek;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["ScheduleExceptionId"] = this.scheduleExceptionId;
        return data; 
    }

    clone(): DailyScheduleDTO {
        const json = this.toJSON();
        let result = new DailyScheduleDTO();
        result.init(json);
        return result;
    }
}

export interface IDailyScheduleDTO {
    id?: number;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    appointmentScheduleId?: number | undefined;
    scheduleExceptionId?: number | undefined;
}

export class TreatmentProviderEmployeeShortDTO implements ITreatmentProviderEmployeeShortDTO {
    id?: number;
    userId?: number;
    user?: UserRefDTO | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    appointmentScheduleEnabled?: boolean;
    currentAssignmentTPEId?: number | undefined;
    treatmentTypes?: TreatmentTypeShortDTO[] | undefined;
    priority?: number;

    constructor(data?: ITreatmentProviderEmployeeShortDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserRefDTO.fromJS(_data["User"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProviderName = _data["TreatmentProviderName"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
            this.currentAssignmentTPEId = _data["CurrentAssignmentTPEId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortDTO.fromJS(item));
            }
            this.priority = _data["Priority"];
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeeShortDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeeShortDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        data["CurrentAssignmentTPEId"] = this.currentAssignmentTPEId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["Priority"] = this.priority;
        return data; 
    }

    clone(): TreatmentProviderEmployeeShortDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeeShortDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeeShortDTO {
    id?: number;
    userId?: number;
    user?: UserRefDTO | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    appointmentScheduleEnabled?: boolean;
    currentAssignmentTPEId?: number | undefined;
    treatmentTypes?: TreatmentTypeShortDTO[] | undefined;
    priority?: number;
}

export class UserRefDTO implements IUserRefDTO {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    profilePicture?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserRefDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.profilePicture = _data["ProfilePicture"];
            this.phoneNumber = _data["PhoneNumber"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): UserRefDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserRefDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["ProfilePicture"] = this.profilePicture;
        data["PhoneNumber"] = this.phoneNumber;
        data["Email"] = this.email;
        return data; 
    }

    clone(): UserRefDTO {
        const json = this.toJSON();
        let result = new UserRefDTO();
        result.init(json);
        return result;
    }
}

export interface IUserRefDTO {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    profilePicture?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export class AppointmentScheduleExceptionCreateDTO implements IAppointmentScheduleExceptionCreateDTO {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailyScheduleDTO[] | undefined;
    scheduleTypeId?: number;
    scheduleType?: ScheduleTypeDTO | undefined;
    appointmentScheduleId?: number | undefined;
    fullDay?: boolean;
    isRepeating?: boolean;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternDTO | undefined;

    constructor(data?: IAppointmentScheduleExceptionCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleDTO.fromJS(item));
            }
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.scheduleType = _data["ScheduleType"] ? ScheduleTypeDTO.fromJS(_data["ScheduleType"]) : <any>undefined;
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.fullDay = _data["FullDay"];
            this.isRepeating = _data["IsRepeating"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternDTO.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleExceptionCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleExceptionCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["FullDay"] = this.fullDay;
        data["IsRepeating"] = this.isRepeating;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AppointmentScheduleExceptionCreateDTO {
        const json = this.toJSON();
        let result = new AppointmentScheduleExceptionCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleExceptionCreateDTO {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailyScheduleDTO[] | undefined;
    scheduleTypeId?: number;
    scheduleType?: ScheduleTypeDTO | undefined;
    appointmentScheduleId?: number | undefined;
    fullDay?: boolean;
    isRepeating?: boolean;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternDTO | undefined;
}

export class AppointmentScheduleExceptionUpdateDTO extends AppointmentScheduleExceptionCreateDTO implements IAppointmentScheduleExceptionUpdateDTO {
    id?: number;

    constructor(data?: IAppointmentScheduleExceptionUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): AppointmentScheduleExceptionUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleExceptionUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data; 
    }

    clone(): AppointmentScheduleExceptionUpdateDTO {
        const json = this.toJSON();
        let result = new AppointmentScheduleExceptionUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleExceptionUpdateDTO extends IAppointmentScheduleExceptionCreateDTO {
    id?: number;
}

export class ScheduleTypeDTO implements IScheduleTypeDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;

    constructor(data?: IScheduleTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.color = _data["Color"];
        }
    }

    static fromJS(data: any): ScheduleTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Color"] = this.color;
        return data; 
    }

    clone(): ScheduleTypeDTO {
        const json = this.toJSON();
        let result = new ScheduleTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IScheduleTypeDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
}

export class ScheduleRepetitionPatternDTO implements IScheduleRepetitionPatternDTO {
    id?: number;
    maximumOccurances?: number | undefined;
    separationCount?: number;
    dayOfWeek?: number | undefined;
    weekOfMonth?: number | undefined;
    dayOfMonth?: number | undefined;
    monthOfYear?: number | undefined;
    scheduleRepetitionPatternTypeId?: number;
    endDate?: moment.Moment | undefined;
    scheduleRepetitionPatternType?: ScheduleRepetitionPatternTypeDTO | undefined;

    constructor(data?: IScheduleRepetitionPatternDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.maximumOccurances = _data["MaximumOccurances"];
            this.separationCount = _data["SeparationCount"];
            this.dayOfWeek = _data["DayOfWeek"];
            this.weekOfMonth = _data["WeekOfMonth"];
            this.dayOfMonth = _data["DayOfMonth"];
            this.monthOfYear = _data["MonthOfYear"];
            this.scheduleRepetitionPatternTypeId = _data["ScheduleRepetitionPatternTypeId"];
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.scheduleRepetitionPatternType = _data["ScheduleRepetitionPatternType"] ? ScheduleRepetitionPatternTypeDTO.fromJS(_data["ScheduleRepetitionPatternType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleRepetitionPatternDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleRepetitionPatternDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MaximumOccurances"] = this.maximumOccurances;
        data["SeparationCount"] = this.separationCount;
        data["DayOfWeek"] = this.dayOfWeek;
        data["WeekOfMonth"] = this.weekOfMonth;
        data["DayOfMonth"] = this.dayOfMonth;
        data["MonthOfYear"] = this.monthOfYear;
        data["ScheduleRepetitionPatternTypeId"] = this.scheduleRepetitionPatternTypeId;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ScheduleRepetitionPatternType"] = this.scheduleRepetitionPatternType ? this.scheduleRepetitionPatternType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ScheduleRepetitionPatternDTO {
        const json = this.toJSON();
        let result = new ScheduleRepetitionPatternDTO();
        result.init(json);
        return result;
    }
}

export interface IScheduleRepetitionPatternDTO {
    id?: number;
    maximumOccurances?: number | undefined;
    separationCount?: number;
    dayOfWeek?: number | undefined;
    weekOfMonth?: number | undefined;
    dayOfMonth?: number | undefined;
    monthOfYear?: number | undefined;
    scheduleRepetitionPatternTypeId?: number;
    endDate?: moment.Moment | undefined;
    scheduleRepetitionPatternType?: ScheduleRepetitionPatternTypeDTO | undefined;
}

export class ScheduleRepetitionPatternTypeDTO implements IScheduleRepetitionPatternTypeDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;

    constructor(data?: IScheduleRepetitionPatternTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
        }
    }

    static fromJS(data: any): ScheduleRepetitionPatternTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleRepetitionPatternTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        return data; 
    }

    clone(): ScheduleRepetitionPatternTypeDTO {
        const json = this.toJSON();
        let result = new ScheduleRepetitionPatternTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IScheduleRepetitionPatternTypeDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
}

export class AssignmentCreateModel implements IAssignmentCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    blockSizeInMinutes?: number;
    treatmentProviderEmployeeId?: number | undefined;
    companiesIds?: number[] | undefined;
    scheduleExceptions?: ScheduleExceptionCreateModel[] | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    userId?: number;
    title?: string | undefined;
    description?: string | undefined;
    roomId?: number | undefined;
    treatmentProviderId?: number | undefined;
    locationId?: number | undefined;
    inhouse?: boolean;
    groupTreatment?: boolean;
    isVideoCallAvailable?: boolean;
    treatmentTypeId?: number;
    numberOfParticipants?: number | undefined;
    treatmentProviderEmployees?: number[] | undefined;
    isTakeover?: boolean;

    constructor(data?: IAssignmentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.blockSizeInMinutes = _data["BlockSizeInMinutes"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            if (Array.isArray(_data["CompaniesIds"])) {
                this.companiesIds = [] as any;
                for (let item of _data["CompaniesIds"])
                    this.companiesIds!.push(item);
            }
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleExceptionCreateModel.fromJS(item));
            }
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternModel.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.roomId = _data["RoomId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.locationId = _data["LocationId"];
            this.inhouse = _data["Inhouse"];
            this.groupTreatment = _data["GroupTreatment"];
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(item);
            }
            this.isTakeover = _data["IsTakeover"];
        }
    }

    static fromJS(data: any): AssignmentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["BlockSizeInMinutes"] = this.blockSizeInMinutes;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        if (Array.isArray(this.companiesIds)) {
            data["CompaniesIds"] = [];
            for (let item of this.companiesIds)
                data["CompaniesIds"].push(item);
        }
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["RoomId"] = this.roomId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["LocationId"] = this.locationId;
        data["Inhouse"] = this.inhouse;
        data["GroupTreatment"] = this.groupTreatment;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item);
        }
        data["IsTakeover"] = this.isTakeover;
        return data; 
    }

    clone(): AssignmentCreateModel {
        const json = this.toJSON();
        let result = new AssignmentCreateModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    blockSizeInMinutes?: number;
    treatmentProviderEmployeeId?: number | undefined;
    companiesIds?: number[] | undefined;
    scheduleExceptions?: ScheduleExceptionCreateModel[] | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    userId?: number;
    title?: string | undefined;
    description?: string | undefined;
    roomId?: number | undefined;
    treatmentProviderId?: number | undefined;
    locationId?: number | undefined;
    inhouse?: boolean;
    groupTreatment?: boolean;
    isVideoCallAvailable?: boolean;
    treatmentTypeId?: number;
    numberOfParticipants?: number | undefined;
    treatmentProviderEmployees?: number[] | undefined;
    isTakeover?: boolean;
}

export class ScheduleExceptionCreateModel implements IScheduleExceptionCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
    scheduleType?: ScheduleTypeModel | undefined;
    repetitionEndDate?: moment.Moment;
    isRepeating?: boolean;
    exceptionTreatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    isTakeover?: boolean;
    availableDates?: string[] | undefined;

    constructor(data?: IScheduleExceptionCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.scheduleType = _data["ScheduleType"] ? ScheduleTypeModel.fromJS(_data["ScheduleType"]) : <any>undefined;
            this.repetitionEndDate = _data["RepetitionEndDate"] ? moment(_data["RepetitionEndDate"].toString()) : <any>undefined;
            this.isRepeating = _data["IsRepeating"];
            if (Array.isArray(_data["ExceptionTreatmentProviderEmployees"])) {
                this.exceptionTreatmentProviderEmployees = [] as any;
                for (let item of _data["ExceptionTreatmentProviderEmployees"])
                    this.exceptionTreatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.isTakeover = _data["IsTakeover"];
            if (Array.isArray(_data["availableDates"])) {
                this.availableDates = [] as any;
                for (let item of _data["availableDates"])
                    this.availableDates!.push(item);
            }
        }
    }

    static fromJS(data: any): ScheduleExceptionCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleExceptionCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        data["RepetitionEndDate"] = this.repetitionEndDate ? this.repetitionEndDate.toISOString() : <any>undefined;
        data["IsRepeating"] = this.isRepeating;
        if (Array.isArray(this.exceptionTreatmentProviderEmployees)) {
            data["ExceptionTreatmentProviderEmployees"] = [];
            for (let item of this.exceptionTreatmentProviderEmployees)
                data["ExceptionTreatmentProviderEmployees"].push(item.toJSON());
        }
        data["IsTakeover"] = this.isTakeover;
        if (Array.isArray(this.availableDates)) {
            data["availableDates"] = [];
            for (let item of this.availableDates)
                data["availableDates"].push(item);
        }
        return data; 
    }

    clone(): ScheduleExceptionCreateModel {
        const json = this.toJSON();
        let result = new ScheduleExceptionCreateModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleExceptionCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
    scheduleType?: ScheduleTypeModel | undefined;
    repetitionEndDate?: moment.Moment;
    isRepeating?: boolean;
    exceptionTreatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    isTakeover?: boolean;
    availableDates?: string[] | undefined;
}

export class AssignmentBookingModel implements IAssignmentBookingModel {
    treatmentProviderId?: number;
    treatmentProviderEmployeeId?: number | undefined;
    dates?: AssignmentDateModel[] | undefined;

    constructor(data?: IAssignmentBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            if (Array.isArray(_data["Dates"])) {
                this.dates = [] as any;
                for (let item of _data["Dates"])
                    this.dates!.push(AssignmentDateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        if (Array.isArray(this.dates)) {
            data["Dates"] = [];
            for (let item of this.dates)
                data["Dates"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AssignmentBookingModel {
        const json = this.toJSON();
        let result = new AssignmentBookingModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentBookingModel {
    treatmentProviderId?: number;
    treatmentProviderEmployeeId?: number | undefined;
    dates?: AssignmentDateModel[] | undefined;
}

export class AssignmentDateModel implements IAssignmentDateModel {
    assignmentId?: number;
    date?: moment.Moment;
    available?: boolean;

    constructor(data?: IAssignmentDateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["AssignmentId"];
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.available = _data["Available"];
        }
    }

    static fromJS(data: any): AssignmentDateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssignmentId"] = this.assignmentId;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Available"] = this.available;
        return data; 
    }

    clone(): AssignmentDateModel {
        const json = this.toJSON();
        let result = new AssignmentDateModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentDateModel {
    assignmentId?: number;
    date?: moment.Moment;
    available?: boolean;
}

export class AssignmentPageModel extends PageModel implements IAssignmentPageModel {
    assignments?: AssignmentPageEntryModel[] | undefined;

    constructor(data?: IAssignmentPageModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(AssignmentPageEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AssignmentPageModel {
        const json = this.toJSON();
        let result = new AssignmentPageModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentPageModel extends IPageModel {
    assignments?: AssignmentPageEntryModel[] | undefined;
}

export class AssignmentPageEntryModel implements IAssignmentPageEntryModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    companyName?: string | undefined;
    treatmentTypeName?: string | undefined;
    scheduleRepetitionPatternEndDate?: moment.Moment | undefined;
    status?: AssignmentStatusModel | undefined;

    constructor(data?: IAssignmentPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.companyName = _data["CompanyName"];
            this.treatmentTypeName = _data["TreatmentTypeName"];
            this.scheduleRepetitionPatternEndDate = _data["ScheduleRepetitionPatternEndDate"] ? moment(_data["ScheduleRepetitionPatternEndDate"].toString()) : <any>undefined;
            this.status = _data["Status"] ? AssignmentStatusModel.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignmentPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["CompanyName"] = this.companyName;
        data["TreatmentTypeName"] = this.treatmentTypeName;
        data["ScheduleRepetitionPatternEndDate"] = this.scheduleRepetitionPatternEndDate ? this.scheduleRepetitionPatternEndDate.toISOString() : <any>undefined;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AssignmentPageEntryModel {
        const json = this.toJSON();
        let result = new AssignmentPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentPageEntryModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    companyName?: string | undefined;
    treatmentTypeName?: string | undefined;
    scheduleRepetitionPatternEndDate?: moment.Moment | undefined;
    status?: AssignmentStatusModel | undefined;
}

export class AssignmentDetailsPageEntryModel implements IAssignmentDetailsPageEntryModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    blockSizeInMinutes?: number;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
    roomId?: number | undefined;
    room?: RoomShortDTO | undefined;
    companies?: CompanyShortModel[] | undefined;
    inhouse?: boolean;
    groupTreatment?: boolean;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    numberOfParticipants?: number | undefined;
    isVideoCallAvailable?: boolean;
    scheduleExceptions?: ScheduleExceptionShortModel[] | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    title?: string | undefined;
    description?: string | undefined;
    statusId?: number;
    status?: AssignmentStatusModel | undefined;

    constructor(data?: IAssignmentDetailsPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.blockSizeInMinutes = _data["BlockSizeInMinutes"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
            this.roomId = _data["RoomId"];
            this.room = _data["Room"] ? RoomShortDTO.fromJS(_data["Room"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanyShortModel.fromJS(item));
            }
            this.inhouse = _data["Inhouse"];
            this.groupTreatment = _data["GroupTreatment"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleExceptionShortModel.fromJS(item));
            }
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternModel.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.statusId = _data["StatusId"];
            this.status = _data["Status"] ? AssignmentStatusModel.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignmentDetailsPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDetailsPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["BlockSizeInMinutes"] = this.blockSizeInMinutes;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["RoomId"] = this.roomId;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["Inhouse"] = this.inhouse;
        data["GroupTreatment"] = this.groupTreatment;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["StatusId"] = this.statusId;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AssignmentDetailsPageEntryModel {
        const json = this.toJSON();
        let result = new AssignmentDetailsPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentDetailsPageEntryModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    blockSizeInMinutes?: number;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
    roomId?: number | undefined;
    room?: RoomShortDTO | undefined;
    companies?: CompanyShortModel[] | undefined;
    inhouse?: boolean;
    groupTreatment?: boolean;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    numberOfParticipants?: number | undefined;
    isVideoCallAvailable?: boolean;
    scheduleExceptions?: ScheduleExceptionShortModel[] | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    title?: string | undefined;
    description?: string | undefined;
    statusId?: number;
    status?: AssignmentStatusModel | undefined;
}

export class LocationModel implements ILocationModel {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: ILocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
        }
    }

    static fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        return data; 
    }

    clone(): LocationModel {
        const json = this.toJSON();
        let result = new LocationModel();
        result.init(json);
        return result;
    }
}

export interface ILocationModel {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class RoomShortDTO implements IRoomShortDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IRoomShortDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): RoomShortDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomShortDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): RoomShortDTO {
        const json = this.toJSON();
        let result = new RoomShortDTO();
        result.init(json);
        return result;
    }
}

export interface IRoomShortDTO {
    id?: number;
    name?: string | undefined;
}

export class CompanyShortModel implements ICompanyShortModel {
    id?: number;
    name?: string | undefined;
    rooms?: RoomModel[] | undefined;

    constructor(data?: ICompanyShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["Rooms"])
                    this.rooms!.push(RoomModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.rooms)) {
            data["Rooms"] = [];
            for (let item of this.rooms)
                data["Rooms"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CompanyShortModel {
        const json = this.toJSON();
        let result = new CompanyShortModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyShortModel {
    id?: number;
    name?: string | undefined;
    rooms?: RoomModel[] | undefined;
}

export class RoomModel implements IRoomModel {
    id?: number;
    name?: string | undefined;
    available?: boolean;
    companyId?: number | undefined;
    locationId?: number;
    location?: LocationModel | undefined;

    constructor(data?: IRoomModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.available = _data["Available"];
            this.companyId = _data["CompanyId"];
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RoomModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoomModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Available"] = this.available;
        data["CompanyId"] = this.companyId;
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RoomModel {
        const json = this.toJSON();
        let result = new RoomModel();
        result.init(json);
        return result;
    }
}

export interface IRoomModel {
    id?: number;
    name?: string | undefined;
    available?: boolean;
    companyId?: number | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
}

export class ScheduleExceptionShortModel implements IScheduleExceptionShortModel {
    id?: number;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    scheduleTypeId?: number;
    scheduleType?: ScheduleTypeModel | undefined;
    isRepeating?: boolean;
    repeatingScheduleId?: number;

    constructor(data?: IScheduleExceptionShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleModel.fromJS(item));
            }
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.scheduleType = _data["ScheduleType"] ? ScheduleTypeModel.fromJS(_data["ScheduleType"]) : <any>undefined;
            this.isRepeating = _data["IsRepeating"];
            this.repeatingScheduleId = _data["RepeatingScheduleId"];
        }
    }

    static fromJS(data: any): ScheduleExceptionShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleExceptionShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        data["IsRepeating"] = this.isRepeating;
        data["RepeatingScheduleId"] = this.repeatingScheduleId;
        return data; 
    }

    clone(): ScheduleExceptionShortModel {
        const json = this.toJSON();
        let result = new ScheduleExceptionShortModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleExceptionShortModel {
    id?: number;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    scheduleTypeId?: number;
    scheduleType?: ScheduleTypeModel | undefined;
    isRepeating?: boolean;
    repeatingScheduleId?: number;
}

export class EditAssignmentModel implements IEditAssignmentModel {
    assignmentId?: number;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    locationId?: number | undefined;
    location?: LocationModel | undefined;
    roomId?: number | undefined;
    room?: RoomShortDTO | undefined;

    constructor(data?: IEditAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["AssignmentId"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
            this.roomId = _data["RoomId"];
            this.room = _data["Room"] ? RoomShortDTO.fromJS(_data["Room"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditAssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssignmentId"] = this.assignmentId;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["RoomId"] = this.roomId;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EditAssignmentModel {
        const json = this.toJSON();
        let result = new EditAssignmentModel();
        result.init(json);
        return result;
    }
}

export interface IEditAssignmentModel {
    assignmentId?: number;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    locationId?: number | undefined;
    location?: LocationModel | undefined;
    roomId?: number | undefined;
    room?: RoomShortDTO | undefined;
}

export class ScheduleExceptionCreateStatusModel implements IScheduleExceptionCreateStatusModel {
    numberOfBookings?: number;

    constructor(data?: IScheduleExceptionCreateStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfBookings = _data["NumberOfBookings"];
        }
    }

    static fromJS(data: any): ScheduleExceptionCreateStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleExceptionCreateStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NumberOfBookings"] = this.numberOfBookings;
        return data; 
    }

    clone(): ScheduleExceptionCreateStatusModel {
        const json = this.toJSON();
        let result = new ScheduleExceptionCreateStatusModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleExceptionCreateStatusModel {
    numberOfBookings?: number;
}

export class AssignmentCancelStatusModel implements IAssignmentCancelStatusModel {
    numberOfBookings?: number;

    constructor(data?: IAssignmentCancelStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfBookings = _data["NumberOfBookings"];
        }
    }

    static fromJS(data: any): AssignmentCancelStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentCancelStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NumberOfBookings"] = this.numberOfBookings;
        return data; 
    }

    clone(): AssignmentCancelStatusModel {
        const json = this.toJSON();
        let result = new AssignmentCancelStatusModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentCancelStatusModel {
    numberOfBookings?: number;
}

export class UpdateRepetitionPatternModel implements IUpdateRepetitionPatternModel {
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    scheduleExceptions?: ScheduleExceptionShortModel[] | undefined;

    constructor(data?: IUpdateRepetitionPatternModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternModel.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleExceptionShortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRepetitionPatternModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRepetitionPatternModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateRepetitionPatternModel {
        const json = this.toJSON();
        let result = new UpdateRepetitionPatternModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateRepetitionPatternModel {
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    scheduleExceptions?: ScheduleExceptionShortModel[] | undefined;
}

export class EditSchedulesModel implements IEditSchedulesModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;

    constructor(data?: IEditSchedulesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
        }
    }

    static fromJS(data: any): EditSchedulesModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditSchedulesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        return data; 
    }

    clone(): EditSchedulesModel {
        const json = this.toJSON();
        let result = new EditSchedulesModel();
        result.init(json);
        return result;
    }
}

export interface IEditSchedulesModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
}

export class ScheduleSlotDTO implements IScheduleSlotDTO {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    isBooked?: boolean;
    unavailable?: boolean;
    isVideoCall?: boolean;
    description?: string | undefined;
    room?: RoomShortDTO | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortDTO[] | undefined;

    constructor(data?: IScheduleSlotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.isBooked = _data["IsBooked"];
            this.unavailable = _data["Unavailable"];
            this.isVideoCall = _data["IsVideoCall"];
            this.description = _data["Description"];
            this.room = _data["Room"] ? RoomShortDTO.fromJS(_data["Room"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleSlotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleSlotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["IsBooked"] = this.isBooked;
        data["Unavailable"] = this.unavailable;
        data["IsVideoCall"] = this.isVideoCall;
        data["Description"] = this.description;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ScheduleSlotDTO {
        const json = this.toJSON();
        let result = new ScheduleSlotDTO();
        result.init(json);
        return result;
    }
}

export interface IScheduleSlotDTO {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    isBooked?: boolean;
    unavailable?: boolean;
    isVideoCall?: boolean;
    description?: string | undefined;
    room?: RoomShortDTO | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortDTO[] | undefined;
}

export class ScheduleDateDTO implements IScheduleDateDTO {
    date?: moment.Moment;
    isAvailable?: boolean;

    constructor(data?: IScheduleDateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.isAvailable = _data["IsAvailable"];
        }
    }

    static fromJS(data: any): ScheduleDateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["IsAvailable"] = this.isAvailable;
        return data; 
    }

    clone(): ScheduleDateDTO {
        const json = this.toJSON();
        let result = new ScheduleDateDTO();
        result.init(json);
        return result;
    }
}

export interface IScheduleDateDTO {
    date?: moment.Moment;
    isAvailable?: boolean;
}

export class TreatmentProviderEmployeesSchedulePartnersDTO implements ITreatmentProviderEmployeesSchedulePartnersDTO {
    treatmentProviderEmployeeIds?: number[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortDTO[] | undefined;

    constructor(data?: ITreatmentProviderEmployeesSchedulePartnersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["TreatmentProviderEmployeeIds"])) {
                this.treatmentProviderEmployeeIds = [] as any;
                for (let item of _data["TreatmentProviderEmployeeIds"])
                    this.treatmentProviderEmployeeIds!.push(item);
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeesSchedulePartnersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeesSchedulePartnersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.treatmentProviderEmployeeIds)) {
            data["TreatmentProviderEmployeeIds"] = [];
            for (let item of this.treatmentProviderEmployeeIds)
                data["TreatmentProviderEmployeeIds"].push(item);
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderEmployeesSchedulePartnersDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeesSchedulePartnersDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeesSchedulePartnersDTO {
    treatmentProviderEmployeeIds?: number[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortDTO[] | undefined;
}

export class BookingPageModel implements IBookingPageModel {
    sortItem?: number;
    sortDirection?: number;
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    bookings?: BookingPageEntryModel[] | undefined;
    hasSpecialAccess?: boolean;

    constructor(data?: IBookingPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortItem = _data["SortItem"];
            this.sortDirection = _data["SortDirection"];
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRow = _data["TotalRow"];
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(BookingPageEntryModel.fromJS(item));
            }
            this.hasSpecialAccess = _data["HasSpecialAccess"];
        }
    }

    static fromJS(data: any): BookingPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SortItem"] = this.sortItem;
        data["SortDirection"] = this.sortDirection;
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRow"] = this.totalRow;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        data["HasSpecialAccess"] = this.hasSpecialAccess;
        return data; 
    }

    clone(): BookingPageModel {
        const json = this.toJSON();
        let result = new BookingPageModel();
        result.init(json);
        return result;
    }
}

export interface IBookingPageModel {
    sortItem?: number;
    sortDirection?: number;
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    bookings?: BookingPageEntryModel[] | undefined;
    hasSpecialAccess?: boolean;
}

export class BookingPageEntryModel implements IBookingPageEntryModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    status?: BookingStatusModel | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    companyId?: number | undefined;
    dateCreated?: moment.Moment;
    treatmentType?: TreatmentTypeShortModel | undefined;
    patient?: UserRefModel | undefined;
    noShow?: boolean;
    groupTreatment?: boolean;
    isVideoCall?: boolean;

    constructor(data?: IBookingPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.status = _data["Status"] ? BookingStatusModel.fromJS(_data["Status"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProviderName = _data["TreatmentProviderName"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.companyId = _data["CompanyId"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.patient = _data["Patient"] ? UserRefModel.fromJS(_data["Patient"]) : <any>undefined;
            this.noShow = _data["NoShow"];
            this.groupTreatment = _data["GroupTreatment"];
            this.isVideoCall = _data["IsVideoCall"];
        }
    }

    static fromJS(data: any): BookingPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["CompanyId"] = this.companyId;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["NoShow"] = this.noShow;
        data["GroupTreatment"] = this.groupTreatment;
        data["IsVideoCall"] = this.isVideoCall;
        return data; 
    }

    clone(): BookingPageEntryModel {
        const json = this.toJSON();
        let result = new BookingPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface IBookingPageEntryModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    status?: BookingStatusModel | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    companyId?: number | undefined;
    dateCreated?: moment.Moment;
    treatmentType?: TreatmentTypeShortModel | undefined;
    patient?: UserRefModel | undefined;
    noShow?: boolean;
    groupTreatment?: boolean;
    isVideoCall?: boolean;
}

export class BookingPageDetailsModel implements IBookingPageDetailsModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    status?: BookingStatusModel | undefined;
    location?: LocationModel | undefined;
    room?: RoomModel | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    companyId?: number | undefined;
    dateCreated?: moment.Moment;
    case?: BookingCaseModel | undefined;
    treatmentType?: TreatmentTypeShortModel | undefined;
    patient?: UserRefModel | undefined;
    noShow?: boolean;
    groupTreatment?: boolean;
    isVideoCall?: boolean;
    assignmentId?: number;
    appointmentScheduleId?: number | undefined;

    constructor(data?: IBookingPageDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.status = _data["Status"] ? BookingStatusModel.fromJS(_data["Status"]) : <any>undefined;
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
            this.room = _data["Room"] ? RoomModel.fromJS(_data["Room"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProviderName = _data["TreatmentProviderName"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.companyId = _data["CompanyId"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.case = _data["Case"] ? BookingCaseModel.fromJS(_data["Case"]) : <any>undefined;
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.patient = _data["Patient"] ? UserRefModel.fromJS(_data["Patient"]) : <any>undefined;
            this.noShow = _data["NoShow"];
            this.groupTreatment = _data["GroupTreatment"];
            this.isVideoCall = _data["IsVideoCall"];
            this.assignmentId = _data["AssignmentId"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
        }
    }

    static fromJS(data: any): BookingPageDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPageDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["CompanyId"] = this.companyId;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["NoShow"] = this.noShow;
        data["GroupTreatment"] = this.groupTreatment;
        data["IsVideoCall"] = this.isVideoCall;
        data["AssignmentId"] = this.assignmentId;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        return data; 
    }

    clone(): BookingPageDetailsModel {
        const json = this.toJSON();
        let result = new BookingPageDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IBookingPageDetailsModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    status?: BookingStatusModel | undefined;
    location?: LocationModel | undefined;
    room?: RoomModel | undefined;
    treatmentProviderId?: number;
    treatmentProviderName?: string | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    companyId?: number | undefined;
    dateCreated?: moment.Moment;
    case?: BookingCaseModel | undefined;
    treatmentType?: TreatmentTypeShortModel | undefined;
    patient?: UserRefModel | undefined;
    noShow?: boolean;
    groupTreatment?: boolean;
    isVideoCall?: boolean;
    assignmentId?: number;
    appointmentScheduleId?: number | undefined;
}

export class BookingCaseModel extends BaseEntityModel implements IBookingCaseModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;

    constructor(data?: IBookingCaseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.description = _data["Description"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): BookingCaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["Description"] = this.description;
        data["Status"] = this.status;
        super.toJSON(data);
        return data; 
    }

    clone(): BookingCaseModel {
        const json = this.toJSON();
        let result = new BookingCaseModel();
        result.init(json);
        return result;
    }
}

export interface IBookingCaseModel extends IBaseEntityModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
}

export class BookingCreateModel implements IBookingCreateModel {
    scheduleId?: number;
    treatmentProviderEmployeeId?: number | undefined;
    employeeGroupEmployeeId?: number | undefined;
    locationId?: number;
    description?: string | undefined;
    userId?: number;
    treatmentTypeId?: number;
    caseId?: number | undefined;
    roomId?: number | undefined;
    isVideoCall?: boolean;

    constructor(data?: IBookingCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data["ScheduleId"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.employeeGroupEmployeeId = _data["EmployeeGroupEmployeeId"];
            this.locationId = _data["LocationId"];
            this.description = _data["Description"];
            this.userId = _data["UserId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.caseId = _data["CaseId"];
            this.roomId = _data["RoomId"];
            this.isVideoCall = _data["IsVideoCall"];
        }
    }

    static fromJS(data: any): BookingCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScheduleId"] = this.scheduleId;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["EmployeeGroupEmployeeId"] = this.employeeGroupEmployeeId;
        data["LocationId"] = this.locationId;
        data["Description"] = this.description;
        data["UserId"] = this.userId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["CaseId"] = this.caseId;
        data["RoomId"] = this.roomId;
        data["IsVideoCall"] = this.isVideoCall;
        return data; 
    }

    clone(): BookingCreateModel {
        const json = this.toJSON();
        let result = new BookingCreateModel();
        result.init(json);
        return result;
    }
}

export interface IBookingCreateModel {
    scheduleId?: number;
    treatmentProviderEmployeeId?: number | undefined;
    employeeGroupEmployeeId?: number | undefined;
    locationId?: number;
    description?: string | undefined;
    userId?: number;
    treatmentTypeId?: number;
    caseId?: number | undefined;
    roomId?: number | undefined;
    isVideoCall?: boolean;
}

export class PastBookingsCreateModel implements IPastBookingsCreateModel {
    treatmentProviderEmployeeId?: number;
    description?: string | undefined;
    userId?: number;
    treatmentTypeId?: number;
    caseId?: number;
    locationId?: number;
    companyId?: number;
    companyIds?: number[] | undefined;
    pastSchedules?: PastScheduleCreateModel[] | undefined;

    constructor(data?: IPastBookingsCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.description = _data["Description"];
            this.userId = _data["UserId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.caseId = _data["CaseId"];
            this.locationId = _data["LocationId"];
            this.companyId = _data["CompanyId"];
            if (Array.isArray(_data["CompanyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["CompanyIds"])
                    this.companyIds!.push(item);
            }
            if (Array.isArray(_data["PastSchedules"])) {
                this.pastSchedules = [] as any;
                for (let item of _data["PastSchedules"])
                    this.pastSchedules!.push(PastScheduleCreateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PastBookingsCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PastBookingsCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["Description"] = this.description;
        data["UserId"] = this.userId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["CaseId"] = this.caseId;
        data["LocationId"] = this.locationId;
        data["CompanyId"] = this.companyId;
        if (Array.isArray(this.companyIds)) {
            data["CompanyIds"] = [];
            for (let item of this.companyIds)
                data["CompanyIds"].push(item);
        }
        if (Array.isArray(this.pastSchedules)) {
            data["PastSchedules"] = [];
            for (let item of this.pastSchedules)
                data["PastSchedules"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PastBookingsCreateModel {
        const json = this.toJSON();
        let result = new PastBookingsCreateModel();
        result.init(json);
        return result;
    }
}

export interface IPastBookingsCreateModel {
    treatmentProviderEmployeeId?: number;
    description?: string | undefined;
    userId?: number;
    treatmentTypeId?: number;
    caseId?: number;
    locationId?: number;
    companyId?: number;
    companyIds?: number[] | undefined;
    pastSchedules?: PastScheduleCreateModel[] | undefined;
}

export class PastScheduleCreateModel implements IPastScheduleCreateModel {
    date?: moment.Moment;
    startTime?: string;
    endTime?: string;
    noShow?: boolean;

    constructor(data?: IPastScheduleCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.noShow = _data["noShow"];
        }
    }

    static fromJS(data: any): PastScheduleCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PastScheduleCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["noShow"] = this.noShow;
        return data; 
    }

    clone(): PastScheduleCreateModel {
        const json = this.toJSON();
        let result = new PastScheduleCreateModel();
        result.init(json);
        return result;
    }
}

export interface IPastScheduleCreateModel {
    date?: moment.Moment;
    startTime?: string;
    endTime?: string;
    noShow?: boolean;
}

export class MultipleBookingCreateModel implements IMultipleBookingCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    appointmentScheduleId?: number;
    treatmentProviderEmployeeId?: number | undefined;
    employeeGroupEmployeeId?: number | undefined;
    locationId?: number | undefined;
    description?: string | undefined;
    userId?: number;
    treatmentTypeId?: number;
    caseId?: number | undefined;
    roomId?: number | undefined;
    isVideoCall?: boolean;

    constructor(data?: IMultipleBookingCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.employeeGroupEmployeeId = _data["EmployeeGroupEmployeeId"];
            this.locationId = _data["LocationId"];
            this.description = _data["Description"];
            this.userId = _data["UserId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.caseId = _data["CaseId"];
            this.roomId = _data["RoomId"];
            this.isVideoCall = _data["IsVideoCall"];
        }
    }

    static fromJS(data: any): MultipleBookingCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleBookingCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["EmployeeGroupEmployeeId"] = this.employeeGroupEmployeeId;
        data["LocationId"] = this.locationId;
        data["Description"] = this.description;
        data["UserId"] = this.userId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["CaseId"] = this.caseId;
        data["RoomId"] = this.roomId;
        data["IsVideoCall"] = this.isVideoCall;
        return data; 
    }

    clone(): MultipleBookingCreateModel {
        const json = this.toJSON();
        let result = new MultipleBookingCreateModel();
        result.init(json);
        return result;
    }
}

export interface IMultipleBookingCreateModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    appointmentScheduleId?: number;
    treatmentProviderEmployeeId?: number | undefined;
    employeeGroupEmployeeId?: number | undefined;
    locationId?: number | undefined;
    description?: string | undefined;
    userId?: number;
    treatmentTypeId?: number;
    caseId?: number | undefined;
    roomId?: number | undefined;
    isVideoCall?: boolean;
}

export class CalendarScheduleModel implements ICalendarScheduleModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    scheduleTypeCode?: string | undefined;
    scheduleTypeId?: number;
    assignmentId?: number;
    appointmentScheduleId?: number | undefined;
    assignmentTreatmentTypeName?: string | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    tPEFullName?: string | undefined;
    roomName?: string | undefined;
    treatmentProviderName?: string | undefined;
    treatmentProviderEmployeesCount?: number;
    locationAddress?: string | undefined;
    description?: string | undefined;
    title?: string | undefined;
    isBooked?: boolean;
    numberOfBookings?: number;
    numberOfParticipants?: number;
    bookings?: CalendarItemBookingModel[] | undefined;

    constructor(data?: ICalendarScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.scheduleTypeCode = _data["ScheduleTypeCode"];
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.assignmentId = _data["AssignmentId"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.assignmentTreatmentTypeName = _data["AssignmentTreatmentTypeName"];
            this.groupTreatment = _data["GroupTreatment"];
            this.inhouse = _data["Inhouse"];
            this.tPEFullName = _data["TPEFullName"];
            this.roomName = _data["RoomName"];
            this.treatmentProviderName = _data["TreatmentProviderName"];
            this.treatmentProviderEmployeesCount = _data["TreatmentProviderEmployeesCount"];
            this.locationAddress = _data["LocationAddress"];
            this.description = _data["Description"];
            this.title = _data["Title"];
            this.isBooked = _data["IsBooked"];
            this.numberOfBookings = _data["NumberOfBookings"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(CalendarItemBookingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["ScheduleTypeCode"] = this.scheduleTypeCode;
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["AssignmentId"] = this.assignmentId;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["AssignmentTreatmentTypeName"] = this.assignmentTreatmentTypeName;
        data["GroupTreatment"] = this.groupTreatment;
        data["Inhouse"] = this.inhouse;
        data["TPEFullName"] = this.tPEFullName;
        data["RoomName"] = this.roomName;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        data["TreatmentProviderEmployeesCount"] = this.treatmentProviderEmployeesCount;
        data["LocationAddress"] = this.locationAddress;
        data["Description"] = this.description;
        data["Title"] = this.title;
        data["IsBooked"] = this.isBooked;
        data["NumberOfBookings"] = this.numberOfBookings;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CalendarScheduleModel {
        const json = this.toJSON();
        let result = new CalendarScheduleModel();
        result.init(json);
        return result;
    }
}

export interface ICalendarScheduleModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    scheduleTypeCode?: string | undefined;
    scheduleTypeId?: number;
    assignmentId?: number;
    appointmentScheduleId?: number | undefined;
    assignmentTreatmentTypeName?: string | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    tPEFullName?: string | undefined;
    roomName?: string | undefined;
    treatmentProviderName?: string | undefined;
    treatmentProviderEmployeesCount?: number;
    locationAddress?: string | undefined;
    description?: string | undefined;
    title?: string | undefined;
    isBooked?: boolean;
    numberOfBookings?: number;
    numberOfParticipants?: number;
    bookings?: CalendarItemBookingModel[] | undefined;
}

export class ExceptionTimeRange implements IExceptionTimeRange {
    startTime?: string;
    endTime?: string;

    constructor(data?: IExceptionTimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
        }
    }

    static fromJS(data: any): ExceptionTimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new ExceptionTimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        return data; 
    }

    clone(): ExceptionTimeRange {
        const json = this.toJSON();
        let result = new ExceptionTimeRange();
        result.init(json);
        return result;
    }
}

export interface IExceptionTimeRange {
    startTime?: string;
    endTime?: string;
}

export class CaseConsentCreateModel implements ICaseConsentCreateModel {
    caseId?: number;
    consentCode?: string | undefined;

    constructor(data?: ICaseConsentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["CaseId"];
            this.consentCode = _data["ConsentCode"];
        }
    }

    static fromJS(data: any): CaseConsentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseConsentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CaseId"] = this.caseId;
        data["ConsentCode"] = this.consentCode;
        return data; 
    }

    clone(): CaseConsentCreateModel {
        const json = this.toJSON();
        let result = new CaseConsentCreateModel();
        result.init(json);
        return result;
    }
}

export interface ICaseConsentCreateModel {
    caseId?: number;
    consentCode?: string | undefined;
}

export class CaseConsentShortModel extends BaseEntityModel implements ICaseConsentShortModel {
    id?: number;
    caseId?: number;
    rejected?: boolean | undefined;
    reason?: string | undefined;
    revoked?: boolean;
    reviewedBy?: number;
    reviewedByFullName?: string | undefined;
    requestedByFullName?: string | undefined;
    consentId?: number;
    consent?: ConsentShortModel | undefined;

    constructor(data?: ICaseConsentShortModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.caseId = _data["CaseId"];
            this.rejected = _data["Rejected"];
            this.reason = _data["Reason"];
            this.revoked = _data["Revoked"];
            this.reviewedBy = _data["ReviewedBy"];
            this.reviewedByFullName = _data["ReviewedByFullName"];
            this.requestedByFullName = _data["RequestedByFullName"];
            this.consentId = _data["ConsentId"];
            this.consent = _data["Consent"] ? ConsentShortModel.fromJS(_data["Consent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseConsentShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseConsentShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CaseId"] = this.caseId;
        data["Rejected"] = this.rejected;
        data["Reason"] = this.reason;
        data["Revoked"] = this.revoked;
        data["ReviewedBy"] = this.reviewedBy;
        data["ReviewedByFullName"] = this.reviewedByFullName;
        data["RequestedByFullName"] = this.requestedByFullName;
        data["ConsentId"] = this.consentId;
        data["Consent"] = this.consent ? this.consent.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): CaseConsentShortModel {
        const json = this.toJSON();
        let result = new CaseConsentShortModel();
        result.init(json);
        return result;
    }
}

export interface ICaseConsentShortModel extends IBaseEntityModel {
    id?: number;
    caseId?: number;
    rejected?: boolean | undefined;
    reason?: string | undefined;
    revoked?: boolean;
    reviewedBy?: number;
    reviewedByFullName?: string | undefined;
    requestedByFullName?: string | undefined;
    consentId?: number;
    consent?: ConsentShortModel | undefined;
}

export class ConsentShortModel implements IConsentShortModel {
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: IConsentShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): ConsentShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Text"] = this.text;
        return data; 
    }

    clone(): ConsentShortModel {
        const json = this.toJSON();
        let result = new ConsentShortModel();
        result.init(json);
        return result;
    }
}

export interface IConsentShortModel {
    code?: string | undefined;
    text?: string | undefined;
}

export class ConsentListModel implements IConsentListModel {
    requestedConsentsByMe?: CaseConsentShortModel[] | undefined;
    reviewedConsentsByMe?: CaseConsentShortModel[] | undefined;

    constructor(data?: IConsentListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RequestedConsentsByMe"])) {
                this.requestedConsentsByMe = [] as any;
                for (let item of _data["RequestedConsentsByMe"])
                    this.requestedConsentsByMe!.push(CaseConsentShortModel.fromJS(item));
            }
            if (Array.isArray(_data["ReviewedConsentsByMe"])) {
                this.reviewedConsentsByMe = [] as any;
                for (let item of _data["ReviewedConsentsByMe"])
                    this.reviewedConsentsByMe!.push(CaseConsentShortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsentListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestedConsentsByMe)) {
            data["RequestedConsentsByMe"] = [];
            for (let item of this.requestedConsentsByMe)
                data["RequestedConsentsByMe"].push(item.toJSON());
        }
        if (Array.isArray(this.reviewedConsentsByMe)) {
            data["ReviewedConsentsByMe"] = [];
            for (let item of this.reviewedConsentsByMe)
                data["ReviewedConsentsByMe"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ConsentListModel {
        const json = this.toJSON();
        let result = new ConsentListModel();
        result.init(json);
        return result;
    }
}

export interface IConsentListModel {
    requestedConsentsByMe?: CaseConsentShortModel[] | undefined;
    reviewedConsentsByMe?: CaseConsentShortModel[] | undefined;
}

export class CasePageModel implements ICasePageModel {
    keyword?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    sortDirection?: number;
    sortItem?: number;
    statusIds?: number[] | undefined;
    cases?: CasePageEntryModel[] | undefined;

    constructor(data?: ICasePageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["Keyword"];
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRow = _data["TotalRow"];
            this.sortDirection = _data["SortDirection"];
            this.sortItem = _data["SortItem"];
            if (Array.isArray(_data["StatusIds"])) {
                this.statusIds = [] as any;
                for (let item of _data["StatusIds"])
                    this.statusIds!.push(item);
            }
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases!.push(CasePageEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CasePageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CasePageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Keyword"] = this.keyword;
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRow"] = this.totalRow;
        data["SortDirection"] = this.sortDirection;
        data["SortItem"] = this.sortItem;
        if (Array.isArray(this.statusIds)) {
            data["StatusIds"] = [];
            for (let item of this.statusIds)
                data["StatusIds"].push(item);
        }
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CasePageModel {
        const json = this.toJSON();
        let result = new CasePageModel();
        result.init(json);
        return result;
    }
}

export interface ICasePageModel {
    keyword?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    sortDirection?: number;
    sortItem?: number;
    statusIds?: number[] | undefined;
    cases?: CasePageEntryModel[] | undefined;
}

export class CasePageEntryModel implements ICasePageEntryModel {
    id?: number;
    subject?: string | undefined;
    startDate?: moment.Moment;
    dateModified?: moment.Moment;
    caseStatus?: CaseStatusShortDetailsModel | undefined;
    patient?: UserRefModel | undefined;
    treatmentArea?: string | undefined;

    constructor(data?: ICasePageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.caseStatus = _data["CaseStatus"] ? CaseStatusShortDetailsModel.fromJS(_data["CaseStatus"]) : <any>undefined;
            this.patient = _data["Patient"] ? UserRefModel.fromJS(_data["Patient"]) : <any>undefined;
            this.treatmentArea = _data["TreatmentArea"];
        }
    }

    static fromJS(data: any): CasePageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CasePageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["CaseStatus"] = this.caseStatus ? this.caseStatus.toJSON() : <any>undefined;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["TreatmentArea"] = this.treatmentArea;
        return data; 
    }

    clone(): CasePageEntryModel {
        const json = this.toJSON();
        let result = new CasePageEntryModel();
        result.init(json);
        return result;
    }
}

export interface ICasePageEntryModel {
    id?: number;
    subject?: string | undefined;
    startDate?: moment.Moment;
    dateModified?: moment.Moment;
    caseStatus?: CaseStatusShortDetailsModel | undefined;
    patient?: UserRefModel | undefined;
    treatmentArea?: string | undefined;
}

export class CaseStatusShortDetailsModel implements ICaseStatusShortDetailsModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;

    constructor(data?: ICaseStatusShortDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.colorCode = _data["ColorCode"];
        }
    }

    static fromJS(data: any): CaseStatusShortDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseStatusShortDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["ColorCode"] = this.colorCode;
        return data; 
    }

    clone(): CaseStatusShortDetailsModel {
        const json = this.toJSON();
        let result = new CaseStatusShortDetailsModel();
        result.init(json);
        return result;
    }
}

export interface ICaseStatusShortDetailsModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
}

export class CaseCreateModel implements ICaseCreateModel {
    subject!: string;
    description!: string;
    startDate!: moment.Moment;
    patientId?: number | undefined;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
    treatmentAreas?: string[] | undefined;

    constructor(data?: ICaseCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["Subject"];
            this.description = _data["Description"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.patientId = _data["PatientId"];
            if (Array.isArray(_data["CaseTreatmentTypes"])) {
                this.caseTreatmentTypes = [] as any;
                for (let item of _data["CaseTreatmentTypes"])
                    this.caseTreatmentTypes!.push(CaseTreatmentTypeModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentAreas"])) {
                this.treatmentAreas = [] as any;
                for (let item of _data["TreatmentAreas"])
                    this.treatmentAreas!.push(item);
            }
        }
    }

    static fromJS(data: any): CaseCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subject"] = this.subject;
        data["Description"] = this.description;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["PatientId"] = this.patientId;
        if (Array.isArray(this.caseTreatmentTypes)) {
            data["CaseTreatmentTypes"] = [];
            for (let item of this.caseTreatmentTypes)
                data["CaseTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentAreas)) {
            data["TreatmentAreas"] = [];
            for (let item of this.treatmentAreas)
                data["TreatmentAreas"].push(item);
        }
        return data; 
    }

    clone(): CaseCreateModel {
        const json = this.toJSON();
        let result = new CaseCreateModel();
        result.init(json);
        return result;
    }
}

export interface ICaseCreateModel {
    subject: string;
    description: string;
    startDate: moment.Moment;
    patientId?: number | undefined;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
    treatmentAreas?: string[] | undefined;
}

export class CaseTreatmentTypeModel implements ICaseTreatmentTypeModel {
    id?: number;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    maxNumberOfBookings?: number | undefined;
    usedNumberOfBookings?: number;
    sortOrder?: number | undefined;

    constructor(data?: ICaseTreatmentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.maxNumberOfBookings = _data["MaxNumberOfBookings"];
            this.usedNumberOfBookings = _data["UsedNumberOfBookings"];
            this.sortOrder = _data["SortOrder"];
        }
    }

    static fromJS(data: any): CaseTreatmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTreatmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["MaxNumberOfBookings"] = this.maxNumberOfBookings;
        data["UsedNumberOfBookings"] = this.usedNumberOfBookings;
        data["SortOrder"] = this.sortOrder;
        return data; 
    }

    clone(): CaseTreatmentTypeModel {
        const json = this.toJSON();
        let result = new CaseTreatmentTypeModel();
        result.init(json);
        return result;
    }
}

export interface ICaseTreatmentTypeModel {
    id?: number;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    maxNumberOfBookings?: number | undefined;
    usedNumberOfBookings?: number;
    sortOrder?: number | undefined;
}

export class CaseDetailsModel implements ICaseDetailsModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    assigneeId?: number | undefined;
    assigneeFullName?: string | undefined;
    isAssignee?: boolean;
    startDate?: moment.Moment;
    dateModified?: moment.Moment;
    caseStatus?: CaseStatusShortDetailsModel | undefined;
    patient?: UserRefModel | undefined;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
    closedByFullName?: string | undefined;
    treatmentProviders?: TreatmentProviderSelectDTO[] | undefined;
    treatmentAreas?: string[] | undefined;

    constructor(data?: ICaseDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.description = _data["Description"];
            this.assigneeId = _data["AssigneeId"];
            this.assigneeFullName = _data["AssigneeFullName"];
            this.isAssignee = _data["IsAssignee"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.caseStatus = _data["CaseStatus"] ? CaseStatusShortDetailsModel.fromJS(_data["CaseStatus"]) : <any>undefined;
            this.patient = _data["Patient"] ? UserRefModel.fromJS(_data["Patient"]) : <any>undefined;
            if (Array.isArray(_data["CaseTreatmentTypes"])) {
                this.caseTreatmentTypes = [] as any;
                for (let item of _data["CaseTreatmentTypes"])
                    this.caseTreatmentTypes!.push(CaseTreatmentTypeModel.fromJS(item));
            }
            this.closedByFullName = _data["ClosedByFullName"];
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProviderSelectDTO.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentAreas"])) {
                this.treatmentAreas = [] as any;
                for (let item of _data["TreatmentAreas"])
                    this.treatmentAreas!.push(item);
            }
        }
    }

    static fromJS(data: any): CaseDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["Description"] = this.description;
        data["AssigneeId"] = this.assigneeId;
        data["AssigneeFullName"] = this.assigneeFullName;
        data["IsAssignee"] = this.isAssignee;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["CaseStatus"] = this.caseStatus ? this.caseStatus.toJSON() : <any>undefined;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.caseTreatmentTypes)) {
            data["CaseTreatmentTypes"] = [];
            for (let item of this.caseTreatmentTypes)
                data["CaseTreatmentTypes"].push(item.toJSON());
        }
        data["ClosedByFullName"] = this.closedByFullName;
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentAreas)) {
            data["TreatmentAreas"] = [];
            for (let item of this.treatmentAreas)
                data["TreatmentAreas"].push(item);
        }
        return data; 
    }

    clone(): CaseDetailsModel {
        const json = this.toJSON();
        let result = new CaseDetailsModel();
        result.init(json);
        return result;
    }
}

export interface ICaseDetailsModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    assigneeId?: number | undefined;
    assigneeFullName?: string | undefined;
    isAssignee?: boolean;
    startDate?: moment.Moment;
    dateModified?: moment.Moment;
    caseStatus?: CaseStatusShortDetailsModel | undefined;
    patient?: UserRefModel | undefined;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
    closedByFullName?: string | undefined;
    treatmentProviders?: TreatmentProviderSelectDTO[] | undefined;
    treatmentAreas?: string[] | undefined;
}

export class CaseEditModel implements ICaseEditModel {
    description?: string | undefined;
    startDate?: moment.Moment;
    statusId?: number;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
    treatmentProviderIds?: number[] | undefined;
    treatmentAreas?: string[] | undefined;
    subject?: string | undefined;

    constructor(data?: ICaseEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.statusId = _data["StatusId"];
            if (Array.isArray(_data["CaseTreatmentTypes"])) {
                this.caseTreatmentTypes = [] as any;
                for (let item of _data["CaseTreatmentTypes"])
                    this.caseTreatmentTypes!.push(CaseTreatmentTypeModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderIds"])) {
                this.treatmentProviderIds = [] as any;
                for (let item of _data["TreatmentProviderIds"])
                    this.treatmentProviderIds!.push(item);
            }
            if (Array.isArray(_data["TreatmentAreas"])) {
                this.treatmentAreas = [] as any;
                for (let item of _data["TreatmentAreas"])
                    this.treatmentAreas!.push(item);
            }
            this.subject = _data["Subject"];
        }
    }

    static fromJS(data: any): CaseEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["StatusId"] = this.statusId;
        if (Array.isArray(this.caseTreatmentTypes)) {
            data["CaseTreatmentTypes"] = [];
            for (let item of this.caseTreatmentTypes)
                data["CaseTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderIds)) {
            data["TreatmentProviderIds"] = [];
            for (let item of this.treatmentProviderIds)
                data["TreatmentProviderIds"].push(item);
        }
        if (Array.isArray(this.treatmentAreas)) {
            data["TreatmentAreas"] = [];
            for (let item of this.treatmentAreas)
                data["TreatmentAreas"].push(item);
        }
        data["Subject"] = this.subject;
        return data; 
    }

    clone(): CaseEditModel {
        const json = this.toJSON();
        let result = new CaseEditModel();
        result.init(json);
        return result;
    }
}

export interface ICaseEditModel {
    description?: string | undefined;
    startDate?: moment.Moment;
    statusId?: number;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
    treatmentProviderIds?: number[] | undefined;
    treatmentAreas?: string[] | undefined;
    subject?: string | undefined;
}

export class Exception implements IException {
    message?: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : <any>undefined;
            this.source = _data["Source"];
            this.stackTrace = _data["StackTrace"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["Source"] = this.source;
        data["StackTrace"] = this.stackTrace;
        return data; 
    }

    clone(): Exception {
        const json = this.toJSON();
        let result = new Exception();
        result.init(json);
        return result;
    }
}

export interface IException {
    message?: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;
}

export class HttpResponseException extends Exception implements IHttpResponseException {
    statusCode?: number;
    value?: any | undefined;

    constructor(data?: IHttpResponseException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusCode = _data["StatusCode"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): HttpResponseException {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StatusCode"] = this.statusCode;
        data["Value"] = this.value;
        super.toJSON(data);
        return data; 
    }

    clone(): HttpResponseException {
        const json = this.toJSON();
        let result = new HttpResponseException();
        result.init(json);
        return result;
    }
}

export interface IHttpResponseException extends IException {
    statusCode?: number;
    value?: any | undefined;
}

export class TreatmentProviderTreatmentTypeModel implements ITreatmentProviderTreatmentTypeModel {
    treatmentProviderId?: number;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    info?: string | undefined;
    photo?: string | undefined;
    treatmentTypeIcon?: string | undefined;
    priority?: number;
    deleted?: boolean;
    galleryImages?: ClinicGalleryImageModel[] | undefined;

    constructor(data?: ITreatmentProviderTreatmentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.info = _data["Info"];
            this.photo = _data["Photo"];
            this.treatmentTypeIcon = _data["TreatmentTypeIcon"];
            this.priority = _data["Priority"];
            this.deleted = _data["Deleted"];
            if (Array.isArray(_data["GalleryImages"])) {
                this.galleryImages = [] as any;
                for (let item of _data["GalleryImages"])
                    this.galleryImages!.push(ClinicGalleryImageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderTreatmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderTreatmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["Info"] = this.info;
        data["Photo"] = this.photo;
        data["TreatmentTypeIcon"] = this.treatmentTypeIcon;
        data["Priority"] = this.priority;
        data["Deleted"] = this.deleted;
        if (Array.isArray(this.galleryImages)) {
            data["GalleryImages"] = [];
            for (let item of this.galleryImages)
                data["GalleryImages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderTreatmentTypeModel {
        const json = this.toJSON();
        let result = new TreatmentProviderTreatmentTypeModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderTreatmentTypeModel {
    treatmentProviderId?: number;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    info?: string | undefined;
    photo?: string | undefined;
    treatmentTypeIcon?: string | undefined;
    priority?: number;
    deleted?: boolean;
    galleryImages?: ClinicGalleryImageModel[] | undefined;
}

export class ClinicGalleryImageModel implements IClinicGalleryImageModel {
    id?: number;
    path?: string | undefined;
    info?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfileModel | undefined;
    priority?: number;
    deleted?: boolean;

    constructor(data?: IClinicGalleryImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.path = _data["Path"];
            this.info = _data["Info"];
            this.clinicProfileId = _data["ClinicProfileId"];
            this.clinicProfile = _data["ClinicProfile"] ? ClinicProfileModel.fromJS(_data["ClinicProfile"]) : <any>undefined;
            this.priority = _data["Priority"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): ClinicGalleryImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicGalleryImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Path"] = this.path;
        data["Info"] = this.info;
        data["ClinicProfileId"] = this.clinicProfileId;
        data["ClinicProfile"] = this.clinicProfile ? this.clinicProfile.toJSON() : <any>undefined;
        data["Priority"] = this.priority;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): ClinicGalleryImageModel {
        const json = this.toJSON();
        let result = new ClinicGalleryImageModel();
        result.init(json);
        return result;
    }
}

export interface IClinicGalleryImageModel {
    id?: number;
    path?: string | undefined;
    info?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfileModel | undefined;
    priority?: number;
    deleted?: boolean;
}

export class ClinicProfileModel implements IClinicProfileModel {
    id?: number;
    description?: string | undefined;
    profileUrl?: string | undefined;
    facebookExternalUrl?: string | undefined;
    instagramExternalUrl?: string | undefined;
    twiiterExternalUrl?: string | undefined;
    linkedInExternalUrl?: string | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProviderClinicProfileModel | undefined;
    workingTime?: WorkingTimeModel[] | undefined;
    clinicGallery?: ClinicGalleryImageModel[] | undefined;

    constructor(data?: IClinicProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.profileUrl = _data["ProfileUrl"];
            this.facebookExternalUrl = _data["FacebookExternalUrl"];
            this.instagramExternalUrl = _data["InstagramExternalUrl"];
            this.twiiterExternalUrl = _data["TwiiterExternalUrl"];
            this.linkedInExternalUrl = _data["LinkedInExternalUrl"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProviderClinicProfileModel.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            if (Array.isArray(_data["WorkingTime"])) {
                this.workingTime = [] as any;
                for (let item of _data["WorkingTime"])
                    this.workingTime!.push(WorkingTimeModel.fromJS(item));
            }
            if (Array.isArray(_data["ClinicGallery"])) {
                this.clinicGallery = [] as any;
                for (let item of _data["ClinicGallery"])
                    this.clinicGallery!.push(ClinicGalleryImageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["ProfileUrl"] = this.profileUrl;
        data["FacebookExternalUrl"] = this.facebookExternalUrl;
        data["InstagramExternalUrl"] = this.instagramExternalUrl;
        data["TwiiterExternalUrl"] = this.twiiterExternalUrl;
        data["LinkedInExternalUrl"] = this.linkedInExternalUrl;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.workingTime)) {
            data["WorkingTime"] = [];
            for (let item of this.workingTime)
                data["WorkingTime"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicGallery)) {
            data["ClinicGallery"] = [];
            for (let item of this.clinicGallery)
                data["ClinicGallery"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ClinicProfileModel {
        const json = this.toJSON();
        let result = new ClinicProfileModel();
        result.init(json);
        return result;
    }
}

export interface IClinicProfileModel {
    id?: number;
    description?: string | undefined;
    profileUrl?: string | undefined;
    facebookExternalUrl?: string | undefined;
    instagramExternalUrl?: string | undefined;
    twiiterExternalUrl?: string | undefined;
    linkedInExternalUrl?: string | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProviderClinicProfileModel | undefined;
    workingTime?: WorkingTimeModel[] | undefined;
    clinicGallery?: ClinicGalleryImageModel[] | undefined;
}

export class TreatmentProviderClinicProfileModel implements ITreatmentProviderClinicProfileModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    coverPhotoPath?: string | undefined;
    locations?: LocationModel[] | undefined;
    contacts?: ContactTreatmentProviderModel[] | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;

    constructor(data?: ITreatmentProviderClinicProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.coverPhotoPath = _data["CoverPhotoPath"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactTreatmentProviderModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderClinicProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderClinicProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["CoverPhotoPath"] = this.coverPhotoPath;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderClinicProfileModel {
        const json = this.toJSON();
        let result = new TreatmentProviderClinicProfileModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderClinicProfileModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    coverPhotoPath?: string | undefined;
    locations?: LocationModel[] | undefined;
    contacts?: ContactTreatmentProviderModel[] | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
}

export class ContactTreatmentProviderModel implements IContactTreatmentProviderModel {
    id?: number;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;

    constructor(data?: IContactTreatmentProviderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.mobile = _data["Mobile"];
            this.fax = _data["Fax"];
            this.uRL = _data["URL"];
        }
    }

    static fromJS(data: any): ContactTreatmentProviderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactTreatmentProviderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Mobile"] = this.mobile;
        data["Fax"] = this.fax;
        data["URL"] = this.uRL;
        return data; 
    }

    clone(): ContactTreatmentProviderModel {
        const json = this.toJSON();
        let result = new ContactTreatmentProviderModel();
        result.init(json);
        return result;
    }
}

export interface IContactTreatmentProviderModel {
    id?: number;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
}

export class WorkingTimeModel implements IWorkingTimeModel {
    id?: number;
    dayOfWeek?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfileModel | undefined;

    constructor(data?: IWorkingTimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.dayOfWeek = _data["DayOfWeek"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.clinicProfileId = _data["ClinicProfileId"];
            this.clinicProfile = _data["ClinicProfile"] ? ClinicProfileModel.fromJS(_data["ClinicProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkingTimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingTimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DayOfWeek"] = this.dayOfWeek;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["ClinicProfileId"] = this.clinicProfileId;
        data["ClinicProfile"] = this.clinicProfile ? this.clinicProfile.toJSON() : <any>undefined;
        return data; 
    }

    clone(): WorkingTimeModel {
        const json = this.toJSON();
        let result = new WorkingTimeModel();
        result.init(json);
        return result;
    }
}

export interface IWorkingTimeModel {
    id?: number;
    dayOfWeek?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfileModel | undefined;
}

export class TreatmentProviderTreatmentSpecialistModel implements ITreatmentProviderTreatmentSpecialistModel {
    id?: number;
    userId?: number;
    user?: UserRefModel | undefined;
    treatmentProviderId?: number;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    priority?: number;
    deleted?: boolean;

    constructor(data?: ITreatmentProviderTreatmentSpecialistModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserRefModel.fromJS(_data["User"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
            this.priority = _data["Priority"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): TreatmentProviderTreatmentSpecialistModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderTreatmentSpecialistModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["Priority"] = this.priority;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): TreatmentProviderTreatmentSpecialistModel {
        const json = this.toJSON();
        let result = new TreatmentProviderTreatmentSpecialistModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderTreatmentSpecialistModel {
    id?: number;
    userId?: number;
    user?: UserRefModel | undefined;
    treatmentProviderId?: number;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    priority?: number;
    deleted?: boolean;
}

export class TreatmentProviderEmployeeClinicProfileModel implements ITreatmentProviderEmployeeClinicProfileModel {
    id?: number;
    userId?: number;
    user?: UserRefModel | undefined;
    treatmentProviderId?: number;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    profileInfo?: string | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
    priority?: number;

    constructor(data?: ITreatmentProviderEmployeeClinicProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserRefModel.fromJS(_data["User"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
            this.profileInfo = _data["ProfileInfo"];
            this.workingExperience = _data["WorkingExperience"];
            this.education = _data["Education"];
            this.certificates = _data["Certificates"];
            this.languages = _data["Languages"];
            this.priority = _data["Priority"];
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeeClinicProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeeClinicProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["ProfileInfo"] = this.profileInfo;
        data["WorkingExperience"] = this.workingExperience;
        data["Education"] = this.education;
        data["Certificates"] = this.certificates;
        data["Languages"] = this.languages;
        data["Priority"] = this.priority;
        return data; 
    }

    clone(): TreatmentProviderEmployeeClinicProfileModel {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeeClinicProfileModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeeClinicProfileModel {
    id?: number;
    userId?: number;
    user?: UserRefModel | undefined;
    treatmentProviderId?: number;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    profileInfo?: string | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
    priority?: number;
}

export class ContactShortModel implements IContactShortModel {
    id?: number;
    email?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
    contactPerson?: string | undefined;
    edited?: boolean;

    constructor(data?: IContactShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.fax = _data["Fax"];
            this.uRL = _data["URL"];
            this.contactPerson = _data["ContactPerson"];
            this.edited = _data["Edited"];
        }
    }

    static fromJS(data: any): ContactShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Fax"] = this.fax;
        data["URL"] = this.uRL;
        data["ContactPerson"] = this.contactPerson;
        data["Edited"] = this.edited;
        return data; 
    }

    clone(): ContactShortModel {
        const json = this.toJSON();
        let result = new ContactShortModel();
        result.init(json);
        return result;
    }
}

export interface IContactShortModel {
    id?: number;
    email?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
    contactPerson?: string | undefined;
    edited?: boolean;
}

export class ClinicDescriptionUpdateModel implements IClinicDescriptionUpdateModel {
    description?: string | undefined;
    treatmentProviderId?: number;

    constructor(data?: IClinicDescriptionUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
        }
    }

    static fromJS(data: any): ClinicDescriptionUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicDescriptionUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        return data; 
    }

    clone(): ClinicDescriptionUpdateModel {
        const json = this.toJSON();
        let result = new ClinicDescriptionUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IClinicDescriptionUpdateModel {
    description?: string | undefined;
    treatmentProviderId?: number;
}

export class FileModel implements IFileModel {
    id?: number;
    fileName?: string | undefined;
    dateCreated?: moment.Moment;
    filePath?: string | undefined;

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fileName = _data["FileName"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.filePath = _data["FilePath"];
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FileName"] = this.fileName;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["FilePath"] = this.filePath;
        return data; 
    }

    clone(): FileModel {
        const json = this.toJSON();
        let result = new FileModel();
        result.init(json);
        return result;
    }
}

export interface IFileModel {
    id?: number;
    fileName?: string | undefined;
    dateCreated?: moment.Moment;
    filePath?: string | undefined;
}

export class TreatmentProviderTreatmentTypeUpdateModel implements ITreatmentProviderTreatmentTypeUpdateModel {
    treatmentProviderId?: number;
    treatmenttypePriorities?: TreatmentTypePriorityUpdateModel[] | undefined;

    constructor(data?: ITreatmentProviderTreatmentTypeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["treatmenttypePriorities"])) {
                this.treatmenttypePriorities = [] as any;
                for (let item of _data["treatmenttypePriorities"])
                    this.treatmenttypePriorities!.push(TreatmentTypePriorityUpdateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderTreatmentTypeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderTreatmentTypeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.treatmenttypePriorities)) {
            data["treatmenttypePriorities"] = [];
            for (let item of this.treatmenttypePriorities)
                data["treatmenttypePriorities"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderTreatmentTypeUpdateModel {
        const json = this.toJSON();
        let result = new TreatmentProviderTreatmentTypeUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderTreatmentTypeUpdateModel {
    treatmentProviderId?: number;
    treatmenttypePriorities?: TreatmentTypePriorityUpdateModel[] | undefined;
}

export class TreatmentTypePriorityUpdateModel implements ITreatmentTypePriorityUpdateModel {
    treatmentTypeId?: number;
    priority?: number;
    deleted?: boolean;

    constructor(data?: ITreatmentTypePriorityUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.priority = _data["Priority"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): TreatmentTypePriorityUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypePriorityUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["Priority"] = this.priority;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): TreatmentTypePriorityUpdateModel {
        const json = this.toJSON();
        let result = new TreatmentTypePriorityUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypePriorityUpdateModel {
    treatmentTypeId?: number;
    priority?: number;
    deleted?: boolean;
}

export class TreatmentProviderGalleryUpdateModel implements ITreatmentProviderGalleryUpdateModel {
    treatmentProviderId?: number;
    clinicGalleryPriorityUpdates?: ClinicGalleryPriorityUpdateModel[] | undefined;

    constructor(data?: ITreatmentProviderGalleryUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["clinicGalleryPriorityUpdates"])) {
                this.clinicGalleryPriorityUpdates = [] as any;
                for (let item of _data["clinicGalleryPriorityUpdates"])
                    this.clinicGalleryPriorityUpdates!.push(ClinicGalleryPriorityUpdateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderGalleryUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderGalleryUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.clinicGalleryPriorityUpdates)) {
            data["clinicGalleryPriorityUpdates"] = [];
            for (let item of this.clinicGalleryPriorityUpdates)
                data["clinicGalleryPriorityUpdates"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderGalleryUpdateModel {
        const json = this.toJSON();
        let result = new TreatmentProviderGalleryUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderGalleryUpdateModel {
    treatmentProviderId?: number;
    clinicGalleryPriorityUpdates?: ClinicGalleryPriorityUpdateModel[] | undefined;
}

export class ClinicGalleryPriorityUpdateModel implements IClinicGalleryPriorityUpdateModel {
    clinicGalleryImageId?: number;
    priority?: number;
    deleted?: boolean;

    constructor(data?: IClinicGalleryPriorityUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicGalleryImageId = _data["ClinicGalleryImageId"];
            this.priority = _data["Priority"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): ClinicGalleryPriorityUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicGalleryPriorityUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClinicGalleryImageId"] = this.clinicGalleryImageId;
        data["Priority"] = this.priority;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): ClinicGalleryPriorityUpdateModel {
        const json = this.toJSON();
        let result = new ClinicGalleryPriorityUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IClinicGalleryPriorityUpdateModel {
    clinicGalleryImageId?: number;
    priority?: number;
    deleted?: boolean;
}

export class TreatmentProviderEmployeePriorityUpdateModel implements ITreatmentProviderEmployeePriorityUpdateModel {
    treatmentProviderId?: number;
    employeePriorityUpdates?: EmployeePriorityUpdateModel[] | undefined;

    constructor(data?: ITreatmentProviderEmployeePriorityUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["EmployeePriorityUpdates"])) {
                this.employeePriorityUpdates = [] as any;
                for (let item of _data["EmployeePriorityUpdates"])
                    this.employeePriorityUpdates!.push(EmployeePriorityUpdateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeePriorityUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeePriorityUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.employeePriorityUpdates)) {
            data["EmployeePriorityUpdates"] = [];
            for (let item of this.employeePriorityUpdates)
                data["EmployeePriorityUpdates"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderEmployeePriorityUpdateModel {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeePriorityUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeePriorityUpdateModel {
    treatmentProviderId?: number;
    employeePriorityUpdates?: EmployeePriorityUpdateModel[] | undefined;
}

export class EmployeePriorityUpdateModel implements IEmployeePriorityUpdateModel {
    treatmentProviderEmployeeId?: number;
    priority?: number;
    deleted?: boolean;

    constructor(data?: IEmployeePriorityUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.priority = _data["Priority"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): EmployeePriorityUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePriorityUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["Priority"] = this.priority;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): EmployeePriorityUpdateModel {
        const json = this.toJSON();
        let result = new EmployeePriorityUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeePriorityUpdateModel {
    treatmentProviderEmployeeId?: number;
    priority?: number;
    deleted?: boolean;
}

export class CreateTPEClinicProfileModel implements ICreateTPEClinicProfileModel {
    fullName?: string | undefined;
    roleId?: number;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    treatmentTypesIds?: number[] | undefined;
    treatmentProviderId?: number | undefined;
    profileInfo?: string | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;

    constructor(data?: ICreateTPEClinicProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.roleId = _data["RoleId"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            if (Array.isArray(_data["TreatmentTypesIds"])) {
                this.treatmentTypesIds = [] as any;
                for (let item of _data["TreatmentTypesIds"])
                    this.treatmentTypesIds!.push(item);
            }
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.profileInfo = _data["ProfileInfo"];
            this.workingExperience = _data["WorkingExperience"];
            this.education = _data["Education"];
            this.certificates = _data["Certificates"];
            this.languages = _data["Languages"];
        }
    }

    static fromJS(data: any): CreateTPEClinicProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTPEClinicProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["RoleId"] = this.roleId;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.treatmentTypesIds)) {
            data["TreatmentTypesIds"] = [];
            for (let item of this.treatmentTypesIds)
                data["TreatmentTypesIds"].push(item);
        }
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["ProfileInfo"] = this.profileInfo;
        data["WorkingExperience"] = this.workingExperience;
        data["Education"] = this.education;
        data["Certificates"] = this.certificates;
        data["Languages"] = this.languages;
        return data; 
    }

    clone(): CreateTPEClinicProfileModel {
        const json = this.toJSON();
        let result = new CreateTPEClinicProfileModel();
        result.init(json);
        return result;
    }
}

export interface ICreateTPEClinicProfileModel {
    fullName?: string | undefined;
    roleId?: number;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    treatmentTypesIds?: number[] | undefined;
    treatmentProviderId?: number | undefined;
    profileInfo?: string | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
}

export class UpdateTreatmentProviderEmployeeClinicProfileModel implements IUpdateTreatmentProviderEmployeeClinicProfileModel {
    id?: number;
    userId?: number;
    treatmentProviderId?: number;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    profileInfo?: string | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
    employeeTreatmentTypeUpdate?: TreatmentProviderEmployeeTreatmentTypeUpdateModel | undefined;

    constructor(data?: IUpdateTreatmentProviderEmployeeClinicProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
            this.profileInfo = _data["ProfileInfo"];
            this.workingExperience = _data["WorkingExperience"];
            this.education = _data["Education"];
            this.certificates = _data["Certificates"];
            this.languages = _data["Languages"];
            this.employeeTreatmentTypeUpdate = _data["employeeTreatmentTypeUpdate"] ? TreatmentProviderEmployeeTreatmentTypeUpdateModel.fromJS(_data["employeeTreatmentTypeUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTreatmentProviderEmployeeClinicProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTreatmentProviderEmployeeClinicProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["ProfileInfo"] = this.profileInfo;
        data["WorkingExperience"] = this.workingExperience;
        data["Education"] = this.education;
        data["Certificates"] = this.certificates;
        data["Languages"] = this.languages;
        data["employeeTreatmentTypeUpdate"] = this.employeeTreatmentTypeUpdate ? this.employeeTreatmentTypeUpdate.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateTreatmentProviderEmployeeClinicProfileModel {
        const json = this.toJSON();
        let result = new UpdateTreatmentProviderEmployeeClinicProfileModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateTreatmentProviderEmployeeClinicProfileModel {
    id?: number;
    userId?: number;
    treatmentProviderId?: number;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    profileInfo?: string | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
    employeeTreatmentTypeUpdate?: TreatmentProviderEmployeeTreatmentTypeUpdateModel | undefined;
}

export class TreatmentProviderEmployeeTreatmentTypeUpdateModel implements ITreatmentProviderEmployeeTreatmentTypeUpdateModel {
    treatmentProviderEmployeeId?: number;
    employeeTreatmentTypeUpdates?: EmployeeTreatmentTypeUpdateModel[] | undefined;

    constructor(data?: ITreatmentProviderEmployeeTreatmentTypeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            if (Array.isArray(_data["EmployeeTreatmentTypeUpdates"])) {
                this.employeeTreatmentTypeUpdates = [] as any;
                for (let item of _data["EmployeeTreatmentTypeUpdates"])
                    this.employeeTreatmentTypeUpdates!.push(EmployeeTreatmentTypeUpdateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeeTreatmentTypeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeeTreatmentTypeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        if (Array.isArray(this.employeeTreatmentTypeUpdates)) {
            data["EmployeeTreatmentTypeUpdates"] = [];
            for (let item of this.employeeTreatmentTypeUpdates)
                data["EmployeeTreatmentTypeUpdates"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderEmployeeTreatmentTypeUpdateModel {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeeTreatmentTypeUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeeTreatmentTypeUpdateModel {
    treatmentProviderEmployeeId?: number;
    employeeTreatmentTypeUpdates?: EmployeeTreatmentTypeUpdateModel[] | undefined;
}

export class EmployeeTreatmentTypeUpdateModel implements IEmployeeTreatmentTypeUpdateModel {
    treatmentTypeId?: number;
    treatmentTypeName?: string | undefined;
    treatmentTypeCode?: string | undefined;
    deleted?: boolean;

    constructor(data?: IEmployeeTreatmentTypeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentTypeName = _data["TreatmentTypeName"];
            this.treatmentTypeCode = _data["TreatmentTypeCode"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): EmployeeTreatmentTypeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTreatmentTypeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentTypeName"] = this.treatmentTypeName;
        data["TreatmentTypeCode"] = this.treatmentTypeCode;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): EmployeeTreatmentTypeUpdateModel {
        const json = this.toJSON();
        let result = new EmployeeTreatmentTypeUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeeTreatmentTypeUpdateModel {
    treatmentTypeId?: number;
    treatmentTypeName?: string | undefined;
    treatmentTypeCode?: string | undefined;
    deleted?: boolean;
}

export class UpdateTreatmentProviderTreatmentTypesModel implements IUpdateTreatmentProviderTreatmentTypesModel {
    treatmentProviderId?: number;
    treatmentTypeId?: number;

    constructor(data?: IUpdateTreatmentProviderTreatmentTypesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
        }
    }

    static fromJS(data: any): UpdateTreatmentProviderTreatmentTypesModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTreatmentProviderTreatmentTypesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        return data; 
    }

    clone(): UpdateTreatmentProviderTreatmentTypesModel {
        const json = this.toJSON();
        let result = new UpdateTreatmentProviderTreatmentTypesModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateTreatmentProviderTreatmentTypesModel {
    treatmentProviderId?: number;
    treatmentTypeId?: number;
}

export class UserProfilePictureModel implements IUserProfilePictureModel {
    imgBase64!: string;
    filename!: string;
    userId?: number;

    constructor(data?: IUserProfilePictureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgBase64 = _data["ImgBase64"];
            this.filename = _data["Filename"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): UserProfilePictureModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfilePictureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImgBase64"] = this.imgBase64;
        data["Filename"] = this.filename;
        data["UserId"] = this.userId;
        return data; 
    }

    clone(): UserProfilePictureModel {
        const json = this.toJSON();
        let result = new UserProfilePictureModel();
        result.init(json);
        return result;
    }
}

export interface IUserProfilePictureModel {
    imgBase64: string;
    filename: string;
    userId?: number;
}

export class CompanyPageModel implements ICompanyPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    companies?: CompanyPageEntryModel[] | undefined;

    constructor(data?: ICompanyPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRows = _data["TotalRows"];
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanyPageEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRows"] = this.totalRows;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CompanyPageModel {
        const json = this.toJSON();
        let result = new CompanyPageModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    companies?: CompanyPageEntryModel[] | undefined;
}

export class CompanyPageEntryModel implements ICompanyPageEntryModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    dateCreated?: moment.Moment;
    treatmentProviderNetworkName?: string | undefined;
    canBeDeleted?: boolean;

    constructor(data?: ICompanyPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.comment = _data["Comment"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.treatmentProviderNetworkName = _data["TreatmentProviderNetworkName"];
            this.canBeDeleted = _data["CanBeDeleted"];
        }
    }

    static fromJS(data: any): CompanyPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Comment"] = this.comment;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["TreatmentProviderNetworkName"] = this.treatmentProviderNetworkName;
        data["CanBeDeleted"] = this.canBeDeleted;
        return data; 
    }

    clone(): CompanyPageEntryModel {
        const json = this.toJSON();
        let result = new CompanyPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyPageEntryModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    dateCreated?: moment.Moment;
    treatmentProviderNetworkName?: string | undefined;
    canBeDeleted?: boolean;
}

export class ShortCompanyDetailsModel extends BaseEntityModel implements IShortCompanyDetailsModel {
    id?: number;
    name?: string | undefined;
    employeeGroups?: EmployeeGroupShortModel[] | undefined;
    treatmentProviderNetworkId?: number;

    constructor(data?: IShortCompanyDetailsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["EmployeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["EmployeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupShortModel.fromJS(item));
            }
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
        }
    }

    static fromJS(data: any): ShortCompanyDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShortCompanyDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.employeeGroups)) {
            data["EmployeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["EmployeeGroups"].push(item.toJSON());
        }
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        super.toJSON(data);
        return data; 
    }

    clone(): ShortCompanyDetailsModel {
        const json = this.toJSON();
        let result = new ShortCompanyDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IShortCompanyDetailsModel extends IBaseEntityModel {
    id?: number;
    name?: string | undefined;
    employeeGroups?: EmployeeGroupShortModel[] | undefined;
    treatmentProviderNetworkId?: number;
}

export class EmployeeGroupShortModel implements IEmployeeGroupShortModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEmployeeGroupShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): EmployeeGroupShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): EmployeeGroupShortModel {
        const json = this.toJSON();
        let result = new EmployeeGroupShortModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroupShortModel {
    id?: number;
    name?: string | undefined;
}

export class CompanyCreateModel implements ICompanyCreateModel {
    companyName?: string | undefined;
    cvr?: string | undefined;
    comment?: string | undefined;
    abbreviation?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
    treatmentProviders?: number[] | undefined;
    employeeGroups?: string[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentTypeModel[] | undefined;
    dataOwner?: DataOwnerModel | undefined;

    constructor(data?: ICompanyCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["CompanyName"];
            this.cvr = _data["Cvr"];
            this.comment = _data["Comment"];
            this.abbreviation = _data["Abbreviation"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(CompanyLocationModel.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactShortModel.fromJS(item));
            }
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkShortModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(item);
            }
            if (Array.isArray(_data["EmployeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["EmployeeGroups"])
                    this.employeeGroups!.push(item);
            }
            if (Array.isArray(_data["CompanyTreatmentTypes"])) {
                this.companyTreatmentTypes = [] as any;
                for (let item of _data["CompanyTreatmentTypes"])
                    this.companyTreatmentTypes!.push(CompanyTreatmentTypeModel.fromJS(item));
            }
            this.dataOwner = _data["DataOwner"] ? DataOwnerModel.fromJS(_data["DataOwner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        data["Cvr"] = this.cvr;
        data["Comment"] = this.comment;
        data["Abbreviation"] = this.abbreviation;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item);
        }
        if (Array.isArray(this.employeeGroups)) {
            data["EmployeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["EmployeeGroups"].push(item);
        }
        if (Array.isArray(this.companyTreatmentTypes)) {
            data["CompanyTreatmentTypes"] = [];
            for (let item of this.companyTreatmentTypes)
                data["CompanyTreatmentTypes"].push(item.toJSON());
        }
        data["DataOwner"] = this.dataOwner ? this.dataOwner.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CompanyCreateModel {
        const json = this.toJSON();
        let result = new CompanyCreateModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyCreateModel {
    companyName?: string | undefined;
    cvr?: string | undefined;
    comment?: string | undefined;
    abbreviation?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
    treatmentProviders?: number[] | undefined;
    employeeGroups?: string[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentTypeModel[] | undefined;
    dataOwner?: DataOwnerModel | undefined;
}

export class CompanyLocationModel implements ICompanyLocationModel {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    rooms?: string[] | undefined;
    edited?: boolean;
    canBeDeleted?: boolean;

    constructor(data?: ICompanyLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            if (Array.isArray(_data["Rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["Rooms"])
                    this.rooms!.push(item);
            }
            this.edited = _data["Edited"];
            this.canBeDeleted = _data["CanBeDeleted"];
        }
    }

    static fromJS(data: any): CompanyLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        if (Array.isArray(this.rooms)) {
            data["Rooms"] = [];
            for (let item of this.rooms)
                data["Rooms"].push(item);
        }
        data["Edited"] = this.edited;
        data["CanBeDeleted"] = this.canBeDeleted;
        return data; 
    }

    clone(): CompanyLocationModel {
        const json = this.toJSON();
        let result = new CompanyLocationModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyLocationModel {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    rooms?: string[] | undefined;
    edited?: boolean;
    canBeDeleted?: boolean;
}

export class TreatmentProviderNetworkShortModel implements ITreatmentProviderNetworkShortModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    preferedLanguage?: string | undefined;
    urlPattern?: string | undefined;
    theme?: string | undefined;
    useNemId?: boolean;
    appTitle?: string | undefined;
    useVideoFeature?: boolean;
    selfRegistration?: boolean;
    defaultClinicProfile?: boolean;
    clinicAccessToAssignments?: boolean;
    clinicSearchAccess?: boolean;
    flexibleSchedule?: boolean;

    constructor(data?: ITreatmentProviderNetworkShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.preferedLanguage = _data["PreferedLanguage"];
            this.urlPattern = _data["UrlPattern"];
            this.theme = _data["Theme"];
            this.useNemId = _data["UseNemId"];
            this.appTitle = _data["AppTitle"];
            this.useVideoFeature = _data["UseVideoFeature"];
            this.selfRegistration = _data["SelfRegistration"];
            this.defaultClinicProfile = _data["DefaultClinicProfile"];
            this.clinicAccessToAssignments = _data["ClinicAccessToAssignments"];
            this.clinicSearchAccess = _data["ClinicSearchAccess"];
            this.flexibleSchedule = _data["FlexibleSchedule"];
        }
    }

    static fromJS(data: any): TreatmentProviderNetworkShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderNetworkShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["PreferedLanguage"] = this.preferedLanguage;
        data["UrlPattern"] = this.urlPattern;
        data["Theme"] = this.theme;
        data["UseNemId"] = this.useNemId;
        data["AppTitle"] = this.appTitle;
        data["UseVideoFeature"] = this.useVideoFeature;
        data["SelfRegistration"] = this.selfRegistration;
        data["DefaultClinicProfile"] = this.defaultClinicProfile;
        data["ClinicAccessToAssignments"] = this.clinicAccessToAssignments;
        data["ClinicSearchAccess"] = this.clinicSearchAccess;
        data["FlexibleSchedule"] = this.flexibleSchedule;
        return data; 
    }

    clone(): TreatmentProviderNetworkShortModel {
        const json = this.toJSON();
        let result = new TreatmentProviderNetworkShortModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderNetworkShortModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    preferedLanguage?: string | undefined;
    urlPattern?: string | undefined;
    theme?: string | undefined;
    useNemId?: boolean;
    appTitle?: string | undefined;
    useVideoFeature?: boolean;
    selfRegistration?: boolean;
    defaultClinicProfile?: boolean;
    clinicAccessToAssignments?: boolean;
    clinicSearchAccess?: boolean;
    flexibleSchedule?: boolean;
}

export class CompanyTreatmentTypeModel implements ICompanyTreatmentTypeModel {
    id?: number;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    initial?: boolean;
    maxNumberOfBookings?: number | undefined;
    yearlyLimitOfBookingsPerUser?: number | undefined;
    sortOrder?: number | undefined;

    constructor(data?: ICompanyTreatmentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.initial = _data["Initial"];
            this.maxNumberOfBookings = _data["MaxNumberOfBookings"];
            this.yearlyLimitOfBookingsPerUser = _data["YearlyLimitOfBookingsPerUser"];
            this.sortOrder = _data["SortOrder"];
        }
    }

    static fromJS(data: any): CompanyTreatmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTreatmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["Initial"] = this.initial;
        data["MaxNumberOfBookings"] = this.maxNumberOfBookings;
        data["YearlyLimitOfBookingsPerUser"] = this.yearlyLimitOfBookingsPerUser;
        data["SortOrder"] = this.sortOrder;
        return data; 
    }

    clone(): CompanyTreatmentTypeModel {
        const json = this.toJSON();
        let result = new CompanyTreatmentTypeModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyTreatmentTypeModel {
    id?: number;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    initial?: boolean;
    maxNumberOfBookings?: number | undefined;
    yearlyLimitOfBookingsPerUser?: number | undefined;
    sortOrder?: number | undefined;
}

export class DataOwnerModel implements IDataOwnerModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IDataOwnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): DataOwnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataOwnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): DataOwnerModel {
        const json = this.toJSON();
        let result = new DataOwnerModel();
        result.init(json);
        return result;
    }
}

export interface IDataOwnerModel {
    id?: number;
    name?: string | undefined;
}

export class CompanyEditDetailsModel implements ICompanyEditDetailsModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    abbreviation?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
    contacts?: ContactShortModel[] | undefined;
    locations?: CompanyLocationModel[] | undefined;
    treatmentProviders?: TreatmentProviderShortModel[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentTypeModel[] | undefined;
    employeeGroups?: EmployeeGroupShortModel[] | undefined;
    dataOwnerId?: number | undefined;
    dataOwner?: DataOwnerModel | undefined;

    constructor(data?: ICompanyEditDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.comment = _data["Comment"];
            this.abbreviation = _data["Abbreviation"];
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkShortModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactShortModel.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(CompanyLocationModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProviderShortModel.fromJS(item));
            }
            if (Array.isArray(_data["CompanyTreatmentTypes"])) {
                this.companyTreatmentTypes = [] as any;
                for (let item of _data["CompanyTreatmentTypes"])
                    this.companyTreatmentTypes!.push(CompanyTreatmentTypeModel.fromJS(item));
            }
            if (Array.isArray(_data["EmployeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["EmployeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupShortModel.fromJS(item));
            }
            this.dataOwnerId = _data["DataOwnerId"];
            this.dataOwner = _data["DataOwner"] ? DataOwnerModel.fromJS(_data["DataOwner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyEditDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyEditDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Comment"] = this.comment;
        data["Abbreviation"] = this.abbreviation;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.companyTreatmentTypes)) {
            data["CompanyTreatmentTypes"] = [];
            for (let item of this.companyTreatmentTypes)
                data["CompanyTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeGroups)) {
            data["EmployeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["EmployeeGroups"].push(item.toJSON());
        }
        data["DataOwnerId"] = this.dataOwnerId;
        data["DataOwner"] = this.dataOwner ? this.dataOwner.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CompanyEditDetailsModel {
        const json = this.toJSON();
        let result = new CompanyEditDetailsModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyEditDetailsModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    abbreviation?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
    contacts?: ContactShortModel[] | undefined;
    locations?: CompanyLocationModel[] | undefined;
    treatmentProviders?: TreatmentProviderShortModel[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentTypeModel[] | undefined;
    employeeGroups?: EmployeeGroupShortModel[] | undefined;
    dataOwnerId?: number | undefined;
    dataOwner?: DataOwnerModel | undefined;
}

export class TreatmentProviderShortModel implements ITreatmentProviderShortModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    locations?: LocationModel[] | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;

    constructor(data?: ITreatmentProviderShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderShortModel {
        const json = this.toJSON();
        let result = new TreatmentProviderShortModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderShortModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    locations?: LocationModel[] | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
}

export class RoomSelectModel implements IRoomSelectModel {
    id?: number;
    name?: string | undefined;
    available?: boolean;
    companyId?: number | undefined;
    companyName?: string | undefined;
    locationId?: number;
    location?: LocationModel | undefined;

    constructor(data?: IRoomSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.available = _data["Available"];
            this.companyId = _data["CompanyId"];
            this.companyName = _data["CompanyName"];
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RoomSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoomSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Available"] = this.available;
        data["CompanyId"] = this.companyId;
        data["CompanyName"] = this.companyName;
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RoomSelectModel {
        const json = this.toJSON();
        let result = new RoomSelectModel();
        result.init(json);
        return result;
    }
}

export interface IRoomSelectModel {
    id?: number;
    name?: string | undefined;
    available?: boolean;
    companyId?: number | undefined;
    companyName?: string | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
}

export class EmployeeGroupPageModel implements IEmployeeGroupPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    employeeGroups?: EmployeeGroupShortModel[] | undefined;

    constructor(data?: IEmployeeGroupPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRows = _data["TotalRows"];
            if (Array.isArray(_data["EmployeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["EmployeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupShortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeGroupPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRows"] = this.totalRows;
        if (Array.isArray(this.employeeGroups)) {
            data["EmployeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["EmployeeGroups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EmployeeGroupPageModel {
        const json = this.toJSON();
        let result = new EmployeeGroupPageModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroupPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    employeeGroups?: EmployeeGroupShortModel[] | undefined;
}

export class ResultDTO implements IResultDTO {
    entityResults?: EntityResultDTO[] | undefined;
    succeeded?: boolean;
    status?: string | undefined;
    statusCode?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["EntityResults"])) {
                this.entityResults = [] as any;
                for (let item of _data["EntityResults"])
                    this.entityResults!.push(EntityResultDTO.fromJS(item));
            }
            this.succeeded = _data["Succeeded"];
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.errorMessage = _data["ErrorMessage"];
            this.errorCode = _data["ErrorCode"];
        }
    }

    static fromJS(data: any): ResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entityResults)) {
            data["EntityResults"] = [];
            for (let item of this.entityResults)
                data["EntityResults"].push(item.toJSON());
        }
        data["Succeeded"] = this.succeeded;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ErrorMessage"] = this.errorMessage;
        data["ErrorCode"] = this.errorCode;
        return data; 
    }

    clone(): ResultDTO {
        const json = this.toJSON();
        let result = new ResultDTO();
        result.init(json);
        return result;
    }
}

export interface IResultDTO {
    entityResults?: EntityResultDTO[] | undefined;
    succeeded?: boolean;
    status?: string | undefined;
    statusCode?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export class EntityResultDTO implements IEntityResultDTO {
    id?: string | undefined;
    externalReferenceId?: string | undefined;
    entityType?: string | undefined;
    operation?: string | undefined;

    constructor(data?: IEntityResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.entityType = _data["EntityType"];
            this.operation = _data["Operation"];
        }
    }

    static fromJS(data: any): EntityResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EntityResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["EntityType"] = this.entityType;
        data["Operation"] = this.operation;
        return data; 
    }

    clone(): EntityResultDTO {
        const json = this.toJSON();
        let result = new EntityResultDTO();
        result.init(json);
        return result;
    }
}

export interface IEntityResultDTO {
    id?: string | undefined;
    externalReferenceId?: string | undefined;
    entityType?: string | undefined;
    operation?: string | undefined;
}

export class CreateUserRepresentativeModel implements ICreateUserRepresentativeModel {
    fullName!: string;
    email!: string;
    phoneNumber!: string;
    password!: string;
    token!: string;
    treatmentProviderId!: number;

    constructor(data?: ICreateUserRepresentativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.password = _data["Password"];
            this.token = _data["Token"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
        }
    }

    static fromJS(data: any): CreateUserRepresentativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRepresentativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Password"] = this.password;
        data["Token"] = this.token;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        return data; 
    }

    clone(): CreateUserRepresentativeModel {
        const json = this.toJSON();
        let result = new CreateUserRepresentativeModel();
        result.init(json);
        return result;
    }
}

export interface ICreateUserRepresentativeModel {
    fullName: string;
    email: string;
    phoneNumber: string;
    password: string;
    token: string;
    treatmentProviderId: number;
}

export class ChangePasswordModel implements IChangePasswordModel {
    currentPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IChangePasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["CurrentPassword"];
            this.newPassword = _data["NewPassword"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CurrentPassword"] = this.currentPassword;
        data["NewPassword"] = this.newPassword;
        data["ConfirmPassword"] = this.confirmPassword;
        return data; 
    }

    clone(): ChangePasswordModel {
        const json = this.toJSON();
        let result = new ChangePasswordModel();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordModel {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
    email!: string;
    language!: string;

    constructor(data?: IForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): ForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Language"] = this.language;
        return data; 
    }

    clone(): ForgotPasswordModel {
        const json = this.toJSON();
        let result = new ForgotPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordModel {
    email: string;
    language: string;
}

export class ResetPasswordModel implements IResetPasswordModel {
    email!: string;
    token!: string;
    password!: string;
    confirmPassword!: string;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.token = _data["Token"];
            this.password = _data["Password"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Token"] = this.token;
        data["Password"] = this.password;
        data["ConfirmPassword"] = this.confirmPassword;
        return data; 
    }

    clone(): ResetPasswordModel {
        const json = this.toJSON();
        let result = new ResetPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordModel {
    email: string;
    token: string;
    password: string;
    confirmPassword: string;
}

export class HomePageCaseModel implements IHomePageCaseModel {
    id?: number;
    subject?: string | undefined;
    pastBookingsCount?: number;
    upcomingBookingsCount?: number;
    nextBookingDate?: moment.Moment | undefined;

    constructor(data?: IHomePageCaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.pastBookingsCount = _data["PastBookingsCount"];
            this.upcomingBookingsCount = _data["UpcomingBookingsCount"];
            this.nextBookingDate = _data["NextBookingDate"] ? moment(_data["NextBookingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomePageCaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new HomePageCaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["PastBookingsCount"] = this.pastBookingsCount;
        data["UpcomingBookingsCount"] = this.upcomingBookingsCount;
        data["NextBookingDate"] = this.nextBookingDate ? this.nextBookingDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): HomePageCaseModel {
        const json = this.toJSON();
        let result = new HomePageCaseModel();
        result.init(json);
        return result;
    }
}

export interface IHomePageCaseModel {
    id?: number;
    subject?: string | undefined;
    pastBookingsCount?: number;
    upcomingBookingsCount?: number;
    nextBookingDate?: moment.Moment | undefined;
}

export class IdentityResultModel implements IIdentityResultModel {
    succeeded?: boolean;
    errors?: string[] | undefined;

    constructor(data?: IIdentityResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            if (Array.isArray(_data["Errors"])) {
                this.errors = [] as any;
                for (let item of _data["Errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): IdentityResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    clone(): IdentityResultModel {
        const json = this.toJSON();
        let result = new IdentityResultModel();
        result.init(json);
        return result;
    }
}

export interface IIdentityResultModel {
    succeeded?: boolean;
    errors?: string[] | undefined;
}

export class InternalCommentPageModel implements IInternalCommentPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalNumber?: number;
    internalComments?: InternalCommentModel[] | undefined;

    constructor(data?: IInternalCommentPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalNumber = _data["TotalNumber"];
            if (Array.isArray(_data["InternalComments"])) {
                this.internalComments = [] as any;
                for (let item of _data["InternalComments"])
                    this.internalComments!.push(InternalCommentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InternalCommentPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternalCommentPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalNumber"] = this.totalNumber;
        if (Array.isArray(this.internalComments)) {
            data["InternalComments"] = [];
            for (let item of this.internalComments)
                data["InternalComments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): InternalCommentPageModel {
        const json = this.toJSON();
        let result = new InternalCommentPageModel();
        result.init(json);
        return result;
    }
}

export interface IInternalCommentPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalNumber?: number;
    internalComments?: InternalCommentModel[] | undefined;
}

export class InternalCommentModel extends BaseEntityModel implements IInternalCommentModel {
    id?: number;
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
    user?: UserRefModel | undefined;

    constructor(data?: IInternalCommentModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.caseId = _data["CaseId"];
            this.user = _data["User"] ? UserRefModel.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternalCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["CaseId"] = this.caseId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): InternalCommentModel {
        const json = this.toJSON();
        let result = new InternalCommentModel();
        result.init(json);
        return result;
    }
}

export interface IInternalCommentModel extends IBaseEntityModel {
    id?: number;
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
    user?: UserRefModel | undefined;
}

export class InternalCommentCreateModel implements IInternalCommentCreateModel {
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;

    constructor(data?: IInternalCommentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.caseId = _data["CaseId"];
        }
    }

    static fromJS(data: any): InternalCommentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternalCommentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["CaseId"] = this.caseId;
        return data; 
    }

    clone(): InternalCommentCreateModel {
        const json = this.toJSON();
        let result = new InternalCommentCreateModel();
        result.init(json);
        return result;
    }
}

export interface IInternalCommentCreateModel {
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
}

export class MedicalJournalPageModel implements IMedicalJournalPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    shouldShowConsent?: boolean;
    hasPendingConsent?: boolean;
    medicalJournals?: MedicalJournalModel[] | undefined;

    constructor(data?: IMedicalJournalPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRow = _data["TotalRow"];
            this.shouldShowConsent = _data["ShouldShowConsent"];
            this.hasPendingConsent = _data["HasPendingConsent"];
            if (Array.isArray(_data["MedicalJournals"])) {
                this.medicalJournals = [] as any;
                for (let item of _data["MedicalJournals"])
                    this.medicalJournals!.push(MedicalJournalModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalJournalPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalJournalPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRow"] = this.totalRow;
        data["ShouldShowConsent"] = this.shouldShowConsent;
        data["HasPendingConsent"] = this.hasPendingConsent;
        if (Array.isArray(this.medicalJournals)) {
            data["MedicalJournals"] = [];
            for (let item of this.medicalJournals)
                data["MedicalJournals"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalJournalPageModel {
        const json = this.toJSON();
        let result = new MedicalJournalPageModel();
        result.init(json);
        return result;
    }
}

export interface IMedicalJournalPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRow?: number;
    shouldShowConsent?: boolean;
    hasPendingConsent?: boolean;
    medicalJournals?: MedicalJournalModel[] | undefined;
}

export class MedicalJournalModel extends BaseEntityModel implements IMedicalJournalModel {
    filePath?: string | undefined;
    id?: number;
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
    user?: UserRefModel | undefined;
    files?: FileModel[] | undefined;
    originalMedicalJournalId?: number | undefined;
    originalMedicalJournal?: MedicalJournalModel | undefined;
    historyMedicalJournal?: MedicalJournalModel[] | undefined;

    constructor(data?: IMedicalJournalModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filePath = _data["FilePath"];
            this.id = _data["Id"];
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.caseId = _data["CaseId"];
            this.user = _data["User"] ? UserRefModel.fromJS(_data["User"]) : <any>undefined;
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            this.originalMedicalJournalId = _data["OriginalMedicalJournalId"];
            this.originalMedicalJournal = _data["OriginalMedicalJournal"] ? MedicalJournalModel.fromJS(_data["OriginalMedicalJournal"]) : <any>undefined;
            if (Array.isArray(_data["HistoryMedicalJournal"])) {
                this.historyMedicalJournal = [] as any;
                for (let item of _data["HistoryMedicalJournal"])
                    this.historyMedicalJournal!.push(MedicalJournalModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalJournalModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalJournalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["Id"] = this.id;
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["CaseId"] = this.caseId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        data["OriginalMedicalJournalId"] = this.originalMedicalJournalId;
        data["OriginalMedicalJournal"] = this.originalMedicalJournal ? this.originalMedicalJournal.toJSON() : <any>undefined;
        if (Array.isArray(this.historyMedicalJournal)) {
            data["HistoryMedicalJournal"] = [];
            for (let item of this.historyMedicalJournal)
                data["HistoryMedicalJournal"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MedicalJournalModel {
        const json = this.toJSON();
        let result = new MedicalJournalModel();
        result.init(json);
        return result;
    }
}

export interface IMedicalJournalModel extends IBaseEntityModel {
    filePath?: string | undefined;
    id?: number;
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
    user?: UserRefModel | undefined;
    files?: FileModel[] | undefined;
    originalMedicalJournalId?: number | undefined;
    originalMedicalJournal?: MedicalJournalModel | undefined;
    historyMedicalJournal?: MedicalJournalModel[] | undefined;
}

export class MedicalJournalCreateModel implements IMedicalJournalCreateModel {
    textHtml?: string | undefined;
    caseId?: number;
    fileIds?: number[] | undefined;
    originalMedicalJorunalId?: number | undefined;

    constructor(data?: IMedicalJournalCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textHtml = _data["TextHtml"];
            this.caseId = _data["CaseId"];
            if (Array.isArray(_data["FileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["FileIds"])
                    this.fileIds!.push(item);
            }
            this.originalMedicalJorunalId = _data["OriginalMedicalJorunalId"];
        }
    }

    static fromJS(data: any): MedicalJournalCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalJournalCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TextHtml"] = this.textHtml;
        data["CaseId"] = this.caseId;
        if (Array.isArray(this.fileIds)) {
            data["FileIds"] = [];
            for (let item of this.fileIds)
                data["FileIds"].push(item);
        }
        data["OriginalMedicalJorunalId"] = this.originalMedicalJorunalId;
        return data; 
    }

    clone(): MedicalJournalCreateModel {
        const json = this.toJSON();
        let result = new MedicalJournalCreateModel();
        result.init(json);
        return result;
    }
}

export interface IMedicalJournalCreateModel {
    textHtml?: string | undefined;
    caseId?: number;
    fileIds?: number[] | undefined;
    originalMedicalJorunalId?: number | undefined;
}

export class NotificationTemplatesPageModel implements INotificationTemplatesPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    notificationTemplates?: NotificationTemplatesPageEntryModel[] | undefined;

    constructor(data?: INotificationTemplatesPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRows = _data["TotalRows"];
            if (Array.isArray(_data["NotificationTemplates"])) {
                this.notificationTemplates = [] as any;
                for (let item of _data["NotificationTemplates"])
                    this.notificationTemplates!.push(NotificationTemplatesPageEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationTemplatesPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTemplatesPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRows"] = this.totalRows;
        if (Array.isArray(this.notificationTemplates)) {
            data["NotificationTemplates"] = [];
            for (let item of this.notificationTemplates)
                data["NotificationTemplates"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NotificationTemplatesPageModel {
        const json = this.toJSON();
        let result = new NotificationTemplatesPageModel();
        result.init(json);
        return result;
    }
}

export interface INotificationTemplatesPageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    notificationTemplates?: NotificationTemplatesPageEntryModel[] | undefined;
}

export class NotificationTemplatesPageEntryModel implements INotificationTemplatesPageEntryModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    language?: string | undefined;
    type?: NotificationTemplateType;
    dateCreated?: moment.Moment;
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;

    constructor(data?: INotificationTemplatesPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.language = _data["Language"];
            this.type = _data["Type"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkShortModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationTemplatesPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTemplatesPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Language"] = this.language;
        data["Type"] = this.type;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        return data; 
    }

    clone(): NotificationTemplatesPageEntryModel {
        const json = this.toJSON();
        let result = new NotificationTemplatesPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface INotificationTemplatesPageEntryModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    language?: string | undefined;
    type?: NotificationTemplateType;
    dateCreated?: moment.Moment;
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
}

export enum NotificationTemplateType {
    Email = 1,
    TextMessage = 2,
}

export class EmailTemplateModel extends BaseEntityModel implements IEmailTemplateModel {
    id?: number;
    subject?: string | undefined;
    body?: string | undefined;
    language?: string | undefined;
    keyword?: string | undefined;
    description?: string | undefined;
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;

    constructor(data?: IEmailTemplateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.language = _data["Language"];
            this.keyword = _data["Keyword"];
            this.description = _data["Description"];
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkShortModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["Language"] = this.language;
        data["Keyword"] = this.keyword;
        data["Description"] = this.description;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): EmailTemplateModel {
        const json = this.toJSON();
        let result = new EmailTemplateModel();
        result.init(json);
        return result;
    }
}

export interface IEmailTemplateModel extends IBaseEntityModel {
    id?: number;
    subject?: string | undefined;
    body?: string | undefined;
    language?: string | undefined;
    keyword?: string | undefined;
    description?: string | undefined;
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
}

export class TextMessageTemplateModel implements ITextMessageTemplateModel {
    id?: number;
    text?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;

    constructor(data?: ITextMessageTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.text = _data["Text"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.language = _data["Language"];
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkShortModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TextMessageTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessageTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Text"] = this.text;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["Language"] = this.language;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TextMessageTemplateModel {
        const json = this.toJSON();
        let result = new TextMessageTemplateModel();
        result.init(json);
        return result;
    }
}

export interface ITextMessageTemplateModel {
    id?: number;
    text?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetworkShortModel | undefined;
}

export class UserNotificationModel implements IUserNotificationModel {
    textMessageEnabled?: boolean;
    emailEnabled?: boolean;
    receiveCalendarInvitation?: boolean;

    constructor(data?: IUserNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textMessageEnabled = _data["TextMessageEnabled"];
            this.emailEnabled = _data["EmailEnabled"];
            this.receiveCalendarInvitation = _data["ReceiveCalendarInvitation"];
        }
    }

    static fromJS(data: any): UserNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TextMessageEnabled"] = this.textMessageEnabled;
        data["EmailEnabled"] = this.emailEnabled;
        data["ReceiveCalendarInvitation"] = this.receiveCalendarInvitation;
        return data; 
    }

    clone(): UserNotificationModel {
        const json = this.toJSON();
        let result = new UserNotificationModel();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationModel {
    textMessageEnabled?: boolean;
    emailEnabled?: boolean;
    receiveCalendarInvitation?: boolean;
}

export class AuditedEntity implements IAuditedEntity {
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;

    constructor(data?: IAuditedEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): AuditedEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AuditedEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): AuditedEntity {
        const json = this.toJSON();
        let result = new AuditedEntity();
        result.init(json);
        return result;
    }
}

export interface IAuditedEntity {
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
}

export class BaseEntityOfInteger extends AuditedEntity implements IBaseEntityOfInteger {
    id?: number;

    constructor(data?: IBaseEntityOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): BaseEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntityOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data; 
    }

    clone(): BaseEntityOfInteger {
        const json = this.toJSON();
        let result = new BaseEntityOfInteger();
        result.init(json);
        return result;
    }
}

export interface IBaseEntityOfInteger extends IAuditedEntity {
    id?: number;
}

export class BaseEntity extends BaseEntityOfInteger implements IBaseEntity {

    constructor(data?: IBaseEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): BaseEntity {
        const json = this.toJSON();
        let result = new BaseEntity();
        result.init(json);
        return result;
    }
}

export interface IBaseEntity extends IBaseEntityOfInteger {
}

export class TextMessageTemplate extends BaseEntity implements ITextMessageTemplate {
    text?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;

    constructor(data?: ITextMessageTemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["Text"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.language = _data["Language"];
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetwork.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TextMessageTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessageTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["Language"] = this.language;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): TextMessageTemplate {
        const json = this.toJSON();
        let result = new TextMessageTemplate();
        result.init(json);
        return result;
    }
}

export interface ITextMessageTemplate extends IBaseEntity {
    text?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
}

export class TreatmentProviderNetwork extends BaseEntity implements ITreatmentProviderNetwork {
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    comment?: string | undefined;
    preferedLanguage?: string | undefined;
    active?: boolean;
    emailFrom?: string | undefined;
    emailFromDisplayName?: string | undefined;
    urlPattern?: string | undefined;
    theme?: string | undefined;
    useNemId?: boolean;
    appTitle?: string | undefined;
    useVideoFeature?: boolean;
    selfRegistration?: boolean;
    defaultClinicProfile?: boolean;
    clinicAccessToAssignments?: boolean;
    clinicSearchAccess?: boolean;
    receiveCalendarInvitation?: boolean;
    flexibleSchedule?: boolean;
    sendTextMessages?: boolean;
    parentId?: number | undefined;
    treatmentProviderNetworkDetails?: TreatmentProviderNetworkDetail[] | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    users?: User[] | undefined;

    constructor(data?: ITreatmentProviderNetwork) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.comment = _data["Comment"];
            this.preferedLanguage = _data["PreferedLanguage"];
            this.active = _data["Active"];
            this.emailFrom = _data["EmailFrom"];
            this.emailFromDisplayName = _data["EmailFromDisplayName"];
            this.urlPattern = _data["UrlPattern"];
            this.theme = _data["Theme"];
            this.useNemId = _data["UseNemId"];
            this.appTitle = _data["AppTitle"];
            this.useVideoFeature = _data["UseVideoFeature"];
            this.selfRegistration = _data["SelfRegistration"];
            this.defaultClinicProfile = _data["DefaultClinicProfile"];
            this.clinicAccessToAssignments = _data["ClinicAccessToAssignments"];
            this.clinicSearchAccess = _data["ClinicSearchAccess"];
            this.receiveCalendarInvitation = _data["ReceiveCalendarInvitation"];
            this.flexibleSchedule = _data["FlexibleSchedule"];
            this.sendTextMessages = _data["SendTextMessages"];
            this.parentId = _data["ParentId"];
            if (Array.isArray(_data["TreatmentProviderNetworkDetails"])) {
                this.treatmentProviderNetworkDetails = [] as any;
                for (let item of _data["TreatmentProviderNetworkDetails"])
                    this.treatmentProviderNetworkDetails!.push(TreatmentProviderNetworkDetail.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderNetwork {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderNetwork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Comment"] = this.comment;
        data["PreferedLanguage"] = this.preferedLanguage;
        data["Active"] = this.active;
        data["EmailFrom"] = this.emailFrom;
        data["EmailFromDisplayName"] = this.emailFromDisplayName;
        data["UrlPattern"] = this.urlPattern;
        data["Theme"] = this.theme;
        data["UseNemId"] = this.useNemId;
        data["AppTitle"] = this.appTitle;
        data["UseVideoFeature"] = this.useVideoFeature;
        data["SelfRegistration"] = this.selfRegistration;
        data["DefaultClinicProfile"] = this.defaultClinicProfile;
        data["ClinicAccessToAssignments"] = this.clinicAccessToAssignments;
        data["ClinicSearchAccess"] = this.clinicSearchAccess;
        data["ReceiveCalendarInvitation"] = this.receiveCalendarInvitation;
        data["FlexibleSchedule"] = this.flexibleSchedule;
        data["SendTextMessages"] = this.sendTextMessages;
        data["ParentId"] = this.parentId;
        if (Array.isArray(this.treatmentProviderNetworkDetails)) {
            data["TreatmentProviderNetworkDetails"] = [];
            for (let item of this.treatmentProviderNetworkDetails)
                data["TreatmentProviderNetworkDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderNetwork {
        const json = this.toJSON();
        let result = new TreatmentProviderNetwork();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderNetwork extends IBaseEntity {
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    comment?: string | undefined;
    preferedLanguage?: string | undefined;
    active?: boolean;
    emailFrom?: string | undefined;
    emailFromDisplayName?: string | undefined;
    urlPattern?: string | undefined;
    theme?: string | undefined;
    useNemId?: boolean;
    appTitle?: string | undefined;
    useVideoFeature?: boolean;
    selfRegistration?: boolean;
    defaultClinicProfile?: boolean;
    clinicAccessToAssignments?: boolean;
    clinicSearchAccess?: boolean;
    receiveCalendarInvitation?: boolean;
    flexibleSchedule?: boolean;
    sendTextMessages?: boolean;
    parentId?: number | undefined;
    treatmentProviderNetworkDetails?: TreatmentProviderNetworkDetail[] | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    users?: User[] | undefined;
}

export class TreatmentProviderNetworkDetail extends BaseEntity implements ITreatmentProviderNetworkDetail {
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
    logoPath?: string | undefined;
    color?: string | undefined;

    constructor(data?: ITreatmentProviderNetworkDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetwork.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            this.logoPath = _data["LogoPath"];
            this.color = _data["Color"];
        }
    }

    static fromJS(data: any): TreatmentProviderNetworkDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderNetworkDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        data["LogoPath"] = this.logoPath;
        data["Color"] = this.color;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderNetworkDetail {
        const json = this.toJSON();
        let result = new TreatmentProviderNetworkDetail();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderNetworkDetail extends IBaseEntity {
    treatmentProviderNetworkId?: number;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
    logoPath?: string | undefined;
    color?: string | undefined;
}

export class Contact extends BaseEntity implements IContact {
    email?: string | undefined;
    phone?: string | undefined;
    phoneComment?: string | undefined;
    mobile?: string | undefined;
    mobileComment?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
    contactPerson?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    contactTypeId?: number;
    contactType?: ContactType | undefined;
    identifier?: string;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetwork[] | undefined;

    constructor(data?: IContact) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.phoneComment = _data["PhoneComment"];
            this.mobile = _data["Mobile"];
            this.mobileComment = _data["MobileComment"];
            this.fax = _data["Fax"];
            this.uRL = _data["URL"];
            this.contactPerson = _data["ContactPerson"];
            this.timeFrom = _data["TimeFrom"];
            this.timeTo = _data["TimeTo"];
            this.contactTypeId = _data["ContactTypeId"];
            this.contactType = _data["ContactType"] ? ContactType.fromJS(_data["ContactType"]) : <any>undefined;
            this.identifier = _data["Identifier"];
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderNetworks"])) {
                this.treatmentProviderNetworks = [] as any;
                for (let item of _data["TreatmentProviderNetworks"])
                    this.treatmentProviderNetworks!.push(TreatmentProviderNetwork.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["PhoneComment"] = this.phoneComment;
        data["Mobile"] = this.mobile;
        data["MobileComment"] = this.mobileComment;
        data["Fax"] = this.fax;
        data["URL"] = this.uRL;
        data["ContactPerson"] = this.contactPerson;
        data["TimeFrom"] = this.timeFrom;
        data["TimeTo"] = this.timeTo;
        data["ContactTypeId"] = this.contactTypeId;
        data["ContactType"] = this.contactType ? this.contactType.toJSON() : <any>undefined;
        data["Identifier"] = this.identifier;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderNetworks)) {
            data["TreatmentProviderNetworks"] = [];
            for (let item of this.treatmentProviderNetworks)
                data["TreatmentProviderNetworks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact extends IBaseEntity {
    email?: string | undefined;
    phone?: string | undefined;
    phoneComment?: string | undefined;
    mobile?: string | undefined;
    mobileComment?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
    contactPerson?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    contactTypeId?: number;
    contactType?: ContactType | undefined;
    identifier?: string;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetwork[] | undefined;
}

export class ContactType extends BaseEntity implements IContactType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IContactType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): ContactType {
        data = typeof data === 'object' ? data : {};
        let result = new ContactType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        super.toJSON(data);
        return data; 
    }

    clone(): ContactType {
        const json = this.toJSON();
        let result = new ContactType();
        result.init(json);
        return result;
    }
}

export interface IContactType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class IdentityUserOfInteger implements IIdentityUserOfInteger {
    id?: number;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: moment.Moment | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userName = _data["UserName"];
            this.normalizedUserName = _data["NormalizedUserName"];
            this.email = _data["Email"];
            this.normalizedEmail = _data["NormalizedEmail"];
            this.emailConfirmed = _data["EmailConfirmed"];
            this.passwordHash = _data["PasswordHash"];
            this.securityStamp = _data["SecurityStamp"];
            this.concurrencyStamp = _data["ConcurrencyStamp"];
            this.phoneNumber = _data["PhoneNumber"];
            this.phoneNumberConfirmed = _data["PhoneNumberConfirmed"];
            this.twoFactorEnabled = _data["TwoFactorEnabled"];
            this.lockoutEnd = _data["LockoutEnd"] ? moment(_data["LockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["LockoutEnabled"];
            this.accessFailedCount = _data["AccessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserName"] = this.userName;
        data["NormalizedUserName"] = this.normalizedUserName;
        data["Email"] = this.email;
        data["NormalizedEmail"] = this.normalizedEmail;
        data["EmailConfirmed"] = this.emailConfirmed;
        data["PasswordHash"] = this.passwordHash;
        data["SecurityStamp"] = this.securityStamp;
        data["ConcurrencyStamp"] = this.concurrencyStamp;
        data["PhoneNumber"] = this.phoneNumber;
        data["PhoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["TwoFactorEnabled"] = this.twoFactorEnabled;
        data["LockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["LockoutEnabled"] = this.lockoutEnabled;
        data["AccessFailedCount"] = this.accessFailedCount;
        return data; 
    }

    clone(): IdentityUserOfInteger {
        const json = this.toJSON();
        let result = new IdentityUserOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserOfInteger {
    id?: number;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: moment.Moment | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class User extends IdentityUserOfInteger implements IUser {
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    preferedLanguage?: string | undefined;
    dateNotificationEmailSent?: moment.Moment | undefined;
    lastLoginTime?: moment.Moment | undefined;
    dateEmailConfirmed?: moment.Moment | undefined;
    sexId?: number;
    sex?: Sex | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompany | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    userPermissions?: UserPermission[] | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployee[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    changeLogs?: ChangeLog[] | undefined;
    emails?: Email[] | undefined;
    files?: File[] | undefined;
    notes?: Note[] | undefined;
    cases?: Case[] | undefined;
    companies?: Company[] | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
    externalReferenceId?: string | undefined;
    synchronizationDate?: moment.Moment | undefined;
    synchronizedBy?: string | undefined;
    active?: boolean;
    membershipId?: string | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetwork[] | undefined;
    userNotifications?: UserNotification[] | undefined;
    claims?: UserClaim[] | undefined;
    logins?: UserLogin[] | undefined;
    tokens?: UserToken[] | undefined;
    userRoles?: UserRole[] | undefined;
    notificationsConfirmed?: boolean;

    constructor(data?: IUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.comment = _data["Comment"];
            this.publicKey = _data["PublicKey"];
            this.profilePicture = _data["ProfilePicture"];
            this.profileInfo = _data["ProfileInfo"];
            this.preferedLanguage = _data["PreferedLanguage"];
            this.dateNotificationEmailSent = _data["DateNotificationEmailSent"] ? moment(_data["DateNotificationEmailSent"].toString()) : <any>undefined;
            this.lastLoginTime = _data["LastLoginTime"] ? moment(_data["LastLoginTime"].toString()) : <any>undefined;
            this.dateEmailConfirmed = _data["DateEmailConfirmed"] ? moment(_data["DateEmailConfirmed"].toString()) : <any>undefined;
            this.sexId = _data["SexId"];
            this.sex = _data["Sex"] ? Sex.fromJS(_data["Sex"]) : <any>undefined;
            this.insuranceCompanyId = _data["InsuranceCompanyId"];
            this.insuranceCompany = _data["InsuranceCompany"] ? InsuranceCompany.fromJS(_data["InsuranceCompany"]) : <any>undefined;
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["UserPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["UserPermissions"])
                    this.userPermissions!.push(UserPermission.fromJS(item));
            }
            if (Array.isArray(_data["EmployeeGroupEmployees"])) {
                this.employeeGroupEmployees = [] as any;
                for (let item of _data["EmployeeGroupEmployees"])
                    this.employeeGroupEmployees!.push(EmployeeGroupEmployee.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployee.fromJS(item));
            }
            if (Array.isArray(_data["ChangeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["ChangeLogs"])
                    this.changeLogs!.push(ChangeLog.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(File.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(Note.fromJS(item));
            }
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases!.push(Case.fromJS(item));
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.synchronizationDate = _data["SynchronizationDate"] ? moment(_data["SynchronizationDate"].toString()) : <any>undefined;
            this.synchronizedBy = _data["SynchronizedBy"];
            this.active = _data["Active"];
            this.membershipId = _data["MembershipId"];
            if (Array.isArray(_data["TreatmentProviderNetworks"])) {
                this.treatmentProviderNetworks = [] as any;
                for (let item of _data["TreatmentProviderNetworks"])
                    this.treatmentProviderNetworks!.push(TreatmentProviderNetwork.fromJS(item));
            }
            if (Array.isArray(_data["UserNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["UserNotifications"])
                    this.userNotifications!.push(UserNotification.fromJS(item));
            }
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["Logins"])) {
                this.logins = [] as any;
                for (let item of _data["Logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["Tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["Tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            if (Array.isArray(_data["UserRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["UserRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.notificationsConfirmed = _data["NotificationsConfirmed"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Comment"] = this.comment;
        data["PublicKey"] = this.publicKey;
        data["ProfilePicture"] = this.profilePicture;
        data["ProfileInfo"] = this.profileInfo;
        data["PreferedLanguage"] = this.preferedLanguage;
        data["DateNotificationEmailSent"] = this.dateNotificationEmailSent ? this.dateNotificationEmailSent.toISOString() : <any>undefined;
        data["LastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["DateEmailConfirmed"] = this.dateEmailConfirmed ? this.dateEmailConfirmed.toISOString() : <any>undefined;
        data["SexId"] = this.sexId;
        data["Sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["InsuranceCompanyId"] = this.insuranceCompanyId;
        data["InsuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["UserPermissions"] = [];
            for (let item of this.userPermissions)
                data["UserPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeGroupEmployees)) {
            data["EmployeeGroupEmployees"] = [];
            for (let item of this.employeeGroupEmployees)
                data["EmployeeGroupEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.changeLogs)) {
            data["ChangeLogs"] = [];
            for (let item of this.changeLogs)
                data["ChangeLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["SynchronizationDate"] = this.synchronizationDate ? this.synchronizationDate.toISOString() : <any>undefined;
        data["SynchronizedBy"] = this.synchronizedBy;
        data["Active"] = this.active;
        data["MembershipId"] = this.membershipId;
        if (Array.isArray(this.treatmentProviderNetworks)) {
            data["TreatmentProviderNetworks"] = [];
            for (let item of this.treatmentProviderNetworks)
                data["TreatmentProviderNetworks"].push(item.toJSON());
        }
        if (Array.isArray(this.userNotifications)) {
            data["UserNotifications"] = [];
            for (let item of this.userNotifications)
                data["UserNotifications"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item.toJSON());
        }
        if (Array.isArray(this.logins)) {
            data["Logins"] = [];
            for (let item of this.logins)
                data["Logins"].push(item.toJSON());
        }
        if (Array.isArray(this.tokens)) {
            data["Tokens"] = [];
            for (let item of this.tokens)
                data["Tokens"].push(item.toJSON());
        }
        if (Array.isArray(this.userRoles)) {
            data["UserRoles"] = [];
            for (let item of this.userRoles)
                data["UserRoles"].push(item.toJSON());
        }
        data["NotificationsConfirmed"] = this.notificationsConfirmed;
        super.toJSON(data);
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser extends IIdentityUserOfInteger {
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    preferedLanguage?: string | undefined;
    dateNotificationEmailSent?: moment.Moment | undefined;
    lastLoginTime?: moment.Moment | undefined;
    dateEmailConfirmed?: moment.Moment | undefined;
    sexId?: number;
    sex?: Sex | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompany | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    userPermissions?: UserPermission[] | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployee[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    changeLogs?: ChangeLog[] | undefined;
    emails?: Email[] | undefined;
    files?: File[] | undefined;
    notes?: Note[] | undefined;
    cases?: Case[] | undefined;
    companies?: Company[] | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
    externalReferenceId?: string | undefined;
    synchronizationDate?: moment.Moment | undefined;
    synchronizedBy?: string | undefined;
    active?: boolean;
    membershipId?: string | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetwork[] | undefined;
    userNotifications?: UserNotification[] | undefined;
    claims?: UserClaim[] | undefined;
    logins?: UserLogin[] | undefined;
    tokens?: UserToken[] | undefined;
    userRoles?: UserRole[] | undefined;
    notificationsConfirmed?: boolean;
}

export class Sex extends BaseEntity implements ISex {
    name?: string | undefined;
    translations?: SexTranslation[] | undefined;

    constructor(data?: ISex) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(SexTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Sex {
        data = typeof data === 'object' ? data : {};
        let result = new Sex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Sex {
        const json = this.toJSON();
        let result = new Sex();
        result.init(json);
        return result;
    }
}

export interface ISex extends IBaseEntity {
    name?: string | undefined;
    translations?: SexTranslation[] | undefined;
}

export class SexTranslation implements ISexTranslation {
    name?: string | undefined;
    entity?: Sex | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: ISexTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.entity = _data["Entity"] ? Sex.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): SexTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new SexTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): SexTranslation {
        const json = this.toJSON();
        let result = new SexTranslation();
        result.init(json);
        return result;
    }
}

export interface ISexTranslation {
    name?: string | undefined;
    entity?: Sex | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class InsuranceCompany extends BaseEntity implements IInsuranceCompany {
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    externalIntegrationSystemId?: number | undefined;
    externalIntegrationSystem?: ExternalIntegrationSystem | undefined;

    constructor(data?: IInsuranceCompany) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.externalIntegrationSystemId = _data["ExternalIntegrationSystemId"];
            this.externalIntegrationSystem = _data["ExternalIntegrationSystem"] ? ExternalIntegrationSystem.fromJS(_data["ExternalIntegrationSystem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ExternalIntegrationSystemId"] = this.externalIntegrationSystemId;
        data["ExternalIntegrationSystem"] = this.externalIntegrationSystem ? this.externalIntegrationSystem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): InsuranceCompany {
        const json = this.toJSON();
        let result = new InsuranceCompany();
        result.init(json);
        return result;
    }
}

export interface IInsuranceCompany extends IBaseEntity {
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    externalIntegrationSystemId?: number | undefined;
    externalIntegrationSystem?: ExternalIntegrationSystem | undefined;
}

export class ExternalIntegrationSystem extends BaseEntity implements IExternalIntegrationSystem {
    clientName?: string | undefined;
    secret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    externalClientName?: string | undefined;
    externalSecret?: string | undefined;
    externalUsername?: string | undefined;
    externalPassword?: string | undefined;
    keyword?: string | undefined;
    active?: boolean;
    refreshTokenDurationInMinutes?: number | undefined;
    externalIntegrationTokens?: ExternalIntegrationToken[] | undefined;

    constructor(data?: IExternalIntegrationSystem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientName = _data["ClientName"];
            this.secret = _data["Secret"];
            this.username = _data["Username"];
            this.password = _data["Password"];
            this.externalClientName = _data["ExternalClientName"];
            this.externalSecret = _data["ExternalSecret"];
            this.externalUsername = _data["ExternalUsername"];
            this.externalPassword = _data["ExternalPassword"];
            this.keyword = _data["Keyword"];
            this.active = _data["Active"];
            this.refreshTokenDurationInMinutes = _data["RefreshTokenDurationInMinutes"];
            if (Array.isArray(_data["ExternalIntegrationTokens"])) {
                this.externalIntegrationTokens = [] as any;
                for (let item of _data["ExternalIntegrationTokens"])
                    this.externalIntegrationTokens!.push(ExternalIntegrationToken.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalIntegrationSystem {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIntegrationSystem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientName"] = this.clientName;
        data["Secret"] = this.secret;
        data["Username"] = this.username;
        data["Password"] = this.password;
        data["ExternalClientName"] = this.externalClientName;
        data["ExternalSecret"] = this.externalSecret;
        data["ExternalUsername"] = this.externalUsername;
        data["ExternalPassword"] = this.externalPassword;
        data["Keyword"] = this.keyword;
        data["Active"] = this.active;
        data["RefreshTokenDurationInMinutes"] = this.refreshTokenDurationInMinutes;
        if (Array.isArray(this.externalIntegrationTokens)) {
            data["ExternalIntegrationTokens"] = [];
            for (let item of this.externalIntegrationTokens)
                data["ExternalIntegrationTokens"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): ExternalIntegrationSystem {
        const json = this.toJSON();
        let result = new ExternalIntegrationSystem();
        result.init(json);
        return result;
    }
}

export interface IExternalIntegrationSystem extends IBaseEntity {
    clientName?: string | undefined;
    secret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    externalClientName?: string | undefined;
    externalSecret?: string | undefined;
    externalUsername?: string | undefined;
    externalPassword?: string | undefined;
    keyword?: string | undefined;
    active?: boolean;
    refreshTokenDurationInMinutes?: number | undefined;
    externalIntegrationTokens?: ExternalIntegrationToken[] | undefined;
}

export class ExternalIntegrationToken extends BaseEntity implements IExternalIntegrationToken {
    externalIntegrationSystemId?: number;
    externalIntegrationSystem?: ExternalIntegrationSystem | undefined;
    token?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    protectedData?: string | undefined;

    constructor(data?: IExternalIntegrationToken) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalIntegrationSystemId = _data["ExternalIntegrationSystemId"];
            this.externalIntegrationSystem = _data["ExternalIntegrationSystem"] ? ExternalIntegrationSystem.fromJS(_data["ExternalIntegrationSystem"]) : <any>undefined;
            this.token = _data["Token"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.protectedData = _data["ProtectedData"];
        }
    }

    static fromJS(data: any): ExternalIntegrationToken {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIntegrationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalIntegrationSystemId"] = this.externalIntegrationSystemId;
        data["ExternalIntegrationSystem"] = this.externalIntegrationSystem ? this.externalIntegrationSystem.toJSON() : <any>undefined;
        data["Token"] = this.token;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ProtectedData"] = this.protectedData;
        super.toJSON(data);
        return data; 
    }

    clone(): ExternalIntegrationToken {
        const json = this.toJSON();
        let result = new ExternalIntegrationToken();
        result.init(json);
        return result;
    }
}

export interface IExternalIntegrationToken extends IBaseEntity {
    externalIntegrationSystemId?: number;
    externalIntegrationSystem?: ExternalIntegrationSystem | undefined;
    token?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    protectedData?: string | undefined;
}

export class Location extends BaseEntity implements ILocation {
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    municipality?: string | undefined;
    regionId?: number | undefined;
    region?: Region | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    locationTypeId?: number;
    locationType?: LocationType | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetwork[] | undefined;

    constructor(data?: ILocation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["Description"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.municipality = _data["Municipality"];
            this.regionId = _data["RegionId"];
            this.region = _data["Region"] ? Region.fromJS(_data["Region"]) : <any>undefined;
            this.state = _data["State"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.locationTypeId = _data["LocationTypeId"];
            this.locationType = _data["LocationType"] ? LocationType.fromJS(_data["LocationType"]) : <any>undefined;
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderNetworks"])) {
                this.treatmentProviderNetworks = [] as any;
                for (let item of _data["TreatmentProviderNetworks"])
                    this.treatmentProviderNetworks!.push(TreatmentProviderNetwork.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Municipality"] = this.municipality;
        data["RegionId"] = this.regionId;
        data["Region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["State"] = this.state;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["LocationTypeId"] = this.locationTypeId;
        data["LocationType"] = this.locationType ? this.locationType.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderNetworks)) {
            data["TreatmentProviderNetworks"] = [];
            for (let item of this.treatmentProviderNetworks)
                data["TreatmentProviderNetworks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Location {
        const json = this.toJSON();
        let result = new Location();
        result.init(json);
        return result;
    }
}

export interface ILocation extends IBaseEntity {
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    municipality?: string | undefined;
    regionId?: number | undefined;
    region?: Region | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    locationTypeId?: number;
    locationType?: LocationType | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetwork[] | undefined;
}

export class Region extends BaseEntity implements IRegion {
    name?: string | undefined;

    constructor(data?: IRegion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        super.toJSON(data);
        return data; 
    }

    clone(): Region {
        const json = this.toJSON();
        let result = new Region();
        result.init(json);
        return result;
    }
}

export interface IRegion extends IBaseEntity {
    name?: string | undefined;
}

export class LocationType extends BaseEntity implements ILocationType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILocationType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): LocationType {
        data = typeof data === 'object' ? data : {};
        let result = new LocationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        super.toJSON(data);
        return data; 
    }

    clone(): LocationType {
        const json = this.toJSON();
        let result = new LocationType();
        result.init(json);
        return result;
    }
}

export interface ILocationType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class Company extends BaseEntity implements ICompany {
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    rootCompanyId?: number | undefined;
    rootCompany?: Company | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompany | undefined;
    treatmentProviderNetworkId?: number | undefined;
    abbreviation?: string | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
    dataOwnerId?: number | undefined;
    dataOwner?: DataOwner | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    employeeGroups?: EmployeeGroup[] | undefined;
    changeLogs?: ChangeLog[] | undefined;
    emails?: Email[] | undefined;
    files?: File[] | undefined;
    notes?: Note[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentType[] | undefined;
    rooms?: Room[] | undefined;
    nurses?: User[] | undefined;
    assignments?: Assignment[] | undefined;
    appointmentSchedules?: AppointmentSchedule[] | undefined;

    constructor(data?: ICompany) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.pnumber = _data["Pnumber"];
            this.comment = _data["Comment"];
            this.publicKey = _data["PublicKey"];
            this.profilePicture = _data["ProfilePicture"];
            this.profileInfo = _data["ProfileInfo"];
            this.rootCompanyId = _data["RootCompanyId"];
            this.rootCompany = _data["RootCompany"] ? Company.fromJS(_data["RootCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["InsuranceCompanyId"];
            this.insuranceCompany = _data["InsuranceCompany"] ? InsuranceCompany.fromJS(_data["InsuranceCompany"]) : <any>undefined;
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.abbreviation = _data["Abbreviation"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetwork.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            this.dataOwnerId = _data["DataOwnerId"];
            this.dataOwner = _data["DataOwner"] ? DataOwner.fromJS(_data["DataOwner"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["EmployeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["EmployeeGroups"])
                    this.employeeGroups!.push(EmployeeGroup.fromJS(item));
            }
            if (Array.isArray(_data["ChangeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["ChangeLogs"])
                    this.changeLogs!.push(ChangeLog.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(File.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(Note.fromJS(item));
            }
            if (Array.isArray(_data["CompanyTreatmentTypes"])) {
                this.companyTreatmentTypes = [] as any;
                for (let item of _data["CompanyTreatmentTypes"])
                    this.companyTreatmentTypes!.push(CompanyTreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["Rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["Rooms"])
                    this.rooms!.push(Room.fromJS(item));
            }
            if (Array.isArray(_data["Nurses"])) {
                this.nurses = [] as any;
                for (let item of _data["Nurses"])
                    this.nurses!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(Assignment.fromJS(item));
            }
            if (Array.isArray(_data["AppointmentSchedules"])) {
                this.appointmentSchedules = [] as any;
                for (let item of _data["AppointmentSchedules"])
                    this.appointmentSchedules!.push(AppointmentSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Pnumber"] = this.pnumber;
        data["Comment"] = this.comment;
        data["PublicKey"] = this.publicKey;
        data["ProfilePicture"] = this.profilePicture;
        data["ProfileInfo"] = this.profileInfo;
        data["RootCompanyId"] = this.rootCompanyId;
        data["RootCompany"] = this.rootCompany ? this.rootCompany.toJSON() : <any>undefined;
        data["InsuranceCompanyId"] = this.insuranceCompanyId;
        data["InsuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["Abbreviation"] = this.abbreviation;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        data["DataOwnerId"] = this.dataOwnerId;
        data["DataOwner"] = this.dataOwner ? this.dataOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeGroups)) {
            data["EmployeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["EmployeeGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.changeLogs)) {
            data["ChangeLogs"] = [];
            for (let item of this.changeLogs)
                data["ChangeLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.companyTreatmentTypes)) {
            data["CompanyTreatmentTypes"] = [];
            for (let item of this.companyTreatmentTypes)
                data["CompanyTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.rooms)) {
            data["Rooms"] = [];
            for (let item of this.rooms)
                data["Rooms"].push(item.toJSON());
        }
        if (Array.isArray(this.nurses)) {
            data["Nurses"] = [];
            for (let item of this.nurses)
                data["Nurses"].push(item.toJSON());
        }
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.appointmentSchedules)) {
            data["AppointmentSchedules"] = [];
            for (let item of this.appointmentSchedules)
                data["AppointmentSchedules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany extends IBaseEntity {
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    rootCompanyId?: number | undefined;
    rootCompany?: Company | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompany | undefined;
    treatmentProviderNetworkId?: number | undefined;
    abbreviation?: string | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
    dataOwnerId?: number | undefined;
    dataOwner?: DataOwner | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    employeeGroups?: EmployeeGroup[] | undefined;
    changeLogs?: ChangeLog[] | undefined;
    emails?: Email[] | undefined;
    files?: File[] | undefined;
    notes?: Note[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentType[] | undefined;
    rooms?: Room[] | undefined;
    nurses?: User[] | undefined;
    assignments?: Assignment[] | undefined;
    appointmentSchedules?: AppointmentSchedule[] | undefined;
}

export class DataOwner extends BaseEntity implements IDataOwner {
    name?: string | undefined;
    companies?: Company[] | undefined;

    constructor(data?: IDataOwner) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataOwner {
        data = typeof data === 'object' ? data : {};
        let result = new DataOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): DataOwner {
        const json = this.toJSON();
        let result = new DataOwner();
        result.init(json);
        return result;
    }
}

export interface IDataOwner extends IBaseEntity {
    name?: string | undefined;
    companies?: Company[] | undefined;
}

export class BaseSynchronizedEntity extends BaseEntity implements IBaseSynchronizedEntity {
    externalReferenceId?: string | undefined;
    synchronizationDate?: moment.Moment | undefined;
    synchronizedBy?: string | undefined;

    constructor(data?: IBaseSynchronizedEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.synchronizationDate = _data["SynchronizationDate"] ? moment(_data["SynchronizationDate"].toString()) : <any>undefined;
            this.synchronizedBy = _data["SynchronizedBy"];
        }
    }

    static fromJS(data: any): BaseSynchronizedEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSynchronizedEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["SynchronizationDate"] = this.synchronizationDate ? this.synchronizationDate.toISOString() : <any>undefined;
        data["SynchronizedBy"] = this.synchronizedBy;
        super.toJSON(data);
        return data; 
    }

    clone(): BaseSynchronizedEntity {
        const json = this.toJSON();
        let result = new BaseSynchronizedEntity();
        result.init(json);
        return result;
    }
}

export interface IBaseSynchronizedEntity extends IBaseEntity {
    externalReferenceId?: string | undefined;
    synchronizationDate?: moment.Moment | undefined;
    synchronizedBy?: string | undefined;
}

export class TreatmentProvider extends BaseSynchronizedEntity implements ITreatmentProvider {
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    referralPossible?: boolean;
    onHold?: boolean;
    dateOnHoldFrom?: moment.Moment | undefined;
    dateOnHoldTo?: moment.Moment | undefined;
    clinicProfileEnabled?: boolean;
    treatmentProviderStatusId?: number;
    treatmentProviderStatus?: TreatmentProviderStatus | undefined;
    ratingId?: number | undefined;
    rating?: Rating | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
    rootTreatmentProviderId?: number | undefined;
    rootTreatmentProvider?: TreatmentProvider | undefined;
    coverPhotoPath?: string | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    treatmentSpecialties?: TreatmentSpecialty[] | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    treatmentProvidersTreatmentTypes?: TreatmentProviderTreatmentType[] | undefined;
    treatmentProperties?: TreatmentProperties[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    treatmentSpecialists?: TreatmentSpecialist[] | undefined;
    changeLogs?: ChangeLog[] | undefined;
    emails?: Email[] | undefined;
    files?: File[] | undefined;
    notes?: Note[] | undefined;
    treatmentProviderDetails?: TreatmentProviderDetail[] | undefined;
    treatmentProviderTypeId?: number | undefined;
    treatmentProviderType?: TreatmentProviderType | undefined;
    companies?: Company[] | undefined;
    availableForPastBookings?: boolean;
    caseTreatmentProviders?: CaseTreatmentProvider[] | undefined;
    reportingId?: string | undefined;
    appointmentScheduleEnabled?: boolean;

    constructor(data?: ITreatmentProvider) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.pnumber = _data["Pnumber"];
            this.comment = _data["Comment"];
            this.publicKey = _data["PublicKey"];
            this.referralPossible = _data["ReferralPossible"];
            this.onHold = _data["OnHold"];
            this.dateOnHoldFrom = _data["DateOnHoldFrom"] ? moment(_data["DateOnHoldFrom"].toString()) : <any>undefined;
            this.dateOnHoldTo = _data["DateOnHoldTo"] ? moment(_data["DateOnHoldTo"].toString()) : <any>undefined;
            this.clinicProfileEnabled = _data["ClinicProfileEnabled"];
            this.treatmentProviderStatusId = _data["TreatmentProviderStatusId"];
            this.treatmentProviderStatus = _data["TreatmentProviderStatus"] ? TreatmentProviderStatus.fromJS(_data["TreatmentProviderStatus"]) : <any>undefined;
            this.ratingId = _data["RatingId"];
            this.rating = _data["Rating"] ? Rating.fromJS(_data["Rating"]) : <any>undefined;
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetwork.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            this.rootTreatmentProviderId = _data["RootTreatmentProviderId"];
            this.rootTreatmentProvider = _data["RootTreatmentProvider"] ? TreatmentProvider.fromJS(_data["RootTreatmentProvider"]) : <any>undefined;
            this.coverPhotoPath = _data["CoverPhotoPath"];
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentSpecialties"])) {
                this.treatmentSpecialties = [] as any;
                for (let item of _data["TreatmentSpecialties"])
                    this.treatmentSpecialties!.push(TreatmentSpecialty.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProvidersTreatmentTypes"])) {
                this.treatmentProvidersTreatmentTypes = [] as any;
                for (let item of _data["TreatmentProvidersTreatmentTypes"])
                    this.treatmentProvidersTreatmentTypes!.push(TreatmentProviderTreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProperties"])) {
                this.treatmentProperties = [] as any;
                for (let item of _data["TreatmentProperties"])
                    this.treatmentProperties!.push(TreatmentProperties.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployee.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentSpecialists"])) {
                this.treatmentSpecialists = [] as any;
                for (let item of _data["TreatmentSpecialists"])
                    this.treatmentSpecialists!.push(TreatmentSpecialist.fromJS(item));
            }
            if (Array.isArray(_data["ChangeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["ChangeLogs"])
                    this.changeLogs!.push(ChangeLog.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(File.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(Note.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderDetails"])) {
                this.treatmentProviderDetails = [] as any;
                for (let item of _data["TreatmentProviderDetails"])
                    this.treatmentProviderDetails!.push(TreatmentProviderDetail.fromJS(item));
            }
            this.treatmentProviderTypeId = _data["TreatmentProviderTypeId"];
            this.treatmentProviderType = _data["TreatmentProviderType"] ? TreatmentProviderType.fromJS(_data["TreatmentProviderType"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            this.availableForPastBookings = _data["AvailableForPastBookings"];
            if (Array.isArray(_data["CaseTreatmentProviders"])) {
                this.caseTreatmentProviders = [] as any;
                for (let item of _data["CaseTreatmentProviders"])
                    this.caseTreatmentProviders!.push(CaseTreatmentProvider.fromJS(item));
            }
            this.reportingId = _data["ReportingId"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
        }
    }

    static fromJS(data: any): TreatmentProvider {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Pnumber"] = this.pnumber;
        data["Comment"] = this.comment;
        data["PublicKey"] = this.publicKey;
        data["ReferralPossible"] = this.referralPossible;
        data["OnHold"] = this.onHold;
        data["DateOnHoldFrom"] = this.dateOnHoldFrom ? this.dateOnHoldFrom.toISOString() : <any>undefined;
        data["DateOnHoldTo"] = this.dateOnHoldTo ? this.dateOnHoldTo.toISOString() : <any>undefined;
        data["ClinicProfileEnabled"] = this.clinicProfileEnabled;
        data["TreatmentProviderStatusId"] = this.treatmentProviderStatusId;
        data["TreatmentProviderStatus"] = this.treatmentProviderStatus ? this.treatmentProviderStatus.toJSON() : <any>undefined;
        data["RatingId"] = this.ratingId;
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        data["RootTreatmentProviderId"] = this.rootTreatmentProviderId;
        data["RootTreatmentProvider"] = this.rootTreatmentProvider ? this.rootTreatmentProvider.toJSON() : <any>undefined;
        data["CoverPhotoPath"] = this.coverPhotoPath;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentSpecialties)) {
            data["TreatmentSpecialties"] = [];
            for (let item of this.treatmentSpecialties)
                data["TreatmentSpecialties"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProvidersTreatmentTypes)) {
            data["TreatmentProvidersTreatmentTypes"] = [];
            for (let item of this.treatmentProvidersTreatmentTypes)
                data["TreatmentProvidersTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProperties)) {
            data["TreatmentProperties"] = [];
            for (let item of this.treatmentProperties)
                data["TreatmentProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentSpecialists)) {
            data["TreatmentSpecialists"] = [];
            for (let item of this.treatmentSpecialists)
                data["TreatmentSpecialists"].push(item.toJSON());
        }
        if (Array.isArray(this.changeLogs)) {
            data["ChangeLogs"] = [];
            for (let item of this.changeLogs)
                data["ChangeLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderDetails)) {
            data["TreatmentProviderDetails"] = [];
            for (let item of this.treatmentProviderDetails)
                data["TreatmentProviderDetails"].push(item.toJSON());
        }
        data["TreatmentProviderTypeId"] = this.treatmentProviderTypeId;
        data["TreatmentProviderType"] = this.treatmentProviderType ? this.treatmentProviderType.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["AvailableForPastBookings"] = this.availableForPastBookings;
        if (Array.isArray(this.caseTreatmentProviders)) {
            data["CaseTreatmentProviders"] = [];
            for (let item of this.caseTreatmentProviders)
                data["CaseTreatmentProviders"].push(item.toJSON());
        }
        data["ReportingId"] = this.reportingId;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProvider {
        const json = this.toJSON();
        let result = new TreatmentProvider();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProvider extends IBaseSynchronizedEntity {
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    referralPossible?: boolean;
    onHold?: boolean;
    dateOnHoldFrom?: moment.Moment | undefined;
    dateOnHoldTo?: moment.Moment | undefined;
    clinicProfileEnabled?: boolean;
    treatmentProviderStatusId?: number;
    treatmentProviderStatus?: TreatmentProviderStatus | undefined;
    ratingId?: number | undefined;
    rating?: Rating | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
    rootTreatmentProviderId?: number | undefined;
    rootTreatmentProvider?: TreatmentProvider | undefined;
    coverPhotoPath?: string | undefined;
    contacts?: Contact[] | undefined;
    locations?: Location[] | undefined;
    treatmentSpecialties?: TreatmentSpecialty[] | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    treatmentProvidersTreatmentTypes?: TreatmentProviderTreatmentType[] | undefined;
    treatmentProperties?: TreatmentProperties[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    treatmentSpecialists?: TreatmentSpecialist[] | undefined;
    changeLogs?: ChangeLog[] | undefined;
    emails?: Email[] | undefined;
    files?: File[] | undefined;
    notes?: Note[] | undefined;
    treatmentProviderDetails?: TreatmentProviderDetail[] | undefined;
    treatmentProviderTypeId?: number | undefined;
    treatmentProviderType?: TreatmentProviderType | undefined;
    companies?: Company[] | undefined;
    availableForPastBookings?: boolean;
    caseTreatmentProviders?: CaseTreatmentProvider[] | undefined;
    reportingId?: string | undefined;
    appointmentScheduleEnabled?: boolean;
}

export class TreatmentProviderStatus extends BaseEntity implements ITreatmentProviderStatus {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    colorCode?: string | undefined;
    colorName?: string | undefined;
    actionScript?: string | undefined;
    cssClass?: string | undefined;
    orderPriority?: number | undefined;
    previousStatusId?: number | undefined;
    nextStatusId?: number | undefined;

    constructor(data?: ITreatmentProviderStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.colorCode = _data["ColorCode"];
            this.colorName = _data["ColorName"];
            this.actionScript = _data["ActionScript"];
            this.cssClass = _data["CssClass"];
            this.orderPriority = _data["OrderPriority"];
            this.previousStatusId = _data["PreviousStatusId"];
            this.nextStatusId = _data["NextStatusId"];
        }
    }

    static fromJS(data: any): TreatmentProviderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ColorCode"] = this.colorCode;
        data["ColorName"] = this.colorName;
        data["ActionScript"] = this.actionScript;
        data["CssClass"] = this.cssClass;
        data["OrderPriority"] = this.orderPriority;
        data["PreviousStatusId"] = this.previousStatusId;
        data["NextStatusId"] = this.nextStatusId;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderStatus {
        const json = this.toJSON();
        let result = new TreatmentProviderStatus();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderStatus extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    colorCode?: string | undefined;
    colorName?: string | undefined;
    actionScript?: string | undefined;
    cssClass?: string | undefined;
    orderPriority?: number | undefined;
    previousStatusId?: number | undefined;
    nextStatusId?: number | undefined;
}

export class Rating extends BaseEntity implements IRating {
    averageValue?: number | undefined;
    minimalValue?: number;
    maximalValue?: number;
    comment?: string | undefined;
    ratingVotes?: RatingVote[] | undefined;

    constructor(data?: IRating) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.averageValue = _data["AverageValue"];
            this.minimalValue = _data["MinimalValue"];
            this.maximalValue = _data["MaximalValue"];
            this.comment = _data["Comment"];
            if (Array.isArray(_data["RatingVotes"])) {
                this.ratingVotes = [] as any;
                for (let item of _data["RatingVotes"])
                    this.ratingVotes!.push(RatingVote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Rating {
        data = typeof data === 'object' ? data : {};
        let result = new Rating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AverageValue"] = this.averageValue;
        data["MinimalValue"] = this.minimalValue;
        data["MaximalValue"] = this.maximalValue;
        data["Comment"] = this.comment;
        if (Array.isArray(this.ratingVotes)) {
            data["RatingVotes"] = [];
            for (let item of this.ratingVotes)
                data["RatingVotes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Rating {
        const json = this.toJSON();
        let result = new Rating();
        result.init(json);
        return result;
    }
}

export interface IRating extends IBaseEntity {
    averageValue?: number | undefined;
    minimalValue?: number;
    maximalValue?: number;
    comment?: string | undefined;
    ratingVotes?: RatingVote[] | undefined;
}

export class RatingVote extends BaseEntity implements IRatingVote {
    value?: number;
    fromImport?: boolean;
    ratingId?: number;
    rating?: Rating | undefined;
    user?: User | undefined;

    constructor(data?: IRatingVote) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["Value"];
            this.fromImport = _data["FromImport"];
            this.ratingId = _data["RatingId"];
            this.rating = _data["Rating"] ? Rating.fromJS(_data["Rating"]) : <any>undefined;
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RatingVote {
        data = typeof data === 'object' ? data : {};
        let result = new RatingVote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["FromImport"] = this.fromImport;
        data["RatingId"] = this.ratingId;
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): RatingVote {
        const json = this.toJSON();
        let result = new RatingVote();
        result.init(json);
        return result;
    }
}

export interface IRatingVote extends IBaseEntity {
    value?: number;
    fromImport?: boolean;
    ratingId?: number;
    rating?: Rating | undefined;
    user?: User | undefined;
}

export class TreatmentSpecialty extends BaseEntity implements ITreatmentSpecialty {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;

    constructor(data?: ITreatmentSpecialty) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentSpecialty {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentSpecialty {
        const json = this.toJSON();
        let result = new TreatmentSpecialty();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialty extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
}

export class TreatmentType extends BaseEntity implements ITreatmentType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    caseRequired?: boolean;
    icon?: string | undefined;
    defaultPhoto?: string | undefined;
    isVideoCall?: boolean;
    treatmentProviders?: TreatmentProvider[] | undefined;
    treatmentProvidersTreatmentTypes?: TreatmentProviderTreatmentType[] | undefined;
    treatmentSpecialties?: TreatmentSpecialty[] | undefined;
    treatments?: Treatment[] | undefined;
    treatmentSpecialists?: TreatmentSpecialist[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentType[] | undefined;
    translations?: TreatmentTypeTranslation[] | undefined;

    constructor(data?: ITreatmentType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.caseRequired = _data["CaseRequired"];
            this.icon = _data["Icon"];
            this.defaultPhoto = _data["DefaultPhoto"];
            this.isVideoCall = _data["IsVideoCall"];
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProvidersTreatmentTypes"])) {
                this.treatmentProvidersTreatmentTypes = [] as any;
                for (let item of _data["TreatmentProvidersTreatmentTypes"])
                    this.treatmentProvidersTreatmentTypes!.push(TreatmentProviderTreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentSpecialties"])) {
                this.treatmentSpecialties = [] as any;
                for (let item of _data["TreatmentSpecialties"])
                    this.treatmentSpecialties!.push(TreatmentSpecialty.fromJS(item));
            }
            if (Array.isArray(_data["Treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["Treatments"])
                    this.treatments!.push(Treatment.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentSpecialists"])) {
                this.treatmentSpecialists = [] as any;
                for (let item of _data["TreatmentSpecialists"])
                    this.treatmentSpecialists!.push(TreatmentSpecialist.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployee.fromJS(item));
            }
            if (Array.isArray(_data["CompanyTreatmentTypes"])) {
                this.companyTreatmentTypes = [] as any;
                for (let item of _data["CompanyTreatmentTypes"])
                    this.companyTreatmentTypes!.push(CompanyTreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TreatmentTypeTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentType {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["CaseRequired"] = this.caseRequired;
        data["Icon"] = this.icon;
        data["DefaultPhoto"] = this.defaultPhoto;
        data["IsVideoCall"] = this.isVideoCall;
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProvidersTreatmentTypes)) {
            data["TreatmentProvidersTreatmentTypes"] = [];
            for (let item of this.treatmentProvidersTreatmentTypes)
                data["TreatmentProvidersTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentSpecialties)) {
            data["TreatmentSpecialties"] = [];
            for (let item of this.treatmentSpecialties)
                data["TreatmentSpecialties"].push(item.toJSON());
        }
        if (Array.isArray(this.treatments)) {
            data["Treatments"] = [];
            for (let item of this.treatments)
                data["Treatments"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentSpecialists)) {
            data["TreatmentSpecialists"] = [];
            for (let item of this.treatmentSpecialists)
                data["TreatmentSpecialists"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.companyTreatmentTypes)) {
            data["CompanyTreatmentTypes"] = [];
            for (let item of this.companyTreatmentTypes)
                data["CompanyTreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentType {
        const json = this.toJSON();
        let result = new TreatmentType();
        result.init(json);
        return result;
    }
}

export interface ITreatmentType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    caseRequired?: boolean;
    icon?: string | undefined;
    defaultPhoto?: string | undefined;
    isVideoCall?: boolean;
    treatmentProviders?: TreatmentProvider[] | undefined;
    treatmentProvidersTreatmentTypes?: TreatmentProviderTreatmentType[] | undefined;
    treatmentSpecialties?: TreatmentSpecialty[] | undefined;
    treatments?: Treatment[] | undefined;
    treatmentSpecialists?: TreatmentSpecialist[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    companyTreatmentTypes?: CompanyTreatmentType[] | undefined;
    translations?: TreatmentTypeTranslation[] | undefined;
}

export class TreatmentProviderTreatmentType implements ITreatmentProviderTreatmentType {
    id?: number;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    info?: string | undefined;
    photo?: string | undefined;
    priority?: number;
    galleryImages?: ClinicGalleryImage[] | undefined;

    constructor(data?: ITreatmentProviderTreatmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProvider.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.info = _data["Info"];
            this.photo = _data["Photo"];
            this.priority = _data["Priority"];
            if (Array.isArray(_data["GalleryImages"])) {
                this.galleryImages = [] as any;
                for (let item of _data["GalleryImages"])
                    this.galleryImages!.push(ClinicGalleryImage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderTreatmentType {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderTreatmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["Info"] = this.info;
        data["Photo"] = this.photo;
        data["Priority"] = this.priority;
        if (Array.isArray(this.galleryImages)) {
            data["GalleryImages"] = [];
            for (let item of this.galleryImages)
                data["GalleryImages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderTreatmentType {
        const json = this.toJSON();
        let result = new TreatmentProviderTreatmentType();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderTreatmentType {
    id?: number;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    info?: string | undefined;
    photo?: string | undefined;
    priority?: number;
    galleryImages?: ClinicGalleryImage[] | undefined;
}

export class ClinicGalleryImage extends BaseEntity implements IClinicGalleryImage {
    path?: string | undefined;
    info?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfile | undefined;
    treatmentProviderTreatmentTypeId?: number | undefined;
    treatmentProviderTreatmentType?: TreatmentProviderTreatmentType | undefined;
    priority?: number;

    constructor(data?: IClinicGalleryImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.path = _data["Path"];
            this.info = _data["Info"];
            this.clinicProfileId = _data["ClinicProfileId"];
            this.clinicProfile = _data["ClinicProfile"] ? ClinicProfile.fromJS(_data["ClinicProfile"]) : <any>undefined;
            this.treatmentProviderTreatmentTypeId = _data["TreatmentProviderTreatmentTypeId"];
            this.treatmentProviderTreatmentType = _data["TreatmentProviderTreatmentType"] ? TreatmentProviderTreatmentType.fromJS(_data["TreatmentProviderTreatmentType"]) : <any>undefined;
            this.priority = _data["Priority"];
        }
    }

    static fromJS(data: any): ClinicGalleryImage {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicGalleryImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Path"] = this.path;
        data["Info"] = this.info;
        data["ClinicProfileId"] = this.clinicProfileId;
        data["ClinicProfile"] = this.clinicProfile ? this.clinicProfile.toJSON() : <any>undefined;
        data["TreatmentProviderTreatmentTypeId"] = this.treatmentProviderTreatmentTypeId;
        data["TreatmentProviderTreatmentType"] = this.treatmentProviderTreatmentType ? this.treatmentProviderTreatmentType.toJSON() : <any>undefined;
        data["Priority"] = this.priority;
        super.toJSON(data);
        return data; 
    }

    clone(): ClinicGalleryImage {
        const json = this.toJSON();
        let result = new ClinicGalleryImage();
        result.init(json);
        return result;
    }
}

export interface IClinicGalleryImage extends IBaseEntity {
    path?: string | undefined;
    info?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfile | undefined;
    treatmentProviderTreatmentTypeId?: number | undefined;
    treatmentProviderTreatmentType?: TreatmentProviderTreatmentType | undefined;
    priority?: number;
}

export class ClinicProfile extends BaseEntity implements IClinicProfile {
    description?: string | undefined;
    profileUrl?: string | undefined;
    facebookExternalUrl?: string | undefined;
    instagramExternalUrl?: string | undefined;
    twiiterExternalUrl?: string | undefined;
    linkedInExternalUrl?: string | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    clinicGallery?: ClinicGalleryImage[] | undefined;
    workingTime?: WorkingTime[] | undefined;

    constructor(data?: IClinicProfile) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["Description"];
            this.profileUrl = _data["ProfileUrl"];
            this.facebookExternalUrl = _data["FacebookExternalUrl"];
            this.instagramExternalUrl = _data["InstagramExternalUrl"];
            this.twiiterExternalUrl = _data["TwiiterExternalUrl"];
            this.linkedInExternalUrl = _data["LinkedInExternalUrl"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProvider.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            if (Array.isArray(_data["ClinicGallery"])) {
                this.clinicGallery = [] as any;
                for (let item of _data["ClinicGallery"])
                    this.clinicGallery!.push(ClinicGalleryImage.fromJS(item));
            }
            if (Array.isArray(_data["WorkingTime"])) {
                this.workingTime = [] as any;
                for (let item of _data["WorkingTime"])
                    this.workingTime!.push(WorkingTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicProfile {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["ProfileUrl"] = this.profileUrl;
        data["FacebookExternalUrl"] = this.facebookExternalUrl;
        data["InstagramExternalUrl"] = this.instagramExternalUrl;
        data["TwiiterExternalUrl"] = this.twiiterExternalUrl;
        data["LinkedInExternalUrl"] = this.linkedInExternalUrl;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.clinicGallery)) {
            data["ClinicGallery"] = [];
            for (let item of this.clinicGallery)
                data["ClinicGallery"].push(item.toJSON());
        }
        if (Array.isArray(this.workingTime)) {
            data["WorkingTime"] = [];
            for (let item of this.workingTime)
                data["WorkingTime"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): ClinicProfile {
        const json = this.toJSON();
        let result = new ClinicProfile();
        result.init(json);
        return result;
    }
}

export interface IClinicProfile extends IBaseEntity {
    description?: string | undefined;
    profileUrl?: string | undefined;
    facebookExternalUrl?: string | undefined;
    instagramExternalUrl?: string | undefined;
    twiiterExternalUrl?: string | undefined;
    linkedInExternalUrl?: string | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    clinicGallery?: ClinicGalleryImage[] | undefined;
    workingTime?: WorkingTime[] | undefined;
}

export class WorkingTime extends BaseEntity implements IWorkingTime {
    dayOfWeek?: DayOfWeek;
    startTime?: string | undefined;
    endTime?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfile | undefined;

    constructor(data?: IWorkingTime) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dayOfWeek = _data["DayOfWeek"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.clinicProfileId = _data["ClinicProfileId"];
            this.clinicProfile = _data["ClinicProfile"] ? ClinicProfile.fromJS(_data["ClinicProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkingTime {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DayOfWeek"] = this.dayOfWeek;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["ClinicProfileId"] = this.clinicProfileId;
        data["ClinicProfile"] = this.clinicProfile ? this.clinicProfile.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): WorkingTime {
        const json = this.toJSON();
        let result = new WorkingTime();
        result.init(json);
        return result;
    }
}

export interface IWorkingTime extends IBaseEntity {
    dayOfWeek?: DayOfWeek;
    startTime?: string | undefined;
    endTime?: string | undefined;
    clinicProfileId?: number;
    clinicProfile?: ClinicProfile | undefined;
}

export class Treatment extends BaseEntity implements ITreatment {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentSpecialtyId?: number;
    treatmentSpecialty?: TreatmentSpecialty | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    treatmentProperties?: TreatmentProperties[] | undefined;

    constructor(data?: ITreatment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.treatmentSpecialtyId = _data["TreatmentSpecialtyId"];
            this.treatmentSpecialty = _data["TreatmentSpecialty"] ? TreatmentSpecialty.fromJS(_data["TreatmentSpecialty"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentProperties"])) {
                this.treatmentProperties = [] as any;
                for (let item of _data["TreatmentProperties"])
                    this.treatmentProperties!.push(TreatmentProperties.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Treatment {
        data = typeof data === 'object' ? data : {};
        let result = new Treatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["TreatmentSpecialtyId"] = this.treatmentSpecialtyId;
        data["TreatmentSpecialty"] = this.treatmentSpecialty ? this.treatmentSpecialty.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentProperties)) {
            data["TreatmentProperties"] = [];
            for (let item of this.treatmentProperties)
                data["TreatmentProperties"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Treatment {
        const json = this.toJSON();
        let result = new Treatment();
        result.init(json);
        return result;
    }
}

export interface ITreatment extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentSpecialtyId?: number;
    treatmentSpecialty?: TreatmentSpecialty | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    treatmentProperties?: TreatmentProperties[] | undefined;
}

export class TreatmentProperties extends BaseEntity implements ITreatmentProperties {
    description?: string | undefined;
    shortDescription?: string | undefined;
    terms?: string | undefined;
    link?: string | undefined;
    diagnosisDays?: number | undefined;
    diagnosisPrice?: number | undefined;
    treatmentDays?: number | undefined;
    treatmentPrice?: number | undefined;
    notAllExclusive?: boolean | undefined;
    notAllExclusiveText?: string | undefined;
    comment?: string | undefined;
    isTreatmentGuarantee?: boolean | undefined;
    treatmentId?: number;
    treatment?: Treatment | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;

    constructor(data?: ITreatmentProperties) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.terms = _data["Terms"];
            this.link = _data["Link"];
            this.diagnosisDays = _data["DiagnosisDays"];
            this.diagnosisPrice = _data["DiagnosisPrice"];
            this.treatmentDays = _data["TreatmentDays"];
            this.treatmentPrice = _data["TreatmentPrice"];
            this.notAllExclusive = _data["NotAllExclusive"];
            this.notAllExclusiveText = _data["NotAllExclusiveText"];
            this.comment = _data["Comment"];
            this.isTreatmentGuarantee = _data["IsTreatmentGuarantee"];
            this.treatmentId = _data["TreatmentId"];
            this.treatment = _data["Treatment"] ? Treatment.fromJS(_data["Treatment"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProvider.fromJS(_data["TreatmentProvider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TreatmentProperties {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["Terms"] = this.terms;
        data["Link"] = this.link;
        data["DiagnosisDays"] = this.diagnosisDays;
        data["DiagnosisPrice"] = this.diagnosisPrice;
        data["TreatmentDays"] = this.treatmentDays;
        data["TreatmentPrice"] = this.treatmentPrice;
        data["NotAllExclusive"] = this.notAllExclusive;
        data["NotAllExclusiveText"] = this.notAllExclusiveText;
        data["Comment"] = this.comment;
        data["IsTreatmentGuarantee"] = this.isTreatmentGuarantee;
        data["TreatmentId"] = this.treatmentId;
        data["Treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProperties {
        const json = this.toJSON();
        let result = new TreatmentProperties();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProperties extends IBaseEntity {
    description?: string | undefined;
    shortDescription?: string | undefined;
    terms?: string | undefined;
    link?: string | undefined;
    diagnosisDays?: number | undefined;
    diagnosisPrice?: number | undefined;
    treatmentDays?: number | undefined;
    treatmentPrice?: number | undefined;
    notAllExclusive?: boolean | undefined;
    notAllExclusiveText?: string | undefined;
    comment?: string | undefined;
    isTreatmentGuarantee?: boolean | undefined;
    treatmentId?: number;
    treatment?: Treatment | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
}

export class TreatmentSpecialist extends BaseEntity implements ITreatmentSpecialist {
    fullName?: string | undefined;
    email?: string | undefined;
    treatmentProviderId?: number;
    phoneNumber?: string | undefined;
    treatmentSpecialtyId?: number | undefined;
    treatmentSpecialty?: TreatmentSpecialty | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    photoUrl?: string | undefined;

    constructor(data?: ITreatmentSpecialist) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.phoneNumber = _data["PhoneNumber"];
            this.treatmentSpecialtyId = _data["TreatmentSpecialtyId"];
            this.treatmentSpecialty = _data["TreatmentSpecialty"] ? TreatmentSpecialty.fromJS(_data["TreatmentSpecialty"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentType.fromJS(item));
            }
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.photoUrl = _data["PhotoUrl"];
        }
    }

    static fromJS(data: any): TreatmentSpecialist {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["PhoneNumber"] = this.phoneNumber;
        data["TreatmentSpecialtyId"] = this.treatmentSpecialtyId;
        data["TreatmentSpecialty"] = this.treatmentSpecialty ? this.treatmentSpecialty.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["PhotoUrl"] = this.photoUrl;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentSpecialist {
        const json = this.toJSON();
        let result = new TreatmentSpecialist();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialist extends IBaseEntity {
    fullName?: string | undefined;
    email?: string | undefined;
    treatmentProviderId?: number;
    phoneNumber?: string | undefined;
    treatmentSpecialtyId?: number | undefined;
    treatmentSpecialty?: TreatmentSpecialty | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    photoUrl?: string | undefined;
}

export class TreatmentProviderEmployee extends BaseEntity implements ITreatmentProviderEmployee {
    userId?: number;
    user?: User | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    schedules?: Schedule[] | undefined;
    appointmentSchedules?: AppointmentSchedule[] | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
    priority?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;

    constructor(data?: ITreatmentProviderEmployee) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["UserId"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProvider.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentType.fromJS(item));
            }
            if (Array.isArray(_data["Schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["Schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            if (Array.isArray(_data["AppointmentSchedules"])) {
                this.appointmentSchedules = [] as any;
                for (let item of _data["AppointmentSchedules"])
                    this.appointmentSchedules!.push(AppointmentSchedule.fromJS(item));
            }
            this.workingExperience = _data["WorkingExperience"];
            this.education = _data["Education"];
            this.certificates = _data["Certificates"];
            this.languages = _data["Languages"];
            this.priority = _data["Priority"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TreatmentProviderEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.schedules)) {
            data["Schedules"] = [];
            for (let item of this.schedules)
                data["Schedules"].push(item.toJSON());
        }
        if (Array.isArray(this.appointmentSchedules)) {
            data["AppointmentSchedules"] = [];
            for (let item of this.appointmentSchedules)
                data["AppointmentSchedules"].push(item.toJSON());
        }
        data["WorkingExperience"] = this.workingExperience;
        data["Education"] = this.education;
        data["Certificates"] = this.certificates;
        data["Languages"] = this.languages;
        data["Priority"] = this.priority;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderEmployee {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployee();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployee extends IBaseEntity {
    userId?: number;
    user?: User | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    treatmentTypes?: TreatmentType[] | undefined;
    schedules?: Schedule[] | undefined;
    appointmentSchedules?: AppointmentSchedule[] | undefined;
    workingExperience?: string | undefined;
    education?: string | undefined;
    certificates?: string | undefined;
    languages?: string | undefined;
    priority?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
}

export class Schedule extends BaseEntity implements ISchedule {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    pauseStartTime?: string;
    pauseEndTime?: string;
    isRepeating?: boolean;
    repeatingScheduleId?: number | undefined;
    repeatingSchedule?: Schedule | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    fullDay?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    numberOfBookings?: number;
    assignmentId?: number;
    assignment?: Assignment | undefined;
    scheduleTypeId?: number | undefined;
    scheduleType?: ScheduleType | undefined;
    bookings?: Booking[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    numberOfParticipants?: number;

    constructor(data?: ISchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.pauseStartTime = _data["PauseStartTime"];
            this.pauseEndTime = _data["PauseEndTime"];
            this.isRepeating = _data["IsRepeating"];
            this.repeatingScheduleId = _data["RepeatingScheduleId"];
            this.repeatingSchedule = _data["RepeatingSchedule"] ? Schedule.fromJS(_data["RepeatingSchedule"]) : <any>undefined;
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPattern.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            this.fullDay = _data["FullDay"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.numberOfBookings = _data["NumberOfBookings"];
            this.assignmentId = _data["AssignmentId"];
            this.assignment = _data["Assignment"] ? Assignment.fromJS(_data["Assignment"]) : <any>undefined;
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.scheduleType = _data["ScheduleType"] ? ScheduleType.fromJS(_data["ScheduleType"]) : <any>undefined;
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployee.fromJS(item));
            }
            this.numberOfParticipants = _data["NumberOfParticipants"];
        }
    }

    static fromJS(data: any): Schedule {
        data = typeof data === 'object' ? data : {};
        let result = new Schedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["PauseStartTime"] = this.pauseStartTime;
        data["PauseEndTime"] = this.pauseEndTime;
        data["IsRepeating"] = this.isRepeating;
        data["RepeatingScheduleId"] = this.repeatingScheduleId;
        data["RepeatingSchedule"] = this.repeatingSchedule ? this.repeatingSchedule.toJSON() : <any>undefined;
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        data["FullDay"] = this.fullDay;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["NumberOfBookings"] = this.numberOfBookings;
        data["AssignmentId"] = this.assignmentId;
        data["Assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["NumberOfParticipants"] = this.numberOfParticipants;
        super.toJSON(data);
        return data; 
    }

    clone(): Schedule {
        const json = this.toJSON();
        let result = new Schedule();
        result.init(json);
        return result;
    }
}

export interface ISchedule extends IBaseEntity {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    pauseStartTime?: string;
    pauseEndTime?: string;
    isRepeating?: boolean;
    repeatingScheduleId?: number | undefined;
    repeatingSchedule?: Schedule | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    fullDay?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    numberOfBookings?: number;
    assignmentId?: number;
    assignment?: Assignment | undefined;
    scheduleTypeId?: number | undefined;
    scheduleType?: ScheduleType | undefined;
    bookings?: Booking[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    numberOfParticipants?: number;
}

export class ScheduleRepetitionPattern extends BaseEntity implements IScheduleRepetitionPattern {
    maximumOccurances?: number | undefined;
    separationCount?: number;
    dayOfWeek?: number | undefined;
    weekOfMonth?: number | undefined;
    dayOfMonth?: number | undefined;
    monthOfYear?: number | undefined;
    scheduleRepetitionPatternTypeId?: number | undefined;
    endDate?: moment.Moment | undefined;
    scheduleRepetitionPatternType?: ScheduleRepetitionPatternType | undefined;

    constructor(data?: IScheduleRepetitionPattern) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maximumOccurances = _data["MaximumOccurances"];
            this.separationCount = _data["SeparationCount"];
            this.dayOfWeek = _data["DayOfWeek"];
            this.weekOfMonth = _data["WeekOfMonth"];
            this.dayOfMonth = _data["DayOfMonth"];
            this.monthOfYear = _data["MonthOfYear"];
            this.scheduleRepetitionPatternTypeId = _data["ScheduleRepetitionPatternTypeId"];
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.scheduleRepetitionPatternType = _data["ScheduleRepetitionPatternType"] ? ScheduleRepetitionPatternType.fromJS(_data["ScheduleRepetitionPatternType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleRepetitionPattern {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleRepetitionPattern();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaximumOccurances"] = this.maximumOccurances;
        data["SeparationCount"] = this.separationCount;
        data["DayOfWeek"] = this.dayOfWeek;
        data["WeekOfMonth"] = this.weekOfMonth;
        data["DayOfMonth"] = this.dayOfMonth;
        data["MonthOfYear"] = this.monthOfYear;
        data["ScheduleRepetitionPatternTypeId"] = this.scheduleRepetitionPatternTypeId;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ScheduleRepetitionPatternType"] = this.scheduleRepetitionPatternType ? this.scheduleRepetitionPatternType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): ScheduleRepetitionPattern {
        const json = this.toJSON();
        let result = new ScheduleRepetitionPattern();
        result.init(json);
        return result;
    }
}

export interface IScheduleRepetitionPattern extends IBaseEntity {
    maximumOccurances?: number | undefined;
    separationCount?: number;
    dayOfWeek?: number | undefined;
    weekOfMonth?: number | undefined;
    dayOfMonth?: number | undefined;
    monthOfYear?: number | undefined;
    scheduleRepetitionPatternTypeId?: number | undefined;
    endDate?: moment.Moment | undefined;
    scheduleRepetitionPatternType?: ScheduleRepetitionPatternType | undefined;
}

export class ScheduleRepetitionPatternType extends BaseEntity implements IScheduleRepetitionPatternType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;

    constructor(data?: IScheduleRepetitionPatternType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
        }
    }

    static fromJS(data: any): ScheduleRepetitionPatternType {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleRepetitionPatternType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        super.toJSON(data);
        return data; 
    }

    clone(): ScheduleRepetitionPatternType {
        const json = this.toJSON();
        let result = new ScheduleRepetitionPatternType();
        result.init(json);
        return result;
    }
}

export interface IScheduleRepetitionPatternType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
}

export class Assignment extends BaseEntity implements IAssignment {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
    blockSizeInMinutes?: number;
    treatmentProviderEmployeeId?: number | undefined;
    treatmentProviderEmployee?: TreatmentProviderEmployee | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    companyId?: number | undefined;
    company?: Company | undefined;
    companies?: Company[] | undefined;
    schedules?: Schedule[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    scheduleExceptions?: ScheduleException[] | undefined;
    roomId?: number | undefined;
    room?: Room | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    statusId?: number;
    status?: AssignmentStatus | undefined;
    isVideoCallAvailable?: boolean;

    constructor(data?: IAssignment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.blockSizeInMinutes = _data["BlockSizeInMinutes"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.treatmentProviderEmployee = _data["TreatmentProviderEmployee"] ? TreatmentProviderEmployee.fromJS(_data["TreatmentProviderEmployee"]) : <any>undefined;
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            this.companyId = _data["CompanyId"];
            this.company = _data["Company"] ? Company.fromJS(_data["Company"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["Schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["Schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPattern.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleException.fromJS(item));
            }
            this.roomId = _data["RoomId"];
            this.room = _data["Room"] ? Room.fromJS(_data["Room"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.groupTreatment = _data["GroupTreatment"];
            this.inhouse = _data["Inhouse"];
            this.statusId = _data["StatusId"];
            this.status = _data["Status"] ? AssignmentStatus.fromJS(_data["Status"]) : <any>undefined;
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
        }
    }

    static fromJS(data: any): Assignment {
        data = typeof data === 'object' ? data : {};
        let result = new Assignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["BlockSizeInMinutes"] = this.blockSizeInMinutes;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["TreatmentProviderEmployee"] = this.treatmentProviderEmployee ? this.treatmentProviderEmployee.toJSON() : <any>undefined;
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["CompanyId"] = this.companyId;
        data["Company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.schedules)) {
            data["Schedules"] = [];
            for (let item of this.schedules)
                data["Schedules"].push(item.toJSON());
        }
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["RoomId"] = this.roomId;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["GroupTreatment"] = this.groupTreatment;
        data["Inhouse"] = this.inhouse;
        data["StatusId"] = this.statusId;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        super.toJSON(data);
        return data; 
    }

    clone(): Assignment {
        const json = this.toJSON();
        let result = new Assignment();
        result.init(json);
        return result;
    }
}

export interface IAssignment extends IBaseEntity {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    startTime?: string;
    endTime?: string;
    blockSizeInMinutes?: number;
    treatmentProviderEmployeeId?: number | undefined;
    treatmentProviderEmployee?: TreatmentProviderEmployee | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    companyId?: number | undefined;
    company?: Company | undefined;
    companies?: Company[] | undefined;
    schedules?: Schedule[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    scheduleExceptions?: ScheduleException[] | undefined;
    roomId?: number | undefined;
    room?: Room | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    statusId?: number;
    status?: AssignmentStatus | undefined;
    isVideoCallAvailable?: boolean;
}

export class ScheduleException extends BaseEntity implements IScheduleException {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailySchedule[] | undefined;
    fullDay?: boolean;
    rescheduled?: boolean;
    cancelled?: boolean;
    isRepeating?: boolean;
    scheduleTypeId?: number | undefined;
    scheduleType?: ScheduleType | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    assignmentId?: number | undefined;
    assignment?: Assignment | undefined;
    appointmentScheduleId?: number | undefined;
    appointmentSchedule?: AppointmentSchedule | undefined;

    constructor(data?: IScheduleException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailySchedule.fromJS(item));
            }
            this.fullDay = _data["FullDay"];
            this.rescheduled = _data["Rescheduled"];
            this.cancelled = _data["Cancelled"];
            this.isRepeating = _data["IsRepeating"];
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.scheduleType = _data["ScheduleType"] ? ScheduleType.fromJS(_data["ScheduleType"]) : <any>undefined;
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPattern.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            this.assignmentId = _data["AssignmentId"];
            this.assignment = _data["Assignment"] ? Assignment.fromJS(_data["Assignment"]) : <any>undefined;
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.appointmentSchedule = _data["AppointmentSchedule"] ? AppointmentSchedule.fromJS(_data["AppointmentSchedule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleException {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["FullDay"] = this.fullDay;
        data["Rescheduled"] = this.rescheduled;
        data["Cancelled"] = this.cancelled;
        data["IsRepeating"] = this.isRepeating;
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        data["AssignmentId"] = this.assignmentId;
        data["Assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["AppointmentSchedule"] = this.appointmentSchedule ? this.appointmentSchedule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): ScheduleException {
        const json = this.toJSON();
        let result = new ScheduleException();
        result.init(json);
        return result;
    }
}

export interface IScheduleException extends IBaseEntity {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    dailySchedules?: DailySchedule[] | undefined;
    fullDay?: boolean;
    rescheduled?: boolean;
    cancelled?: boolean;
    isRepeating?: boolean;
    scheduleTypeId?: number | undefined;
    scheduleType?: ScheduleType | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    assignmentId?: number | undefined;
    assignment?: Assignment | undefined;
    appointmentScheduleId?: number | undefined;
    appointmentSchedule?: AppointmentSchedule | undefined;
}

export class DailySchedule extends BaseEntity implements IDailySchedule {
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    appointmentScheduleId?: number | undefined;
    appointmentSchedule?: AppointmentSchedule | undefined;
    scheduleExceptionId?: number | undefined;
    scheduleException?: ScheduleException | undefined;

    constructor(data?: IDailySchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dayOfWeek = _data["DayOfWeek"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.appointmentSchedule = _data["AppointmentSchedule"] ? AppointmentSchedule.fromJS(_data["AppointmentSchedule"]) : <any>undefined;
            this.scheduleExceptionId = _data["ScheduleExceptionId"];
            this.scheduleException = _data["ScheduleException"] ? ScheduleException.fromJS(_data["ScheduleException"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DailySchedule {
        data = typeof data === 'object' ? data : {};
        let result = new DailySchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DayOfWeek"] = this.dayOfWeek;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["AppointmentSchedule"] = this.appointmentSchedule ? this.appointmentSchedule.toJSON() : <any>undefined;
        data["ScheduleExceptionId"] = this.scheduleExceptionId;
        data["ScheduleException"] = this.scheduleException ? this.scheduleException.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): DailySchedule {
        const json = this.toJSON();
        let result = new DailySchedule();
        result.init(json);
        return result;
    }
}

export interface IDailySchedule extends IBaseEntity {
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    appointmentScheduleId?: number | undefined;
    appointmentSchedule?: AppointmentSchedule | undefined;
    scheduleExceptionId?: number | undefined;
    scheduleException?: ScheduleException | undefined;
}

export class AppointmentSchedule extends BaseEntity implements IAppointmentSchedule {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailySchedule[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    bookings?: Booking[] | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    companies?: Company[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    scheduleExceptions?: ScheduleException[] | undefined;
    roomId?: number | undefined;
    room?: Room | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    statusId?: number;
    status?: AssignmentStatus | undefined;
    isVideoCallAvailable?: boolean;
    appointmentScheduleBatchId?: string | undefined;
    appointmentScheduleBatch?: AppointmentScheduleBatch | undefined;

    constructor(data?: IAppointmentSchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailySchedule.fromJS(item));
            }
            this.duration = _data["Duration"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.maxDaysInAdvanceCanBeBooked = _data["MaxDaysInAdvanceCanBeBooked"];
            this.minHoursBeforeScheduleStartCanBeBooked = _data["MinHoursBeforeScheduleStartCanBeBooked"];
            this.bufferTimeBetweenSlotsInMinutes = _data["BufferTimeBetweenSlotsInMinutes"];
            this.bookableEveryInMinutes = _data["BookableEveryInMinutes"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployee.fromJS(item));
            }
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPattern.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleException.fromJS(item));
            }
            this.roomId = _data["RoomId"];
            this.room = _data["Room"] ? Room.fromJS(_data["Room"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.groupTreatment = _data["GroupTreatment"];
            this.inhouse = _data["Inhouse"];
            this.statusId = _data["StatusId"];
            this.status = _data["Status"] ? AssignmentStatus.fromJS(_data["Status"]) : <any>undefined;
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
            this.appointmentScheduleBatchId = _data["AppointmentScheduleBatchId"];
            this.appointmentScheduleBatch = _data["AppointmentScheduleBatch"] ? AppointmentScheduleBatch.fromJS(_data["AppointmentScheduleBatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["Duration"] = this.duration;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["MaxDaysInAdvanceCanBeBooked"] = this.maxDaysInAdvanceCanBeBooked;
        data["MinHoursBeforeScheduleStartCanBeBooked"] = this.minHoursBeforeScheduleStartCanBeBooked;
        data["BufferTimeBetweenSlotsInMinutes"] = this.bufferTimeBetweenSlotsInMinutes;
        data["BookableEveryInMinutes"] = this.bookableEveryInMinutes;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["RoomId"] = this.roomId;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["GroupTreatment"] = this.groupTreatment;
        data["Inhouse"] = this.inhouse;
        data["StatusId"] = this.statusId;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        data["AppointmentScheduleBatchId"] = this.appointmentScheduleBatchId;
        data["AppointmentScheduleBatch"] = this.appointmentScheduleBatch ? this.appointmentScheduleBatch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppointmentSchedule {
        const json = this.toJSON();
        let result = new AppointmentSchedule();
        result.init(json);
        return result;
    }
}

export interface IAppointmentSchedule extends IBaseEntity {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailySchedule[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployee[] | undefined;
    bookings?: Booking[] | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    companies?: Company[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPattern | undefined;
    scheduleExceptions?: ScheduleException[] | undefined;
    roomId?: number | undefined;
    room?: Room | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    statusId?: number;
    status?: AssignmentStatus | undefined;
    isVideoCallAvailable?: boolean;
    appointmentScheduleBatchId?: string | undefined;
    appointmentScheduleBatch?: AppointmentScheduleBatch | undefined;
}

export class Booking extends BaseEntity implements IBooking {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    cancelled?: boolean;
    noShow?: boolean;
    scheduleId?: number | undefined;
    schedule?: Schedule | undefined;
    assignmentId?: number | undefined;
    assignment?: Assignment | undefined;
    appointmentScheduleId?: number | undefined;
    appointmentSchedule?: AppointmentSchedule | undefined;
    groupBookingSessionId?: number | undefined;
    description?: string | undefined;
    employeeGroupEmployeeId?: number | undefined;
    employeeGroupEmployee?: EmployeeGroupEmployee | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    bookingStatusId?: number;
    bookingStatus?: BookingStatus | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    caseId?: number | undefined;
    case?: Case | undefined;
    rescheduledBookingId?: number | undefined;
    changeLogs?: ChangeLog[] | undefined;
    isVideoCall?: boolean;
    calendarEventGUID?: string;

    constructor(data?: IBooking) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.cancelled = _data["Cancelled"];
            this.noShow = _data["NoShow"];
            this.scheduleId = _data["ScheduleId"];
            this.schedule = _data["Schedule"] ? Schedule.fromJS(_data["Schedule"]) : <any>undefined;
            this.assignmentId = _data["AssignmentId"];
            this.assignment = _data["Assignment"] ? Assignment.fromJS(_data["Assignment"]) : <any>undefined;
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            this.appointmentSchedule = _data["AppointmentSchedule"] ? AppointmentSchedule.fromJS(_data["AppointmentSchedule"]) : <any>undefined;
            this.groupBookingSessionId = _data["GroupBookingSessionId"];
            this.description = _data["Description"];
            this.employeeGroupEmployeeId = _data["EmployeeGroupEmployeeId"];
            this.employeeGroupEmployee = _data["EmployeeGroupEmployee"] ? EmployeeGroupEmployee.fromJS(_data["EmployeeGroupEmployee"]) : <any>undefined;
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            this.bookingStatusId = _data["BookingStatusId"];
            this.bookingStatus = _data["BookingStatus"] ? BookingStatus.fromJS(_data["BookingStatus"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? Case.fromJS(_data["Case"]) : <any>undefined;
            this.rescheduledBookingId = _data["RescheduledBookingId"];
            if (Array.isArray(_data["ChangeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["ChangeLogs"])
                    this.changeLogs!.push(ChangeLog.fromJS(item));
            }
            this.isVideoCall = _data["IsVideoCall"];
            this.calendarEventGUID = _data["CalendarEventGUID"];
        }
    }

    static fromJS(data: any): Booking {
        data = typeof data === 'object' ? data : {};
        let result = new Booking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["Cancelled"] = this.cancelled;
        data["NoShow"] = this.noShow;
        data["ScheduleId"] = this.scheduleId;
        data["Schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        data["AssignmentId"] = this.assignmentId;
        data["Assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        data["AppointmentSchedule"] = this.appointmentSchedule ? this.appointmentSchedule.toJSON() : <any>undefined;
        data["GroupBookingSessionId"] = this.groupBookingSessionId;
        data["Description"] = this.description;
        data["EmployeeGroupEmployeeId"] = this.employeeGroupEmployeeId;
        data["EmployeeGroupEmployee"] = this.employeeGroupEmployee ? this.employeeGroupEmployee.toJSON() : <any>undefined;
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["BookingStatusId"] = this.bookingStatusId;
        data["BookingStatus"] = this.bookingStatus ? this.bookingStatus.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["RescheduledBookingId"] = this.rescheduledBookingId;
        if (Array.isArray(this.changeLogs)) {
            data["ChangeLogs"] = [];
            for (let item of this.changeLogs)
                data["ChangeLogs"].push(item.toJSON());
        }
        data["IsVideoCall"] = this.isVideoCall;
        data["CalendarEventGUID"] = this.calendarEventGUID;
        super.toJSON(data);
        return data; 
    }

    clone(): Booking {
        const json = this.toJSON();
        let result = new Booking();
        result.init(json);
        return result;
    }
}

export interface IBooking extends IBaseEntity {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    cancelled?: boolean;
    noShow?: boolean;
    scheduleId?: number | undefined;
    schedule?: Schedule | undefined;
    assignmentId?: number | undefined;
    assignment?: Assignment | undefined;
    appointmentScheduleId?: number | undefined;
    appointmentSchedule?: AppointmentSchedule | undefined;
    groupBookingSessionId?: number | undefined;
    description?: string | undefined;
    employeeGroupEmployeeId?: number | undefined;
    employeeGroupEmployee?: EmployeeGroupEmployee | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    bookingStatusId?: number;
    bookingStatus?: BookingStatus | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    caseId?: number | undefined;
    case?: Case | undefined;
    rescheduledBookingId?: number | undefined;
    changeLogs?: ChangeLog[] | undefined;
    isVideoCall?: boolean;
    calendarEventGUID?: string;
}

export class EmployeeGroupEmployee extends BaseEntity implements IEmployeeGroupEmployee {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    employeeGroupId?: number;
    employeeGroup?: EmployeeGroup | undefined;
    userId?: number;
    user?: User | undefined;
    bookings?: Booking[] | undefined;

    constructor(data?: IEmployeeGroupEmployee) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.employeeGroupId = _data["EmployeeGroupId"];
            this.employeeGroup = _data["EmployeeGroup"] ? EmployeeGroup.fromJS(_data["EmployeeGroup"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeGroupEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["EmployeeGroupId"] = this.employeeGroupId;
        data["EmployeeGroup"] = this.employeeGroup ? this.employeeGroup.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmployeeGroupEmployee {
        const json = this.toJSON();
        let result = new EmployeeGroupEmployee();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroupEmployee extends IBaseEntity {
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    employeeGroupId?: number;
    employeeGroup?: EmployeeGroup | undefined;
    userId?: number;
    user?: User | undefined;
    bookings?: Booking[] | undefined;
}

export class EmployeeGroup extends BaseEntity implements IEmployeeGroup {
    name?: string | undefined;
    companyId?: number;
    company?: Company | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployee[] | undefined;

    constructor(data?: IEmployeeGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.companyId = _data["CompanyId"];
            this.company = _data["Company"] ? Company.fromJS(_data["Company"]) : <any>undefined;
            if (Array.isArray(_data["EmployeeGroupEmployees"])) {
                this.employeeGroupEmployees = [] as any;
                for (let item of _data["EmployeeGroupEmployees"])
                    this.employeeGroupEmployees!.push(EmployeeGroupEmployee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["CompanyId"] = this.companyId;
        data["Company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.employeeGroupEmployees)) {
            data["EmployeeGroupEmployees"] = [];
            for (let item of this.employeeGroupEmployees)
                data["EmployeeGroupEmployees"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmployeeGroup {
        const json = this.toJSON();
        let result = new EmployeeGroup();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroup extends IBaseEntity {
    name?: string | undefined;
    companyId?: number;
    company?: Company | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployee[] | undefined;
}

export class BookingStatus extends BaseEntity implements IBookingStatus {
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
    translations?: BookingStatusTranslation[] | undefined;

    constructor(data?: IBookingStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.colorCode = _data["ColorCode"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(BookingStatusTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new BookingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["ColorCode"] = this.colorCode;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): BookingStatus {
        const json = this.toJSON();
        let result = new BookingStatus();
        result.init(json);
        return result;
    }
}

export interface IBookingStatus extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
    translations?: BookingStatusTranslation[] | undefined;
}

export class BookingStatusTranslation implements IBookingStatusTranslation {
    name?: string | undefined;
    entity?: BookingStatus | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: IBookingStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.entity = _data["Entity"] ? BookingStatus.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): BookingStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new BookingStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): BookingStatusTranslation {
        const json = this.toJSON();
        let result = new BookingStatusTranslation();
        result.init(json);
        return result;
    }
}

export interface IBookingStatusTranslation {
    name?: string | undefined;
    entity?: BookingStatus | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class BaseEntityOfLong extends AuditedEntity implements IBaseEntityOfLong {
    id?: number;

    constructor(data?: IBaseEntityOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): BaseEntityOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntityOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data; 
    }

    clone(): BaseEntityOfLong {
        const json = this.toJSON();
        let result = new BaseEntityOfLong();
        result.init(json);
        return result;
    }
}

export interface IBaseEntityOfLong extends IAuditedEntity {
    id?: number;
}

export class Case extends BaseEntityOfLong implements ICase {
    subject?: string | undefined;
    description?: string | undefined;
    startDate?: moment.Moment;
    caseStatusId?: number | undefined;
    caseStatus?: CaseStatus | undefined;
    patientId?: number;
    assigneeId?: number | undefined;
    assignee?: TreatmentProviderEmployee | undefined;
    patient?: User | undefined;
    internalComments?: InternalComment[] | undefined;
    medicalJournals?: MedicalJournal[] | undefined;
    bookings?: Booking[] | undefined;
    caseTreatmentTypes?: CaseTreatmentType[] | undefined;
    user?: User | undefined;
    caseTreatmentProviders?: CaseTreatmentProvider[] | undefined;
    treatmentAreas?: TreatmentArea[] | undefined;

    constructor(data?: ICase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["Subject"];
            this.description = _data["Description"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.caseStatusId = _data["CaseStatusId"];
            this.caseStatus = _data["CaseStatus"] ? CaseStatus.fromJS(_data["CaseStatus"]) : <any>undefined;
            this.patientId = _data["PatientId"];
            this.assigneeId = _data["AssigneeId"];
            this.assignee = _data["Assignee"] ? TreatmentProviderEmployee.fromJS(_data["Assignee"]) : <any>undefined;
            this.patient = _data["Patient"] ? User.fromJS(_data["Patient"]) : <any>undefined;
            if (Array.isArray(_data["InternalComments"])) {
                this.internalComments = [] as any;
                for (let item of _data["InternalComments"])
                    this.internalComments!.push(InternalComment.fromJS(item));
            }
            if (Array.isArray(_data["MedicalJournals"])) {
                this.medicalJournals = [] as any;
                for (let item of _data["MedicalJournals"])
                    this.medicalJournals!.push(MedicalJournal.fromJS(item));
            }
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["CaseTreatmentTypes"])) {
                this.caseTreatmentTypes = [] as any;
                for (let item of _data["CaseTreatmentTypes"])
                    this.caseTreatmentTypes!.push(CaseTreatmentType.fromJS(item));
            }
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            if (Array.isArray(_data["CaseTreatmentProviders"])) {
                this.caseTreatmentProviders = [] as any;
                for (let item of _data["CaseTreatmentProviders"])
                    this.caseTreatmentProviders!.push(CaseTreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentAreas"])) {
                this.treatmentAreas = [] as any;
                for (let item of _data["TreatmentAreas"])
                    this.treatmentAreas!.push(TreatmentArea.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Case {
        data = typeof data === 'object' ? data : {};
        let result = new Case();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subject"] = this.subject;
        data["Description"] = this.description;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["CaseStatusId"] = this.caseStatusId;
        data["CaseStatus"] = this.caseStatus ? this.caseStatus.toJSON() : <any>undefined;
        data["PatientId"] = this.patientId;
        data["AssigneeId"] = this.assigneeId;
        data["Assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.internalComments)) {
            data["InternalComments"] = [];
            for (let item of this.internalComments)
                data["InternalComments"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalJournals)) {
            data["MedicalJournals"] = [];
            for (let item of this.medicalJournals)
                data["MedicalJournals"].push(item.toJSON());
        }
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.caseTreatmentTypes)) {
            data["CaseTreatmentTypes"] = [];
            for (let item of this.caseTreatmentTypes)
                data["CaseTreatmentTypes"].push(item.toJSON());
        }
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.caseTreatmentProviders)) {
            data["CaseTreatmentProviders"] = [];
            for (let item of this.caseTreatmentProviders)
                data["CaseTreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentAreas)) {
            data["TreatmentAreas"] = [];
            for (let item of this.treatmentAreas)
                data["TreatmentAreas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Case {
        const json = this.toJSON();
        let result = new Case();
        result.init(json);
        return result;
    }
}

export interface ICase extends IBaseEntityOfLong {
    subject?: string | undefined;
    description?: string | undefined;
    startDate?: moment.Moment;
    caseStatusId?: number | undefined;
    caseStatus?: CaseStatus | undefined;
    patientId?: number;
    assigneeId?: number | undefined;
    assignee?: TreatmentProviderEmployee | undefined;
    patient?: User | undefined;
    internalComments?: InternalComment[] | undefined;
    medicalJournals?: MedicalJournal[] | undefined;
    bookings?: Booking[] | undefined;
    caseTreatmentTypes?: CaseTreatmentType[] | undefined;
    user?: User | undefined;
    caseTreatmentProviders?: CaseTreatmentProvider[] | undefined;
    treatmentAreas?: TreatmentArea[] | undefined;
}

export class CaseStatus extends BaseEntity implements ICaseStatus {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    colorCode?: string | undefined;
    colorName?: string | undefined;
    cssClass?: string | undefined;
    orderPriority?: number | undefined;
    cases?: Case[] | undefined;
    translations?: CaseStatusTranslation[] | undefined;

    constructor(data?: ICaseStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.colorCode = _data["ColorCode"];
            this.colorName = _data["ColorName"];
            this.cssClass = _data["CssClass"];
            this.orderPriority = _data["OrderPriority"];
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases!.push(Case.fromJS(item));
            }
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(CaseStatusTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CaseStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ColorCode"] = this.colorCode;
        data["ColorName"] = this.colorName;
        data["CssClass"] = this.cssClass;
        data["OrderPriority"] = this.orderPriority;
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CaseStatus {
        const json = this.toJSON();
        let result = new CaseStatus();
        result.init(json);
        return result;
    }
}

export interface ICaseStatus extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    colorCode?: string | undefined;
    colorName?: string | undefined;
    cssClass?: string | undefined;
    orderPriority?: number | undefined;
    cases?: Case[] | undefined;
    translations?: CaseStatusTranslation[] | undefined;
}

export class CaseStatusTranslation implements ICaseStatusTranslation {
    name?: string | undefined;
    description?: string | undefined;
    entity?: CaseStatus | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: ICaseStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.entity = _data["Entity"] ? CaseStatus.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): CaseStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CaseStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): CaseStatusTranslation {
        const json = this.toJSON();
        let result = new CaseStatusTranslation();
        result.init(json);
        return result;
    }
}

export interface ICaseStatusTranslation {
    name?: string | undefined;
    description?: string | undefined;
    entity?: CaseStatus | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class InternalComment extends BaseEntity implements IInternalComment {
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
    case?: Case | undefined;
    user?: User | undefined;

    constructor(data?: IInternalComment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? Case.fromJS(_data["Case"]) : <any>undefined;
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalComment {
        data = typeof data === 'object' ? data : {};
        let result = new InternalComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): InternalComment {
        const json = this.toJSON();
        let result = new InternalComment();
        result.init(json);
        return result;
    }
}

export interface IInternalComment extends IBaseEntity {
    text?: string | undefined;
    textHtml?: string | undefined;
    caseId?: number;
    case?: Case | undefined;
    user?: User | undefined;
}

export class MedicalJournal extends BaseEntity implements IMedicalJournal {
    text?: string | undefined;
    textHtml?: string | undefined;
    filePath?: string | undefined;
    caseId?: number;
    case?: Case | undefined;
    user?: User | undefined;
    files?: File[] | undefined;
    originalMedicalJournalId?: number | undefined;

    constructor(data?: IMedicalJournal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.filePath = _data["FilePath"];
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? Case.fromJS(_data["Case"]) : <any>undefined;
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(File.fromJS(item));
            }
            this.originalMedicalJournalId = _data["OriginalMedicalJournalId"];
        }
    }

    static fromJS(data: any): MedicalJournal {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalJournal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["FilePath"] = this.filePath;
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        data["OriginalMedicalJournalId"] = this.originalMedicalJournalId;
        super.toJSON(data);
        return data; 
    }

    clone(): MedicalJournal {
        const json = this.toJSON();
        let result = new MedicalJournal();
        result.init(json);
        return result;
    }
}

export interface IMedicalJournal extends IBaseEntity {
    text?: string | undefined;
    textHtml?: string | undefined;
    filePath?: string | undefined;
    caseId?: number;
    case?: Case | undefined;
    user?: User | undefined;
    files?: File[] | undefined;
    originalMedicalJournalId?: number | undefined;
}

export class File extends BaseEntity implements IFile {
    filePath?: string | undefined;
    originalFileName?: string | undefined;
    downloadLogs?: DownloadLog[] | undefined;
    medicalJournals?: MedicalJournal[] | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;

    constructor(data?: IFile) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filePath = _data["FilePath"];
            this.originalFileName = _data["OriginalFileName"];
            if (Array.isArray(_data["DownloadLogs"])) {
                this.downloadLogs = [] as any;
                for (let item of _data["DownloadLogs"])
                    this.downloadLogs!.push(DownloadLog.fromJS(item));
            }
            if (Array.isArray(_data["MedicalJournals"])) {
                this.medicalJournals = [] as any;
                for (let item of _data["MedicalJournals"])
                    this.medicalJournals!.push(MedicalJournal.fromJS(item));
            }
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["OriginalFileName"] = this.originalFileName;
        if (Array.isArray(this.downloadLogs)) {
            data["DownloadLogs"] = [];
            for (let item of this.downloadLogs)
                data["DownloadLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalJournals)) {
            data["MedicalJournals"] = [];
            for (let item of this.medicalJournals)
                data["MedicalJournals"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): File {
        const json = this.toJSON();
        let result = new File();
        result.init(json);
        return result;
    }
}

export interface IFile extends IBaseEntity {
    filePath?: string | undefined;
    originalFileName?: string | undefined;
    downloadLogs?: DownloadLog[] | undefined;
    medicalJournals?: MedicalJournal[] | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
}

export class DownloadLog extends BaseEntity implements IDownloadLog {
    ipAddress?: string | undefined;
    rawUrl?: string | undefined;
    platform?: string | undefined;
    userAgent?: string | undefined;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    fileLength?: number;
    files?: File[] | undefined;

    constructor(data?: IDownloadLog) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ipAddress = _data["IpAddress"];
            this.rawUrl = _data["RawUrl"];
            this.platform = _data["Platform"];
            this.userAgent = _data["UserAgent"];
            this.filePath = _data["FilePath"];
            this.fileHash = _data["FileHash"];
            this.fileLength = _data["FileLength"];
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadLog {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IpAddress"] = this.ipAddress;
        data["RawUrl"] = this.rawUrl;
        data["Platform"] = this.platform;
        data["UserAgent"] = this.userAgent;
        data["FilePath"] = this.filePath;
        data["FileHash"] = this.fileHash;
        data["FileLength"] = this.fileLength;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): DownloadLog {
        const json = this.toJSON();
        let result = new DownloadLog();
        result.init(json);
        return result;
    }
}

export interface IDownloadLog extends IBaseEntity {
    ipAddress?: string | undefined;
    rawUrl?: string | undefined;
    platform?: string | undefined;
    userAgent?: string | undefined;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    fileLength?: number;
    files?: File[] | undefined;
}

export class CaseTreatmentType extends BaseEntity implements ICaseTreatmentType {
    caseId?: number;
    case?: Case | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    maxNumberOfBookings?: number | undefined;
    usedNumberOfBookings?: number;
    sortOrder?: number | undefined;

    constructor(data?: ICaseTreatmentType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? Case.fromJS(_data["Case"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.maxNumberOfBookings = _data["MaxNumberOfBookings"];
            this.usedNumberOfBookings = _data["UsedNumberOfBookings"];
            this.sortOrder = _data["SortOrder"];
        }
    }

    static fromJS(data: any): CaseTreatmentType {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTreatmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["MaxNumberOfBookings"] = this.maxNumberOfBookings;
        data["UsedNumberOfBookings"] = this.usedNumberOfBookings;
        data["SortOrder"] = this.sortOrder;
        super.toJSON(data);
        return data; 
    }

    clone(): CaseTreatmentType {
        const json = this.toJSON();
        let result = new CaseTreatmentType();
        result.init(json);
        return result;
    }
}

export interface ICaseTreatmentType extends IBaseEntity {
    caseId?: number;
    case?: Case | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    maxNumberOfBookings?: number | undefined;
    usedNumberOfBookings?: number;
    sortOrder?: number | undefined;
}

export class CaseTreatmentProvider extends BaseEntity implements ICaseTreatmentProvider {
    caseId?: number;
    case?: Case | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;

    constructor(data?: ICaseTreatmentProvider) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? Case.fromJS(_data["Case"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProvider.fromJS(_data["TreatmentProvider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseTreatmentProvider {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTreatmentProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): CaseTreatmentProvider {
        const json = this.toJSON();
        let result = new CaseTreatmentProvider();
        result.init(json);
        return result;
    }
}

export interface ICaseTreatmentProvider extends IBaseEntity {
    caseId?: number;
    case?: Case | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
}

export class TreatmentArea extends BaseEntity implements ITreatmentArea {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    cases?: Case[] | undefined;
    translations?: TreatmentAreaTranslation[] | undefined;

    constructor(data?: ITreatmentArea) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.image = _data["Image"];
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases!.push(Case.fromJS(item));
            }
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TreatmentAreaTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentArea {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["Image"] = this.image;
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentArea {
        const json = this.toJSON();
        let result = new TreatmentArea();
        result.init(json);
        return result;
    }
}

export interface ITreatmentArea extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    cases?: Case[] | undefined;
    translations?: TreatmentAreaTranslation[] | undefined;
}

export class TreatmentAreaTranslation implements ITreatmentAreaTranslation {
    name?: string | undefined;
    description?: string | undefined;
    entity?: TreatmentArea | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: ITreatmentAreaTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.entity = _data["Entity"] ? TreatmentArea.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): TreatmentAreaTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentAreaTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): TreatmentAreaTranslation {
        const json = this.toJSON();
        let result = new TreatmentAreaTranslation();
        result.init(json);
        return result;
    }
}

export interface ITreatmentAreaTranslation {
    name?: string | undefined;
    description?: string | undefined;
    entity?: TreatmentArea | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class ChangeLog implements IChangeLog {
    id?: number;
    tableName?: string | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    deleted?: boolean;
    changeLogDetails?: ChangeLogDetail[] | undefined;
    bookings?: Booking[] | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    caseConsents?: CaseConsent[] | undefined;

    constructor(data?: IChangeLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tableName = _data["TableName"];
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
            if (Array.isArray(_data["ChangeLogDetails"])) {
                this.changeLogDetails = [] as any;
                for (let item of _data["ChangeLogDetails"])
                    this.changeLogDetails!.push(ChangeLogDetail.fromJS(item));
            }
            if (Array.isArray(_data["Bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["Bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["CaseConsents"])) {
                this.caseConsents = [] as any;
                for (let item of _data["CaseConsents"])
                    this.caseConsents!.push(CaseConsent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeLog {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TableName"] = this.tableName;
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        if (Array.isArray(this.changeLogDetails)) {
            data["ChangeLogDetails"] = [];
            for (let item of this.changeLogDetails)
                data["ChangeLogDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.bookings)) {
            data["Bookings"] = [];
            for (let item of this.bookings)
                data["Bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.caseConsents)) {
            data["CaseConsents"] = [];
            for (let item of this.caseConsents)
                data["CaseConsents"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ChangeLog {
        const json = this.toJSON();
        let result = new ChangeLog();
        result.init(json);
        return result;
    }
}

export interface IChangeLog {
    id?: number;
    tableName?: string | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    deleted?: boolean;
    changeLogDetails?: ChangeLogDetail[] | undefined;
    bookings?: Booking[] | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    caseConsents?: CaseConsent[] | undefined;
}

export class ChangeLogDetail implements IChangeLogDetail {
    id?: number;
    columnName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    deleted?: boolean;
    changeLogId?: number;
    changeLog?: ChangeLog | undefined;

    constructor(data?: IChangeLogDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.columnName = _data["ColumnName"];
            this.oldValue = _data["OldValue"];
            this.newValue = _data["NewValue"];
            this.deleted = _data["Deleted"];
            this.changeLogId = _data["ChangeLogId"];
            this.changeLog = _data["ChangeLog"] ? ChangeLog.fromJS(_data["ChangeLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeLogDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ColumnName"] = this.columnName;
        data["OldValue"] = this.oldValue;
        data["NewValue"] = this.newValue;
        data["Deleted"] = this.deleted;
        data["ChangeLogId"] = this.changeLogId;
        data["ChangeLog"] = this.changeLog ? this.changeLog.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ChangeLogDetail {
        const json = this.toJSON();
        let result = new ChangeLogDetail();
        result.init(json);
        return result;
    }
}

export interface IChangeLogDetail {
    id?: number;
    columnName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    deleted?: boolean;
    changeLogId?: number;
    changeLog?: ChangeLog | undefined;
}

export class CaseConsent extends BaseEntity implements ICaseConsent {
    caseId?: number;
    case?: Case | undefined;
    consentId?: number;
    consent?: Consent | undefined;
    rejected?: boolean | undefined;
    reason?: string | undefined;
    user?: User | undefined;
    reviewedBy?: number | undefined;
    revoked?: boolean;
    createdByUser?: User | undefined;
    changeLogs?: ChangeLog[] | undefined;

    constructor(data?: ICaseConsent) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? Case.fromJS(_data["Case"]) : <any>undefined;
            this.consentId = _data["ConsentId"];
            this.consent = _data["Consent"] ? Consent.fromJS(_data["Consent"]) : <any>undefined;
            this.rejected = _data["Rejected"];
            this.reason = _data["Reason"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            this.reviewedBy = _data["ReviewedBy"];
            this.revoked = _data["Revoked"];
            this.createdByUser = _data["CreatedByUser"] ? User.fromJS(_data["CreatedByUser"]) : <any>undefined;
            if (Array.isArray(_data["ChangeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["ChangeLogs"])
                    this.changeLogs!.push(ChangeLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseConsent {
        data = typeof data === 'object' ? data : {};
        let result = new CaseConsent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["ConsentId"] = this.consentId;
        data["Consent"] = this.consent ? this.consent.toJSON() : <any>undefined;
        data["Rejected"] = this.rejected;
        data["Reason"] = this.reason;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["ReviewedBy"] = this.reviewedBy;
        data["Revoked"] = this.revoked;
        data["CreatedByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.changeLogs)) {
            data["ChangeLogs"] = [];
            for (let item of this.changeLogs)
                data["ChangeLogs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CaseConsent {
        const json = this.toJSON();
        let result = new CaseConsent();
        result.init(json);
        return result;
    }
}

export interface ICaseConsent extends IBaseEntity {
    caseId?: number;
    case?: Case | undefined;
    consentId?: number;
    consent?: Consent | undefined;
    rejected?: boolean | undefined;
    reason?: string | undefined;
    user?: User | undefined;
    reviewedBy?: number | undefined;
    revoked?: boolean;
    createdByUser?: User | undefined;
    changeLogs?: ChangeLog[] | undefined;
}

export class Consent extends BaseEntity implements IConsent {
    name?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
    text?: string | undefined;
    consentTypeId?: number;
    consentType?: ConsentType | undefined;

    constructor(data?: IConsent) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.code = _data["Code"];
            this.text = _data["Text"];
            this.consentTypeId = _data["ConsentTypeId"];
            this.consentType = _data["ConsentType"] ? ConsentType.fromJS(_data["ConsentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Consent {
        data = typeof data === 'object' ? data : {};
        let result = new Consent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Code"] = this.code;
        data["Text"] = this.text;
        data["ConsentTypeId"] = this.consentTypeId;
        data["ConsentType"] = this.consentType ? this.consentType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): Consent {
        const json = this.toJSON();
        let result = new Consent();
        result.init(json);
        return result;
    }
}

export interface IConsent extends IBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
    text?: string | undefined;
    consentTypeId?: number;
    consentType?: ConsentType | undefined;
}

export class ConsentType extends BaseEntity implements IConsentType {
    name?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;

    constructor(data?: IConsentType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): ConsentType {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Code"] = this.code;
        super.toJSON(data);
        return data; 
    }

    clone(): ConsentType {
        const json = this.toJSON();
        let result = new ConsentType();
        result.init(json);
        return result;
    }
}

export interface IConsentType extends IBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
}

export class Room extends BaseEntity implements IRoom {
    name?: string | undefined;
    locationId?: number;
    location?: Location | undefined;
    companyId?: number | undefined;
    company?: Company | undefined;

    constructor(data?: IRoom) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? Location.fromJS(_data["Location"]) : <any>undefined;
            this.companyId = _data["CompanyId"];
            this.company = _data["Company"] ? Company.fromJS(_data["Company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Room {
        data = typeof data === 'object' ? data : {};
        let result = new Room();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["CompanyId"] = this.companyId;
        data["Company"] = this.company ? this.company.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): Room {
        const json = this.toJSON();
        let result = new Room();
        result.init(json);
        return result;
    }
}

export interface IRoom extends IBaseEntity {
    name?: string | undefined;
    locationId?: number;
    location?: Location | undefined;
    companyId?: number | undefined;
    company?: Company | undefined;
}

export class AssignmentStatus extends BaseEntity implements IAssignmentStatus {
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
    translations?: AssignmentStatusTranslation[] | undefined;

    constructor(data?: IAssignmentStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.colorCode = _data["ColorCode"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(AssignmentStatusTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["ColorCode"] = this.colorCode;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AssignmentStatus {
        const json = this.toJSON();
        let result = new AssignmentStatus();
        result.init(json);
        return result;
    }
}

export interface IAssignmentStatus extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    colorCode?: string | undefined;
    translations?: AssignmentStatusTranslation[] | undefined;
}

export class AssignmentStatusTranslation implements IAssignmentStatusTranslation {
    name?: string | undefined;
    entity?: AssignmentStatus | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: IAssignmentStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.entity = _data["Entity"] ? AssignmentStatus.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): AssignmentStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): AssignmentStatusTranslation {
        const json = this.toJSON();
        let result = new AssignmentStatusTranslation();
        result.init(json);
        return result;
    }
}

export interface IAssignmentStatusTranslation {
    name?: string | undefined;
    entity?: AssignmentStatus | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class AppointmentScheduleBatch implements IAppointmentScheduleBatch {
    id?: string;
    userId?: number;
    isFinalized?: boolean;
    createdAt?: moment.Moment;

    constructor(data?: IAppointmentScheduleBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.isFinalized = _data["IsFinalized"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentScheduleBatch {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["IsFinalized"] = this.isFinalized;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }

    clone(): AppointmentScheduleBatch {
        const json = this.toJSON();
        let result = new AppointmentScheduleBatch();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleBatch {
    id?: string;
    userId?: number;
    isFinalized?: boolean;
    createdAt?: moment.Moment;
}

export class ScheduleType extends BaseEntity implements IScheduleType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
    translations?: ScheduleTypeTranslation[] | undefined;

    constructor(data?: IScheduleType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.color = _data["Color"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(ScheduleTypeTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleType {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["Color"] = this.color;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): ScheduleType {
        const json = this.toJSON();
        let result = new ScheduleType();
        result.init(json);
        return result;
    }
}

export interface IScheduleType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
    translations?: ScheduleTypeTranslation[] | undefined;
}

export class ScheduleTypeTranslation implements IScheduleTypeTranslation {
    name?: string | undefined;
    description?: string | undefined;
    entity?: ScheduleType | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: IScheduleTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.entity = _data["Entity"] ? ScheduleType.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): ScheduleTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): ScheduleTypeTranslation {
        const json = this.toJSON();
        let result = new ScheduleTypeTranslation();
        result.init(json);
        return result;
    }
}

export interface IScheduleTypeTranslation {
    name?: string | undefined;
    description?: string | undefined;
    entity?: ScheduleType | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class CompanyTreatmentType extends BaseEntity implements ICompanyTreatmentType {
    companyId?: number;
    company?: Company | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    initial?: boolean;
    maxNumberOfBookings?: number | undefined;
    yearlyLimitOfBookingsPerUser?: number | undefined;
    sortOrder?: number | undefined;

    constructor(data?: ICompanyTreatmentType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["CompanyId"];
            this.company = _data["Company"] ? Company.fromJS(_data["Company"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentType.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.initial = _data["Initial"];
            this.maxNumberOfBookings = _data["MaxNumberOfBookings"];
            this.yearlyLimitOfBookingsPerUser = _data["YearlyLimitOfBookingsPerUser"];
            this.sortOrder = _data["SortOrder"];
        }
    }

    static fromJS(data: any): CompanyTreatmentType {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTreatmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyId"] = this.companyId;
        data["Company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["Initial"] = this.initial;
        data["MaxNumberOfBookings"] = this.maxNumberOfBookings;
        data["YearlyLimitOfBookingsPerUser"] = this.yearlyLimitOfBookingsPerUser;
        data["SortOrder"] = this.sortOrder;
        super.toJSON(data);
        return data; 
    }

    clone(): CompanyTreatmentType {
        const json = this.toJSON();
        let result = new CompanyTreatmentType();
        result.init(json);
        return result;
    }
}

export interface ICompanyTreatmentType extends IBaseEntity {
    companyId?: number;
    company?: Company | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentType | undefined;
    initial?: boolean;
    maxNumberOfBookings?: number | undefined;
    yearlyLimitOfBookingsPerUser?: number | undefined;
    sortOrder?: number | undefined;
}

export class TreatmentTypeTranslation implements ITreatmentTypeTranslation {
    name?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    entity?: TreatmentType | undefined;
    entityId?: number;
    language?: string | undefined;
    id?: number;

    constructor(data?: ITreatmentTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.entity = _data["Entity"] ? TreatmentType.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.language = _data["Language"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): TreatmentTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Language"] = this.language;
        data["Id"] = this.id;
        return data; 
    }

    clone(): TreatmentTypeTranslation {
        const json = this.toJSON();
        let result = new TreatmentTypeTranslation();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeTranslation {
    name?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    entity?: TreatmentType | undefined;
    entityId?: number;
    language?: string | undefined;
    id?: number;
}

export class Email extends BaseEntity implements IEmail {
    subject?: string | undefined;
    body?: string | undefined;
    from?: string | undefined;
    fromDisplayName?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    sent?: boolean;
    dateSent?: moment.Moment | undefined;
    automaticSend?: boolean;
    automaticSendingDate?: moment.Moment | undefined;
    errorSending?: boolean;
    errorMessage?: string | undefined;
    emailTemplateId?: number | undefined;
    emailTemplate?: EmailTemplate | undefined;
    notificationId?: number | undefined;
    notification?: Notification | undefined;
    emailAttachments?: EmailAttachment[] | undefined;
    calendarEventIsSent?: boolean;
    bookingId?: number | undefined;
    booking?: Booking | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    userNotifications?: UserNotification[] | undefined;

    constructor(data?: IEmail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.from = _data["From"];
            this.fromDisplayName = _data["FromDisplayName"];
            this.to = _data["To"];
            this.cc = _data["Cc"];
            this.bcc = _data["Bcc"];
            this.sent = _data["Sent"];
            this.dateSent = _data["DateSent"] ? moment(_data["DateSent"].toString()) : <any>undefined;
            this.automaticSend = _data["AutomaticSend"];
            this.automaticSendingDate = _data["AutomaticSendingDate"] ? moment(_data["AutomaticSendingDate"].toString()) : <any>undefined;
            this.errorSending = _data["ErrorSending"];
            this.errorMessage = _data["ErrorMessage"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.emailTemplate = _data["EmailTemplate"] ? EmailTemplate.fromJS(_data["EmailTemplate"]) : <any>undefined;
            this.notificationId = _data["NotificationId"];
            this.notification = _data["Notification"] ? Notification.fromJS(_data["Notification"]) : <any>undefined;
            if (Array.isArray(_data["EmailAttachments"])) {
                this.emailAttachments = [] as any;
                for (let item of _data["EmailAttachments"])
                    this.emailAttachments!.push(EmailAttachment.fromJS(item));
            }
            this.calendarEventIsSent = _data["CalendarEventIsSent"];
            this.bookingId = _data["BookingId"];
            this.booking = _data["Booking"] ? Booking.fromJS(_data["Booking"]) : <any>undefined;
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["UserNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["UserNotifications"])
                    this.userNotifications!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["From"] = this.from;
        data["FromDisplayName"] = this.fromDisplayName;
        data["To"] = this.to;
        data["Cc"] = this.cc;
        data["Bcc"] = this.bcc;
        data["Sent"] = this.sent;
        data["DateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["AutomaticSend"] = this.automaticSend;
        data["AutomaticSendingDate"] = this.automaticSendingDate ? this.automaticSendingDate.toISOString() : <any>undefined;
        data["ErrorSending"] = this.errorSending;
        data["ErrorMessage"] = this.errorMessage;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["EmailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["NotificationId"] = this.notificationId;
        data["Notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        if (Array.isArray(this.emailAttachments)) {
            data["EmailAttachments"] = [];
            for (let item of this.emailAttachments)
                data["EmailAttachments"].push(item.toJSON());
        }
        data["CalendarEventIsSent"] = this.calendarEventIsSent;
        data["BookingId"] = this.bookingId;
        data["Booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.userNotifications)) {
            data["UserNotifications"] = [];
            for (let item of this.userNotifications)
                data["UserNotifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Email {
        const json = this.toJSON();
        let result = new Email();
        result.init(json);
        return result;
    }
}

export interface IEmail extends IBaseEntity {
    subject?: string | undefined;
    body?: string | undefined;
    from?: string | undefined;
    fromDisplayName?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    sent?: boolean;
    dateSent?: moment.Moment | undefined;
    automaticSend?: boolean;
    automaticSendingDate?: moment.Moment | undefined;
    errorSending?: boolean;
    errorMessage?: string | undefined;
    emailTemplateId?: number | undefined;
    emailTemplate?: EmailTemplate | undefined;
    notificationId?: number | undefined;
    notification?: Notification | undefined;
    emailAttachments?: EmailAttachment[] | undefined;
    calendarEventIsSent?: boolean;
    bookingId?: number | undefined;
    booking?: Booking | undefined;
    users?: User[] | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    userNotifications?: UserNotification[] | undefined;
}

export class EmailTemplate extends BaseEntity implements IEmailTemplate {
    keyword?: string | undefined;
    description?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    filePath?: string | undefined;
    language?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;

    constructor(data?: IEmailTemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyword = _data["Keyword"];
            this.description = _data["Description"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.filePath = _data["FilePath"];
            this.language = _data["Language"];
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetwork.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Keyword"] = this.keyword;
        data["Description"] = this.description;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["FilePath"] = this.filePath;
        data["Language"] = this.language;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): EmailTemplate {
        const json = this.toJSON();
        let result = new EmailTemplate();
        result.init(json);
        return result;
    }
}

export interface IEmailTemplate extends IBaseEntity {
    keyword?: string | undefined;
    description?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    filePath?: string | undefined;
    language?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
}

export class Notification extends BaseEntity implements INotification {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    recipientTypeId?: number;
    recipientType?: RecipientType | undefined;
    textMessagesEnabled?: boolean;
    textMessageTemplateCode?: string | undefined;
    emailTemplateCode?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;

    constructor(data?: INotification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.enabled = _data["Enabled"];
            this.recipientTypeId = _data["RecipientTypeId"];
            this.recipientType = _data["RecipientType"] ? RecipientType.fromJS(_data["RecipientType"]) : <any>undefined;
            this.textMessagesEnabled = _data["TextMessagesEnabled"];
            this.textMessageTemplateCode = _data["TextMessageTemplateCode"];
            this.emailTemplateCode = _data["EmailTemplateCode"];
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetwork.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["Enabled"] = this.enabled;
        data["RecipientTypeId"] = this.recipientTypeId;
        data["RecipientType"] = this.recipientType ? this.recipientType.toJSON() : <any>undefined;
        data["TextMessagesEnabled"] = this.textMessagesEnabled;
        data["TextMessageTemplateCode"] = this.textMessageTemplateCode;
        data["EmailTemplateCode"] = this.emailTemplateCode;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): Notification {
        const json = this.toJSON();
        let result = new Notification();
        result.init(json);
        return result;
    }
}

export interface INotification extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    recipientTypeId?: number;
    recipientType?: RecipientType | undefined;
    textMessagesEnabled?: boolean;
    textMessageTemplateCode?: string | undefined;
    emailTemplateCode?: string | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetwork | undefined;
}

export class RecipientType extends BaseEntity implements IRecipientType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IRecipientType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): RecipientType {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        super.toJSON(data);
        return data; 
    }

    clone(): RecipientType {
        const json = this.toJSON();
        let result = new RecipientType();
        result.init(json);
        return result;
    }
}

export interface IRecipientType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class EmailAttachment extends BaseEntity implements IEmailAttachment {
    filePath?: string | undefined;
    emailId?: number;
    email?: Email | undefined;
    emailAttachmentTypeId?: number | undefined;
    emailAttachmentType?: EmailAttachmentType | undefined;

    constructor(data?: IEmailAttachment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filePath = _data["FilePath"];
            this.emailId = _data["EmailId"];
            this.email = _data["Email"] ? Email.fromJS(_data["Email"]) : <any>undefined;
            this.emailAttachmentTypeId = _data["EmailAttachmentTypeId"];
            this.emailAttachmentType = _data["EmailAttachmentType"] ? EmailAttachmentType.fromJS(_data["EmailAttachmentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["EmailId"] = this.emailId;
        data["Email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["EmailAttachmentTypeId"] = this.emailAttachmentTypeId;
        data["EmailAttachmentType"] = this.emailAttachmentType ? this.emailAttachmentType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): EmailAttachment {
        const json = this.toJSON();
        let result = new EmailAttachment();
        result.init(json);
        return result;
    }
}

export interface IEmailAttachment extends IBaseEntity {
    filePath?: string | undefined;
    emailId?: number;
    email?: Email | undefined;
    emailAttachmentTypeId?: number | undefined;
    emailAttachmentType?: EmailAttachmentType | undefined;
}

export class EmailAttachmentType extends BaseEntity implements IEmailAttachmentType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    emailAttachments?: EmailAttachment[] | undefined;

    constructor(data?: IEmailAttachmentType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            if (Array.isArray(_data["EmailAttachments"])) {
                this.emailAttachments = [] as any;
                for (let item of _data["EmailAttachments"])
                    this.emailAttachments!.push(EmailAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailAttachmentType {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        if (Array.isArray(this.emailAttachments)) {
            data["EmailAttachments"] = [];
            for (let item of this.emailAttachments)
                data["EmailAttachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmailAttachmentType {
        const json = this.toJSON();
        let result = new EmailAttachmentType();
        result.init(json);
        return result;
    }
}

export interface IEmailAttachmentType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    emailAttachments?: EmailAttachment[] | undefined;
}

export class UserNotification extends BaseEntity implements IUserNotification {
    notificationId?: number;
    notification?: Notification | undefined;
    userId?: number;
    user?: User | undefined;
    textMessageEnabled?: boolean;
    emailEnabled?: boolean;
    receiveCalendarInvitation?: boolean;
    textMessages?: TextMessage[] | undefined;
    emails?: Email[] | undefined;

    constructor(data?: IUserNotification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationId = _data["NotificationId"];
            this.notification = _data["Notification"] ? Notification.fromJS(_data["Notification"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            this.textMessageEnabled = _data["TextMessageEnabled"];
            this.emailEnabled = _data["EmailEnabled"];
            this.receiveCalendarInvitation = _data["ReceiveCalendarInvitation"];
            if (Array.isArray(_data["TextMessages"])) {
                this.textMessages = [] as any;
                for (let item of _data["TextMessages"])
                    this.textMessages!.push(TextMessage.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        data["Notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TextMessageEnabled"] = this.textMessageEnabled;
        data["EmailEnabled"] = this.emailEnabled;
        data["ReceiveCalendarInvitation"] = this.receiveCalendarInvitation;
        if (Array.isArray(this.textMessages)) {
            data["TextMessages"] = [];
            for (let item of this.textMessages)
                data["TextMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): UserNotification {
        const json = this.toJSON();
        let result = new UserNotification();
        result.init(json);
        return result;
    }
}

export interface IUserNotification extends IBaseEntity {
    notificationId?: number;
    notification?: Notification | undefined;
    userId?: number;
    user?: User | undefined;
    textMessageEnabled?: boolean;
    emailEnabled?: boolean;
    receiveCalendarInvitation?: boolean;
    textMessages?: TextMessage[] | undefined;
    emails?: Email[] | undefined;
}

export class TextMessage extends BaseEntity implements ITextMessage {
    text?: string | undefined;
    recipient?: string | undefined;
    sender?: string | undefined;
    sent?: boolean;
    errorMessage?: string | undefined;
    textMessageTemplateId?: number | undefined;
    textMessageTemplate?: TextMessageTemplate | undefined;
    notificationId?: number | undefined;
    notification?: Notification | undefined;
    bookingId?: number | undefined;
    booking?: Booking | undefined;
    userNotifications?: UserNotification[] | undefined;

    constructor(data?: ITextMessage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["Text"];
            this.recipient = _data["Recipient"];
            this.sender = _data["Sender"];
            this.sent = _data["Sent"];
            this.errorMessage = _data["ErrorMessage"];
            this.textMessageTemplateId = _data["TextMessageTemplateId"];
            this.textMessageTemplate = _data["TextMessageTemplate"] ? TextMessageTemplate.fromJS(_data["TextMessageTemplate"]) : <any>undefined;
            this.notificationId = _data["NotificationId"];
            this.notification = _data["Notification"] ? Notification.fromJS(_data["Notification"]) : <any>undefined;
            this.bookingId = _data["BookingId"];
            this.booking = _data["Booking"] ? Booking.fromJS(_data["Booking"]) : <any>undefined;
            if (Array.isArray(_data["UserNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["UserNotifications"])
                    this.userNotifications!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TextMessage {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["Recipient"] = this.recipient;
        data["Sender"] = this.sender;
        data["Sent"] = this.sent;
        data["ErrorMessage"] = this.errorMessage;
        data["TextMessageTemplateId"] = this.textMessageTemplateId;
        data["TextMessageTemplate"] = this.textMessageTemplate ? this.textMessageTemplate.toJSON() : <any>undefined;
        data["NotificationId"] = this.notificationId;
        data["Notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["BookingId"] = this.bookingId;
        data["Booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        if (Array.isArray(this.userNotifications)) {
            data["UserNotifications"] = [];
            for (let item of this.userNotifications)
                data["UserNotifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): TextMessage {
        const json = this.toJSON();
        let result = new TextMessage();
        result.init(json);
        return result;
    }
}

export interface ITextMessage extends IBaseEntity {
    text?: string | undefined;
    recipient?: string | undefined;
    sender?: string | undefined;
    sent?: boolean;
    errorMessage?: string | undefined;
    textMessageTemplateId?: number | undefined;
    textMessageTemplate?: TextMessageTemplate | undefined;
    notificationId?: number | undefined;
    notification?: Notification | undefined;
    bookingId?: number | undefined;
    booking?: Booking | undefined;
    userNotifications?: UserNotification[] | undefined;
}

export class Note extends BaseEntity implements INote {
    text?: string | undefined;
    textHtml?: string | undefined;
    user?: User | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    users?: User[] | undefined;

    constructor(data?: INote) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(Company.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProvider.fromJS(item));
            }
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Note {
        data = typeof data === 'object' ? data : {};
        let result = new Note();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Note {
        const json = this.toJSON();
        let result = new Note();
        result.init(json);
        return result;
    }
}

export interface INote extends IBaseEntity {
    text?: string | undefined;
    textHtml?: string | undefined;
    user?: User | undefined;
    companies?: Company[] | undefined;
    treatmentProviders?: TreatmentProvider[] | undefined;
    users?: User[] | undefined;
}

export class TreatmentProviderDetail extends BaseEntity implements ITreatmentProviderDetail {
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    title?: string | undefined;
    uRLAlias?: string | undefined;
    metaTags?: string | undefined;
    moreInfo?: string | undefined;
    securityRatingOK?: boolean;
    securityRatingDescription?: string | undefined;
    sendNewsletter?: boolean;

    constructor(data?: ITreatmentProviderDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProvider.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            this.title = _data["Title"];
            this.uRLAlias = _data["URLAlias"];
            this.metaTags = _data["MetaTags"];
            this.moreInfo = _data["MoreInfo"];
            this.securityRatingOK = _data["SecurityRatingOK"];
            this.securityRatingDescription = _data["SecurityRatingDescription"];
            this.sendNewsletter = _data["SendNewsletter"];
        }
    }

    static fromJS(data: any): TreatmentProviderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        data["Title"] = this.title;
        data["URLAlias"] = this.uRLAlias;
        data["MetaTags"] = this.metaTags;
        data["MoreInfo"] = this.moreInfo;
        data["SecurityRatingOK"] = this.securityRatingOK;
        data["SecurityRatingDescription"] = this.securityRatingDescription;
        data["SendNewsletter"] = this.sendNewsletter;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderDetail {
        const json = this.toJSON();
        let result = new TreatmentProviderDetail();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderDetail extends IBaseEntity {
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProvider | undefined;
    title?: string | undefined;
    uRLAlias?: string | undefined;
    metaTags?: string | undefined;
    moreInfo?: string | undefined;
    securityRatingOK?: boolean;
    securityRatingDescription?: string | undefined;
    sendNewsletter?: boolean;
}

export class TreatmentProviderType extends BaseEntity implements ITreatmentProviderType {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITreatmentProviderType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): TreatmentProviderType {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderType {
        const json = this.toJSON();
        let result = new TreatmentProviderType();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderType extends IBaseEntity {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class UserPermission implements IUserPermission {
    id?: number;
    userId?: number;
    user?: User | undefined;
    permissionId?: number;
    permission?: Permission | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;

    constructor(data?: IUserPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            this.permissionId = _data["PermissionId"];
            this.permission = _data["Permission"] ? Permission.fromJS(_data["Permission"]) : <any>undefined;
            this.create = _data["Create"];
            this.read = _data["Read"];
            this.update = _data["Update"];
            this.delete = _data["Delete"];
        }
    }

    static fromJS(data: any): UserPermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["PermissionId"] = this.permissionId;
        data["Permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        data["Create"] = this.create;
        data["Read"] = this.read;
        data["Update"] = this.update;
        data["Delete"] = this.delete;
        return data; 
    }

    clone(): UserPermission {
        const json = this.toJSON();
        let result = new UserPermission();
        result.init(json);
        return result;
    }
}

export interface IUserPermission {
    id?: number;
    userId?: number;
    user?: User | undefined;
    permissionId?: number;
    permission?: Permission | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
}

export class Permission extends BaseEntity implements IPermission {
    name?: string | undefined;
    description?: string | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;

    constructor(data?: IPermission) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.create = _data["Create"];
            this.read = _data["Read"];
            this.update = _data["Update"];
            this.delete = _data["Delete"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Create"] = this.create;
        data["Read"] = this.read;
        data["Update"] = this.update;
        data["Delete"] = this.delete;
        super.toJSON(data);
        return data; 
    }

    clone(): Permission {
        const json = this.toJSON();
        let result = new Permission();
        result.init(json);
        return result;
    }
}

export interface IPermission extends IBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
}

export class IdentityUserClaimOfInteger implements IIdentityUserClaimOfInteger {
    id?: number;
    userId?: number;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IIdentityUserClaimOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.claimType = _data["ClaimType"];
            this.claimValue = _data["ClaimValue"];
        }
    }

    static fromJS(data: any): IdentityUserClaimOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserClaimOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["ClaimType"] = this.claimType;
        data["ClaimValue"] = this.claimValue;
        return data; 
    }

    clone(): IdentityUserClaimOfInteger {
        const json = this.toJSON();
        let result = new IdentityUserClaimOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserClaimOfInteger {
    id?: number;
    userId?: number;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class UserClaim extends IdentityUserClaimOfInteger implements IUserClaim {
    user?: User | undefined;

    constructor(data?: IUserClaim) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim extends IIdentityUserClaimOfInteger {
    user?: User | undefined;
}

export class IdentityUserLoginOfInteger implements IIdentityUserLoginOfInteger {
    loginProvider?: string | undefined;
    providerKey?: string | undefined;
    providerDisplayName?: string | undefined;
    userId?: number;

    constructor(data?: IIdentityUserLoginOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["LoginProvider"];
            this.providerKey = _data["ProviderKey"];
            this.providerDisplayName = _data["ProviderDisplayName"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): IdentityUserLoginOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserLoginOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LoginProvider"] = this.loginProvider;
        data["ProviderKey"] = this.providerKey;
        data["ProviderDisplayName"] = this.providerDisplayName;
        data["UserId"] = this.userId;
        return data; 
    }

    clone(): IdentityUserLoginOfInteger {
        const json = this.toJSON();
        let result = new IdentityUserLoginOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserLoginOfInteger {
    loginProvider?: string | undefined;
    providerKey?: string | undefined;
    providerDisplayName?: string | undefined;
    userId?: number;
}

export class UserLogin extends IdentityUserLoginOfInteger implements IUserLogin {
    user?: User | undefined;

    constructor(data?: IUserLogin) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin extends IIdentityUserLoginOfInteger {
    user?: User | undefined;
}

export class IdentityUserTokenOfInteger implements IIdentityUserTokenOfInteger {
    userId?: number;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IIdentityUserTokenOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.loginProvider = _data["LoginProvider"];
            this.name = _data["Name"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): IdentityUserTokenOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserTokenOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["LoginProvider"] = this.loginProvider;
        data["Name"] = this.name;
        data["Value"] = this.value;
        return data; 
    }

    clone(): IdentityUserTokenOfInteger {
        const json = this.toJSON();
        let result = new IdentityUserTokenOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserTokenOfInteger {
    userId?: number;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
}

export class UserToken extends IdentityUserTokenOfInteger implements IUserToken {
    user?: User | undefined;

    constructor(data?: IUserToken) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken extends IIdentityUserTokenOfInteger {
    user?: User | undefined;
}

export class IdentityUserRoleOfInteger implements IIdentityUserRoleOfInteger {
    userId?: number;
    roleId?: number;

    constructor(data?: IIdentityUserRoleOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.roleId = _data["RoleId"];
        }
    }

    static fromJS(data: any): IdentityUserRoleOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserRoleOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["RoleId"] = this.roleId;
        return data; 
    }

    clone(): IdentityUserRoleOfInteger {
        const json = this.toJSON();
        let result = new IdentityUserRoleOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserRoleOfInteger {
    userId?: number;
    roleId?: number;
}

export class UserRole extends IdentityUserRoleOfInteger implements IUserRole {
    user?: User | undefined;
    role?: Role | undefined;

    constructor(data?: IUserRole) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
            this.role = _data["Role"] ? Role.fromJS(_data["Role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["Role"] = this.role ? this.role.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole extends IIdentityUserRoleOfInteger {
    user?: User | undefined;
    role?: Role | undefined;
}

export class IdentityRoleOfInteger implements IIdentityRoleOfInteger {
    id?: number;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: IIdentityRoleOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.normalizedName = _data["NormalizedName"];
            this.concurrencyStamp = _data["ConcurrencyStamp"];
        }
    }

    static fromJS(data: any): IdentityRoleOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["NormalizedName"] = this.normalizedName;
        data["ConcurrencyStamp"] = this.concurrencyStamp;
        return data; 
    }

    clone(): IdentityRoleOfInteger {
        const json = this.toJSON();
        let result = new IdentityRoleOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityRoleOfInteger {
    id?: number;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class Role extends IdentityRoleOfInteger implements IRole {
    code?: string | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
    rolePermissions?: RolePermission[] | undefined;
    acronym?: string | undefined;
    translations?: RoleTranslation[] | undefined;
    userRoles?: UserRole[] | undefined;
    roleClaims?: UserRoleClaim[] | undefined;

    constructor(data?: IRole) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["Code"];
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
            if (Array.isArray(_data["RolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["RolePermissions"])
                    this.rolePermissions!.push(RolePermission.fromJS(item));
            }
            this.acronym = _data["Acronym"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(RoleTranslation.fromJS(item));
            }
            if (Array.isArray(_data["UserRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["UserRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["RoleClaims"])) {
                this.roleClaims = [] as any;
                for (let item of _data["RoleClaims"])
                    this.roleClaims!.push(UserRoleClaim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        if (Array.isArray(this.rolePermissions)) {
            data["RolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["RolePermissions"].push(item.toJSON());
        }
        data["Acronym"] = this.acronym;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        if (Array.isArray(this.userRoles)) {
            data["UserRoles"] = [];
            for (let item of this.userRoles)
                data["UserRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.roleClaims)) {
            data["RoleClaims"] = [];
            for (let item of this.roleClaims)
                data["RoleClaims"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole extends IIdentityRoleOfInteger {
    code?: string | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
    rolePermissions?: RolePermission[] | undefined;
    acronym?: string | undefined;
    translations?: RoleTranslation[] | undefined;
    userRoles?: UserRole[] | undefined;
    roleClaims?: UserRoleClaim[] | undefined;
}

export class RolePermission implements IRolePermission {
    id?: number;
    roleId?: number;
    role?: Role | undefined;
    permissionId?: number;
    permission?: Permission | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;

    constructor(data?: IRolePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.roleId = _data["RoleId"];
            this.role = _data["Role"] ? Role.fromJS(_data["Role"]) : <any>undefined;
            this.permissionId = _data["PermissionId"];
            this.permission = _data["Permission"] ? Permission.fromJS(_data["Permission"]) : <any>undefined;
            this.create = _data["Create"];
            this.read = _data["Read"];
            this.update = _data["Update"];
            this.delete = _data["Delete"];
        }
    }

    static fromJS(data: any): RolePermission {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RoleId"] = this.roleId;
        data["Role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["PermissionId"] = this.permissionId;
        data["Permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        data["Create"] = this.create;
        data["Read"] = this.read;
        data["Update"] = this.update;
        data["Delete"] = this.delete;
        return data; 
    }

    clone(): RolePermission {
        const json = this.toJSON();
        let result = new RolePermission();
        result.init(json);
        return result;
    }
}

export interface IRolePermission {
    id?: number;
    roleId?: number;
    role?: Role | undefined;
    permissionId?: number;
    permission?: Permission | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
}

export class RoleTranslation implements IRoleTranslation {
    name?: string | undefined;
    entity?: Role | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;

    constructor(data?: IRoleTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.entity = _data["Entity"] ? Role.fromJS(_data["Entity"]) : <any>undefined;
            this.entityId = _data["EntityId"];
            this.id = _data["Id"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): RoleTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new RoleTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["EntityId"] = this.entityId;
        data["Id"] = this.id;
        data["Language"] = this.language;
        return data; 
    }

    clone(): RoleTranslation {
        const json = this.toJSON();
        let result = new RoleTranslation();
        result.init(json);
        return result;
    }
}

export interface IRoleTranslation {
    name?: string | undefined;
    entity?: Role | undefined;
    entityId?: number;
    id?: number;
    language?: string | undefined;
}

export class IdentityRoleClaimOfInteger implements IIdentityRoleClaimOfInteger {
    id?: number;
    roleId?: number;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IIdentityRoleClaimOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.roleId = _data["RoleId"];
            this.claimType = _data["ClaimType"];
            this.claimValue = _data["ClaimValue"];
        }
    }

    static fromJS(data: any): IdentityRoleClaimOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleClaimOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RoleId"] = this.roleId;
        data["ClaimType"] = this.claimType;
        data["ClaimValue"] = this.claimValue;
        return data; 
    }

    clone(): IdentityRoleClaimOfInteger {
        const json = this.toJSON();
        let result = new IdentityRoleClaimOfInteger();
        result.init(json);
        return result;
    }
}

export interface IIdentityRoleClaimOfInteger {
    id?: number;
    roleId?: number;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class UserRoleClaim extends IdentityRoleClaimOfInteger implements IUserRoleClaim {
    role?: Role | undefined;

    constructor(data?: IUserRoleClaim) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.role = _data["Role"] ? Role.fromJS(_data["Role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Role"] = this.role ? this.role.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserRoleClaim {
        const json = this.toJSON();
        let result = new UserRoleClaim();
        result.init(json);
        return result;
    }
}

export interface IUserRoleClaim extends IIdentityRoleClaimOfInteger {
    role?: Role | undefined;
}

export class NotificationModel implements INotificationModel {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.enabled = _data["Enabled"];
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["Enabled"] = this.enabled;
        return data; 
    }

    clone(): NotificationModel {
        const json = this.toJSON();
        let result = new NotificationModel();
        result.init(json);
        return result;
    }
}

export interface INotificationModel {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
}

export class PortalNotificationModel implements IPortalNotificationModel {
    id?: number;
    description?: string | undefined;
    dueDate?: moment.Moment | undefined;
    startDate?: moment.Moment;
    isRead?: boolean;
    resendNotification?: boolean;
    recipientTypeCode?: string | undefined;

    constructor(data?: IPortalNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.dueDate = _data["DueDate"] ? moment(_data["DueDate"].toString()) : <any>undefined;
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.isRead = _data["IsRead"];
            this.resendNotification = _data["ResendNotification"];
            this.recipientTypeCode = _data["RecipientTypeCode"];
        }
    }

    static fromJS(data: any): PortalNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PortalNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["DueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["IsRead"] = this.isRead;
        data["ResendNotification"] = this.resendNotification;
        data["RecipientTypeCode"] = this.recipientTypeCode;
        return data; 
    }

    clone(): PortalNotificationModel {
        const json = this.toJSON();
        let result = new PortalNotificationModel();
        result.init(json);
        return result;
    }
}

export interface IPortalNotificationModel {
    id?: number;
    description?: string | undefined;
    dueDate?: moment.Moment | undefined;
    startDate?: moment.Moment;
    isRead?: boolean;
    resendNotification?: boolean;
    recipientTypeCode?: string | undefined;
}

export class RegionModel implements IRegionModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IRegionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): RegionModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): RegionModel {
        const json = this.toJSON();
        let result = new RegionModel();
        result.init(json);
        return result;
    }
}

export interface IRegionModel {
    id?: number;
    name?: string | undefined;
}

export class PowerBiTokenModel implements IPowerBiTokenModel {
    succeeded?: boolean;
    token?: string | undefined;
    expiresOn?: moment.Moment;
    url?: string | undefined;
    groupId?: string | undefined;
    reportId?: string | undefined;
    type?: string | undefined;
    tokenType?: string | undefined;

    constructor(data?: IPowerBiTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            this.token = _data["Token"];
            this.expiresOn = _data["ExpiresOn"] ? moment(_data["ExpiresOn"].toString()) : <any>undefined;
            this.url = _data["Url"];
            this.groupId = _data["GroupId"];
            this.reportId = _data["ReportId"];
            this.type = _data["Type"];
            this.tokenType = _data["TokenType"];
        }
    }

    static fromJS(data: any): PowerBiTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        data["Token"] = this.token;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["Url"] = this.url;
        data["GroupId"] = this.groupId;
        data["ReportId"] = this.reportId;
        data["Type"] = this.type;
        data["TokenType"] = this.tokenType;
        return data; 
    }

    clone(): PowerBiTokenModel {
        const json = this.toJSON();
        let result = new PowerBiTokenModel();
        result.init(json);
        return result;
    }
}

export interface IPowerBiTokenModel {
    succeeded?: boolean;
    token?: string | undefined;
    expiresOn?: moment.Moment;
    url?: string | undefined;
    groupId?: string | undefined;
    reportId?: string | undefined;
    type?: string | undefined;
    tokenType?: string | undefined;
}

export class ReportModel implements IReportModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    applicationId?: string | undefined;
    groupId?: string | undefined;
    reportId?: string | undefined;
    authorityUrl?: string | undefined;
    resourceUrl?: string | undefined;
    apiUrl?: string | undefined;
    embedUrlBase?: string | undefined;

    constructor(data?: IReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.applicationId = _data["ApplicationId"];
            this.groupId = _data["GroupId"];
            this.reportId = _data["ReportId"];
            this.authorityUrl = _data["AuthorityUrl"];
            this.resourceUrl = _data["ResourceUrl"];
            this.apiUrl = _data["ApiUrl"];
            this.embedUrlBase = _data["EmbedUrlBase"];
        }
    }

    static fromJS(data: any): ReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["ApplicationId"] = this.applicationId;
        data["GroupId"] = this.groupId;
        data["ReportId"] = this.reportId;
        data["AuthorityUrl"] = this.authorityUrl;
        data["ResourceUrl"] = this.resourceUrl;
        data["ApiUrl"] = this.apiUrl;
        data["EmbedUrlBase"] = this.embedUrlBase;
        return data; 
    }

    clone(): ReportModel {
        const json = this.toJSON();
        let result = new ReportModel();
        result.init(json);
        return result;
    }
}

export interface IReportModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    applicationId?: string | undefined;
    groupId?: string | undefined;
    reportId?: string | undefined;
    authorityUrl?: string | undefined;
    resourceUrl?: string | undefined;
    apiUrl?: string | undefined;
    embedUrlBase?: string | undefined;
}

export class RoleModel implements IRoleModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        return data; 
    }

    clone(): RoleModel {
        const json = this.toJSON();
        let result = new RoleModel();
        result.init(json);
        return result;
    }
}

export interface IRoleModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class ScheduleItemGroupModel implements IScheduleItemGroupModel {
    id?: number;
    startDate?: moment.Moment;
    clinicName?: string | undefined;
    clinicId?: number;
    schedules?: ScheduleItemModel[] | undefined;

    constructor(data?: IScheduleItemGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.clinicName = _data["ClinicName"];
            this.clinicId = _data["ClinicId"];
            if (Array.isArray(_data["Schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["Schedules"])
                    this.schedules!.push(ScheduleItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleItemGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleItemGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["ClinicName"] = this.clinicName;
        data["ClinicId"] = this.clinicId;
        if (Array.isArray(this.schedules)) {
            data["Schedules"] = [];
            for (let item of this.schedules)
                data["Schedules"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ScheduleItemGroupModel {
        const json = this.toJSON();
        let result = new ScheduleItemGroupModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleItemGroupModel {
    id?: number;
    startDate?: moment.Moment;
    clinicName?: string | undefined;
    clinicId?: number;
    schedules?: ScheduleItemModel[] | undefined;
}

export class ScheduleItemModel implements IScheduleItemModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    numberOfBookings?: number;
    numberOfParticipants?: number;
    scheduleTypeId?: number | undefined;
    scheduleType?: ScheduleTypeModel | undefined;
    caseId?: number;
    case?: CaseShortModel | undefined;
    userId?: number;
    user?: UserShortModel | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    clinicId?: number;
    clinic?: TreatmentProviderShortModel | undefined;
    bookingId?: number | undefined;
    booking?: BookingPageDetailsModel | undefined;

    constructor(data?: IScheduleItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.numberOfBookings = _data["NumberOfBookings"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.scheduleTypeId = _data["ScheduleTypeId"];
            this.scheduleType = _data["ScheduleType"] ? ScheduleTypeModel.fromJS(_data["ScheduleType"]) : <any>undefined;
            this.caseId = _data["CaseId"];
            this.case = _data["Case"] ? CaseShortModel.fromJS(_data["Case"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserShortModel.fromJS(_data["User"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.clinicId = _data["ClinicId"];
            this.clinic = _data["Clinic"] ? TreatmentProviderShortModel.fromJS(_data["Clinic"]) : <any>undefined;
            this.bookingId = _data["BookingId"];
            this.booking = _data["Booking"] ? BookingPageDetailsModel.fromJS(_data["Booking"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["NumberOfBookings"] = this.numberOfBookings;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["ScheduleTypeId"] = this.scheduleTypeId;
        data["ScheduleType"] = this.scheduleType ? this.scheduleType.toJSON() : <any>undefined;
        data["CaseId"] = this.caseId;
        data["Case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["ClinicId"] = this.clinicId;
        data["Clinic"] = this.clinic ? this.clinic.toJSON() : <any>undefined;
        data["BookingId"] = this.bookingId;
        data["Booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ScheduleItemModel {
        const json = this.toJSON();
        let result = new ScheduleItemModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleItemModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    numberOfBookings?: number;
    numberOfParticipants?: number;
    scheduleTypeId?: number | undefined;
    scheduleType?: ScheduleTypeModel | undefined;
    caseId?: number;
    case?: CaseShortModel | undefined;
    userId?: number;
    user?: UserShortModel | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    clinicId?: number;
    clinic?: TreatmentProviderShortModel | undefined;
    bookingId?: number | undefined;
    booking?: BookingPageDetailsModel | undefined;
}

export class CaseShortModel extends BaseEntityModel implements ICaseShortModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;

    constructor(data?: ICaseShortModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.description = _data["Description"];
            if (Array.isArray(_data["CaseTreatmentTypes"])) {
                this.caseTreatmentTypes = [] as any;
                for (let item of _data["CaseTreatmentTypes"])
                    this.caseTreatmentTypes!.push(CaseTreatmentTypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["Description"] = this.description;
        if (Array.isArray(this.caseTreatmentTypes)) {
            data["CaseTreatmentTypes"] = [];
            for (let item of this.caseTreatmentTypes)
                data["CaseTreatmentTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CaseShortModel {
        const json = this.toJSON();
        let result = new CaseShortModel();
        result.init(json);
        return result;
    }
}

export interface ICaseShortModel extends IBaseEntityModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    caseTreatmentTypes?: CaseTreatmentTypeModel[] | undefined;
}

export class UserShortModel implements IUserShortModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cases?: CaseShortModel[] | undefined;
    companyId?: number | undefined;

    constructor(data?: IUserShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases!.push(CaseShortModel.fromJS(item));
            }
            this.companyId = _data["CompanyId"];
        }
    }

    static fromJS(data: any): UserShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        data["CompanyId"] = this.companyId;
        return data; 
    }

    clone(): UserShortModel {
        const json = this.toJSON();
        let result = new UserShortModel();
        result.init(json);
        return result;
    }
}

export interface IUserShortModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cases?: CaseShortModel[] | undefined;
    companyId?: number | undefined;
}

export class SelfRegistrationRequestModel implements ISelfRegistrationRequestModel {
    email!: string;
    registartionParameter?: string | undefined;
    urlPattern?: string | undefined;
    preferedLanguage?: string | undefined;

    constructor(data?: ISelfRegistrationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.registartionParameter = _data["RegistartionParameter"];
            this.urlPattern = _data["UrlPattern"];
            this.preferedLanguage = _data["PreferedLanguage"];
        }
    }

    static fromJS(data: any): SelfRegistrationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfRegistrationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["RegistartionParameter"] = this.registartionParameter;
        data["UrlPattern"] = this.urlPattern;
        data["PreferedLanguage"] = this.preferedLanguage;
        return data; 
    }

    clone(): SelfRegistrationRequestModel {
        const json = this.toJSON();
        let result = new SelfRegistrationRequestModel();
        result.init(json);
        return result;
    }
}

export interface ISelfRegistrationRequestModel {
    email: string;
    registartionParameter?: string | undefined;
    urlPattern?: string | undefined;
    preferedLanguage?: string | undefined;
}

export class SelfRegisterTreatmentProviderCreateModel implements ISelfRegisterTreatmentProviderCreateModel {
    userEmail?: string | undefined;
    networkCode?: string | undefined;
    cVR?: string | undefined;
    name?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentTypes?: number[] | undefined;
    treatmentProviderNetworkId?: number;
    availableForPastBookings?: boolean;

    constructor(data?: ISelfRegisterTreatmentProviderCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["UserEmail"];
            this.networkCode = _data["NetworkCode"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(CompanyLocationModel.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactShortModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.availableForPastBookings = _data["AvailableForPastBookings"];
        }
    }

    static fromJS(data: any): SelfRegisterTreatmentProviderCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfRegisterTreatmentProviderCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserEmail"] = this.userEmail;
        data["NetworkCode"] = this.networkCode;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item);
        }
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["AvailableForPastBookings"] = this.availableForPastBookings;
        return data; 
    }

    clone(): SelfRegisterTreatmentProviderCreateModel {
        const json = this.toJSON();
        let result = new SelfRegisterTreatmentProviderCreateModel();
        result.init(json);
        return result;
    }
}

export interface ISelfRegisterTreatmentProviderCreateModel {
    userEmail?: string | undefined;
    networkCode?: string | undefined;
    cVR?: string | undefined;
    name?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentTypes?: number[] | undefined;
    treatmentProviderNetworkId?: number;
    availableForPastBookings?: boolean;
}

export class UserInfo implements IUserInfo {
    id?: number;
    fullName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    roles?: ShortRoleModel[] | undefined;
    userPermissions?: ShortPermissionModel[] | undefined;
    profilePicture?: string | undefined;
    cPR?: string | undefined;
    preferedLanguage?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    phoneNumber?: string | undefined;
    sex?: SexModel | undefined;
    location?: LocationModel | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetworkShortModel[] | undefined;
    hasRequiredInfo?: boolean;
    networkPhoneNumber?: string | undefined;
    notificationsConfirmed?: boolean;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.userName = _data["UserName"];
            this.email = _data["Email"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(ShortRoleModel.fromJS(item));
            }
            if (Array.isArray(_data["UserPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["UserPermissions"])
                    this.userPermissions!.push(ShortPermissionModel.fromJS(item));
            }
            this.profilePicture = _data["ProfilePicture"];
            this.cPR = _data["CPR"];
            this.preferedLanguage = _data["PreferedLanguage"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.phoneNumber = _data["PhoneNumber"];
            this.sex = _data["Sex"] ? SexModel.fromJS(_data["Sex"]) : <any>undefined;
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderNetworks"])) {
                this.treatmentProviderNetworks = [] as any;
                for (let item of _data["TreatmentProviderNetworks"])
                    this.treatmentProviderNetworks!.push(TreatmentProviderNetworkShortModel.fromJS(item));
            }
            this.hasRequiredInfo = _data["HasRequiredInfo"];
            this.networkPhoneNumber = _data["NetworkPhoneNumber"];
            this.notificationsConfirmed = _data["NotificationsConfirmed"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["UserName"] = this.userName;
        data["Email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["UserPermissions"] = [];
            for (let item of this.userPermissions)
                data["UserPermissions"].push(item.toJSON());
        }
        data["ProfilePicture"] = this.profilePicture;
        data["CPR"] = this.cPR;
        data["PreferedLanguage"] = this.preferedLanguage;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["PhoneNumber"] = this.phoneNumber;
        data["Sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderNetworks)) {
            data["TreatmentProviderNetworks"] = [];
            for (let item of this.treatmentProviderNetworks)
                data["TreatmentProviderNetworks"].push(item.toJSON());
        }
        data["HasRequiredInfo"] = this.hasRequiredInfo;
        data["NetworkPhoneNumber"] = this.networkPhoneNumber;
        data["NotificationsConfirmed"] = this.notificationsConfirmed;
        return data; 
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    id?: number;
    fullName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    roles?: ShortRoleModel[] | undefined;
    userPermissions?: ShortPermissionModel[] | undefined;
    profilePicture?: string | undefined;
    cPR?: string | undefined;
    preferedLanguage?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    phoneNumber?: string | undefined;
    sex?: SexModel | undefined;
    location?: LocationModel | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    treatmentProviderNetworks?: TreatmentProviderNetworkShortModel[] | undefined;
    hasRequiredInfo?: boolean;
    networkPhoneNumber?: string | undefined;
    notificationsConfirmed?: boolean;
}

export class ShortRoleModel implements IShortRoleModel {
    name?: string | undefined;
    code?: string | undefined;
    permissions?: ShortPermissionModel[] | undefined;

    constructor(data?: IShortRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            if (Array.isArray(_data["Permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["Permissions"])
                    this.permissions!.push(ShortPermissionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShortRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShortRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        if (Array.isArray(this.permissions)) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShortRoleModel {
        const json = this.toJSON();
        let result = new ShortRoleModel();
        result.init(json);
        return result;
    }
}

export interface IShortRoleModel {
    name?: string | undefined;
    code?: string | undefined;
    permissions?: ShortPermissionModel[] | undefined;
}

export class ShortPermissionModel implements IShortPermissionModel {
    name?: string | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;

    constructor(data?: IShortPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.create = _data["Create"];
            this.read = _data["Read"];
            this.update = _data["Update"];
            this.delete = _data["Delete"];
        }
    }

    static fromJS(data: any): ShortPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShortPermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Create"] = this.create;
        data["Read"] = this.read;
        data["Update"] = this.update;
        data["Delete"] = this.delete;
        return data; 
    }

    clone(): ShortPermissionModel {
        const json = this.toJSON();
        let result = new ShortPermissionModel();
        result.init(json);
        return result;
    }
}

export interface IShortPermissionModel {
    name?: string | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
}

export class SexModel implements ISexModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: ISexModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): SexModel {
        data = typeof data === 'object' ? data : {};
        let result = new SexModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): SexModel {
        const json = this.toJSON();
        let result = new SexModel();
        result.init(json);
        return result;
    }
}

export interface ISexModel {
    id?: number;
    name?: string | undefined;
}

export class UpdateUserModel implements IUpdateUserModel {
    userEmail?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    newPassword?: string | undefined;
    token?: string | undefined;
    networkCode?: string | undefined;

    constructor(data?: IUpdateUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["UserEmail"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.newPassword = _data["NewPassword"];
            this.token = _data["Token"];
            this.networkCode = _data["NetworkCode"];
        }
    }

    static fromJS(data: any): UpdateUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserEmail"] = this.userEmail;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["NewPassword"] = this.newPassword;
        data["Token"] = this.token;
        data["NetworkCode"] = this.networkCode;
        return data; 
    }

    clone(): UpdateUserModel {
        const json = this.toJSON();
        let result = new UpdateUserModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserModel {
    userEmail?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    newPassword?: string | undefined;
    token?: string | undefined;
    networkCode?: string | undefined;
}

export class TreatmentProviderNetworkRequestModel implements ITreatmentProviderNetworkRequestModel {
    urlPattern?: string | undefined;

    constructor(data?: ITreatmentProviderNetworkRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlPattern = _data["UrlPattern"];
        }
    }

    static fromJS(data: any): TreatmentProviderNetworkRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderNetworkRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UrlPattern"] = this.urlPattern;
        return data; 
    }

    clone(): TreatmentProviderNetworkRequestModel {
        const json = this.toJSON();
        let result = new TreatmentProviderNetworkRequestModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderNetworkRequestModel {
    urlPattern?: string | undefined;
}

export class TermsAndConditionsModel implements ITermsAndConditionsModel {
    text?: string | undefined;

    constructor(data?: ITermsAndConditionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): TermsAndConditionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        return data; 
    }

    clone(): TermsAndConditionsModel {
        const json = this.toJSON();
        let result = new TermsAndConditionsModel();
        result.init(json);
        return result;
    }
}

export interface ITermsAndConditionsModel {
    text?: string | undefined;
}

export class TermsAndConditionsUpdateModel implements ITermsAndConditionsUpdateModel {
    text?: string | undefined;
    codeType?: string | undefined;
    codeEntity?: string | undefined;
    urlPattern?: string | undefined;

    constructor(data?: ITermsAndConditionsUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
            this.codeType = _data["CodeType"];
            this.codeEntity = _data["CodeEntity"];
            this.urlPattern = _data["UrlPattern"];
        }
    }

    static fromJS(data: any): TermsAndConditionsUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["CodeType"] = this.codeType;
        data["CodeEntity"] = this.codeEntity;
        data["UrlPattern"] = this.urlPattern;
        return data; 
    }

    clone(): TermsAndConditionsUpdateModel {
        const json = this.toJSON();
        let result = new TermsAndConditionsUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITermsAndConditionsUpdateModel {
    text?: string | undefined;
    codeType?: string | undefined;
    codeEntity?: string | undefined;
    urlPattern?: string | undefined;
}

export class TreatmentAreaModel implements ITreatmentAreaModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ITreatmentAreaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): TreatmentAreaModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentAreaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        return data; 
    }

    clone(): TreatmentAreaModel {
        const json = this.toJSON();
        let result = new TreatmentAreaModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentAreaModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class PhotoPostResponseModel implements IPhotoPostResponseModel {
    coverPhotoPath?: string | undefined;
    id?: string | undefined;

    constructor(data?: IPhotoPostResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coverPhotoPath = _data["CoverPhotoPath"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): PhotoPostResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoPostResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CoverPhotoPath"] = this.coverPhotoPath;
        data["Id"] = this.id;
        return data; 
    }

    clone(): PhotoPostResponseModel {
        const json = this.toJSON();
        let result = new PhotoPostResponseModel();
        result.init(json);
        return result;
    }
}

export interface IPhotoPostResponseModel {
    coverPhotoPath?: string | undefined;
    id?: string | undefined;
}

export class TreatmentProviderPhotoModel implements ITreatmentProviderPhotoModel {
    treatmentProviderId!: number;
    imgBase64!: string;
    filename!: string;

    constructor(data?: ITreatmentProviderPhotoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.imgBase64 = _data["ImgBase64"];
            this.filename = _data["Filename"];
        }
    }

    static fromJS(data: any): TreatmentProviderPhotoModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderPhotoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["ImgBase64"] = this.imgBase64;
        data["Filename"] = this.filename;
        return data; 
    }

    clone(): TreatmentProviderPhotoModel {
        const json = this.toJSON();
        let result = new TreatmentProviderPhotoModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderPhotoModel {
    treatmentProviderId: number;
    imgBase64: string;
    filename: string;
}

export class PhotoDeleteResponseModel implements IPhotoDeleteResponseModel {
    id?: number;

    constructor(data?: IPhotoDeleteResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): PhotoDeleteResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoDeleteResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        return data; 
    }

    clone(): PhotoDeleteResponseModel {
        const json = this.toJSON();
        let result = new PhotoDeleteResponseModel();
        result.init(json);
        return result;
    }
}

export interface IPhotoDeleteResponseModel {
    id?: number;
}

export class TreatmentProviderRegisterModel implements ITreatmentProviderRegisterModel {
    cVR!: string;
    name!: string;
    email!: string;
    referralPossible?: boolean;
    onHold?: boolean;
    location!: LocationTreatmentProviderModel;
    treatmentTypes?: number[] | undefined;
    treatmentProviderTypeId!: number;
    regionId!: number;

    constructor(data?: ITreatmentProviderRegisterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationTreatmentProviderModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.referralPossible = _data["ReferralPossible"];
            this.onHold = _data["OnHold"];
            this.location = _data["Location"] ? LocationTreatmentProviderModel.fromJS(_data["Location"]) : new LocationTreatmentProviderModel();
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
            this.treatmentProviderTypeId = _data["TreatmentProviderTypeId"];
            this.regionId = _data["RegionId"];
        }
    }

    static fromJS(data: any): TreatmentProviderRegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderRegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["ReferralPossible"] = this.referralPossible;
        data["OnHold"] = this.onHold;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item);
        }
        data["TreatmentProviderTypeId"] = this.treatmentProviderTypeId;
        data["RegionId"] = this.regionId;
        return data; 
    }

    clone(): TreatmentProviderRegisterModel {
        const json = this.toJSON();
        let result = new TreatmentProviderRegisterModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderRegisterModel {
    cVR: string;
    name: string;
    email: string;
    referralPossible?: boolean;
    onHold?: boolean;
    location: LocationTreatmentProviderModel;
    treatmentTypes?: number[] | undefined;
    treatmentProviderTypeId: number;
    regionId: number;
}

export class LocationTreatmentProviderModel implements ILocationTreatmentProviderModel {
    id?: number;
    description?: string | undefined;
    address!: string;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    region?: RegionModel | undefined;

    constructor(data?: ILocationTreatmentProviderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.region = _data["Region"] ? RegionModel.fromJS(_data["Region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationTreatmentProviderModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTreatmentProviderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["Region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LocationTreatmentProviderModel {
        const json = this.toJSON();
        let result = new LocationTreatmentProviderModel();
        result.init(json);
        return result;
    }
}

export interface ILocationTreatmentProviderModel {
    id?: number;
    description?: string | undefined;
    address: string;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    region?: RegionModel | undefined;
}

export class TreatmentProviderCreateModel implements ITreatmentProviderCreateModel {
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentTypes?: number[] | undefined;
    treatmentProviderNetworkId?: number;
    availableForPastBookings?: boolean;

    constructor(data?: ITreatmentProviderCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.comment = _data["Comment"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(CompanyLocationModel.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactShortModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.availableForPastBookings = _data["AvailableForPastBookings"];
        }
    }

    static fromJS(data: any): TreatmentProviderCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Comment"] = this.comment;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item);
        }
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["AvailableForPastBookings"] = this.availableForPastBookings;
        return data; 
    }

    clone(): TreatmentProviderCreateModel {
        const json = this.toJSON();
        let result = new TreatmentProviderCreateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderCreateModel {
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentTypes?: number[] | undefined;
    treatmentProviderNetworkId?: number;
    availableForPastBookings?: boolean;
}

export class TreatmentProviderPageModel implements ITreatmentProviderPageModel {
    pageNumber?: number;
    pageSize?: number | undefined;
    totalRows?: number;
    keyword?: string | undefined;
    treatmentProviders?: TreatmentProviderPageEntryModel[] | undefined;

    constructor(data?: ITreatmentProviderPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRows = _data["TotalRows"];
            this.keyword = _data["Keyword"];
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProviderPageEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRows"] = this.totalRows;
        data["Keyword"] = this.keyword;
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderPageModel {
        const json = this.toJSON();
        let result = new TreatmentProviderPageModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderPageModel {
    pageNumber?: number;
    pageSize?: number | undefined;
    totalRows?: number;
    keyword?: string | undefined;
    treatmentProviders?: TreatmentProviderPageEntryModel[] | undefined;
}

export class TreatmentProviderPageEntryModel implements ITreatmentProviderPageEntryModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    treatmentProviderNetworkName?: string | undefined;
    treatmentTypes?: string | undefined;
    locations?: TreatmentProviderLocationModel[] | undefined;

    constructor(data?: ITreatmentProviderPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.treatmentProviderNetworkName = _data["TreatmentProviderNetworkName"];
            this.treatmentTypes = _data["TreatmentTypes"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(TreatmentProviderLocationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["TreatmentProviderNetworkName"] = this.treatmentProviderNetworkName;
        data["TreatmentTypes"] = this.treatmentTypes;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderPageEntryModel {
        const json = this.toJSON();
        let result = new TreatmentProviderPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderPageEntryModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    treatmentProviderNetworkName?: string | undefined;
    treatmentTypes?: string | undefined;
    locations?: TreatmentProviderLocationModel[] | undefined;
}

export class TreatmentProviderLocationModel implements ITreatmentProviderLocationModel {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deleted?: boolean;

    constructor(data?: ITreatmentProviderLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): TreatmentProviderLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): TreatmentProviderLocationModel {
        const json = this.toJSON();
        let result = new TreatmentProviderLocationModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderLocationModel {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deleted?: boolean;
}

export class TreatmentProviderEditModel implements ITreatmentProviderEditModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    treatmentProviderNetworkId?: number;
    availableForPastBookings?: boolean;
    appointmentScheduleEnabled?: boolean;

    constructor(data?: ITreatmentProviderEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.comment = _data["Comment"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(CompanyLocationModel.fromJS(item));
            }
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactShortModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortModel.fromJS(item));
            }
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.availableForPastBookings = _data["AvailableForPastBookings"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
        }
    }

    static fromJS(data: any): TreatmentProviderEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Comment"] = this.comment;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["AvailableForPastBookings"] = this.availableForPastBookings;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        return data; 
    }

    clone(): TreatmentProviderEditModel {
        const json = this.toJSON();
        let result = new TreatmentProviderEditModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEditModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    locations?: CompanyLocationModel[] | undefined;
    contacts?: ContactShortModel[] | undefined;
    treatmentTypes?: TreatmentTypeShortModel[] | undefined;
    treatmentProviderNetworkId?: number;
    availableForPastBookings?: boolean;
    appointmentScheduleEnabled?: boolean;
}

export class GoogleDistanceResultModel implements IGoogleDistanceResultModel {
    distance?: string | undefined;
    duration?: string | undefined;

    constructor(data?: IGoogleDistanceResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distance = _data["Distance"];
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): GoogleDistanceResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleDistanceResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Distance"] = this.distance;
        data["Duration"] = this.duration;
        return data; 
    }

    clone(): GoogleDistanceResultModel {
        const json = this.toJSON();
        let result = new GoogleDistanceResultModel();
        result.init(json);
        return result;
    }
}

export interface IGoogleDistanceResultModel {
    distance?: string | undefined;
    duration?: string | undefined;
}

export class TreatmentProviderMapLocationDTO implements ITreatmentProviderMapLocationDTO {
    treatmentProvider?: TreatmentProviderSelectDTO | undefined;
    location?: MapLocationDTO | undefined;

    constructor(data?: ITreatmentProviderMapLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProviderSelectDTO.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            this.location = _data["Location"] ? MapLocationDTO.fromJS(_data["Location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TreatmentProviderMapLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderMapLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TreatmentProviderMapLocationDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderMapLocationDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderMapLocationDTO {
    treatmentProvider?: TreatmentProviderSelectDTO | undefined;
    location?: MapLocationDTO | undefined;
}

export class MapLocationDTO implements IMapLocationDTO {
    id?: number;
    address?: string | undefined;
    description?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mapLocationType?: MapLocationType;

    constructor(data?: IMapLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.address = _data["Address"];
            this.description = _data["Description"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.mapLocationType = _data["MapLocationType"];
        }
    }

    static fromJS(data: any): MapLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Address"] = this.address;
        data["Description"] = this.description;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["MapLocationType"] = this.mapLocationType;
        return data; 
    }

    clone(): MapLocationDTO {
        const json = this.toJSON();
        let result = new MapLocationDTO();
        result.init(json);
        return result;
    }
}

export interface IMapLocationDTO {
    id?: number;
    address?: string | undefined;
    description?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mapLocationType?: MapLocationType;
}

export enum MapLocationType {
    Home = 0,
    Company = 1,
    TreatmentProvider = 2,
}

export class TreatmentProviderStatusModel implements ITreatmentProviderStatusModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ITreatmentProviderStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): TreatmentProviderStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        return data; 
    }

    clone(): TreatmentProviderStatusModel {
        const json = this.toJSON();
        let result = new TreatmentProviderStatusModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderStatusModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class TreatmentSpecialtyModel implements ITreatmentSpecialtyModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentTypes?: TreatmentTypeModel[] | undefined;

    constructor(data?: ITreatmentSpecialtyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentSpecialtyModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialtyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentSpecialtyModel {
        const json = this.toJSON();
        let result = new TreatmentSpecialtyModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialtyModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentTypes?: TreatmentTypeModel[] | undefined;
}

export class TreatmentTypeModel extends BaseEntityModel implements ITreatmentTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatments?: TreatmentModel[] | undefined;
    caseRequired?: boolean;

    constructor(data?: ITreatmentTypeModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            if (Array.isArray(_data["Treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["Treatments"])
                    this.treatments!.push(TreatmentModel.fromJS(item));
            }
            this.caseRequired = _data["CaseRequired"];
        }
    }

    static fromJS(data: any): TreatmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        if (Array.isArray(this.treatments)) {
            data["Treatments"] = [];
            for (let item of this.treatments)
                data["Treatments"].push(item.toJSON());
        }
        data["CaseRequired"] = this.caseRequired;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentTypeModel {
        const json = this.toJSON();
        let result = new TreatmentTypeModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeModel extends IBaseEntityModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatments?: TreatmentModel[] | undefined;
    caseRequired?: boolean;
}

export class TreatmentModel implements ITreatmentModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentPrice?: number;
    diagnosisDays?: number;
    treatmentSpecialtyId?: number;
    treatmentTypeId?: number;

    constructor(data?: ITreatmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.treatmentPrice = _data["TreatmentPrice"];
            this.diagnosisDays = _data["DiagnosisDays"];
            this.treatmentSpecialtyId = _data["TreatmentSpecialtyId"];
            this.treatmentTypeId = _data["TreatmentTypeId"];
        }
    }

    static fromJS(data: any): TreatmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["TreatmentPrice"] = this.treatmentPrice;
        data["DiagnosisDays"] = this.diagnosisDays;
        data["TreatmentSpecialtyId"] = this.treatmentSpecialtyId;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        return data; 
    }

    clone(): TreatmentModel {
        const json = this.toJSON();
        let result = new TreatmentModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    treatmentPrice?: number;
    diagnosisDays?: number;
    treatmentSpecialtyId?: number;
    treatmentTypeId?: number;
}

export class TreatmentProviderTreatmentSpecialtyUpdateDTO implements ITreatmentProviderTreatmentSpecialtyUpdateDTO {
    treatmentSpecialtyId?: number;
    treatmentProviderId?: number;

    constructor(data?: ITreatmentProviderTreatmentSpecialtyUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentSpecialtyId = _data["TreatmentSpecialtyId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
        }
    }

    static fromJS(data: any): TreatmentProviderTreatmentSpecialtyUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderTreatmentSpecialtyUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentSpecialtyId"] = this.treatmentSpecialtyId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        return data; 
    }

    clone(): TreatmentProviderTreatmentSpecialtyUpdateDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderTreatmentSpecialtyUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderTreatmentSpecialtyUpdateDTO {
    treatmentSpecialtyId?: number;
    treatmentProviderId?: number;
}

export class TreatmentProviderTypeModel implements ITreatmentProviderTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ITreatmentProviderTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): TreatmentProviderTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        return data; 
    }

    clone(): TreatmentProviderTypeModel {
        const json = this.toJSON();
        let result = new TreatmentProviderTypeModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class TreatmentSpecialistModel implements ITreatmentSpecialistModel {
    id?: number;
    fullName!: string;
    email!: string;
    treatmentProviderId?: number;
    treatmentSpecialty?: TreatmentSpecialtyModel | undefined;
    treatmentTypes?: SpecialistTreatmentTypeModel[] | undefined;
    photoUrl?: string | undefined;

    constructor(data?: ITreatmentSpecialistModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentSpecialty = _data["TreatmentSpecialty"] ? TreatmentSpecialtyModel.fromJS(_data["TreatmentSpecialty"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(SpecialistTreatmentTypeModel.fromJS(item));
            }
            this.photoUrl = _data["PhotoUrl"];
        }
    }

    static fromJS(data: any): TreatmentSpecialistModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialistModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentSpecialty"] = this.treatmentSpecialty ? this.treatmentSpecialty.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["PhotoUrl"] = this.photoUrl;
        return data; 
    }

    clone(): TreatmentSpecialistModel {
        const json = this.toJSON();
        let result = new TreatmentSpecialistModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialistModel {
    id?: number;
    fullName: string;
    email: string;
    treatmentProviderId?: number;
    treatmentSpecialty?: TreatmentSpecialtyModel | undefined;
    treatmentTypes?: SpecialistTreatmentTypeModel[] | undefined;
    photoUrl?: string | undefined;
}

export class SpecialistTreatmentTypeModel implements ISpecialistTreatmentTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    selected?: boolean;

    constructor(data?: ISpecialistTreatmentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.selected = _data["Selected"];
        }
    }

    static fromJS(data: any): SpecialistTreatmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialistTreatmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Selected"] = this.selected;
        return data; 
    }

    clone(): SpecialistTreatmentTypeModel {
        const json = this.toJSON();
        let result = new SpecialistTreatmentTypeModel();
        result.init(json);
        return result;
    }
}

export interface ISpecialistTreatmentTypeModel {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    selected?: boolean;
}

export class TreatmentSpecialistCreateModel implements ITreatmentSpecialistCreateModel {
    fullName!: string;
    email!: string;
    treatmentProviderId?: number;
    treatmentSpecialtyId!: number;
    treatmentTypes?: SpecialistTreatmentTypeModel[] | undefined;
    imgBase64?: string | undefined;
    filename?: string | undefined;

    constructor(data?: ITreatmentSpecialistCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentSpecialtyId = _data["TreatmentSpecialtyId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(SpecialistTreatmentTypeModel.fromJS(item));
            }
            this.imgBase64 = _data["ImgBase64"];
            this.filename = _data["Filename"];
        }
    }

    static fromJS(data: any): TreatmentSpecialistCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialistCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentSpecialtyId"] = this.treatmentSpecialtyId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["ImgBase64"] = this.imgBase64;
        data["Filename"] = this.filename;
        return data; 
    }

    clone(): TreatmentSpecialistCreateModel {
        const json = this.toJSON();
        let result = new TreatmentSpecialistCreateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialistCreateModel {
    fullName: string;
    email: string;
    treatmentProviderId?: number;
    treatmentSpecialtyId: number;
    treatmentTypes?: SpecialistTreatmentTypeModel[] | undefined;
    imgBase64?: string | undefined;
    filename?: string | undefined;
}

export class TreatmentSpecialistEditModel implements ITreatmentSpecialistEditModel {
    fullName!: string;
    email!: string;
    treatmentProviderId?: number;
    treatmentSpecialtyId?: number;
    treatmentTypes?: SpecialistTreatmentTypeModel[] | undefined;
    imgBase64?: string | undefined;
    filename?: string | undefined;

    constructor(data?: ITreatmentSpecialistEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentSpecialtyId = _data["TreatmentSpecialtyId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(SpecialistTreatmentTypeModel.fromJS(item));
            }
            this.imgBase64 = _data["ImgBase64"];
            this.filename = _data["Filename"];
        }
    }

    static fromJS(data: any): TreatmentSpecialistEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialistEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentSpecialtyId"] = this.treatmentSpecialtyId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["ImgBase64"] = this.imgBase64;
        data["Filename"] = this.filename;
        return data; 
    }

    clone(): TreatmentSpecialistEditModel {
        const json = this.toJSON();
        let result = new TreatmentSpecialistEditModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialistEditModel {
    fullName: string;
    email: string;
    treatmentProviderId?: number;
    treatmentSpecialtyId?: number;
    treatmentTypes?: SpecialistTreatmentTypeModel[] | undefined;
    imgBase64?: string | undefined;
    filename?: string | undefined;
}

export class TreatmentSpecialistDeleteResponse implements ITreatmentSpecialistDeleteResponse {
    id?: number;
    treatmentProviderId?: number;
    succeeded?: boolean;

    constructor(data?: ITreatmentSpecialistDeleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.succeeded = _data["Succeeded"];
        }
    }

    static fromJS(data: any): TreatmentSpecialistDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialistDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["Succeeded"] = this.succeeded;
        return data; 
    }

    clone(): TreatmentSpecialistDeleteResponse {
        const json = this.toJSON();
        let result = new TreatmentSpecialistDeleteResponse();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialistDeleteResponse {
    id?: number;
    treatmentProviderId?: number;
    succeeded?: boolean;
}

export class TreatmentSpecialistDeleteModel implements ITreatmentSpecialistDeleteModel {
    treatmentSpecialistId?: number;
    treatmentProviderId?: number;

    constructor(data?: ITreatmentSpecialistDeleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentSpecialistId = _data["TreatmentSpecialistId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
        }
    }

    static fromJS(data: any): TreatmentSpecialistDeleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSpecialistDeleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentSpecialistId"] = this.treatmentSpecialistId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        return data; 
    }

    clone(): TreatmentSpecialistDeleteModel {
        const json = this.toJSON();
        let result = new TreatmentSpecialistDeleteModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentSpecialistDeleteModel {
    treatmentSpecialistId?: number;
    treatmentProviderId?: number;
}

export class TreatmentTypePageModel implements ITreatmentTypePageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    treatmentTypes?: TreatmentTypeModel[] | undefined;

    constructor(data?: ITreatmentTypePageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRows = _data["TotalRows"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentTypePageModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypePageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRows"] = this.totalRows;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentTypePageModel {
        const json = this.toJSON();
        let result = new TreatmentTypePageModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypePageModel {
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    treatmentTypes?: TreatmentTypeModel[] | undefined;
}

export class TreatmentTypeCreateModel implements ITreatmentTypeCreateModel {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    caseRequired?: boolean;
    translations?: TreatmentTypeTranslationModel[] | undefined;

    constructor(data?: ITreatmentTypeCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.caseRequired = _data["CaseRequired"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TreatmentTypeTranslationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentTypeCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["CaseRequired"] = this.caseRequired;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentTypeCreateModel {
        const json = this.toJSON();
        let result = new TreatmentTypeCreateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeCreateModel {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    caseRequired?: boolean;
    translations?: TreatmentTypeTranslationModel[] | undefined;
}

export class TreatmentTypeUpdateModel extends TreatmentTypeCreateModel implements ITreatmentTypeUpdateModel {
    id?: number;

    constructor(data?: ITreatmentTypeUpdateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): TreatmentTypeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentTypeUpdateModel {
        const json = this.toJSON();
        let result = new TreatmentTypeUpdateModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeUpdateModel extends ITreatmentTypeCreateModel {
    id?: number;
}

export class TreatmentTypeTranslationModel implements ITreatmentTypeTranslationModel {
    name?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    entityId?: number;
    language?: string | undefined;
    id?: number;

    constructor(data?: ITreatmentTypeTranslationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.shortDescription = _data["ShortDescription"];
            this.entityId = _data["EntityId"];
            this.language = _data["Language"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): TreatmentTypeTranslationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeTranslationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["ShortDescription"] = this.shortDescription;
        data["EntityId"] = this.entityId;
        data["Language"] = this.language;
        data["Id"] = this.id;
        return data; 
    }

    clone(): TreatmentTypeTranslationModel {
        const json = this.toJSON();
        let result = new TreatmentTypeTranslationModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeTranslationModel {
    name?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    entityId?: number;
    language?: string | undefined;
    id?: number;
}

export class UserConsentDeclineModel implements IUserConsentDeclineModel {
    reason?: string | undefined;
    patientId?: number | undefined;

    constructor(data?: IUserConsentDeclineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["Reason"];
            this.patientId = _data["PatientId"];
        }
    }

    static fromJS(data: any): UserConsentDeclineModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserConsentDeclineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Reason"] = this.reason;
        data["PatientId"] = this.patientId;
        return data; 
    }

    clone(): UserConsentDeclineModel {
        const json = this.toJSON();
        let result = new UserConsentDeclineModel();
        result.init(json);
        return result;
    }
}

export interface IUserConsentDeclineModel {
    reason?: string | undefined;
    patientId?: number | undefined;
}

export class UpdateUserInfoModel implements IUpdateUserInfoModel {
    fullName!: string;
    email?: string | undefined;
    cPR?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    location!: LocationModel;
    sex?: SexModel | undefined;
    emailEnabled?: boolean | undefined;
    textMessageEnabled?: boolean | undefined;
    receiveCalendarInvitation?: boolean | undefined;
    notificationsConfirmed?: boolean | undefined;

    constructor(data?: IUpdateUserInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.cPR = _data["CPR"];
            this.phoneNumber = _data["PhoneNumber"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : new LocationModel();
            this.sex = _data["Sex"] ? SexModel.fromJS(_data["Sex"]) : <any>undefined;
            this.emailEnabled = _data["EmailEnabled"];
            this.textMessageEnabled = _data["TextMessageEnabled"];
            this.receiveCalendarInvitation = _data["ReceiveCalendarInvitation"];
            this.notificationsConfirmed = _data["NotificationsConfirmed"];
        }
    }

    static fromJS(data: any): UpdateUserInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["CPR"] = this.cPR;
        data["PhoneNumber"] = this.phoneNumber;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["Sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["EmailEnabled"] = this.emailEnabled;
        data["TextMessageEnabled"] = this.textMessageEnabled;
        data["ReceiveCalendarInvitation"] = this.receiveCalendarInvitation;
        data["NotificationsConfirmed"] = this.notificationsConfirmed;
        return data; 
    }

    clone(): UpdateUserInfoModel {
        const json = this.toJSON();
        let result = new UpdateUserInfoModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserInfoModel {
    fullName: string;
    email?: string | undefined;
    cPR?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    location: LocationModel;
    sex?: SexModel | undefined;
    emailEnabled?: boolean | undefined;
    textMessageEnabled?: boolean | undefined;
    receiveCalendarInvitation?: boolean | undefined;
    notificationsConfirmed?: boolean | undefined;
}

export class ConfirmationUserInfoModel implements IConfirmationUserInfoModel {
    userName?: string | undefined;
    fullName?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IConfirmationUserInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.fullName = _data["FullName"];
            this.token = _data["Token"];
            this.newPassword = _data["NewPassword"];
        }
    }

    static fromJS(data: any): ConfirmationUserInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmationUserInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["FullName"] = this.fullName;
        data["Token"] = this.token;
        data["NewPassword"] = this.newPassword;
        return data; 
    }

    clone(): ConfirmationUserInfoModel {
        const json = this.toJSON();
        let result = new ConfirmationUserInfoModel();
        result.init(json);
        return result;
    }
}

export interface IConfirmationUserInfoModel {
    userName?: string | undefined;
    fullName?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export class UserPageModel implements IUserPageModel {
    keyword?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    sortDirection?: number;
    sortItem?: number;
    users?: UserPageEntryModel[] | undefined;

    constructor(data?: IUserPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["Keyword"];
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.totalRows = _data["TotalRows"];
            this.sortDirection = _data["SortDirection"];
            this.sortItem = _data["SortItem"];
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(UserPageEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Keyword"] = this.keyword;
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["TotalRows"] = this.totalRows;
        data["SortDirection"] = this.sortDirection;
        data["SortItem"] = this.sortItem;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserPageModel {
        const json = this.toJSON();
        let result = new UserPageModel();
        result.init(json);
        return result;
    }
}

export interface IUserPageModel {
    keyword?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRows?: number;
    sortDirection?: number;
    sortItem?: number;
    users?: UserPageEntryModel[] | undefined;
}

export class UserPageEntryModel implements IUserPageEntryModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    sex?: SexModel | undefined;
    email?: string | undefined;
    active?: boolean;
    roleName?: string | undefined;
    roleCodes?: string[] | undefined;
    companies?: CompanySelectDTO[] | undefined;
    employeeGroup?: EmployeeGroupShortDTO | undefined;
    treatmentProviderName?: string | undefined;
    treatmentProviderNetworkName?: string | undefined;
    treatmentProviderId?: number | undefined;
    treatmentTypes?: TreatmentTypeShortDTO[] | undefined;
    membershipId?: string | undefined;
    companyId?: number | undefined;

    constructor(data?: IUserPageEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.phoneNumber = _data["PhoneNumber"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.sex = _data["Sex"] ? SexModel.fromJS(_data["Sex"]) : <any>undefined;
            this.email = _data["Email"];
            this.active = _data["Active"];
            this.roleName = _data["RoleName"];
            if (Array.isArray(_data["RoleCodes"])) {
                this.roleCodes = [] as any;
                for (let item of _data["RoleCodes"])
                    this.roleCodes!.push(item);
            }
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanySelectDTO.fromJS(item));
            }
            this.employeeGroup = _data["EmployeeGroup"] ? EmployeeGroupShortDTO.fromJS(_data["EmployeeGroup"]) : <any>undefined;
            this.treatmentProviderName = _data["TreatmentProviderName"];
            this.treatmentProviderNetworkName = _data["TreatmentProviderNetworkName"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeShortDTO.fromJS(item));
            }
            this.membershipId = _data["MembershipId"];
            this.companyId = _data["CompanyId"];
        }
    }

    static fromJS(data: any): UserPageEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPageEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["PhoneNumber"] = this.phoneNumber;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["Email"] = this.email;
        data["Active"] = this.active;
        data["RoleName"] = this.roleName;
        if (Array.isArray(this.roleCodes)) {
            data["RoleCodes"] = [];
            for (let item of this.roleCodes)
                data["RoleCodes"].push(item);
        }
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["EmployeeGroup"] = this.employeeGroup ? this.employeeGroup.toJSON() : <any>undefined;
        data["TreatmentProviderName"] = this.treatmentProviderName;
        data["TreatmentProviderNetworkName"] = this.treatmentProviderNetworkName;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["MembershipId"] = this.membershipId;
        data["CompanyId"] = this.companyId;
        return data; 
    }

    clone(): UserPageEntryModel {
        const json = this.toJSON();
        let result = new UserPageEntryModel();
        result.init(json);
        return result;
    }
}

export interface IUserPageEntryModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    sex?: SexModel | undefined;
    email?: string | undefined;
    active?: boolean;
    roleName?: string | undefined;
    roleCodes?: string[] | undefined;
    companies?: CompanySelectDTO[] | undefined;
    employeeGroup?: EmployeeGroupShortDTO | undefined;
    treatmentProviderName?: string | undefined;
    treatmentProviderNetworkName?: string | undefined;
    treatmentProviderId?: number | undefined;
    treatmentTypes?: TreatmentTypeShortDTO[] | undefined;
    membershipId?: string | undefined;
    companyId?: number | undefined;
}

export class EmployeeGroupShortDTO implements IEmployeeGroupShortDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEmployeeGroupShortDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): EmployeeGroupShortDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupShortDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): EmployeeGroupShortDTO {
        const json = this.toJSON();
        let result = new EmployeeGroupShortDTO();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroupShortDTO {
    id?: number;
    name?: string | undefined;
}

export class UserCreateModel implements IUserCreateModel {
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sexId?: number;
    roleId?: number;
    companyId?: number | undefined;
    employeeGroupId?: number | undefined;
    treatmentProviderId?: number | undefined;
    networkId?: number | undefined;
    membershipId?: string | undefined;
    treatmentTypesIds?: number[] | undefined;
    companiesIds?: number[] | undefined;
    active?: boolean;

    constructor(data?: IUserCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.sexId = _data["SexId"];
            this.roleId = _data["RoleId"];
            this.companyId = _data["CompanyId"];
            this.employeeGroupId = _data["EmployeeGroupId"];
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.networkId = _data["NetworkId"];
            this.membershipId = _data["MembershipId"];
            if (Array.isArray(_data["TreatmentTypesIds"])) {
                this.treatmentTypesIds = [] as any;
                for (let item of _data["TreatmentTypesIds"])
                    this.treatmentTypesIds!.push(item);
            }
            if (Array.isArray(_data["CompaniesIds"])) {
                this.companiesIds = [] as any;
                for (let item of _data["CompaniesIds"])
                    this.companiesIds!.push(item);
            }
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): UserCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["SexId"] = this.sexId;
        data["RoleId"] = this.roleId;
        data["CompanyId"] = this.companyId;
        data["EmployeeGroupId"] = this.employeeGroupId;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["NetworkId"] = this.networkId;
        data["MembershipId"] = this.membershipId;
        if (Array.isArray(this.treatmentTypesIds)) {
            data["TreatmentTypesIds"] = [];
            for (let item of this.treatmentTypesIds)
                data["TreatmentTypesIds"].push(item);
        }
        if (Array.isArray(this.companiesIds)) {
            data["CompaniesIds"] = [];
            for (let item of this.companiesIds)
                data["CompaniesIds"].push(item);
        }
        data["Active"] = this.active;
        return data; 
    }

    clone(): UserCreateModel {
        const json = this.toJSON();
        let result = new UserCreateModel();
        result.init(json);
        return result;
    }
}

export interface IUserCreateModel {
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sexId?: number;
    roleId?: number;
    companyId?: number | undefined;
    employeeGroupId?: number | undefined;
    treatmentProviderId?: number | undefined;
    networkId?: number | undefined;
    membershipId?: string | undefined;
    treatmentTypesIds?: number[] | undefined;
    companiesIds?: number[] | undefined;
    active?: boolean;
}

export class UserEditModel implements IUserEditModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cpr?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    sexId?: number;
    active?: boolean;
    employeeGroupId?: number;
    companyId?: number | undefined;
    companies?: CompanySelectDTO[] | undefined;
    treatmentTypeIds?: number[] | undefined;
    treatmentProviderId?: number | undefined;
    emailEnabled?: boolean;
    textMessageEnabled?: boolean;
    receiveCalendarInvitation?: boolean;

    constructor(data?: IUserEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.cpr = _data["Cpr"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.sexId = _data["SexId"];
            this.active = _data["Active"];
            this.employeeGroupId = _data["EmployeeGroupId"];
            this.companyId = _data["CompanyId"];
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanySelectDTO.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypeIds"])) {
                this.treatmentTypeIds = [] as any;
                for (let item of _data["TreatmentTypeIds"])
                    this.treatmentTypeIds!.push(item);
            }
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.emailEnabled = _data["EmailEnabled"];
            this.textMessageEnabled = _data["TextMessageEnabled"];
            this.receiveCalendarInvitation = _data["ReceiveCalendarInvitation"];
        }
    }

    static fromJS(data: any): UserEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Cpr"] = this.cpr;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["SexId"] = this.sexId;
        data["Active"] = this.active;
        data["EmployeeGroupId"] = this.employeeGroupId;
        data["CompanyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypeIds)) {
            data["TreatmentTypeIds"] = [];
            for (let item of this.treatmentTypeIds)
                data["TreatmentTypeIds"].push(item);
        }
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["EmailEnabled"] = this.emailEnabled;
        data["TextMessageEnabled"] = this.textMessageEnabled;
        data["ReceiveCalendarInvitation"] = this.receiveCalendarInvitation;
        return data; 
    }

    clone(): UserEditModel {
        const json = this.toJSON();
        let result = new UserEditModel();
        result.init(json);
        return result;
    }
}

export interface IUserEditModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cpr?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    sexId?: number;
    active?: boolean;
    employeeGroupId?: number;
    companyId?: number | undefined;
    companies?: CompanySelectDTO[] | undefined;
    treatmentTypeIds?: number[] | undefined;
    treatmentProviderId?: number | undefined;
    emailEnabled?: boolean;
    textMessageEnabled?: boolean;
    receiveCalendarInvitation?: boolean;
}

export class TreatmentProviderModel extends BaseEntityModel implements ITreatmentProviderModel {
    treatmentProviderRepresentativeId?: number;
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    contact?: ContactTreatmentProviderModel | undefined;
    location?: LocationTreatmentProviderModel | undefined;
    treatmentSpecialists?: TreatmentSpecialistModel[] | undefined;
    treatmentProviderTypeId?: number | undefined;
    treatmentProviderType?: TreatmentProviderTypeModel | undefined;
    treatmentProviderStatus?: TreatmentProviderStatusModel | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    referralPossible?: boolean;
    onHold?: boolean;
    dateOnHoldFrom?: moment.Moment | undefined;
    dateOnHoldTo?: moment.Moment | undefined;
    ratingId?: number | undefined;
    rating?: RatingModel | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkModel | undefined;
    rootTreatmentProviderId?: number | undefined;
    rootTreatmentProvider?: TreatmentProviderModel | undefined;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    treatmentSpecialties?: TreatmentSpecialtyModel[] | undefined;
    treatmentTypes?: TreatmentTypeModel[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeModel[] | undefined;
    emails?: EmailModel[] | undefined;
    files?: FileModel[] | undefined;
    notes?: NoteModel[] | undefined;
    appointmentScheduleEnabled?: boolean;

    constructor(data?: ITreatmentProviderModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentProviderRepresentativeId = _data["TreatmentProviderRepresentativeId"];
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.pnumber = _data["Pnumber"];
            this.contact = _data["Contact"] ? ContactTreatmentProviderModel.fromJS(_data["Contact"]) : <any>undefined;
            this.location = _data["Location"] ? LocationTreatmentProviderModel.fromJS(_data["Location"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentSpecialists"])) {
                this.treatmentSpecialists = [] as any;
                for (let item of _data["TreatmentSpecialists"])
                    this.treatmentSpecialists!.push(TreatmentSpecialistModel.fromJS(item));
            }
            this.treatmentProviderTypeId = _data["TreatmentProviderTypeId"];
            this.treatmentProviderType = _data["TreatmentProviderType"] ? TreatmentProviderTypeModel.fromJS(_data["TreatmentProviderType"]) : <any>undefined;
            this.treatmentProviderStatus = _data["TreatmentProviderStatus"] ? TreatmentProviderStatusModel.fromJS(_data["TreatmentProviderStatus"]) : <any>undefined;
            this.comment = _data["Comment"];
            this.publicKey = _data["PublicKey"];
            this.referralPossible = _data["ReferralPossible"];
            this.onHold = _data["OnHold"];
            this.dateOnHoldFrom = _data["DateOnHoldFrom"] ? moment(_data["DateOnHoldFrom"].toString()) : <any>undefined;
            this.dateOnHoldTo = _data["DateOnHoldTo"] ? moment(_data["DateOnHoldTo"].toString()) : <any>undefined;
            this.ratingId = _data["RatingId"];
            this.rating = _data["Rating"] ? RatingModel.fromJS(_data["Rating"]) : <any>undefined;
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            this.rootTreatmentProviderId = _data["RootTreatmentProviderId"];
            this.rootTreatmentProvider = _data["RootTreatmentProvider"] ? TreatmentProviderModel.fromJS(_data["RootTreatmentProvider"]) : <any>undefined;
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactModel.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentSpecialties"])) {
                this.treatmentSpecialties = [] as any;
                for (let item of _data["TreatmentSpecialties"])
                    this.treatmentSpecialties!.push(TreatmentSpecialtyModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeModel.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(EmailModel.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NoteModel.fromJS(item));
            }
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
        }
    }

    static fromJS(data: any): TreatmentProviderModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TreatmentProviderRepresentativeId"] = this.treatmentProviderRepresentativeId;
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Pnumber"] = this.pnumber;
        data["Contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentSpecialists)) {
            data["TreatmentSpecialists"] = [];
            for (let item of this.treatmentSpecialists)
                data["TreatmentSpecialists"].push(item.toJSON());
        }
        data["TreatmentProviderTypeId"] = this.treatmentProviderTypeId;
        data["TreatmentProviderType"] = this.treatmentProviderType ? this.treatmentProviderType.toJSON() : <any>undefined;
        data["TreatmentProviderStatus"] = this.treatmentProviderStatus ? this.treatmentProviderStatus.toJSON() : <any>undefined;
        data["Comment"] = this.comment;
        data["PublicKey"] = this.publicKey;
        data["ReferralPossible"] = this.referralPossible;
        data["OnHold"] = this.onHold;
        data["DateOnHoldFrom"] = this.dateOnHoldFrom ? this.dateOnHoldFrom.toISOString() : <any>undefined;
        data["DateOnHoldTo"] = this.dateOnHoldTo ? this.dateOnHoldTo.toISOString() : <any>undefined;
        data["RatingId"] = this.ratingId;
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        data["RootTreatmentProviderId"] = this.rootTreatmentProviderId;
        data["RootTreatmentProvider"] = this.rootTreatmentProvider ? this.rootTreatmentProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentSpecialties)) {
            data["TreatmentSpecialties"] = [];
            for (let item of this.treatmentSpecialties)
                data["TreatmentSpecialties"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderModel {
        const json = this.toJSON();
        let result = new TreatmentProviderModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderModel extends IBaseEntityModel {
    treatmentProviderRepresentativeId?: number;
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    contact?: ContactTreatmentProviderModel | undefined;
    location?: LocationTreatmentProviderModel | undefined;
    treatmentSpecialists?: TreatmentSpecialistModel[] | undefined;
    treatmentProviderTypeId?: number | undefined;
    treatmentProviderType?: TreatmentProviderTypeModel | undefined;
    treatmentProviderStatus?: TreatmentProviderStatusModel | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    referralPossible?: boolean;
    onHold?: boolean;
    dateOnHoldFrom?: moment.Moment | undefined;
    dateOnHoldTo?: moment.Moment | undefined;
    ratingId?: number | undefined;
    rating?: RatingModel | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkModel | undefined;
    rootTreatmentProviderId?: number | undefined;
    rootTreatmentProvider?: TreatmentProviderModel | undefined;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    treatmentSpecialties?: TreatmentSpecialtyModel[] | undefined;
    treatmentTypes?: TreatmentTypeModel[] | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeModel[] | undefined;
    emails?: EmailModel[] | undefined;
    files?: FileModel[] | undefined;
    notes?: NoteModel[] | undefined;
    appointmentScheduleEnabled?: boolean;
}

export class RatingModel implements IRatingModel {
    id?: number;
    averageValue?: number | undefined;
    minimalValue?: number;
    maximalValue?: number;
    comment?: string | undefined;
    ratingVotes?: RatingVoteModel[] | undefined;

    constructor(data?: IRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.averageValue = _data["AverageValue"];
            this.minimalValue = _data["MinimalValue"];
            this.maximalValue = _data["MaximalValue"];
            this.comment = _data["Comment"];
            if (Array.isArray(_data["RatingVotes"])) {
                this.ratingVotes = [] as any;
                for (let item of _data["RatingVotes"])
                    this.ratingVotes!.push(RatingVoteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AverageValue"] = this.averageValue;
        data["MinimalValue"] = this.minimalValue;
        data["MaximalValue"] = this.maximalValue;
        data["Comment"] = this.comment;
        if (Array.isArray(this.ratingVotes)) {
            data["RatingVotes"] = [];
            for (let item of this.ratingVotes)
                data["RatingVotes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RatingModel {
        const json = this.toJSON();
        let result = new RatingModel();
        result.init(json);
        return result;
    }
}

export interface IRatingModel {
    id?: number;
    averageValue?: number | undefined;
    minimalValue?: number;
    maximalValue?: number;
    comment?: string | undefined;
    ratingVotes?: RatingVoteModel[] | undefined;
}

export class RatingVoteModel implements IRatingVoteModel {
    id?: number;
    value?: number;
    fromImport?: boolean;
    ratingId?: number;
    rating?: RatingModel | undefined;
    user?: UserModel | undefined;

    constructor(data?: IRatingVoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.value = _data["Value"];
            this.fromImport = _data["FromImport"];
            this.ratingId = _data["RatingId"];
            this.rating = _data["Rating"] ? RatingModel.fromJS(_data["Rating"]) : <any>undefined;
            this.user = _data["User"] ? UserModel.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RatingVoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingVoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Value"] = this.value;
        data["FromImport"] = this.fromImport;
        data["RatingId"] = this.ratingId;
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RatingVoteModel {
        const json = this.toJSON();
        let result = new RatingVoteModel();
        result.init(json);
        return result;
    }
}

export interface IRatingVoteModel {
    id?: number;
    value?: number;
    fromImport?: boolean;
    ratingId?: number;
    rating?: RatingModel | undefined;
    user?: UserModel | undefined;
}

export class UserModel implements IUserModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    passwordHash?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    dateNotificationEmailSent?: moment.Moment | undefined;
    lastLoginTime?: moment.Moment | undefined;
    dateEmailConfirmed?: moment.Moment | undefined;
    sexId?: number;
    sex?: SexModel | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompanyModel | undefined;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    userPermissions?: UserPermissionModel[] | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployeeModel[] | undefined;
    emails?: EmailModel[] | undefined;
    files?: FileModel[] | undefined;
    notes?: NoteModel[] | undefined;
    roles?: UserRoleModel[] | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
    externalReferenceId?: string | undefined;
    synchronizationDate?: moment.Moment | undefined;
    synchronizedBy?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.email = _data["Email"];
            this.emailConfirmed = _data["EmailConfirmed"];
            this.phoneNumber = _data["PhoneNumber"];
            this.userName = _data["UserName"];
            this.passwordHash = _data["PasswordHash"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.comment = _data["Comment"];
            this.publicKey = _data["PublicKey"];
            this.profilePicture = _data["ProfilePicture"];
            this.profileInfo = _data["ProfileInfo"];
            this.dateNotificationEmailSent = _data["DateNotificationEmailSent"] ? moment(_data["DateNotificationEmailSent"].toString()) : <any>undefined;
            this.lastLoginTime = _data["LastLoginTime"] ? moment(_data["LastLoginTime"].toString()) : <any>undefined;
            this.dateEmailConfirmed = _data["DateEmailConfirmed"] ? moment(_data["DateEmailConfirmed"].toString()) : <any>undefined;
            this.sexId = _data["SexId"];
            this.sex = _data["Sex"] ? SexModel.fromJS(_data["Sex"]) : <any>undefined;
            this.insuranceCompanyId = _data["InsuranceCompanyId"];
            this.insuranceCompany = _data["InsuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["InsuranceCompany"]) : <any>undefined;
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactModel.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["UserPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["UserPermissions"])
                    this.userPermissions!.push(UserPermissionModel.fromJS(item));
            }
            if (Array.isArray(_data["EmployeeGroupEmployees"])) {
                this.employeeGroupEmployees = [] as any;
                for (let item of _data["EmployeeGroupEmployees"])
                    this.employeeGroupEmployees!.push(EmployeeGroupEmployeeModel.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(EmailModel.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NoteModel.fromJS(item));
            }
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(UserRoleModel.fromJS(item));
            }
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.synchronizationDate = _data["SynchronizationDate"] ? moment(_data["SynchronizationDate"].toString()) : <any>undefined;
            this.synchronizedBy = _data["SynchronizedBy"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["Email"] = this.email;
        data["EmailConfirmed"] = this.emailConfirmed;
        data["PhoneNumber"] = this.phoneNumber;
        data["UserName"] = this.userName;
        data["PasswordHash"] = this.passwordHash;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Comment"] = this.comment;
        data["PublicKey"] = this.publicKey;
        data["ProfilePicture"] = this.profilePicture;
        data["ProfileInfo"] = this.profileInfo;
        data["DateNotificationEmailSent"] = this.dateNotificationEmailSent ? this.dateNotificationEmailSent.toISOString() : <any>undefined;
        data["LastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["DateEmailConfirmed"] = this.dateEmailConfirmed ? this.dateEmailConfirmed.toISOString() : <any>undefined;
        data["SexId"] = this.sexId;
        data["Sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["InsuranceCompanyId"] = this.insuranceCompanyId;
        data["InsuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["UserPermissions"] = [];
            for (let item of this.userPermissions)
                data["UserPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeGroupEmployees)) {
            data["EmployeeGroupEmployees"] = [];
            for (let item of this.employeeGroupEmployees)
                data["EmployeeGroupEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item.toJSON());
        }
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["SynchronizationDate"] = this.synchronizationDate ? this.synchronizationDate.toISOString() : <any>undefined;
        data["SynchronizedBy"] = this.synchronizedBy;
        return data; 
    }

    clone(): UserModel {
        const json = this.toJSON();
        let result = new UserModel();
        result.init(json);
        return result;
    }
}

export interface IUserModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    passwordHash?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    comment?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    dateNotificationEmailSent?: moment.Moment | undefined;
    lastLoginTime?: moment.Moment | undefined;
    dateEmailConfirmed?: moment.Moment | undefined;
    sexId?: number;
    sex?: SexModel | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompanyModel | undefined;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    userPermissions?: UserPermissionModel[] | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployeeModel[] | undefined;
    emails?: EmailModel[] | undefined;
    files?: FileModel[] | undefined;
    notes?: NoteModel[] | undefined;
    roles?: UserRoleModel[] | undefined;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
    externalReferenceId?: string | undefined;
    synchronizationDate?: moment.Moment | undefined;
    synchronizedBy?: string | undefined;
}

export class InsuranceCompanyModel extends BaseEntityModel implements IInsuranceCompanyModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    externalIntegrationSystemId?: number | undefined;
    externalIntegrationSystem?: ExternalIntegrationSystemModel | undefined;

    constructor(data?: IInsuranceCompanyModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.externalIntegrationSystemId = _data["ExternalIntegrationSystemId"];
            this.externalIntegrationSystem = _data["ExternalIntegrationSystem"] ? ExternalIntegrationSystemModel.fromJS(_data["ExternalIntegrationSystem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InsuranceCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["ExternalIntegrationSystemId"] = this.externalIntegrationSystemId;
        data["ExternalIntegrationSystem"] = this.externalIntegrationSystem ? this.externalIntegrationSystem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): InsuranceCompanyModel {
        const json = this.toJSON();
        let result = new InsuranceCompanyModel();
        result.init(json);
        return result;
    }
}

export interface IInsuranceCompanyModel extends IBaseEntityModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    externalIntegrationSystemId?: number | undefined;
    externalIntegrationSystem?: ExternalIntegrationSystemModel | undefined;
}

export class ExternalIntegrationSystemModel extends BaseEntityModel implements IExternalIntegrationSystemModel {
    id?: number;
    clientName?: string | undefined;
    secret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    externalClientName?: string | undefined;
    externalSecret?: string | undefined;
    externalUsername?: string | undefined;
    externalPassword?: string | undefined;
    keyword?: string | undefined;
    active?: boolean;
    refreshTokenDurationInMinutes?: number | undefined;
    externalIntegrationTokens?: ExternalIntegrationTokenModel[] | undefined;

    constructor(data?: IExternalIntegrationSystemModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.clientName = _data["ClientName"];
            this.secret = _data["Secret"];
            this.username = _data["Username"];
            this.password = _data["Password"];
            this.externalClientName = _data["ExternalClientName"];
            this.externalSecret = _data["ExternalSecret"];
            this.externalUsername = _data["ExternalUsername"];
            this.externalPassword = _data["ExternalPassword"];
            this.keyword = _data["Keyword"];
            this.active = _data["Active"];
            this.refreshTokenDurationInMinutes = _data["RefreshTokenDurationInMinutes"];
            if (Array.isArray(_data["ExternalIntegrationTokens"])) {
                this.externalIntegrationTokens = [] as any;
                for (let item of _data["ExternalIntegrationTokens"])
                    this.externalIntegrationTokens!.push(ExternalIntegrationTokenModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalIntegrationSystemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIntegrationSystemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ClientName"] = this.clientName;
        data["Secret"] = this.secret;
        data["Username"] = this.username;
        data["Password"] = this.password;
        data["ExternalClientName"] = this.externalClientName;
        data["ExternalSecret"] = this.externalSecret;
        data["ExternalUsername"] = this.externalUsername;
        data["ExternalPassword"] = this.externalPassword;
        data["Keyword"] = this.keyword;
        data["Active"] = this.active;
        data["RefreshTokenDurationInMinutes"] = this.refreshTokenDurationInMinutes;
        if (Array.isArray(this.externalIntegrationTokens)) {
            data["ExternalIntegrationTokens"] = [];
            for (let item of this.externalIntegrationTokens)
                data["ExternalIntegrationTokens"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): ExternalIntegrationSystemModel {
        const json = this.toJSON();
        let result = new ExternalIntegrationSystemModel();
        result.init(json);
        return result;
    }
}

export interface IExternalIntegrationSystemModel extends IBaseEntityModel {
    id?: number;
    clientName?: string | undefined;
    secret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    externalClientName?: string | undefined;
    externalSecret?: string | undefined;
    externalUsername?: string | undefined;
    externalPassword?: string | undefined;
    keyword?: string | undefined;
    active?: boolean;
    refreshTokenDurationInMinutes?: number | undefined;
    externalIntegrationTokens?: ExternalIntegrationTokenModel[] | undefined;
}

export class ExternalIntegrationTokenModel extends BaseEntityModel implements IExternalIntegrationTokenModel {
    id?: number;
    externalIntegrationSystemId?: number;
    externalIntegrationSystem?: ExternalIntegrationSystemModel | undefined;
    token?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    protectedData?: string | undefined;

    constructor(data?: IExternalIntegrationTokenModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.externalIntegrationSystemId = _data["ExternalIntegrationSystemId"];
            this.externalIntegrationSystem = _data["ExternalIntegrationSystem"] ? ExternalIntegrationSystemModel.fromJS(_data["ExternalIntegrationSystem"]) : <any>undefined;
            this.token = _data["Token"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.protectedData = _data["ProtectedData"];
        }
    }

    static fromJS(data: any): ExternalIntegrationTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIntegrationTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ExternalIntegrationSystemId"] = this.externalIntegrationSystemId;
        data["ExternalIntegrationSystem"] = this.externalIntegrationSystem ? this.externalIntegrationSystem.toJSON() : <any>undefined;
        data["Token"] = this.token;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ProtectedData"] = this.protectedData;
        super.toJSON(data);
        return data; 
    }

    clone(): ExternalIntegrationTokenModel {
        const json = this.toJSON();
        let result = new ExternalIntegrationTokenModel();
        result.init(json);
        return result;
    }
}

export interface IExternalIntegrationTokenModel extends IBaseEntityModel {
    id?: number;
    externalIntegrationSystemId?: number;
    externalIntegrationSystem?: ExternalIntegrationSystemModel | undefined;
    token?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    protectedData?: string | undefined;
}

export class ContactModel implements IContactModel {
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
    contactPerson?: string | undefined;

    constructor(data?: IContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.mobile = _data["Mobile"];
            this.fax = _data["Fax"];
            this.uRL = _data["URL"];
            this.contactPerson = _data["ContactPerson"];
        }
    }

    static fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Mobile"] = this.mobile;
        data["Fax"] = this.fax;
        data["URL"] = this.uRL;
        data["ContactPerson"] = this.contactPerson;
        return data; 
    }

    clone(): ContactModel {
        const json = this.toJSON();
        let result = new ContactModel();
        result.init(json);
        return result;
    }
}

export interface IContactModel {
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    fax?: string | undefined;
    uRL?: string | undefined;
    contactPerson?: string | undefined;
}

export class UserPermissionModel implements IUserPermissionModel {
    id?: number;
    userId?: number;
    user?: UserModel | undefined;
    permissionId?: number;
    permission?: PermissionModel | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;

    constructor(data?: IUserPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserModel.fromJS(_data["User"]) : <any>undefined;
            this.permissionId = _data["PermissionId"];
            this.permission = _data["Permission"] ? PermissionModel.fromJS(_data["Permission"]) : <any>undefined;
            this.create = _data["Create"];
            this.read = _data["Read"];
            this.update = _data["Update"];
            this.delete = _data["Delete"];
        }
    }

    static fromJS(data: any): UserPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["PermissionId"] = this.permissionId;
        data["Permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        data["Create"] = this.create;
        data["Read"] = this.read;
        data["Update"] = this.update;
        data["Delete"] = this.delete;
        return data; 
    }

    clone(): UserPermissionModel {
        const json = this.toJSON();
        let result = new UserPermissionModel();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionModel {
    id?: number;
    userId?: number;
    user?: UserModel | undefined;
    permissionId?: number;
    permission?: PermissionModel | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
}

export class PermissionModel implements IPermissionModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;

    constructor(data?: IPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.create = _data["Create"];
            this.read = _data["Read"];
            this.update = _data["Update"];
            this.delete = _data["Delete"];
            this.createdBy = _data["CreatedBy"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.dateModified = _data["DateModified"] ? moment(_data["DateModified"].toString()) : <any>undefined;
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): PermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Create"] = this.create;
        data["Read"] = this.read;
        data["Update"] = this.update;
        data["Delete"] = this.delete;
        data["CreatedBy"] = this.createdBy;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): PermissionModel {
        const json = this.toJSON();
        let result = new PermissionModel();
        result.init(json);
        return result;
    }
}

export interface IPermissionModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
    createdBy?: number;
    dateCreated?: moment.Moment;
    modifiedBy?: number | undefined;
    dateModified?: moment.Moment | undefined;
    deleted?: boolean;
}

export class EmployeeGroupEmployeeModel extends BaseEntityModel implements IEmployeeGroupEmployeeModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    employeeGroupId?: number;
    employeeGroup?: EmployeeGroupModel | undefined;
    userId?: number;
    user?: UserModel | undefined;

    constructor(data?: IEmployeeGroupEmployeeModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.employeeGroupId = _data["EmployeeGroupId"];
            this.employeeGroup = _data["EmployeeGroup"] ? EmployeeGroupModel.fromJS(_data["EmployeeGroup"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserModel.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeGroupEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["EmployeeGroupId"] = this.employeeGroupId;
        data["EmployeeGroup"] = this.employeeGroup ? this.employeeGroup.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): EmployeeGroupEmployeeModel {
        const json = this.toJSON();
        let result = new EmployeeGroupEmployeeModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroupEmployeeModel extends IBaseEntityModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    employeeGroupId?: number;
    employeeGroup?: EmployeeGroupModel | undefined;
    userId?: number;
    user?: UserModel | undefined;
}

export class EmployeeGroupModel extends BaseEntityModel implements IEmployeeGroupModel {
    id?: number;
    name?: string | undefined;
    companyId?: number;
    company?: CompanyModel | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployeeModel[] | undefined;

    constructor(data?: IEmployeeGroupModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.companyId = _data["CompanyId"];
            this.company = _data["Company"] ? CompanyModel.fromJS(_data["Company"]) : <any>undefined;
            if (Array.isArray(_data["EmployeeGroupEmployees"])) {
                this.employeeGroupEmployees = [] as any;
                for (let item of _data["EmployeeGroupEmployees"])
                    this.employeeGroupEmployees!.push(EmployeeGroupEmployeeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CompanyId"] = this.companyId;
        data["Company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.employeeGroupEmployees)) {
            data["EmployeeGroupEmployees"] = [];
            for (let item of this.employeeGroupEmployees)
                data["EmployeeGroupEmployees"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmployeeGroupModel {
        const json = this.toJSON();
        let result = new EmployeeGroupModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGroupModel extends IBaseEntityModel {
    id?: number;
    name?: string | undefined;
    companyId?: number;
    company?: CompanyModel | undefined;
    employeeGroupEmployees?: EmployeeGroupEmployeeModel[] | undefined;
}

export class CompanyModel extends BaseEntityModel implements ICompanyModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    comment?: string | undefined;
    abbreviation?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    rootCompanyId?: number | undefined;
    rootCompany?: CompanyModel | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompanyModel | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkModel | undefined;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    employeeGroups?: EmployeeGroupModel[] | undefined;
    emails?: EmailModel[] | undefined;
    files?: FileModel[] | undefined;
    notes?: NoteModel[] | undefined;
    nurses?: User[] | undefined;
    dataOwnerId?: number | undefined;
    dataOwner?: DataOwnerModel | undefined;
    assignments?: AssignmentModel[] | undefined;
    appointmentSchedules?: AppointmentScheduleModel[] | undefined;

    constructor(data?: ICompanyModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.pnumber = _data["Pnumber"];
            this.comment = _data["Comment"];
            this.abbreviation = _data["Abbreviation"];
            this.publicKey = _data["PublicKey"];
            this.profilePicture = _data["ProfilePicture"];
            this.profileInfo = _data["ProfileInfo"];
            this.rootCompanyId = _data["RootCompanyId"];
            this.rootCompany = _data["RootCompany"] ? CompanyModel.fromJS(_data["RootCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["InsuranceCompanyId"];
            this.insuranceCompany = _data["InsuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["InsuranceCompany"]) : <any>undefined;
            this.treatmentProviderNetworkId = _data["TreatmentProviderNetworkId"];
            this.treatmentProviderNetwork = _data["TreatmentProviderNetwork"] ? TreatmentProviderNetworkModel.fromJS(_data["TreatmentProviderNetwork"]) : <any>undefined;
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactModel.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["EmployeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["EmployeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupModel.fromJS(item));
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(EmailModel.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NoteModel.fromJS(item));
            }
            if (Array.isArray(_data["Nurses"])) {
                this.nurses = [] as any;
                for (let item of _data["Nurses"])
                    this.nurses!.push(User.fromJS(item));
            }
            this.dataOwnerId = _data["DataOwnerId"];
            this.dataOwner = _data["DataOwner"] ? DataOwnerModel.fromJS(_data["DataOwner"]) : <any>undefined;
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(AssignmentModel.fromJS(item));
            }
            if (Array.isArray(_data["AppointmentSchedules"])) {
                this.appointmentSchedules = [] as any;
                for (let item of _data["AppointmentSchedules"])
                    this.appointmentSchedules!.push(AppointmentScheduleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Pnumber"] = this.pnumber;
        data["Comment"] = this.comment;
        data["Abbreviation"] = this.abbreviation;
        data["PublicKey"] = this.publicKey;
        data["ProfilePicture"] = this.profilePicture;
        data["ProfileInfo"] = this.profileInfo;
        data["RootCompanyId"] = this.rootCompanyId;
        data["RootCompany"] = this.rootCompany ? this.rootCompany.toJSON() : <any>undefined;
        data["InsuranceCompanyId"] = this.insuranceCompanyId;
        data["InsuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["TreatmentProviderNetworkId"] = this.treatmentProviderNetworkId;
        data["TreatmentProviderNetwork"] = this.treatmentProviderNetwork ? this.treatmentProviderNetwork.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeGroups)) {
            data["EmployeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["EmployeeGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.nurses)) {
            data["Nurses"] = [];
            for (let item of this.nurses)
                data["Nurses"].push(item.toJSON());
        }
        data["DataOwnerId"] = this.dataOwnerId;
        data["DataOwner"] = this.dataOwner ? this.dataOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.appointmentSchedules)) {
            data["AppointmentSchedules"] = [];
            for (let item of this.appointmentSchedules)
                data["AppointmentSchedules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CompanyModel {
        const json = this.toJSON();
        let result = new CompanyModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyModel extends IBaseEntityModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    pnumber?: string | undefined;
    comment?: string | undefined;
    abbreviation?: string | undefined;
    publicKey?: string | undefined;
    profilePicture?: string | undefined;
    profileInfo?: string | undefined;
    rootCompanyId?: number | undefined;
    rootCompany?: CompanyModel | undefined;
    insuranceCompanyId?: number | undefined;
    insuranceCompany?: InsuranceCompanyModel | undefined;
    treatmentProviderNetworkId?: number | undefined;
    treatmentProviderNetwork?: TreatmentProviderNetworkModel | undefined;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    employeeGroups?: EmployeeGroupModel[] | undefined;
    emails?: EmailModel[] | undefined;
    files?: FileModel[] | undefined;
    notes?: NoteModel[] | undefined;
    nurses?: User[] | undefined;
    dataOwnerId?: number | undefined;
    dataOwner?: DataOwnerModel | undefined;
    assignments?: AssignmentModel[] | undefined;
    appointmentSchedules?: AppointmentScheduleModel[] | undefined;
}

export class TreatmentProviderNetworkModel extends BaseEntityModel implements ITreatmentProviderNetworkModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    comment?: string | undefined;
    active?: boolean;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    treatmentProviders?: TreatmentProviderModel[] | undefined;

    constructor(data?: ITreatmentProviderNetworkModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.code = _data["Code"];
            this.comment = _data["Comment"];
            this.active = _data["Active"];
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(ContactModel.fromJS(item));
            }
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["TreatmentProviders"])) {
                this.treatmentProviders = [] as any;
                for (let item of _data["TreatmentProviders"])
                    this.treatmentProviders!.push(TreatmentProviderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderNetworkModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderNetworkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["Code"] = this.code;
        data["Comment"] = this.comment;
        data["Active"] = this.active;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentProviders)) {
            data["TreatmentProviders"] = [];
            for (let item of this.treatmentProviders)
                data["TreatmentProviders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): TreatmentProviderNetworkModel {
        const json = this.toJSON();
        let result = new TreatmentProviderNetworkModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderNetworkModel extends IBaseEntityModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    comment?: string | undefined;
    active?: boolean;
    contacts?: ContactModel[] | undefined;
    locations?: LocationModel[] | undefined;
    treatmentProviders?: TreatmentProviderModel[] | undefined;
}

export class EmailModel extends BaseEntityModel implements IEmailModel {
    id?: number;
    subject?: string | undefined;
    body?: string | undefined;
    from?: string | undefined;
    fromDisplayName?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    sent?: boolean;
    dateSent?: moment.Moment | undefined;
    automaticSend?: boolean;
    automaticSendingDate?: moment.Moment | undefined;
    errorSending?: boolean;
    errorMessage?: string | undefined;
    calendarEventIsSent?: boolean;
    emailTemplateId?: number | undefined;
    emailTemplate?: EmailTemplateModel | undefined;
    emailAttachments?: EmailAttachmentModel[] | undefined;

    constructor(data?: IEmailModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.from = _data["From"];
            this.fromDisplayName = _data["FromDisplayName"];
            this.to = _data["To"];
            this.cc = _data["Cc"];
            this.bcc = _data["Bcc"];
            this.sent = _data["Sent"];
            this.dateSent = _data["DateSent"] ? moment(_data["DateSent"].toString()) : <any>undefined;
            this.automaticSend = _data["AutomaticSend"];
            this.automaticSendingDate = _data["AutomaticSendingDate"] ? moment(_data["AutomaticSendingDate"].toString()) : <any>undefined;
            this.errorSending = _data["ErrorSending"];
            this.errorMessage = _data["ErrorMessage"];
            this.calendarEventIsSent = _data["CalendarEventIsSent"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.emailTemplate = _data["EmailTemplate"] ? EmailTemplateModel.fromJS(_data["EmailTemplate"]) : <any>undefined;
            if (Array.isArray(_data["EmailAttachments"])) {
                this.emailAttachments = [] as any;
                for (let item of _data["EmailAttachments"])
                    this.emailAttachments!.push(EmailAttachmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["From"] = this.from;
        data["FromDisplayName"] = this.fromDisplayName;
        data["To"] = this.to;
        data["Cc"] = this.cc;
        data["Bcc"] = this.bcc;
        data["Sent"] = this.sent;
        data["DateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["AutomaticSend"] = this.automaticSend;
        data["AutomaticSendingDate"] = this.automaticSendingDate ? this.automaticSendingDate.toISOString() : <any>undefined;
        data["ErrorSending"] = this.errorSending;
        data["ErrorMessage"] = this.errorMessage;
        data["CalendarEventIsSent"] = this.calendarEventIsSent;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["EmailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.emailAttachments)) {
            data["EmailAttachments"] = [];
            for (let item of this.emailAttachments)
                data["EmailAttachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmailModel {
        const json = this.toJSON();
        let result = new EmailModel();
        result.init(json);
        return result;
    }
}

export interface IEmailModel extends IBaseEntityModel {
    id?: number;
    subject?: string | undefined;
    body?: string | undefined;
    from?: string | undefined;
    fromDisplayName?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    sent?: boolean;
    dateSent?: moment.Moment | undefined;
    automaticSend?: boolean;
    automaticSendingDate?: moment.Moment | undefined;
    errorSending?: boolean;
    errorMessage?: string | undefined;
    calendarEventIsSent?: boolean;
    emailTemplateId?: number | undefined;
    emailTemplate?: EmailTemplateModel | undefined;
    emailAttachments?: EmailAttachmentModel[] | undefined;
}

export class EmailAttachmentModel extends BaseEntityModel implements IEmailAttachmentModel {
    id?: number;
    filePath?: string | undefined;
    emailId?: number;
    emailAttachmentTypeId?: number | undefined;

    constructor(data?: IEmailAttachmentModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.filePath = _data["FilePath"];
            this.emailId = _data["EmailId"];
            this.emailAttachmentTypeId = _data["EmailAttachmentTypeId"];
        }
    }

    static fromJS(data: any): EmailAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FilePath"] = this.filePath;
        data["EmailId"] = this.emailId;
        data["EmailAttachmentTypeId"] = this.emailAttachmentTypeId;
        super.toJSON(data);
        return data; 
    }

    clone(): EmailAttachmentModel {
        const json = this.toJSON();
        let result = new EmailAttachmentModel();
        result.init(json);
        return result;
    }
}

export interface IEmailAttachmentModel extends IBaseEntityModel {
    id?: number;
    filePath?: string | undefined;
    emailId?: number;
    emailAttachmentTypeId?: number | undefined;
}

export class NoteModel implements INoteModel {
    id?: number;
    dateCreated?: moment.Moment;
    text?: string | undefined;
    textHtml?: string | undefined;
    createdBy?: number;
    user?: UserModel | undefined;

    constructor(data?: INoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.dateCreated = _data["DateCreated"] ? moment(_data["DateCreated"].toString()) : <any>undefined;
            this.text = _data["Text"];
            this.textHtml = _data["TextHtml"];
            this.createdBy = _data["CreatedBy"];
            this.user = _data["User"] ? UserModel.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["Text"] = this.text;
        data["TextHtml"] = this.textHtml;
        data["CreatedBy"] = this.createdBy;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): NoteModel {
        const json = this.toJSON();
        let result = new NoteModel();
        result.init(json);
        return result;
    }
}

export interface INoteModel {
    id?: number;
    dateCreated?: moment.Moment;
    text?: string | undefined;
    textHtml?: string | undefined;
    createdBy?: number;
    user?: UserModel | undefined;
}

export class AssignmentModel implements IAssignmentModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    blockSizeInMinutes?: number;
    treatmentProviderEmployeeId?: number;
    treatmentProviderEmployee?: TreatmentProviderEmployeeModel | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
    companies?: CompanyModel[] | undefined;
    schedules?: ScheduleModel[] | undefined;
    scheduleExceptions?: ScheduleExceptionModel[] | undefined;
    statusId?: number;
    status?: AssignmentStatusModel | undefined;

    constructor(data?: IAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.blockSizeInMinutes = _data["BlockSizeInMinutes"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
            this.treatmentProviderEmployee = _data["TreatmentProviderEmployee"] ? TreatmentProviderEmployeeModel.fromJS(_data["TreatmentProviderEmployee"]) : <any>undefined;
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanyModel.fromJS(item));
            }
            if (Array.isArray(_data["Schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["Schedules"])
                    this.schedules!.push(ScheduleModel.fromJS(item));
            }
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleExceptionModel.fromJS(item));
            }
            this.statusId = _data["StatusId"];
            this.status = _data["Status"] ? AssignmentStatusModel.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["BlockSizeInMinutes"] = this.blockSizeInMinutes;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        data["TreatmentProviderEmployee"] = this.treatmentProviderEmployee ? this.treatmentProviderEmployee.toJSON() : <any>undefined;
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        if (Array.isArray(this.schedules)) {
            data["Schedules"] = [];
            for (let item of this.schedules)
                data["Schedules"].push(item.toJSON());
        }
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["StatusId"] = this.statusId;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AssignmentModel {
        const json = this.toJSON();
        let result = new AssignmentModel();
        result.init(json);
        return result;
    }
}

export interface IAssignmentModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    blockSizeInMinutes?: number;
    treatmentProviderEmployeeId?: number;
    treatmentProviderEmployee?: TreatmentProviderEmployeeModel | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
    companies?: CompanyModel[] | undefined;
    schedules?: ScheduleModel[] | undefined;
    scheduleExceptions?: ScheduleExceptionModel[] | undefined;
    statusId?: number;
    status?: AssignmentStatusModel | undefined;
}

export class TreatmentProviderEmployeeModel implements ITreatmentProviderEmployeeModel {
    id?: number;
    userId?: number;
    user?: UserModel | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProviderModel | undefined;
    treatmentTypes?: TreatmentTypeModel[] | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    currentAssignmentTPEId?: number | undefined;

    constructor(data?: ITreatmentProviderEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserModel.fromJS(_data["User"]) : <any>undefined;
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProvider = _data["TreatmentProvider"] ? TreatmentProviderModel.fromJS(_data["TreatmentProvider"]) : <any>undefined;
            if (Array.isArray(_data["TreatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["TreatmentTypes"])
                    this.treatmentTypes!.push(TreatmentTypeModel.fromJS(item));
            }
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.currentAssignmentTPEId = _data["CurrentAssignmentTPEId"];
        }
    }

    static fromJS(data: any): TreatmentProviderEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProvider"] = this.treatmentProvider ? this.treatmentProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.treatmentTypes)) {
            data["TreatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["TreatmentTypes"].push(item.toJSON());
        }
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["CurrentAssignmentTPEId"] = this.currentAssignmentTPEId;
        return data; 
    }

    clone(): TreatmentProviderEmployeeModel {
        const json = this.toJSON();
        let result = new TreatmentProviderEmployeeModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderEmployeeModel {
    id?: number;
    userId?: number;
    user?: UserModel | undefined;
    treatmentProviderId?: number;
    treatmentProvider?: TreatmentProviderModel | undefined;
    treatmentTypes?: TreatmentTypeModel[] | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    currentAssignmentTPEId?: number | undefined;
}

export class ScheduleModel extends BaseEntityModel implements IScheduleModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    pauseStartTime?: string;
    pauseEndTime?: string;
    startTime?: string;
    endTime?: string;
    isRepeating?: boolean;
    fullDay?: boolean;
    blockSizeInMinutes?: number;
    title?: string | undefined;
    description?: string | undefined;
    assignmentId?: number;
    assignment?: AssignmentModel | undefined;
    isBooked?: boolean;
    unavailable?: boolean;

    constructor(data?: IScheduleModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.pauseStartTime = _data["PauseStartTime"];
            this.pauseEndTime = _data["PauseEndTime"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.isRepeating = _data["IsRepeating"];
            this.fullDay = _data["FullDay"];
            this.blockSizeInMinutes = _data["BlockSizeInMinutes"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.assignmentId = _data["AssignmentId"];
            this.assignment = _data["Assignment"] ? AssignmentModel.fromJS(_data["Assignment"]) : <any>undefined;
            this.isBooked = _data["IsBooked"];
            this.unavailable = _data["Unavailable"];
        }
    }

    static fromJS(data: any): ScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["PauseStartTime"] = this.pauseStartTime;
        data["PauseEndTime"] = this.pauseEndTime;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["IsRepeating"] = this.isRepeating;
        data["FullDay"] = this.fullDay;
        data["BlockSizeInMinutes"] = this.blockSizeInMinutes;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["AssignmentId"] = this.assignmentId;
        data["Assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        data["IsBooked"] = this.isBooked;
        data["Unavailable"] = this.unavailable;
        super.toJSON(data);
        return data; 
    }

    clone(): ScheduleModel {
        const json = this.toJSON();
        let result = new ScheduleModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleModel extends IBaseEntityModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    pauseStartTime?: string;
    pauseEndTime?: string;
    startTime?: string;
    endTime?: string;
    isRepeating?: boolean;
    fullDay?: boolean;
    blockSizeInMinutes?: number;
    title?: string | undefined;
    description?: string | undefined;
    assignmentId?: number;
    assignment?: AssignmentModel | undefined;
    isBooked?: boolean;
    unavailable?: boolean;
}

export class ScheduleExceptionModel extends BaseEntityModel implements IScheduleExceptionModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    fullDay?: boolean;
    rescheduled?: boolean;
    cancelled?: boolean;
    scheduleId?: number;
    assignmentId?: number;
    sheduleTypeId?: number;
    appointmentScheduleId?: number | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;

    constructor(data?: IScheduleExceptionModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.fullDay = _data["FullDay"];
            this.rescheduled = _data["Rescheduled"];
            this.cancelled = _data["Cancelled"];
            this.scheduleId = _data["ScheduleId"];
            this.assignmentId = _data["AssignmentId"];
            this.sheduleTypeId = _data["SheduleTypeId"];
            this.appointmentScheduleId = _data["AppointmentScheduleId"];
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleExceptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleExceptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["FullDay"] = this.fullDay;
        data["Rescheduled"] = this.rescheduled;
        data["Cancelled"] = this.cancelled;
        data["ScheduleId"] = this.scheduleId;
        data["AssignmentId"] = this.assignmentId;
        data["SheduleTypeId"] = this.sheduleTypeId;
        data["AppointmentScheduleId"] = this.appointmentScheduleId;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): ScheduleExceptionModel {
        const json = this.toJSON();
        let result = new ScheduleExceptionModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleExceptionModel extends IBaseEntityModel {
    id?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    startTime?: string;
    endTime?: string;
    fullDay?: boolean;
    rescheduled?: boolean;
    cancelled?: boolean;
    scheduleId?: number;
    assignmentId?: number;
    sheduleTypeId?: number;
    appointmentScheduleId?: number | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
}

export class AppointmentScheduleModel implements IAppointmentScheduleModel {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    locationId?: number | undefined;
    location?: LocationModel | undefined;
    companies?: CompanyShortModel[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    scheduleExceptions?: ScheduleExceptionShortModel[] | undefined;
    roomId?: number | undefined;
    room?: RoomModel | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    statusId?: number;
    status?: AssignmentStatusModel | undefined;
    isVideoCallAvailable?: boolean;

    constructor(data?: IAppointmentScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? moment(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["DailySchedules"])) {
                this.dailySchedules = [] as any;
                for (let item of _data["DailySchedules"])
                    this.dailySchedules!.push(DailyScheduleModel.fromJS(item));
            }
            this.duration = _data["Duration"];
            this.numberOfParticipants = _data["NumberOfParticipants"];
            this.maxDaysInAdvanceCanBeBooked = _data["MaxDaysInAdvanceCanBeBooked"];
            this.minHoursBeforeScheduleStartCanBeBooked = _data["MinHoursBeforeScheduleStartCanBeBooked"];
            this.bufferTimeBetweenSlotsInMinutes = _data["BufferTimeBetweenSlotsInMinutes"];
            this.bookableEveryInMinutes = _data["BookableEveryInMinutes"];
            if (Array.isArray(_data["TreatmentProviderEmployees"])) {
                this.treatmentProviderEmployees = [] as any;
                for (let item of _data["TreatmentProviderEmployees"])
                    this.treatmentProviderEmployees!.push(TreatmentProviderEmployeeShortModel.fromJS(item));
            }
            this.locationId = _data["LocationId"];
            this.location = _data["Location"] ? LocationModel.fromJS(_data["Location"]) : <any>undefined;
            if (Array.isArray(_data["Companies"])) {
                this.companies = [] as any;
                for (let item of _data["Companies"])
                    this.companies!.push(CompanyShortModel.fromJS(item));
            }
            this.scheduleRepetitionPatternId = _data["ScheduleRepetitionPatternId"];
            this.scheduleRepetitionPattern = _data["ScheduleRepetitionPattern"] ? ScheduleRepetitionPatternModel.fromJS(_data["ScheduleRepetitionPattern"]) : <any>undefined;
            if (Array.isArray(_data["ScheduleExceptions"])) {
                this.scheduleExceptions = [] as any;
                for (let item of _data["ScheduleExceptions"])
                    this.scheduleExceptions!.push(ScheduleExceptionShortModel.fromJS(item));
            }
            this.roomId = _data["RoomId"];
            this.room = _data["Room"] ? RoomModel.fromJS(_data["Room"]) : <any>undefined;
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.treatmentType = _data["TreatmentType"] ? TreatmentTypeShortModel.fromJS(_data["TreatmentType"]) : <any>undefined;
            this.groupTreatment = _data["GroupTreatment"];
            this.inhouse = _data["Inhouse"];
            this.statusId = _data["StatusId"];
            this.status = _data["Status"] ? AssignmentStatusModel.fromJS(_data["Status"]) : <any>undefined;
            this.isVideoCallAvailable = _data["IsVideoCallAvailable"];
        }
    }

    static fromJS(data: any): AppointmentScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.dailySchedules)) {
            data["DailySchedules"] = [];
            for (let item of this.dailySchedules)
                data["DailySchedules"].push(item.toJSON());
        }
        data["Duration"] = this.duration;
        data["NumberOfParticipants"] = this.numberOfParticipants;
        data["MaxDaysInAdvanceCanBeBooked"] = this.maxDaysInAdvanceCanBeBooked;
        data["MinHoursBeforeScheduleStartCanBeBooked"] = this.minHoursBeforeScheduleStartCanBeBooked;
        data["BufferTimeBetweenSlotsInMinutes"] = this.bufferTimeBetweenSlotsInMinutes;
        data["BookableEveryInMinutes"] = this.bookableEveryInMinutes;
        if (Array.isArray(this.treatmentProviderEmployees)) {
            data["TreatmentProviderEmployees"] = [];
            for (let item of this.treatmentProviderEmployees)
                data["TreatmentProviderEmployees"].push(item.toJSON());
        }
        data["LocationId"] = this.locationId;
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["Companies"] = [];
            for (let item of this.companies)
                data["Companies"].push(item.toJSON());
        }
        data["ScheduleRepetitionPatternId"] = this.scheduleRepetitionPatternId;
        data["ScheduleRepetitionPattern"] = this.scheduleRepetitionPattern ? this.scheduleRepetitionPattern.toJSON() : <any>undefined;
        if (Array.isArray(this.scheduleExceptions)) {
            data["ScheduleExceptions"] = [];
            for (let item of this.scheduleExceptions)
                data["ScheduleExceptions"].push(item.toJSON());
        }
        data["RoomId"] = this.roomId;
        data["Room"] = this.room ? this.room.toJSON() : <any>undefined;
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["TreatmentType"] = this.treatmentType ? this.treatmentType.toJSON() : <any>undefined;
        data["GroupTreatment"] = this.groupTreatment;
        data["Inhouse"] = this.inhouse;
        data["StatusId"] = this.statusId;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["IsVideoCallAvailable"] = this.isVideoCallAvailable;
        return data; 
    }

    clone(): AppointmentScheduleModel {
        const json = this.toJSON();
        let result = new AppointmentScheduleModel();
        result.init(json);
        return result;
    }
}

export interface IAppointmentScheduleModel {
    title?: string | undefined;
    description?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    dailySchedules?: DailyScheduleModel[] | undefined;
    duration?: number;
    numberOfParticipants?: number;
    maxDaysInAdvanceCanBeBooked?: number | undefined;
    minHoursBeforeScheduleStartCanBeBooked?: number | undefined;
    bufferTimeBetweenSlotsInMinutes?: number | undefined;
    bookableEveryInMinutes?: number | undefined;
    treatmentProviderEmployees?: TreatmentProviderEmployeeShortModel[] | undefined;
    locationId?: number | undefined;
    location?: LocationModel | undefined;
    companies?: CompanyShortModel[] | undefined;
    scheduleRepetitionPatternId?: number | undefined;
    scheduleRepetitionPattern?: ScheduleRepetitionPatternModel | undefined;
    scheduleExceptions?: ScheduleExceptionShortModel[] | undefined;
    roomId?: number | undefined;
    room?: RoomModel | undefined;
    treatmentTypeId?: number;
    treatmentType?: TreatmentTypeShortModel | undefined;
    groupTreatment?: boolean;
    inhouse?: boolean;
    statusId?: number;
    status?: AssignmentStatusModel | undefined;
    isVideoCallAvailable?: boolean;
}

export class UserRoleModel implements IUserRoleModel {
    role?: RoleModel | undefined;

    constructor(data?: IUserRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["Role"] ? RoleModel.fromJS(_data["Role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserRoleModel {
        const json = this.toJSON();
        let result = new UserRoleModel();
        result.init(json);
        return result;
    }
}

export interface IUserRoleModel {
    role?: RoleModel | undefined;
}

export class UserAutoCompleteModel implements IUserAutoCompleteModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cases?: CaseShortModel[] | undefined;

    constructor(data?: IUserAutoCompleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases!.push(CaseShortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAutoCompleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAutoCompleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserAutoCompleteModel {
        const json = this.toJSON();
        let result = new UserAutoCompleteModel();
        result.init(json);
        return result;
    }
}

export interface IUserAutoCompleteModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cases?: CaseShortModel[] | undefined;
}

export class TreatmentProviderSelectModel implements ITreatmentProviderSelectModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    onlyInhouse?: boolean;
    clinicProfileEnabled?: boolean;
    appointmentScheduleEnabled?: boolean;

    constructor(data?: ITreatmentProviderSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.onlyInhouse = _data["OnlyInhouse"];
            this.clinicProfileEnabled = _data["ClinicProfileEnabled"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
        }
    }

    static fromJS(data: any): TreatmentProviderSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["OnlyInhouse"] = this.onlyInhouse;
        data["ClinicProfileEnabled"] = this.clinicProfileEnabled;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        return data; 
    }

    clone(): TreatmentProviderSelectModel {
        const json = this.toJSON();
        let result = new TreatmentProviderSelectModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderSelectModel {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    onlyInhouse?: boolean;
    clinicProfileEnabled?: boolean;
    appointmentScheduleEnabled?: boolean;
}

export class VideoParticipantModel extends BaseEntityModel implements IVideoParticipantModel {
    personalInfo?: PersonalInfoModel | undefined;
    caseInfo?: CaseInfoModel | undefined;

    constructor(data?: IVideoParticipantModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personalInfo = _data["PersonalInfo"] ? PersonalInfoModel.fromJS(_data["PersonalInfo"]) : <any>undefined;
            this.caseInfo = _data["CaseInfo"] ? CaseInfoModel.fromJS(_data["CaseInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VideoParticipantModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoParticipantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PersonalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        data["CaseInfo"] = this.caseInfo ? this.caseInfo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): VideoParticipantModel {
        const json = this.toJSON();
        let result = new VideoParticipantModel();
        result.init(json);
        return result;
    }
}

export interface IVideoParticipantModel extends IBaseEntityModel {
    personalInfo?: PersonalInfoModel | undefined;
    caseInfo?: CaseInfoModel | undefined;
}

export class PersonalInfoModel implements IPersonalInfoModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sex?: SexModel | undefined;
    address?: string | undefined;

    constructor(data?: IPersonalInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.sex = _data["Sex"] ? SexModel.fromJS(_data["Sex"]) : <any>undefined;
            this.address = _data["Address"];
        }
    }

    static fromJS(data: any): PersonalInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["Address"] = this.address;
        return data; 
    }

    clone(): PersonalInfoModel {
        const json = this.toJSON();
        let result = new PersonalInfoModel();
        result.init(json);
        return result;
    }
}

export interface IPersonalInfoModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sex?: SexModel | undefined;
    address?: string | undefined;
}

export class CaseInfoModel implements ICaseInfoModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    startDate?: moment.Moment;

    constructor(data?: ICaseInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            this.description = _data["Description"];
            this.startDate = _data["StartDate"] ? moment(_data["StartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        data["Description"] = this.description;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CaseInfoModel {
        const json = this.toJSON();
        let result = new CaseInfoModel();
        result.init(json);
        return result;
    }
}

export interface ICaseInfoModel {
    id?: number;
    subject?: string | undefined;
    description?: string | undefined;
    startDate?: moment.Moment;
}

export class ParticipantResultModel implements IParticipantResultModel {
    succeeded?: boolean;
    errors?: string[] | undefined;

    constructor(data?: IParticipantResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            if (Array.isArray(_data["Errors"])) {
                this.errors = [] as any;
                for (let item of _data["Errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ParticipantResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    clone(): ParticipantResultModel {
        const json = this.toJSON();
        let result = new ParticipantResultModel();
        result.init(json);
        return result;
    }
}

export interface IParticipantResultModel {
    succeeded?: boolean;
    errors?: string[] | undefined;
}

export class PersonalInfoEditModel implements IPersonalInfoEditModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sexId?: number;
    address?: string | undefined;

    constructor(data?: IPersonalInfoEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.cPR = _data["CPR"];
            this.dateOfBirth = _data["DateOfBirth"] ? moment(_data["DateOfBirth"].toString()) : <any>undefined;
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.sexId = _data["SexId"];
            this.address = _data["Address"];
        }
    }

    static fromJS(data: any): PersonalInfoEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CPR"] = this.cPR;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["SexId"] = this.sexId;
        data["Address"] = this.address;
        return data; 
    }

    clone(): PersonalInfoEditModel {
        const json = this.toJSON();
        let result = new PersonalInfoEditModel();
        result.init(json);
        return result;
    }
}

export interface IPersonalInfoEditModel {
    id?: number;
    fullName?: string | undefined;
    cPR?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sexId?: number;
    address?: string | undefined;
}

export class TreatmentProviderAssignmentsSelectModel implements ITreatmentProviderAssignmentsSelectModel {
    searchKeyword?: string | undefined;
    companyIds?: number[] | undefined;
    treatmentTypeId?: number | undefined;
    mustHaveEmployees?: boolean;
    appointmentScheduleEnabled?: boolean | undefined;
    withLocation?: boolean;
    networkId?: number | undefined;
    availableForPastBookings?: boolean;

    constructor(data?: ITreatmentProviderAssignmentsSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchKeyword = _data["SearchKeyword"];
            if (Array.isArray(_data["CompanyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["CompanyIds"])
                    this.companyIds!.push(item);
            }
            this.treatmentTypeId = _data["TreatmentTypeId"];
            this.mustHaveEmployees = _data["MustHaveEmployees"];
            this.appointmentScheduleEnabled = _data["AppointmentScheduleEnabled"];
            this.withLocation = _data["WithLocation"];
            this.networkId = _data["NetworkId"];
            this.availableForPastBookings = _data["AvailableForPastBookings"];
        }
    }

    static fromJS(data: any): TreatmentProviderAssignmentsSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderAssignmentsSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SearchKeyword"] = this.searchKeyword;
        if (Array.isArray(this.companyIds)) {
            data["CompanyIds"] = [];
            for (let item of this.companyIds)
                data["CompanyIds"].push(item);
        }
        data["TreatmentTypeId"] = this.treatmentTypeId;
        data["MustHaveEmployees"] = this.mustHaveEmployees;
        data["AppointmentScheduleEnabled"] = this.appointmentScheduleEnabled;
        data["WithLocation"] = this.withLocation;
        data["NetworkId"] = this.networkId;
        data["AvailableForPastBookings"] = this.availableForPastBookings;
        return data; 
    }

    clone(): TreatmentProviderAssignmentsSelectModel {
        const json = this.toJSON();
        let result = new TreatmentProviderAssignmentsSelectModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderAssignmentsSelectModel {
    searchKeyword?: string | undefined;
    companyIds?: number[] | undefined;
    treatmentTypeId?: number | undefined;
    mustHaveEmployees?: boolean;
    appointmentScheduleEnabled?: boolean | undefined;
    withLocation?: boolean;
    networkId?: number | undefined;
    availableForPastBookings?: boolean;
}

export class TreatmentProviderAvailableForPastBookingsDTO implements ITreatmentProviderAvailableForPastBookingsDTO {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    availableForPastBookings?: boolean;
    locations?: TreatmentProviderLocationDTO[] | undefined;

    constructor(data?: ITreatmentProviderAvailableForPastBookingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.cVR = _data["CVR"];
            this.name = _data["Name"];
            this.availableForPastBookings = _data["AvailableForPastBookings"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(TreatmentProviderLocationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentProviderAvailableForPastBookingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderAvailableForPastBookingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CVR"] = this.cVR;
        data["Name"] = this.name;
        data["AvailableForPastBookings"] = this.availableForPastBookings;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreatmentProviderAvailableForPastBookingsDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderAvailableForPastBookingsDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderAvailableForPastBookingsDTO {
    id?: number;
    cVR?: string | undefined;
    name?: string | undefined;
    availableForPastBookings?: boolean;
    locations?: TreatmentProviderLocationDTO[] | undefined;
}

export class TreatmentProviderLocationDTO implements ITreatmentProviderLocationDTO {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deleted?: boolean;

    constructor(data?: ITreatmentProviderLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): TreatmentProviderLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProviderLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["Deleted"] = this.deleted;
        return data; 
    }

    clone(): TreatmentProviderLocationDTO {
        const json = this.toJSON();
        let result = new TreatmentProviderLocationDTO();
        result.init(json);
        return result;
    }
}

export interface ITreatmentProviderLocationDTO {
    id?: number;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deleted?: boolean;
}

export class TreatmentTypeSelectModel implements ITreatmentTypeSelectModel {
    searchKeyword?: string | undefined;
    caseRequired?: boolean | undefined;
    companyIds?: number[] | undefined;
    treatmentProviderId?: number | undefined;
    treatmentProviderEmployeeId?: number | undefined;

    constructor(data?: ITreatmentTypeSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchKeyword = _data["SearchKeyword"];
            this.caseRequired = _data["CaseRequired"];
            if (Array.isArray(_data["CompanyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["CompanyIds"])
                    this.companyIds!.push(item);
            }
            this.treatmentProviderId = _data["TreatmentProviderId"];
            this.treatmentProviderEmployeeId = _data["TreatmentProviderEmployeeId"];
        }
    }

    static fromJS(data: any): TreatmentTypeSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTypeSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SearchKeyword"] = this.searchKeyword;
        data["CaseRequired"] = this.caseRequired;
        if (Array.isArray(this.companyIds)) {
            data["CompanyIds"] = [];
            for (let item of this.companyIds)
                data["CompanyIds"].push(item);
        }
        data["TreatmentProviderId"] = this.treatmentProviderId;
        data["TreatmentProviderEmployeeId"] = this.treatmentProviderEmployeeId;
        return data; 
    }

    clone(): TreatmentTypeSelectModel {
        const json = this.toJSON();
        let result = new TreatmentTypeSelectModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentTypeSelectModel {
    searchKeyword?: string | undefined;
    caseRequired?: boolean | undefined;
    companyIds?: number[] | undefined;
    treatmentProviderId?: number | undefined;
    treatmentProviderEmployeeId?: number | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
